webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = apiGet;
/* harmony export (immutable) */ __webpack_exports__["a"] = apiPost;
/* harmony export (immutable) */ __webpack_exports__["f"] = apiPut;
/* harmony export (immutable) */ __webpack_exports__["g"] = apiGetExcel;
/* harmony export (immutable) */ __webpack_exports__["e"] = apiDelete;
/* harmony export (immutable) */ __webpack_exports__["d"] = apiUploadWithParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = notify;
function apiGet(vm, url, params, onSuccess, onError, onFinish) {
  var obj = { params: params };
  if (params.octopus) {
    url = '' + "https://api-octopus.datacont.com" + url;
    params.token = localStorage.getItem('tokenOctopus');
  } else params.token = localStorage.getItem('token');
  params.empresa = "reprodata";

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    // console.log('response:', response)
    if (data.status === -1) {
      // No se ha logueado
      localStorage.clear();
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiPost(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;

  params.empresa = "reprodata";
  params.token = localStorage.getItem('token');

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.clear();
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiPut(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;

  params.empresa = "reprodata";
  params.token = localStorage.getItem('token');

  vm.axios.put(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.clear();
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiGetExcel(vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    responseType: 'arraybuffer',
    params: params
  };

  if (params.octopus) {
    var api = '';
    api = "https://api-octopus.datacont.com";
    url = api + url;
  }

  params.empresa = "reprodata";

  if (params.octopus) params.token = localStorage.getItem('tokenOctopus');else params.token = localStorage.getItem('token');

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data;
    onSuccess(data);
    if (onFinish) onFinish();
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiDelete(vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    params: params
  };

  params.empresa = "reprodata";
  params.token = localStorage.getItem('token');

  vm.axios.delete(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.clear();
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiUploadWithParams(vm, url, body, params, onSuccess, onError, onFinish) {
  var obj = body;

  body.empresa = "reprodata";
  body.token = localStorage.getItem('token');
  params.empresa = "reprodata".toLowerCase();
  params.app = "HELPDESK".toLowerCase();

  vm.axios.post(url, obj, { params: params }).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    if (data.status === -1) {
      // No se ha logueado
      localStorage.clear();
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function notify(vm, type, title, text) {
  vm.$notify({
    title: title,
    text: text,
    position: 'bottom right',
    type: type
    // duration: 1000000
  });
}

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(532),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_View_welcome_dispatcher__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_View_welcome_dispatcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_View_welcome_dispatcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_View_detalle_ticket__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_View_detalle_ticket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_View_detalle_ticket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_View_programacion_de_citas__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_View_programacion_de_citas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_View_programacion_de_citas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_View_reportes__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_View_reportes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_View_reportes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_c_reporte_previsualizar__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_c_reporte_previsualizar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_c_reporte_previsualizar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_View_creacion_ticket_multiple__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_View_creacion_ticket_multiple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_View_creacion_ticket_multiple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_View_user_profile__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_View_user_profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_View_user_profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_notification__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_View_administrador_usuarios__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_View_administrador_usuarios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_View_administrador_usuarios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_New_Ticket_Contrato_View__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_New_Ticket_Contrato_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_New_Ticket_Contrato_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__websanova_vue_upload__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__websanova_vue_upload_dist_drivers_http_axios_esm_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_services_goto__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_services_goto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_es5_services_goto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment_locale_es__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment_locale_es__);




















__WEBPACK_IMPORTED_MODULE_14_moment___default.a.locale('es');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__websanova_vue_upload__["a" /* default */], {
  http: __WEBPACK_IMPORTED_MODULE_17__websanova_vue_upload_dist_drivers_http_axios_esm_js__["a" /* default */]
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = "https://api-helpdesk.datacont.com";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    var scrollTo = 0;
    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }
    return __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_services_goto___default()(scrollTo);
  },
  routes: [{ path: '/login', redirect: '/' }, {
    path: '/',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_5__views_View_welcome_dispatcher___default.a
  }, {
    path: '/tickets/:tipo/:tipoDeArea?',
    name: 'listado_tickets',
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 234));
    },
    props: true
  }, {
    path: '/ticket-contrato/nuevo',
    name: 'nuevo_ticket_contrato',
    component: __WEBPACK_IMPORTED_MODULE_15__components_New_Ticket_Contrato_View___default.a
  }, {
    path: '/ticket/:numero',
    name: 'detalle_ticket',
    component: __WEBPACK_IMPORTED_MODULE_6__views_View_detalle_ticket___default.a,
    props: true
  }, {
    path: '/programacion/citas/:id?',
    name: 'citas',
    component: __WEBPACK_IMPORTED_MODULE_7__views_View_programacion_de_citas___default.a,
    props: true
  }, {
    path: '/profile',
    name: 'profile',
    component: __WEBPACK_IMPORTED_MODULE_11__views_View_user_profile___default.a
  }, {
    path: '/reportes',
    name: 'reportes',
    component: __WEBPACK_IMPORTED_MODULE_8__views_View_reportes___default.a,
    props: true
  }, {
    path: '/reportes/view/:tipo',
    name: 'reportes_view',
    component: __WEBPACK_IMPORTED_MODULE_9__components_c_reporte_previsualizar___default.a,
    props: true
  }, {
    path: '/ticket/crear/multiple',
    name: 'ticket_crear_multiple_view',
    component: __WEBPACK_IMPORTED_MODULE_10__views_View_creacion_ticket_multiple___default.a,
    props: true
  }, {
    path: '/manager/usuarios',
    name: 'usuarios',
    component: __WEBPACK_IMPORTED_MODULE_13__views_View_administrador_usuarios___default.a
  }]
}));

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_View__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Login_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Register_user__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Register_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Register_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Verificar_email__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Verificar_email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Verificar_email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Forgot_password_request__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Forgot_password_request___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Forgot_password_request__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_View_Forgot_Password_Post__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_View_Forgot_Password_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_View_Forgot_Password_Post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_notification__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_notification__);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = "https://api-helpdesk.datacont.com";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/register',
    name: 'register',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Register_user___default.a
  }, {
    path: '/',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login_View___default.a
  }, {
    path: '/forgot-password-request',
    name: 'forgot-password',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Forgot_password_request___default.a
  }, {
    path: '/forgot-password-post',
    name: 'forgot-password-post',
    component: __WEBPACK_IMPORTED_MODULE_8__components_View_Forgot_Password_Post___default.a
  }, {
    path: '/profile-activate',
    name: 'profile-activate',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Verificar_email___default.a
  }, {
    path: '/*',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login_View___default.a
  }]
}));

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(485),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26f6a596",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(395)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(496),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a313020",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(531),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_View_welcome_customer__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_View_welcome_customer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_View_welcome_customer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_New_Ticket_View__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_New_Ticket_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_New_Ticket_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_New_Ticket_Contrato_View__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_New_Ticket_Contrato_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_New_Ticket_Contrato_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_View_tickets__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_View_tickets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_View_tickets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_View_detalle_ticket__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_View_detalle_ticket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_View_detalle_ticket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_View_user_profile__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_View_user_profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_View_user_profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_notification__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__websanova_vue_upload__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__websanova_vue_upload_dist_drivers_http_axios_esm_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_services_goto__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_services_goto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_es5_services_goto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment_locale_es__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment_locale_es__);

















__WEBPACK_IMPORTED_MODULE_12_moment___default.a.locale('es');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__websanova_vue_upload__["a" /* default */], {
  http: __WEBPACK_IMPORTED_MODULE_14__websanova_vue_upload_dist_drivers_http_axios_esm_js__["a" /* default */]
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = "https://api-helpdesk.datacont.com";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    var scrollTo = 0;
    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_services_goto___default()(scrollTo);
  },
  routes: [{ path: '/login', redirect: '/' }, { path: '/register', redirect: '/profile' }, {
    path: '/',
    name: 'welcome_customer',
    component: __WEBPACK_IMPORTED_MODULE_5__views_View_welcome_customer___default.a
  }, {
    path: '/ticket/nuevo',
    name: 'nuevo_ticket',
    component: __WEBPACK_IMPORTED_MODULE_6__components_New_Ticket_View___default.a
  }, {
    path: '/ticket-contrato/nuevo',
    name: 'nuevo_ticket_contrato',
    component: __WEBPACK_IMPORTED_MODULE_7__components_New_Ticket_Contrato_View___default.a
  }, {
    path: '/tickets',
    name: 'ticket_list',
    component: __WEBPACK_IMPORTED_MODULE_8__views_View_tickets___default.a
  }, {
    path: '/ticket/:numero',
    name: 'detalle_ticket',
    component: __WEBPACK_IMPORTED_MODULE_9__views_View_detalle_ticket___default.a,
    props: true
  }, {
    path: '/profile',
    name: 'profile',
    component: __WEBPACK_IMPORTED_MODULE_10__views_View_user_profile___default.a
  }, {
    path: '/profile-activate',
    name: 'profile-activate',
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 224));
    }
  }]
}));

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(379)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(477),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-112d9eae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-db511a52",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(517),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Admin_View__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Admin_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Admin_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_View_Cliente_Admin__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_View_Cliente_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_View_Cliente_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_View_parametros__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_View_parametros___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_View_parametros__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_View_manager__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_View_manager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_View_manager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_View_administrador_estados__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_View_administrador_estados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_View_administrador_estados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_View_administrador_usuarios__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_View_administrador_usuarios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_View_administrador_usuarios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_View_notificaciones__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_View_notificaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_View_notificaciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_View_auditoria__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_View_auditoria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_View_auditoria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_locale_es__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment_locale_es__);














__WEBPACK_IMPORTED_MODULE_12_moment___default.a.locale('es');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = "https://api-helpdesk.datacont.com";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'admin',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Admin_View___default.a
  }, {
    path: '/cliente',
    name: 'client_admin',
    component: __WEBPACK_IMPORTED_MODULE_5__components_View_Cliente_Admin___default.a
  }, {
    path: '/auditoria',
    name: 'auditoria',
    component: __WEBPACK_IMPORTED_MODULE_11__views_View_auditoria___default.a
  }, {
    path: '/notificaciones',
    name: 'notificaciones',
    component: __WEBPACK_IMPORTED_MODULE_10__views_View_notificaciones___default.a
  }, {
    path: '/manager',
    name: 'manager_view',
    component: __WEBPACK_IMPORTED_MODULE_7__views_View_manager___default.a
  }, {
    path: '/manager/parametros',
    name: 'parametros',
    component: __WEBPACK_IMPORTED_MODULE_6__views_View_parametros___default.a
  }, {
    path: '/manager/usuarios',
    name: 'usuarios',
    component: __WEBPACK_IMPORTED_MODULE_9__views_View_administrador_usuarios___default.a
  }, {
    path: '/manager/estados',
    name: 'estados',
    component: __WEBPACK_IMPORTED_MODULE_8__views_View_administrador_estados___default.a
  }]
}));

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJsb2dvc2FuZHR5cGVzX2NvbSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTUwIDE1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMTYzYWM7fS5jbHMtMntmaWxsOm5vbmU7fS5jbHMtM3tmaWxsOiNhZTBkNDE7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTAsMEgxNTBWMTUwSDBWMFoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xMDguODIsOTYuNDljNy4yLTI4LjMxLTYuNjYtMjcuOTktMjkuNjQtMzAuNzUtNi4xNy0uOS0xMi41NC0xLjE1LTE4LjQzLTIuOTctMTMuNTktMi43NC0yMi44Ny0yMC42Ni0xMi42MS0zMS45OSw3LjM3LTcuOCwxNS0xNS4zNSwyMi41Ny0yMi45NiwyLjUxLTIuNTMsNi40Ni0yLjMyLDksLjIsNy42MSw3LjU1LDQyLjMzLDQyLjA5LDUyLjA4LDUxLjc5LDcuMTUsNS43LDYuOTYsMTAuODQtLjIxLDE2LjMtNy4zMSw3LjA1LTE0Ljc0LDE0LTIyLjIyLDIwLjg4bC0uNTUtLjQ5aDBaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNDEuNjMsNTEuNjljLTIuNzQsMTIuNTktNC41MSwyNS42MSwxMC41MiwyOS40MSwxNC44LDQuNTYsMzEuNjctLjM1LDQ0Ljk4LDguOTYsOS43Miw2LjA2LDEzLjI4LDE5LjkxLDQuODMsMjguNTEtNy4yMyw3Ljk4LTE0Ljk3LDE1LjQ5LTIyLjY2LDIzLjAzLTEuNTksMS41NS02LjIxLDEuNzUtNy44MiwuMi0xOC4wMS0xNy43Mi0zNS41Ny0zNS45Mi01My42OS01My41NC05LjExLTcuNTItMi40Mi0xMS41MywzLjc5LTE3LjU3LDYuNS02LjIsMTMuMDUtMTIuMzYsMjAuMDYtMTguOTloMFoiLz48L3N2Zz4="

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc.248dbda.png";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/exe.b36ffdf.png";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pdf.49d4041.png";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/search.1aa64b3.png";

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(474),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02efff14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(514),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(478),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-630610ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(493),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3dd831be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(513),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(506),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-723f9e35",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(518),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(505),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b9885e7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(378)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(476),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0fd8c3f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(411)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(519),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8f057728",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(491),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30dd1b12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(509),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_lib_locale_es__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
var opciones = {
  icons: { iconfont: 'md' },
  theme: {
    themes: {
      light: {
        primary: '#b80813',
        secondary: '#f7e2e3',
        error: '#f14668',
        background: '#ebeff3',
        success: '#48c78e',
        opacity: '#b80813cc',
        dark: '#2d4258'
      },
      dark: {
        primary: '#b80813',
        secondary: '#441115',
        error: '#f14668',
        background: '#272727',
        success: '#48c78e',
        opacity: '#b80813cc'
      }
    }
  },
  lang: {
    locales: { es: __WEBPACK_IMPORTED_MODULE_3_vuetify_lib_locale_es__["a" /* default */] },
    current: 'es'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuetify___default.a(opciones));

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ticket__ = __webpack_require__(264);






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__app__["a" /* default */]),
    ticket: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__ticket__["a" /* default */])
  }
}));

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(490),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(494),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(488),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(417)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(526),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Not_Logged_App__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Not_Logged_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Not_Logged_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Admin_App__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Admin_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Admin_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Customer_App__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Customer_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Customer_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dispatcher_App__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dispatcher_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Dispatcher_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_not_logged__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_admin__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_customer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_dispatcher__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_vuetify__ = __webpack_require__(239);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('timeAgo', function (value) {
  return value;
});

/* eslint-disable no-new */
var perfil = localStorage.getItem('perfil');
var token = localStorage.getItem('token');
console.log('token', token);
console.log('perfil', perfil);
if (token) {
  if (perfil) {
    if (perfil === 'usuario-contrato' || perfil === 'usuario') {
      new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
        el: '#app',
        router: __WEBPACK_IMPORTED_MODULE_8__router_customer__["a" /* default */],
        vuetify: __WEBPACK_IMPORTED_MODULE_10__plugins_vuetify__["a" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
        template: '<customerApp/>',
        components: { customerApp: __WEBPACK_IMPORTED_MODULE_4__Customer_App___default.a }
      });
    } else if (perfil === 'dispatcher' || perfil === 'recepcion' || perfil === 'supervisor' || perfil === 'tecnico taller') {
      new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
        el: '#app',
        router: __WEBPACK_IMPORTED_MODULE_9__router_dispatcher__["a" /* default */],
        vuetify: __WEBPACK_IMPORTED_MODULE_10__plugins_vuetify__["a" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
        template: '<dispatcherApp/>',
        components: { dispatcherApp: __WEBPACK_IMPORTED_MODULE_5__Dispatcher_App___default.a }
      });
    } else if (perfil === 'sistemas') {
      new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
        el: '#app',
        vuetify: __WEBPACK_IMPORTED_MODULE_10__plugins_vuetify__["a" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
        router: __WEBPACK_IMPORTED_MODULE_7__router_admin__["a" /* default */],
        template: '<adminApp/>',
        components: { adminApp: __WEBPACK_IMPORTED_MODULE_3__Admin_App___default.a }
      });
    } else {
      new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
        el: '#app',
        vuetify: __WEBPACK_IMPORTED_MODULE_10__plugins_vuetify__["a" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
        router: __WEBPACK_IMPORTED_MODULE_6__router_not_logged__["a" /* default */],
        template: '<notLoggedApp/>',
        components: { notLoggedApp: __WEBPACK_IMPORTED_MODULE_2__Not_Logged_App___default.a }
      });
    }
  } else {
    new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
      el: '#app',
      vuetify: __WEBPACK_IMPORTED_MODULE_10__plugins_vuetify__["a" /* default */],
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
      router: __WEBPACK_IMPORTED_MODULE_6__router_not_logged__["a" /* default */],
      template: '<notLoggedApp/>',
      components: { notLoggedApp: __WEBPACK_IMPORTED_MODULE_2__Not_Logged_App___default.a }
    });
  }
} else {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    vuetify: __WEBPACK_IMPORTED_MODULE_10__plugins_vuetify__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_6__router_not_logged__["a" /* default */],
    template: '<notLoggedApp/>',
    components: { notLoggedApp: __WEBPACK_IMPORTED_MODULE_2__Not_Logged_App___default.a }
  });
}

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  state: {
    transaction: {
      isProceso: false,
      message: '',
      force: false
    },
    showProcesos: true,
    openPopupNotifications: false,
    countAllDownloands: 0,
    settings: {
      general: {
        theme: {
          name: 'datacont',
          dark: false
        }
      }
    }
  },
  mutations: {
    SET_SHOW_PROCESOS: function SET_SHOW_PROCESOS(state, aux) {
      state.showProcesos = aux;
    },
    SET_COUNT_DOWNLOANDS: function SET_COUNT_DOWNLOANDS(state, aux) {
      state.countAllDownloands = aux;
    },
    SET_SETTINGS: function SET_SETTINGS(state, aux) {
      state.settings = aux;
    },
    SET_OPEN_NOTIFICATIONS: function SET_OPEN_NOTIFICATIONS(state, aux) {
      state.openPopupNotifications = aux;
    },
    SET_SHOW_TRANSACTION: function SET_SHOW_TRANSACTION(state, aux) {
      if (!state.transaction.force) {
        state.transaction.isProceso = aux.isProceso;
        state.transaction.message = aux.message;
      }
    },
    SET_SHOW_TRANSACTION_FORCE: function SET_SHOW_TRANSACTION_FORCE(state, aux) {
      state.transaction.isProceso = aux.force;
      state.transaction.force = aux.force;
      state.transaction.message = aux.message;
    }
  },
  actions: {
    transaccion: function transaccion(_ref, payload) {
      var commit = _ref.commit;

      commit('SET_SHOW_TRANSACTION', payload);
    },
    transaccionForce: function transaccionForce(_ref2, payload) {
      var commit = _ref2.commit;

      commit('SET_SHOW_TRANSACTION_FORCE', payload);
    },
    openProcesos: function openProcesos(_ref3) {
      var commit = _ref3.commit;

      commit('SET_SHOW_PROCESOS', false);
      setTimeout(function () {
        commit('SET_SHOW_PROCESOS', true);
      }, 1);
    },
    closeProcesos: function closeProcesos(_ref4) {
      var commit = _ref4.commit;

      commit('SET_SHOW_PROCESOS', false);
    },
    setOpenPopupNotifications: function setOpenPopupNotifications(_ref5, payload) {
      var commit = _ref5.commit;

      commit('SET_OPEN_NOTIFICATIONS', payload);
    },
    setCountAllDownloands: function setCountAllDownloands(_ref6, payload) {
      var commit = _ref6.commit;

      commit('SET_COUNT_DOWNLOANDS', payload);
    },
    setSettings: function setSettings(_ref7, payload) {
      var commit = _ref7.commit;

      commit('SET_SETTINGS', payload);
    }
  },
  getters: {}
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  state: {
    abiertos: {
      solicitud_de_insumo: 0,
      incidencia_con_equipo: 0,
      all_usuario_o_cliente: 0,
      garantia_sin_atencion: 0,
      garantia_sin_asignar: 0,
      garantia_campo: 0,
      garantia_taller: 0
    }
  },
  mutations: {
    SET_CONTADORES: function SET_CONTADORES(state, aux) {
      state.abiertos.solicitud_de_insumo = aux.solicitud_de_insumo || 0;
      state.abiertos.incidencia_con_equipo = aux.incidencia_con_equipo || 0;
      state.abiertos.all_usuario_o_cliente = aux.all_usuario_o_cliente || 0;
      state.abiertos.garantia_campo = aux.garantia_campo || 0;
      state.abiertos.garantia_taller = aux.garantia_taller || 0;
      state.abiertos.garantia_sin_asignar = aux.garantia_sin_asignar || 0;
      state.abiertos.garantia_sin_atencion = aux.garantia_sin_atencion || 0;
    }
  },
  actions: {
    setContadores: function setContadores(_ref, payload) {
      var commit = _ref.commit;

      commit('SET_CONTADORES', payload);
    }
  },
  getters: {}
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_loading_transaction__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_loading_transaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_loading_transaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_theme_changer__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_theme_changer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_theme_changer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_admin_js__ = __webpack_require__(54);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'adminApp',
  components: {
    'theme-provider': __WEBPACK_IMPORTED_MODULE_1__components_c_theme_changer___default.a,
    'avatar-perfil': __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil___default.a,
    'loading-transaction': __WEBPACK_IMPORTED_MODULE_0__components_c_loading_transaction___default.a
  },
  data: function data() {
    return {
      tab: null,
      perfil: localStorage.getItem('perfil'),
      username: localStorage.getItem('username'),
      nombre: localStorage.getItem('nombre'),
      menu: [{
        name: 'Dashboard',
        path: '/',
        icon: 'dashboard'
      }, {
        name: 'Auditoria',
        path: '/auditoria',
        icon: 'style',
        key: 'auditoria',
        notify: ''
      }, {
        name: 'Notificaciones',
        path: '/notificaciones',
        icon: 'style',
        key: 'notificaciones',
        notify: ''
      }, {
        name: 'Manager',
        path: '/manager',
        icon: 'cog',
        key: 'manager',
        notify: ''
      }]
    };
  },
  created: function created() {},

  computed: {
    transaction: function transaction() {
      var vm = this;
      return vm.$store.state.app.transaction;
    },
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    logout: function logout() {
      localStorage.clear();
      window.location.href = '/';
    },
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_3__router_admin_js__["a" /* default */].push(page);
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_View_sidebar__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_View_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_View_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_loading_transaction__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_loading_transaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_loading_transaction__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Customer_App',
  components: {
    'side-bar': __WEBPACK_IMPORTED_MODULE_0__views_View_sidebar___default.a,
    'loading-transaction': __WEBPACK_IMPORTED_MODULE_1__components_c_loading_transaction___default.a
  },
  data: function data() {
    return {
      empresa: "reprodata",
      empresaFull: "Reprodata S.A.C."
    };
  },

  computed: {
    transaction: function transaction() {
      var vm = this;
      return vm.$store.state.app.transaction;
    },
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    logout: function logout() {
      localStorage.setItem('logged', '');
      localStorage.setItem('perfil', '');
      window.location.href = '/';
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_View_sidebar__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_View_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_View_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_loading_transaction__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_loading_transaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_loading_transaction__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dispatcherApp',
  components: {
    'side-bar': __WEBPACK_IMPORTED_MODULE_1__views_View_sidebar___default.a,
    'loading-transaction': __WEBPACK_IMPORTED_MODULE_2__components_c_loading_transaction___default.a
  },
  data: function data() {
    return {
      empresa: "reprodata",
      empresaFull: "Reprodata S.A.C.",
      usuario: localStorage.getItem('username'),
      isLoading: false
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchGetDataUser();
  },

  computed: {
    transaction: function transaction() {
      var vm = this;
      return vm.$store.state.app.transaction;
    },
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    scrollbarTheme: function scrollbarTheme() {
      var vm = this;
      return vm.$vuetify.theme.dark ? 'dark-scroll' : 'light-scroll';
    }
  },
  methods: {
    fetchGetDataUser: function fetchGetDataUser() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        usuario: vm.usuario
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/usuario/obtener', obj, function (data) {
        var usuario = data.lista[0];
        if (usuario.configuracionesApp) {
          var configs = JSON.parse(usuario.configuracionesApp);
          vm.$store.dispatch('setSettings', configs);
          vm.$vuetify.theme.dark = configs.general.theme.dark;
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoading = true;
      });
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_loading_transaction__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_loading_transaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_loading_transaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_theme_changer__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_theme_changer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_theme_changer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'loading-transaction': __WEBPACK_IMPORTED_MODULE_0__components_c_loading_transaction___default.a,
    'theme-provider': __WEBPACK_IMPORTED_MODULE_1__components_c_theme_changer___default.a
  },
  data: function data() {
    return {
      hideTabs: false,
      empresaFull: "Reprodata S.A.C."
    };
  },
  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    transaction: function transaction() {
      var vm = this;
      return vm.$store.state.app.transaction;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function handler(to) {
        var vm = this;
        vm.hideTabs = to.name === 'forgot-password' || to.name === 'profile-activate' || to.name === 'forgot-password-post';
      }
    }
  },
  methods: {}
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      username: localStorage.getItem('nombre'),
      password: '',
      errorMessage: '',
      isLoading: false
    };
  },

  methods: {}
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cliente_contact_list',
  props: ['cliente'],
  data: function data() {
    return {
      isLoading: true,
      lista: [],
      clienteSeleccionado: {},
      nuevo: {
        usuario: '',
        nombre: '',
        cargo: '',
        telefono: '',
        password: ''
      },
      seleccionado: false,
      isAdding: false
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = { codigo: vm.cliente.codigo };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/admin/cliente/contacto', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    remover: function remover(o) {
      var vm = this;

      var obj = {
        usuario: o.usuario
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["e" /* apiDelete */])(vm, '/admin/cliente/contacto', obj, function (data) {
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    guardar: function guardar(o) {
      var vm = this;
      var obj = {
        usuario: o.usuario,
        nombre: o.nombre,
        cargo: o.cargo,
        telefono: o.telefono,
        password: o.password
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["f" /* apiPut */])(vm, '/admin/cliente/contacto', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', '', 'Datos guardados correctamente');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    },
    insertar: function insertar() {
      var vm = this;
      var obj = {
        usuario: vm.nuevo.usuario,
        nombre: vm.nuevo.nombre,
        cargo: vm.nuevo.cargo,
        telefono: vm.nuevo.telefono,
        password: vm.nuevo.password,
        codigoCliente: vm.cliente.codigo,
        razonSocial: vm.cliente.nombre
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/admin/cliente/contacto', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', '', 'Datos guardados correctamente');
        vm.nuevo = {
          usuario: '',
          nombre: '',
          cargo: '',
          telefono: '',
          password: ''
        };
        vm.isAdding = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cliente_equipo_list',
  props: ['cliente'],
  data: function data() {
    return {
      isLoading: true,
      lista: [],
      clienteSeleccionado: {},
      seleccionado: false
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = { codigo: vm.cliente.codigo };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/admin/cliente/equipo', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    remover: function remover(o) {
      var vm = this;

      var obj = {
        serie: o.serie
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["e" /* apiDelete */])(vm, '/admin/cliente/equipo', obj, function (data) {
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cliente_list',
  data: function data() {
    return {
      isLoading: true,
      lista: [],
      clienteSeleccionado: {},
      seleccionado: false,
      codigoClienteAgregar: '',
      isAdding: false,
      isUpdating: false
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/admin/cliente', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    remove: function remove(o) {
      var vm = this;

      var obj = {
        codigo: o.codigo
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["e" /* apiDelete */])(vm, '/admin/cliente', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', '', 'Eliminado correctamente');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    ver: function ver(o) {
      var vm = this;
      vm.$emit('selected', o);
      vm.clienteSeleccionado.codigo = o.codigo;
      vm.clienteSeleccionado.nombre = o.nombre;
      vm.seleccionado = true;
    },
    deseleccionar: function deseleccionar() {
      var vm = this;
      vm.$emit('deselected');
      vm.clienteSeleccionado = {};
      vm.seleccionado = false;
      vm.fetch();
    },
    agregar: function agregar() {
      var vm = this;

      if (!vm.codigoClienteAgregar) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un cliente');
        return;
      }

      vm.isAdding = true;
      var obj = {
        codigoCliente: vm.codigoClienteAgregar
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/admin/cliente', obj, function (data) {
        vm.codigoClienteAgregar = '';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', '', 'Datos guardados correctamente');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isAdding = false;
      });
    },
    actualizarTodos: function actualizarTodos() {
      var vm = this;

      vm.isUpdating = true;
      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/admin/cliente/all', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', '', 'Datos actualizados correctamente');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isUpdating = false;
      });
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_not_logged_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      isLoading: false,
      showInfo: false
    };
  },

  methods: {
    goTo: function goTo(page) {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1__router_not_logged_js__["a" /* default */].push(page);
      vm.showInfo = false;
    },
    fetchRestablecerContraseña: function fetchRestablecerContraseA() {
      var vm = this;
      if (vm.email === '') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El campo de del email se encuentra vacio');
        vm.$refs.usuarioResetPassword.focus();
        return;
      }

      vm.isLoading = true;
      var obj = {
        email: vm.email,
        empresa: "reprodata"
      };

      vm.axios.post('/usuario/forgot-password-request', obj).then(function (response) {
        if (response.data.status === 1) {
          vm.showInfo = true;
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', response.data.message);
        }
        vm.isLoading = false;
      }).catch(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_not_logged_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      // username    : 'aris.sorporte.sistemas@gmail.com',
      // password    : '123456a+',
      username: '',
      password: '',
      isLoading: false,
      showPassword: false,
      shouldStayLoggedIn: true
    };
  },

  methods: {
    lowercase: function lowercase(e) {
      var vm = this;
      vm.username = e.target.value.toLowerCase();
    },
    fetchLogin: function fetchLogin() {
      var vm = this;
      if (!vm.username) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un usuario valido');
        vm.$refs.username.focus();
        return;
      }

      if (!vm.password) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un password valido');
        vm.$refs.password.focus();
        return;
      }

      vm.isLoading = true;
      var obj = {
        empresa: "reprodata",
        username: vm.username,
        password: vm.password
      };

      vm.axios.post('/usuario/login', obj).then(function (response) {
        var data = response.data;
        if (data.status) {
          localStorage.setItem('perfil', data.perfil);
          localStorage.setItem('username', data.username);
          localStorage.setItem('codigoCliente', data.codigoCliente);
          localStorage.setItem('nombre', data.nombre);
          localStorage.setItem('razonSocial', data.razonSocial);
          localStorage.setItem('entidad', data.entidad);
          localStorage.setItem('token', data.token);
          localStorage.setItem('tokenSistServer', data.tokenSistServer);
          localStorage.setItem('tokenOctopus', data.tokenOctopus);
          localStorage.setItem('esCuentaAdministrador', data.esCuentaAdministrador);
          localStorage.setItem('ruc', data.ruc);
          window.location.reload(true);
          vm.isLoading = false;
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', data.message);
          vm.isLoading = false;
        }
      }).catch(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.isLoading = false;
      });
    },
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_0__router_not_logged_js__["a" /* default */].push(page);
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_dispatcher_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__c_adjuntar_archivos__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__c_adjuntar_archivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__c_adjuntar_archivos__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nuevo_ticket_contrato',
  components: {
    'adjuntar-archivos': __WEBPACK_IMPORTED_MODULE_3__c_adjuntar_archivos___default.a
  },
  data: function data() {
    return {
      isGettingFallas: false,
      isLoadingUbigeos: false,
      isChangeCustomer: false,
      isLoadingProceso: false,
      tipoFiltroBusquedaEquipo: 'ruc',
      serieFiltro: '',
      fallas: [],
      listaInsumos: [],
      clasificacion: '',
      tiposEquipo: [],
      categoriasTicket: [{
        name: 'Incidencia con equipo',
        value: 'incidencia con equipo'
      }, {
        name: 'Solicitud de insumo',
        value: 'solicitud de insumo'
      }],
      tipoTicket: 'incidencia con equipo',
      usuario: localStorage.getItem('username'),
      perfilUsuario: localStorage.getItem('perfil'),
      ruc: localStorage.getItem('ruc'),
      nombreCliente: localStorage.getItem('razonSocial'),
      ubigeos: [],
      isGettingEquipos: false,
      modelosAgrupados: [],
      tickets: [],
      usuariosContrato: [],
      departamentos: [],
      equiposDelModelo: [],
      // modeloSeleccionado   : '',
      isLoadingDirecciones: false,
      isLoading: false,
      isLoadingCambiarRuc: false,
      rucEditCliente: 0,
      nombreEditCliente: '',
      usuarioLogged: null,
      usuarioSeleccionado: null
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchGetDataUser();
    vm.fetchUbigeos(function (err) {
      if (err) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
    });
    if (vm.ruc) {
      vm.tipoFiltroBusquedaEquipo = 'ruc';
      vm.fetchEquipos();
    }
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    modelosAgrupadosFiltrados: function modelosAgrupadosFiltrados() {
      var vm = this;
      var seriesAgregados = vm.tickets.map(function (e) {
        return e.serie;
      });
      return vm.equiposDelModelo.filter(function (e) {
        return !seriesAgregados.includes(e.serie);
      });
    }
  },
  watch: {
    tipoTicket: function tipoTicket(val) {
      var vm = this;
      for (var i = 0; i < vm.tickets.length; i++) {
        vm.tickets[i].tipo = val;
        vm.tickets[i] = vm.recalcularInsumos(vm.tickets[i]);
      }
    }
  },
  methods: {
    fetchGetDataUser: function fetchGetDataUser() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        usuario: vm.usuario
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/usuario/obtener', obj, function (data) {
        vm.usuarioLogged = data.lista[0];
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoading = true;
      });
    },
    openDialogIsChangeCustomer: function openDialogIsChangeCustomer() {
      var vm = this;
      vm.rucEditCliente = localStorage.getItem('ruc');
      vm.nombreEditCliente = localStorage.getItem('razonSocial');
      vm.isChangeCustomer = true;
    },
    closeDialogIsChangeCustomer: function closeDialogIsChangeCustomer() {
      var vm = this;
      vm.rucEditCliente = 0;
      vm.nombreEditCliente = '';
      vm.isChangeCustomer = false;
    },
    limpiarModelo: function limpiarModelo() {
      var vm = this;
      vm.equiposDelModelo = [];
    },
    fetchEquipos: function fetchEquipos() {
      var vm = this;
      if (vm.tipoFiltroBusquedaEquipo === 'ruc' && !vm.ruc) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El numero de ruc es invalido');
      if (vm.tipoFiltroBusquedaEquipo === 'serie' && !vm.serieFiltro) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El codigo de la serie es invalido');
      vm.isGettingEquipos = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo listado de equipos' });
      var obj = {
        ruc: vm.ruc,
        serie: vm.serieFiltro
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/cliente/serie/agrupado/all', obj, function (data) {
        vm.modelosAgrupados = data.equiposAgrupados;
        var rucFilter = vm.tipoFiltroBusquedaEquipo === 'ruc' ? vm.ruc : data.ruc;
        vm.verificarUsuarioAntesCrearTicket(rucFilter, function (err, usuarios) {
          if (err) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
            vm.isLoadingProceso = false;
            return;
          }

          vm.usuariosContrato = usuarios;
          vm.usuarioSeleccionado = usuarios[0].usuario;

          if (vm.tipoFiltroBusquedaEquipo === 'serie' && vm.modelosAgrupados.length) {
            vm.equiposDelModelo = vm.modelosAgrupados[0].equipos;
            vm.agregarNuevoTicket(vm.equiposDelModelo[0]);
          }
          vm.isGettingEquipos = false;
          vm.$store.dispatch('transaccion', { isProceso: false });
        });
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.isGettingEquipos = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
      }, function () {});
    },
    verificarUsuarioAntesCrearTicket: function verificarUsuarioAntesCrearTicket(ruc, callback) {
      var vm = this;
      var obj = {
        ruc: ruc
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/usuario/obtener/por/ruc', obj, function (data) {
        callback(null, data.usuarios || []);
      }, function (error) {
        callback(error);
      });
    },
    fetchUbigeos: function fetchUbigeos(callback) {
      var vm = this;
      vm.isLoadingUbigeos = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/ubigeo/obtener', obj, function (data) {
        vm.ubigeos = data.lista;
        for (var i = 0; i < data.lista.length; i++) {
          if (!vm.departamentos.includes(data.lista[i].departamento)) vm.departamentos.push(data.lista[i].departamento);
        }
        callback && callback();
      }, function (error) {
        callback ? callback(error) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingUbigeos = false;
      });
    },
    rellenarInformacion: function rellenarInformacion(tipo, index) {
      var vm = this;
      if (tipo === 'departamento') {
        vm.tickets[index].provincias = [];
        vm.tickets[index].provincia = '';
        vm.tickets[index].distritos = [];
        vm.tickets[index].distrito = '';
      } else if (tipo === 'provincia') {
        vm.tickets[index].distritos = [];
        vm.tickets[index].distrito = '';
      }

      for (var i = 0; i < vm.ubigeos.length; i++) {
        if (tipo === 'departamento') {
          if (vm.tickets[index].departamento === vm.ubigeos[i].departamento) {
            vm.tickets[index].provincias.push(vm.ubigeos[i].provincia);
          }
        } else if (tipo === 'provincia') {
          if (vm.tickets[index].provincia === vm.ubigeos[i].provincia) {
            vm.tickets[index].distritos.push(vm.ubigeos[i].distrito);
          }
        }
      }

      if (vm.tickets[index].departamento && vm.tickets[index].provincia && vm.tickets[index].distrito) {
        vm.tickets[index].ubigeo = vm.ubigeos.find(function (e) {
          return e.descripcion === vm.tickets[index].departamento + '-' + vm.tickets[index].provincia + '-' + vm.tickets[index].distrito;
        }).ubigeo;
      } else vm.tickets[index].ubigeo = '';
    },
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_1__router_dispatcher_js__["a" /* default */].push(page);
    },
    fetchFallas: function fetchFallas(tipoProductoMaquina) {
      var vm = this;
      vm.isGettingFallas = true;
      var obj = {
        codigoTipoEquipo: tipoProductoMaquina
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/falla/por/tipo/producto', obj, function (data) {
        vm.fallas = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isGettingFallas = false;
      });
    },
    procesoGenerarTickets: function procesoGenerarTickets() {
      var vm = this;
      vm.isLoadingProceso = true;
      vm.validarValoresAntesGenerarTicket(function () {
        vm.$store.dispatch('transaccion', { isProceso: true, message: 'Generando tickets datos...' });
        vm.guardarTicketRecursivo(0, function (err) {
          if (err) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
            vm.$store.dispatch('transaccion', { isProceso: false });
            vm.isLoadingProceso = false;
            return;
          }

          vm.isLoadingProceso = false;
          vm.$store.dispatch('transaccion', { isProceso: false });

          if (vm.tickets.length === 1) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'El ticket  se generó correctamente');
            vm.goTo('/ticket/' + vm.tickets[0].numero);
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los tickets se generarón correctamente');
            vm.goTo('/tickets');
          }
        });
      });
    },
    guardarTicketRecursivo: function guardarTicketRecursivo(index, callback) {
      var vm = this;
      vm.fetchGuardarTicket(vm.tickets[index], function (err, response) {
        if (err) callback(err);else {
          vm.tickets[index].numero = response.numero;
          index++;
          if (index === vm.tickets.length) callback(null);else vm.guardarTicketRecursivo(index, callback);
        }
      });
    },
    fetchGuardarTicket: function fetchGuardarTicket(ticket, callback) {
      var vm = this;
      var obj = {
        ticket: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, ticket, {
          usuario: vm.usuarioSeleccionado,
          insumo: ticket.insumo.filter(function (e) {
            return e.active;
          }).map(function (e) {
            return e.name;
          })
        }),
        isGenerarIT: vm.perfilUsuario !== 'dispatcher',
        isPlantilla: vm.perfilUsuario === 'dispatcher' ? 1 : 0
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/ticket/registrar', obj, function (data) {
        callback(null, data);
      }, function (error) {
        callback(error);
      });
    },
    validarValoresAntesGenerarTicket: function validarValoresAntesGenerarTicket(callback) {
      var vm = this;
      for (var i = 0; i < vm.tickets.length; i++) {
        var ticket = vm.tickets[i];
        vm.tickets[i].tipo = vm.tipoTicket;

        if (!ticket.tipo) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Para la serie ' + ticket.serie + ', Por favor seleccione una categoria para el ticket');
          vm.isLoadingProceso = false;
          return;
        }

        if (!ticket.serie) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Para la serie ' + ticket.serie + ', Por favor seleccione una serie');
          vm.isLoadingProceso = false;
          return;
        }

        if (ticket.tipo === 'incidencia con equipo') {
          if (!ticket.falla.codigoFallaGeneral) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Para la serie ' + ticket.serie + ', Por favor seleccione una falla');
            vm.isLoadingProceso = false;
            return;
          }
        }

        if (ticket.tipo === 'solicitud de insumo') {
          if (!ticket.direccion) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Para la serie ' + ticket.serie + ', Por favor ingrese una direccion para el destino del insumo');
            vm.isLoadingProceso = false;
            return;
          }
          if (!ticket.departamento) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Para la serie ' + ticket.serie + ', Por favor seleccione un departamento');
            vm.isLoadingProceso = false;
            return;
          }
          if (!ticket.provincia) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Para la serie ' + ticket.serie + ', Por favor seleccione una provincia');
            vm.isLoadingProceso = false;
            return;
          }
          if (!ticket.distrito) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Para la serie ' + ticket.serie + ', Por favor seleccione un distrito');
            vm.isLoadingProceso = false;
            return;
          }
          if (!ticket.nombreContacto) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Para la serie ' + ticket.serie + ', Por favor ingrese el nombre de un contacto para recepcionar los insumos.');
            vm.isLoadingProceso = false;
            return;
          }
          if (!ticket.numeroTelefono) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Para la serie ' + ticket.serie + ', Por favor ingrese el numero de telefono del contacto para recepcionar los insumos.');
            vm.isLoadingProceso = false;
            return;
          }
        }
      }
      callback && callback();
    },
    clearSerie: function clearSerie() {
      var vm = this;
      vm.ticket.serie = '';
      vm.ticket.tipoProductoMaquina = '';
      vm.ticket.descripcionTipoEquipo = '';
      vm.fallas = [];
    },
    limpiarSerie: function limpiarSerie() {
      var vm = this;
      vm.$emit('clear');
    },
    eliminarItemSerie: function eliminarItemSerie(index) {
      var vm = this;
      vm.tickets = vm.tickets.filter(function (e, i) {
        return i !== index;
      });
    },
    agregarNuevoTicket: function agregarNuevoTicket(serieSeleccionado) {
      var vm = this;
      var nuevaSerie = {};
      nuevaSerie.tipo = vm.tipoTicket;
      nuevaSerie.active = true;
      nuevaSerie.insumo = [];
      nuevaSerie.serie = serieSeleccionado.serie;
      nuevaSerie.modelo = serieSeleccionado.modelo;
      nuevaSerie.descripcion = serieSeleccionado.descripcionArticulo;
      nuevaSerie.direccion = serieSeleccionado.direccionMaquina;
      nuevaSerie.clasificacion = '';
      nuevaSerie.ubigeo = serieSeleccionado.ubigeo;
      nuevaSerie.esColor = serieSeleccionado.esColor;
      nuevaSerie.codigoArticuloSap = serieSeleccionado.codigoArticuloSap;
      nuevaSerie.incluyePapel = serieSeleccionado.incluyePapel;
      nuevaSerie.numeroContrato = serieSeleccionado.numeroContrato;
      nuevaSerie.departamentos = vm.departamentos;
      nuevaSerie.provincias = [];
      nuevaSerie.distritos = [];
      nuevaSerie.departamento = '';
      nuevaSerie.falla = {
        codigoFallaGeneral: 0,
        descripcionFallaGeneral: ''
      };
      nuevaSerie.provincia = '';
      nuevaSerie.distrito = '';
      nuevaSerie.grupoPedidoInsumo = 'consumible';
      nuevaSerie.tipoProductoMaquina = serieSeleccionado.codigoArticuloSap ? serieSeleccionado.codigoArticuloSap.substring(0, 2) : '';

      if (serieSeleccionado.descripcionUbigeoMaquina) {
        var ubigeoEquipo = vm.ubigeos.find(function (e) {
          return e.descripcion === serieSeleccionado.descripcionUbigeoMaquina;
        });
        if (ubigeoEquipo) {
          nuevaSerie.departamento = ubigeoEquipo.departamento;
          nuevaSerie.provincia = ubigeoEquipo.provincia;
          nuevaSerie.distrito = ubigeoEquipo.distrito;

          nuevaSerie.provincias = vm.ubigeos.filter(function (e) {
            return e.departamento === nuevaSerie.departamento;
          }).map(function (e) {
            return e.provincia;
          });
          nuevaSerie.distritos = vm.ubigeos.filter(function (e) {
            return e.provincia === nuevaSerie.provincia;
          }).map(function (e) {
            return e.distrito;
          });
        }
      }

      vm.fetchFallas(nuevaSerie.tipoProductoMaquina);
      var nuevaSerieConInsumo = vm.recalcularInsumos(nuevaSerie);
      vm.tickets.push(nuevaSerieConInsumo);
      vm.limpiarSerie();
    },
    recalcularInsumos: function recalcularInsumos(ticket) {
      ticket.insumo = [];
      if (ticket.tipo === 'solicitud de insumo') {
        if (ticket.grupoPedidoInsumo === 'papel') {
          ticket.insumo = [{
            name: 'PAPEL',
            code: 'papel',
            active: true
          }];
          return ticket;
        } else {
          if (['CF'].includes(ticket.tipoProductoMaquina)) {
            ticket.clasificacion = 'cafetera';
            ticket.insumo = [{
              name: 'BOLSA DE CAFE',
              code: 'bolsa de cafe',
              active: true
            }];
          } else if (['ML', 'MT', 'PD', 'FA'].includes(ticket.tipoProductoMaquina)) {
            ticket.clasificacion = 'multifuncional';
            if (!ticket.esColor) {
              ticket.insumo.push({
                name: 'TONER COLOR - CYAN (C)',
                code: 'toner color cyan',
                active: true
              }, {
                name: 'TONER COLOR - MAGENTA (M)',
                code: 'toner color magenta',
                active: true
              }, {
                name: 'TONER COLOR - AMARILLO (Y)',
                code: 'toner color amarillo',
                active: true
              });
            }
            ticket.insumo.push({
              name: 'TONER COLOR - NEGRO (K)',
              code: 'toner color negro',
              active: true
            });
          }
          return ticket;
        }
      } else {
        return ticket;
      }
    },
    fetchCambiarRUCCuenta: function fetchCambiarRUCCuenta() {
      var isGuardar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var vm = this;
      if (isNaN(vm.ruc)) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El numero de RUC, es invalido.');
      }

      if (vm.ruc.length < 11) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El numero de RUC no puede tener menos de 11 digitos.');
      }

      if (vm.ruc.length > 11) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El numero de RUC no puede tener mas de 11 digitos.');
      }

      if (vm.ruc === vm.rucEditCliente) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El numero de RUC ya se encuentra asignado a la cuenta.');
      }

      vm.isLoadingCambiarRuc = true;
      var obj = {
        ruc: vm.rucEditCliente,
        isGuardar: isGuardar
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/usuario/actualizar/ruc', obj, function (data) {
        if (isGuardar) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los datos del cliente se cambiaron correctamente.');
          localStorage.setItem('codigoCliente', data.cliente.codigoCliente);
          localStorage.setItem('razonSocial', data.cliente.razonSocial);
          localStorage.setItem('ruc', data.cliente.ruc);
          vm.closeDialogIsChangeCustomer();
          window.location.reload();
        } else {
          vm.nombreEditCliente = data.cliente.razonSocial;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingCambiarRuc = false;
      });
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_customer_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__c_adjuntar_archivos__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__c_adjuntar_archivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__c_adjuntar_archivos__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nuevo_ticket',
  components: {
    'adjuntar-archivos': __WEBPACK_IMPORTED_MODULE_5__c_adjuntar_archivos___default.a
  },
  data: function data() {
    return {
      isContrato: false,
      isGettingFallas: false,
      fallas: [],
      isSuccessfullyCreated: false,
      isGettingTiposEquipo: false,
      tiposEquipo: [],
      marcas: [],
      files: [],
      filesUploads: [],
      tiposInforme: [{
        name: 'Mantenimiento Preventivo',
        value: 1
      }, {
        name: 'Falla en el equipo',
        value: 2
      }, {
        name: 'Otros',
        value: 3
      }],
      acciones: [{
        name: 'He comprado mi equipo aqui',
        value: 1
      }, {
        name: 'No he comprado el equipo aqui',
        value: 0
      }],
      ticket: {
        tipo: 'garantia',
        tipoInforme: 1,
        serie: '',
        falla: {},
        comentarioFalla: '',
        comentarioGeneral: '',
        files: [],
        sigueEnGarantia: false,
        numeroFactura: '',
        tipoEquipo: {},
        marca: '',
        modelo: '',
        comproAqui: 1,
        departamente: '',
        provincia: '',
        distrito: '',
        ubigeo: '',
        categoria: 'garantia'
      },
      perfilUsuario: localStorage.getItem('perfil'),
      departamentos: [],
      provincias: [],
      distritos: [],
      ubigeos: [],
      isLoadingDepartamentos: false,
      isLoadingProvincias: false,
      isLoadingDistritos: false,
      isLoadingUbigeos: false
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchUbigeos(false, function (err) {
      if (err) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un numero de RUC');
    });
    vm.fetchGetDataMarcas();
    vm.fetchTiposEquipo();
  },

  watch: {
    'ticket.tipo': function ticketTipo(tipo) {
      var vm = this;
      if (tipo === 'garantia') {
        vm.fetchTiposEquipo();
      }
    }
  },
  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    fetchFallas: function fetchFallas(tipoEquipo) {
      console.log('tipoEquipo', tipoEquipo);
      var vm = this;
      vm.isGettingFallas = true;
      var obj = {
        codigoTipoEquipo: tipoEquipo.codigo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["c" /* apiGet */])(vm, '/falla/por/tipo/equipo', obj, function (data) {
        vm.fallas = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isGettingFallas = false;
      });
    },
    fetchGetDataMarcas: function fetchGetDataMarcas() {
      var vm = this;
      var obj = {
        octopus: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["c" /* apiGet */])(vm, '/articulo/marca-articulo', obj, function (data) {
        vm.marcas = data.lista;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    rellenarInformacion: function rellenarInformacion(tipo) {
      var vm = this;
      if (tipo === 'departamento') {
        vm.provincias = [];
        vm.ticket.provincia = '';
        vm.distritos = [];
        vm.ticket.distrito = '';
      } else if (tipo === 'provincia') {
        vm.distritos = [];
        vm.ticket.distrito = '';
      }

      for (var i = 0; i < vm.ubigeos.length; i++) {
        if (tipo === 'departamento') {
          if (vm.ticket.departamento === vm.ubigeos[i].departamento) {
            vm.provincias.push(vm.ubigeos[i].provincia);
          }
        } else if (tipo === 'provincia') {
          if (vm.ticket.provincia === vm.ubigeos[i].provincia) {
            vm.distritos.push(vm.ubigeos[i].distrito);
          }
        }
      }

      if (vm.ticket.departamento && vm.ticket.provincia && vm.ticket.distrito) {
        vm.ticket.ubigeo = vm.ubigeos.find(function (e) {
          return e.descripcion === vm.ticket.departamento + '-' + vm.ticket.provincia + '-' + vm.ticket.distrito;
        }).ubigeo;
      } else vm.ticket.ubigeo = '';
    },
    fetchUbigeos: function fetchUbigeos(ingresoUbigeo, callback) {
      var vm = this;
      vm.isLoadingUbigeos = true;
      var obj = {
        codigo: vm.ticket.ubigeo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["c" /* apiGet */])(vm, '/ubigeo/obtener', obj, function (data) {
        if (ingresoUbigeo) {
          var lista = data.lista[0];
          for (var j = 0; j < vm.ubigeos.length; j++) {
            if (lista.departamento === vm.ubigeos[j].departamento) {
              vm.provincias.push(vm.ubigeos[j].provincia);
            }

            if (lista.provincia === vm.ubigeos[j].provincia) {
              vm.distritos.push(vm.ubigeos[j].distrito);
            }
          }
          vm.ticket.departamento = lista.departamento;
          vm.ticket.provincia = lista.provincia;
          vm.ticket.distrito = lista.distrito;
        } else {
          vm.ubigeos = data.lista;
          for (var i = 0; i < data.lista.length; i++) {
            vm.departamentos.push(data.lista[i].departamento);
          }
        }
        callback && callback();
      }, function (error) {
        callback ? callback(error) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingUbigeos = false;
      });
    },
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_3__router_customer_js__["a" /* default */].push(page);
    },

    // fetchFallas () {
    //   var vm = this
    //   vm.isGettingFallas = true
    //   var obj = {
    //     codigoTipoEquipo: vm.ticket.tipoEquipo.codigo
    //   }
    //   apiGet(vm, '/falla_tipo_equipo/lista', obj, function (data) {
    //     vm.fallas = data.lista
    //   }, function (error) {
    //     notify(vm, 'error', 'Error', error.message)
    //   }, function () {
    //     vm.isGettingFallas = false
    //   })
    // },
    fetchGuardarTicket: function fetchGuardarTicket() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vm, obj;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this;

                if (!(vm.ticket.tipo === 'garantia' && vm.ticket.sigueEnGarantia && !vm.ticket.numeroFactura && vm.ticket.comproAqui)) {
                  _context.next = 5;
                  break;
                }

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor Ingrese el numero de factura o boleta');
                vm.$refs.numeroFactura.focus();
                return _context.abrupt('return');

              case 5:
                if (!(vm.ticket.tipo === 'garantia' && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(vm.ticket.tipoEquipo).length)) {
                  _context.next = 8;
                  break;
                }

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor seleccione un tipo de equipo');
                return _context.abrupt('return');

              case 8:
                if (!(vm.ticket.tipo === 'garantia' && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(vm.ticket.falla).length)) {
                  _context.next = 11;
                  break;
                }

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor seleccione una falla');
                return _context.abrupt('return');

              case 11:

                vm.ticket.sigueEnGarantia = vm.ticket.sigueEnGarantia ? 1 : 0;
                _context.next = 14;
                return vm.$refs.archivos.getFiles();

              case 14:
                vm.files = _context.sent;

                if (!(vm.ticket.tipo === 'garantia' && vm.ticket.comproAqui && vm.ticket.sigueEnGarantia && !vm.files.length)) {
                  _context.next = 18;
                  break;
                }

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Es requerido adjuntar la boleta o factura, use la opción de adjuntar que se encuentra en la parte inferior de este formulario.');
                return _context.abrupt('return');

              case 18:

                vm.$store.dispatch('transaccion', { isProceso: true, message: 'Generando ticket' });
                obj = {
                  ticket: vm.ticket
                };


                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["a" /* apiPost */])(vm, '/ticket/registrar', obj, function (data) {
                  if (data.numero) {
                    vm.ticket.numero = data.numero;
                    if (vm.files.length) vm.fetchUploadsFiles();else {
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'El ticket se creo correctamente');
                      vm.goTo('/ticket/' + vm.ticket.numero);
                    }
                  }
                }, function (error) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
                  vm.$store.dispatch('transaccion', { isProceso: false });
                });

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setearSerie: function setearSerie(equipo) {
      var vm = this;
      vm.ticket.serie = equipo.serie;
      vm.ticket.modelo = equipo.modelo;
      vm.ticket.descripcion = equipo.descripcionArticulo;
      vm.ticket.tipoEquipo = {
        codigo: 99,
        descripcion: ''
        // codigo     : equipo.codigoTipoEquipo || '',
        // descripcion: equipo.descripcionTipoEquipo  || ''
      };
      vm.fetchFallas();
    },
    clearSerie: function clearSerie() {
      var vm = this;
      vm.ticket.serie = '';
      vm.ticket.tipoEquipo = {};
      vm.fallas = [];
    },
    fetchTiposEquipo: function fetchTiposEquipo() {
      var vm = this;
      vm.isGettingTiposEquipo = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["c" /* apiGet */])(vm, '/tipo_equipo/lista', obj, function (data) {
        // data.lista.pop();
        console.log('data.lista', data.lista);
        vm.tiposEquipo = data.lista;
      }, function (error) {
        alert('error:' + error.message);
      }, function () {
        vm.isGettingTiposEquipo = false;
      });
    },
    fetchUploadsFiles: function fetchUploadsFiles() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Adjuntando archivos al ticket' });
      vm.fileUploadRecursivo(0, function (err) {
        if (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
          vm.$store.dispatch('transaccion', { isProceso: false });
          return;
        }

        vm.files = [];
        vm.filesUploads = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'El ticket se creo correctamente');
        vm.$store.dispatch('transaccion', { isProceso: false });
        vm.goTo('/ticket/' + vm.ticket.numero);
      });
    },
    fileUploadRecursivo: function fileUploadRecursivo(index, callback) {
      var _this2 = this;

      var vm = this;
      vm.uploadFile(vm.files[index], function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(err, response) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (err) {
                    callback(err);
                  } else {
                    vm.fetchInsertarActividad(response, function (err) {
                      if (err) callback(err);else {
                        index++;
                        if (index === vm.files.length) callback(null);else vm.fileUploadRecursivo(index, callback);
                      }
                    });
                  }

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    fetchInsertarActividad: function fetchInsertarActividad(adjunto, callback) {
      var vm = this;
      var obj = {
        numero: vm.ticket.numero,
        tipo: 'adjunto',
        contenido: adjunto.ruta,
        nombreAdjunto: adjunto.archivo,
        tipoAdjunto: adjunto.mimetype,
        noEnviarEmail: 1
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["a" /* apiPost */])(vm, '/ticket/registrar/actividad', obj, function (data) {
        callback && callback(null);
      }, function (error) {
        callback && callback(error);
      });
    },
    uploadFile: function uploadFile(file, callback) {
      var vm = this;
      var fd = new FormData();
      var apiUploadRoute = "https://api-sil.datacont.com";
      var url = apiUploadRoute + '/upload';
      fd.append('file', file);
      var params = {
        carpeta: 'actividades',
        usuario: localStorage.getItem('usuario')
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["d" /* apiUploadWithParams */])(vm, url, fd, params, function (res) {
        callback(null, res);
      }, function (err) {
        callback(err);
      });
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_not_logged_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Register_user',
  data: function data() {
    return {
      nombre: '',
      username: '',
      password: '',
      ruc: '',
      direccion: '',
      isLoading: false,
      showPassword: false,
      showPassword1: false,
      aceptaPoliticasDePrivacidad: true,
      tipoUsuario: 'usuario',
      tiposUsuario: [{
        name: 'No tengo contrato',
        value: 'usuario'
      }, {
        name: 'Tengo un contrato',
        value: 'usuario-contrato'
      }]
    };
  },

  computed: {
    progress: function progress() {
      var vm = this;
      return Math.min(100, vm.password.length * 16.7);
    },
    color: function color() {
      var vm = this;
      return ['error', 'warning', 'success'][Math.floor(vm.progress / 40)];
    }
  },
  methods: {
    uppercase: function uppercase(e) {
      var vm = this;
      vm.nombre = e.target.value.toUpperCase();
    },
    lowercase: function lowercase(e) {
      var vm = this;
      vm.username = e.target.value.toLowerCase();
    },
    validateEmail: function validateEmail(email) {
      return (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      );
    },
    fetchLogin: function fetchLogin() {
      var vm = this;
      var obj = {
        empresa: "reprodata",
        username: vm.username,
        password: vm.password
      };

      vm.axios.post('/usuario/login', obj).then(function (response) {
        var data = response.data;
        if (data.status) {
          localStorage.setItem('perfil', data.perfil);
          localStorage.setItem('username', data.username);
          localStorage.setItem('codigoCliente', data.codigoCliente);
          localStorage.setItem('nombre', data.nombre);
          localStorage.setItem('razonSocial', data.razonSocial);
          localStorage.setItem('entidad', data.entidad);
          localStorage.setItem('token', data.token);
          // vm.goTo('/ticket')
          window.location.reload(true);
          // vm.$store.dispatch('transaccion', {isProceso : false})
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', data.message);
          vm.isLoading = false;
        }
      }).catch(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    fetchGetDatosSunat: function fetchGetDatosSunat() {
      var vm = this;

      if (!vm.ruc) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un numero de RUC');
        vm.$refs.ruc.focus();
        return;
      }
      vm.nombre = '';
      vm.direccion = '';
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo información de SUNAT' });
      var obj = {
        ruc: vm.ruc
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/cliente/sunat', obj, function (data) {
        console.log('data', data);
        if (data.empresa) {
          vm.nombre = data.empresa.nombre_o_razon_social;
          vm.direccion = data.empresa.direccion;
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchRegistrarme: function fetchRegistrarme() {
      var vm = this;
      var url = '/usuario/registrar';
      if (vm.tipoUsuario === 'usuario-contrato' && !vm.ruc) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El RUC de la empresa es  requerido.');
        vm.$refs.ruc.focus();
        return;
      }

      if (!vm.nombre) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un nombre u razon social valido');
        vm.$refs.nombre.focus();
        return;
      }

      if (!vm.username) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un email valido');
        vm.$refs.username.focus();
        return;
      }

      if (vm.username) {
        if (!vm.validateEmail(vm.username)) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El email no cumple con el formato adecuado');
          vm.$refs.username.focus();
          return;
        }
      }

      if (!vm.password) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un password valido');
        vm.$refs.password.focus();
        return;
      }

      if (vm.password && vm.progress < 100) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'La contraseña debe de tener como minimo 6 caracteres');
        vm.$refs.password.focus();
        return;
      }

      vm.isLoading = true;
      var obj = {
        nombre: vm.nombre,
        username: vm.username,
        password: vm.password,
        aceptaPoliticasDePrivacidad: vm.aceptaPoliticasDePrivacidad ? 1 : 0,
        ruc: vm.ruc,
        tipoUsuario: vm.tipoUsuario
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, url, obj, function (data) {
        vm.fetchLogin();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.isLoading = false;
      });
    },
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_0__router_not_logged_js__["a" /* default */].push(page);
    },
    redirectProteccion: function redirectProteccion() {
      // var vm = this
      window.open('https://www.minjus.gob.pe/wp-content/uploads/2013/04/LEY-29733.pdf', '_blanck');
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_not_logged_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isLoading: true,
      token: localStorage.getItem('token')
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchActivateEmail();
  },

  methods: {
    fetchActivateEmail: function fetchActivateEmail() {
      var vm = this;
      var obj = {
        email: vm.$route.query.email,
        tokenVerify: vm.$route.query.verify
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/usuario/verificar/email', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Tu cuenta fue activada correctamente');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.goTo('/');
      });
    },
    goTo: function goTo(page) {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0__router_not_logged_js__["a" /* default */].push(page);
      vm.token && vm.$router.go();
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Cliente_List__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Cliente_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Cliente_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Cliente_Contact_List__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Cliente_Contact_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Cliente_Contact_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Cliente_Equipo_List__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Cliente_Equipo_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Cliente_Equipo_List__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'client_admin',
  components: {
    ClientList: __WEBPACK_IMPORTED_MODULE_0__Component_Cliente_List___default.a,
    ClientContactList: __WEBPACK_IMPORTED_MODULE_1__Component_Cliente_Contact_List___default.a,
    ClientEquipoList: __WEBPACK_IMPORTED_MODULE_2__Component_Cliente_Equipo_List___default.a
  },
  data: function data() {
    return {
      empresa: "reprodata",
      empresa_full: "Reprodata S.A.C.",
      clienteSeleccionado: {},
      seleccionado: false
    };
  },
  created: function created() {},

  methods: {
    selected: function selected(cliente) {
      this.clienteSeleccionado.codigo = cliente.codigo;
      this.clienteSeleccionado.nombre = cliente.nombre;
      this.seleccionado = true;
    },
    deselected: function deselected(cliente) {
      this.clienteSeleccionado = {};
      this.seleccionado = false;
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_not_logged_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'forgot-password-post-request',
  data: function data() {
    return {
      newPassword: '',
      repeatNewPassword: '',
      isLoading: false,
      showPassword: false,
      showPassword1: false
    };
  },

  methods: {
    restablecer: function restablecer() {
      var vm = this;
      if (!vm.newPassword || !vm.repeatNewPassword) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese la nueva contraseña dos veces');
        vm.$refs.password.focus();
        return;
      }

      if (vm.newPassword !== vm.repeatNewPassword) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Las contraseñas deben ser iguales');
        vm.$refs.password1.focus();
        return;
      }
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'actualizando contraseña' });
      var obj = {
        newPassword: vm.newPassword,
        email: vm.$route.query.email,
        resetToken: vm.$route.query.resettoken
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/usuario/forgot-password-post', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Contraseña cambiada con exito');
        // setTimeout(function () {
        //   window.location.href = '/login'
        // }, 500)
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_0__router_not_logged_js__["a" /* default */].push(page);
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_preview_files__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_preview_files___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__c_preview_files__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_adjuntar_archivos',
  props: {
    modeInsert: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    isSetProfile: {
      type: Boolean,
      default: false
    },
    extensions: {
      type: Array
    },
    label: {
      type: String,
      default: 'Enviar archivos'
    },
    accept: {
      type: Array
    }
  },
  components: {
    'preview-files': __WEBPACK_IMPORTED_MODULE_1__c_preview_files___default.a
  },
  data: function data() {
    return {
      showLista: false,
      files: [],
      tab: 0,
      maxSize: 1024 * 1024 * 30,
      name: 'adjuntar_archivo_ticket',
      extensionsAllow: this.extensions || ['pdf', 'png', 'jpg', 'jpeg', 'docx', 'xlsx', 'pptx', 'txt', 'html', 'exe', 'doc', 'mp4']
    };
  },
  mounted: function mounted() {
    var vm = this;
    window.addEventListener('paste', vm.uploadClipBoard);
    vm.create();
    vm.$forceUpdate();
  },
  beforeDestroy: function beforeDestroy() {
    var vm = this;
    window.removeEventListener('paste', vm.uploadClipBoard);
    vm.$upload.off(vm.name);
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  filters: {
    mb: function mb(v) {
      return v / 1024 / 1024;
    }
  },
  methods: {
    volverASeleccionar: function volverASeleccionar() {
      var vm = this;
      if (vm.multiple) {} else {
        vm.files = [];
      }
      vm.tab = 0;
    },
    sendFilesToSave: function sendFilesToSave() {
      var vm = this;
      if (vm.$upload.errors(vm.name).length) {
        if (vm.$upload.errors(vm.name)[0].code === 'file-max-size') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El archivo ' + vm.$upload.errors(vm.name)[0].file.name + ' sobrepasa el peso maximo que es 5MB');
          return;
        }
        if (vm.$upload.errors(vm.name)[0].code === 'file-extension') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El archivo ' + vm.$upload.errors(vm.name)[0].file.name + ' tiene una extencion no permitida');
          return;
        }
      } else vm.$emit('save', vm.files);
      // } else vm.$emit('save', vm.files)
    },
    removeFile: function removeFile(objFile) {
      var vm = this;
      if (vm.$upload.errors(vm.name).length) {
        for (var i = 0; i < vm.$upload.errors(vm.name).length; i++) {
          var file = vm.$upload.errors(vm.name)[i];
          if (objFile.name === file.file.name) {
            file.clear();
          }
        }
      }
    },
    create: function create() {
      var _this = this;

      var vm = this;
      vm.$upload.on(vm.name, {
        extensions: vm.extensionsAllow,
        maxSizePerFile: vm.maxSize,
        dropzoneId: 'dropzone',
        startOnSelect: false,
        multiple: vm.multiple,
        accept: vm.accept || ['*'],
        invalidExtensionMsg: 'El archivo no tiene una extencion no permitida',
        maxFileSizeMsg: 'Máximo de {max}MB por archivo',
        http: function http(data) {
          console.log('IM IN THE HTTP METHOD', data);
        },
        onSelect: function onSelect(files, res) {
          for (var i = 0; i < files.length; i++) {
            if (vm.multiple) vm.files.push(files[i]);else {
              vm.files.push(files[i]);
            }
          }
          vm.tab = 1;
        },
        onProgress: function onProgress(file, res) {
          console.log('onProgress');
          console.log(file);
          console.log(res);
        },

        onSuccess: function onSuccess(file, res) {
          console.log('onSuccess');
          console.log(file);
          console.log(res);
          _this.file = res.data.data;
        },
        onError: function onError(file, res) {
          console.log('onError');
          console.log(file);
          console.log(res);
          console.log(vm.$upload.errors(vm.name));
        },
        onEnd: function onEnd(files, res) {
          console.log('onEnd');
        }
      });
    },
    select: function select() {
      var vm = this;
      vm.$upload.select(vm.name);
    },
    uploadClipBoard: function uploadClipBoard(e) {
      var vm = this;
      if (e.clipboardData && e.clipboardData.items) {
        var ele = e.clipboardData.items;
        for (var i = 0; i < ele.length; ++i) {
          if (ele[i].kind === 'file' && ele[i].type.indexOf('image/') !== -1) {
            var blob = ele[i].getAsFile();
            vm.files.push(blob);
            vm.tab = 1;
          }
        }
      } else {
        return;
      }
    },
    close: function close() {
      var vm = this;
      vm.$emit('close');
    },
    getFiles: function getFiles() {
      var vm = this;
      return vm.files;
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  nem: 'c_avatar_perfil',
  props: {
    path: {
      type: String,
      default: ''
    },
    gradient: {
      type: Boolean,
      default: false
    },
    isFetch: {
      type: Boolean,
      default: false
    },
    usuario: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isLoading: false,
      urlImage: this.path || '/static/nobody.jpg'
    };
  },
  created: function created() {
    var vm = this;
    if (vm.isFetch) {
      vm.fetchGetDataUser();
    }
  },

  watch: {
    path: function path(val) {
      var vm = this;
      vm.urlImage = val || '/static/nobody.jpg';
    },
    usuario: function usuario(val) {
      var vm = this;
      console.log(val);
      vm.fetchGetDataUser();
    }
  },
  methods: {
    fetchGetDataUser: function fetchGetDataUser() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        usuario: vm.usuario
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/usuario/obtener', obj, function (data) {
        vm.urlImage = data.lista[0].foto || '/static/nobody.jpg';
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_chart_bar_tickets_en_recall__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_chart_bar_tickets_en_recall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__c_chart_bar_tickets_en_recall__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_item_ticket_lista__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_item_ticket_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__c_item_ticket_lista__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_card_chart_bar_tickets_en_recall',
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_1__c_chart_bar_tickets_en_recall___default.a,
    'ticket-summary-info': __WEBPACK_IMPORTED_MODULE_2__c_item_ticket_lista___default.a
  },
  props: {
    tipo: {
      type: String,
      default: 'garantia'
    },
    count: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      reveal: false,
      isLoading: false,
      renderChart: true,
      serieRecall: '',
      incluirCerrados: false,
      ticketsEnRecall: [],
      cantidadTicketsEnRecall: 0
    };
  },

  methods: {
    obtenerCantidad: function obtenerCantidad(count) {
      var vm = this;
      vm.cantidadTicketsEnRecall = count;
    },
    obtenerSeleccionado: function obtenerSeleccionado(item) {
      var vm = this;
      vm.serieRecall = item;
      vm.fetchTicketsDeSerieEnRecall();
      vm.reveal = true;
    },
    fetchTicketsDeSerieEnRecall: function fetchTicketsDeSerieEnRecall() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        tipo: vm.tipo.toLowerCase(),
        incluirCerrados: vm.incluirCerrados ? 1 : 0,
        serie: vm.serieRecall
      };
      console.log('obj', obj);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/ticket/abiertos/count/recall', obj, function (data) {
        vm.ticketsEnRecall = data.data;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    reRenderChart: function reRenderChart() {
      var vm = this;
      vm.renderChart = false;
      vm.$nextTick(function () {
        vm.renderChart = true;
      });
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_chart_pie_tickets_pendientes_por_asesor__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_chart_pie_tickets_pendientes_por_asesor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__c_chart_pie_tickets_pendientes_por_asesor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_card_chart_bar_tickets_pendientes_por_asesor',
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_2__c_chart_pie_tickets_pendientes_por_asesor___default.a
  },
  props: {
    tipo: {
      type: String,
      default: 'garantia'
    },
    tipoArea: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isLoading: false,
      renderChart: false,
      headers: [{ text: '', value: 'periodo' }, { text: 'Ene', value: 'Ene' }, { text: 'Feb', value: 'Feb' }, { text: 'Mar', value: 'Mar' }, { text: 'Abr', value: 'Abr' }, { text: 'May', value: 'May' }, { text: 'Jun', value: 'Jun' }, { text: 'Jul', value: 'Jul' }, { text: 'Ago', value: 'Ago' }, { text: 'Set', value: 'Set' }, { text: 'Oct', value: 'Oct' }, { text: 'Nov', value: 'Nov' }, { text: 'Dic', value: 'Dic' }],
      valuesPendientes: [],
      valuesResueltos: [],
      lista: [],
      year: __WEBPACK_IMPORTED_MODULE_4_moment___default()().year(),
      years: [2022, 2021]
    };
  },
  created: function created() {
    var vm = this;
    if (!vm.years.includes(__WEBPACK_IMPORTED_MODULE_4_moment___default()().year())) {
      vm.years.unshift(__WEBPACK_IMPORTED_MODULE_4_moment___default()().year());
    }
    vm.fetchTicketsPorAnio();
  },

  methods: {
    fetchTicketsPorAnio: function fetchTicketsPorAnio() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obtener listado de tickets...' });
      vm.lista = [];
      vm.valuesPendientes = [];
      vm.valuesResueltos = [];
      var obj = {
        tipoTicket: vm.tipo,
        year: vm.year,
        tipoArea: vm.tipoArea
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/ticket/pendientes/count/with/asesor', obj, function (data) {
        vm.lista.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ periodo: 'Resueltos' }, data.data.resueltos));
        vm.lista.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ periodo: 'Pendientes' }, data.data.pendientes));
        vm.lista.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ periodo: 'TOTAL' }, data.data.totales));

        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.data.pendientes).length; i++) {
          vm.valuesPendientes.push(data.data.pendientes[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.data.pendientes)[i]]);
        }
        for (var j = 0; j < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.data.resueltos).length; j++) {
          vm.valuesResueltos.push(data.data.resueltos[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.data.resueltos)[j]]);
        }
        vm.reRenderChart();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    reRenderChart: function reRenderChart() {
      var vm = this;
      vm.renderChart = false;
      vm.$nextTick(function () {
        vm.renderChart = true;
      });
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_chart_line_cantidad_tickets_abiertos_por_estado__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_chart_line_cantidad_tickets_abiertos_por_estado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_chart_line_cantidad_tickets_abiertos_por_estado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_card_chart_line_cantidad_total_tickets_por_estados',
  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_0__components_c_chart_line_cantidad_tickets_abiertos_por_estado___default.a
  },
  props: {
    tipo: {
      type: String,
      default: 'garantia'
    }
  },
  data: function data() {
    return {
      isLoading: false,
      renderChart: false,
      lista: [],
      tiempos: [{
        id: 1,
        name: 'Hoy',
        desde: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD'),
        hasta: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')
      }, {
        id: 2,
        name: 'Hace una semana',
        desde: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(7, 'day').format('YYYY-MM-DD'),
        hasta: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')
      }, {
        id: 3,
        name: 'Hace un mes',
        desde: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'month').format('YYYY-MM-DD'),
        hasta: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')
      }, {
        id: 4,
        name: 'Hace 6 meses',
        desde: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(6, 'month').format('YYYY-MM-DD'),
        hasta: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')
      }, {
        id: 5,
        name: 'Hace 1 año',
        desde: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'year').format('YYYY-MM-DD'),
        hasta: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')
      }, {
        id: 6,
        name: 'Personalizado'
      }],
      tiempo: 3,
      desde: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'month').format('YYYY-MM-DD'),
      hasta: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.reRenderChart();
  },

  methods: {
    reRenderChart: function reRenderChart() {
      var vm = this;
      if (!vm.desde || !vm.hasta) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Alguna de las fechas no son validas');
      }
      vm.renderChart = false;
      vm.$nextTick(function () {
        vm.renderChart = true;
      });
    },
    getDatesForChart: function getDatesForChart() {
      var vm = this;
      if (vm.tiempo !== 6) {
        var _vm$tiempos$find = vm.tiempos.find(function (e) {
          return e.id === vm.tiempo;
        }),
            desde = _vm$tiempos$find.desde,
            hasta = _vm$tiempos$find.hasta;

        vm.desde = desde;
        vm.hasta = hasta;
        vm.reRenderChart();
      } else {
        vm.desde = '';
        vm.hasta = '';
      }
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_chart_line_tickets_cerrados_por_horas_activo__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_chart_line_tickets_cerrados_por_horas_activo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__c_chart_line_tickets_cerrados_por_horas_activo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { apiGet, notify } from '../util/general'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_card_chart_line_tickets_cerrados_por_horas_activo',
  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_1__c_chart_line_tickets_cerrados_por_horas_activo___default.a
  },
  props: {
    tipo: {
      type: String,
      default: 'garantia'
    },
    count: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isLoading: false,
      renderChart: true,
      serieRecall: '',
      incluirCerrados: false,
      ticketsCerrados: [],
      cantidadTicketsCerrados: 0,
      numeroRecnum: 0,
      noMore: false,
      disabledScrollExcecute: false,
      // desde                  : '',
      // hasta                  : ''
      desde: __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(30, 'days').format('YYYY-MM-DD'),
      hasta: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),
      tiempos: [{
        name: 'dd'
      }]
    };
  },

  methods: {
    obtenerCantidad: function obtenerCantidad(count) {
      var vm = this;
      vm.cantidadTicketsCerrados = count;
    },
    reRenderChart: function reRenderChart() {
      var vm = this;
      vm.renderChart = false;
      vm.$nextTick(function () {
        vm.renderChart = true;
      });
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_chart_pie_cantidad_total_tickets_por_meses__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_chart_pie_cantidad_total_tickets_por_meses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__c_chart_pie_cantidad_total_tickets_por_meses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_card_chart_pie_cantidad_total_tickets_por_meses',
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_2__c_chart_pie_cantidad_total_tickets_por_meses___default.a
  },
  props: {
    tipo: {
      type: String,
      default: 'garantia'
    },
    tipoArea: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isLoading: false,
      renderChart: false,
      headers: [{ text: '', value: 'periodo' }, { text: 'Ene', value: 'Ene' }, { text: 'Feb', value: 'Feb' }, { text: 'Mar', value: 'Mar' }, { text: 'Abr', value: 'Abr' }, { text: 'May', value: 'May' }, { text: 'Jun', value: 'Jun' }, { text: 'Jul', value: 'Jul' }, { text: 'Ago', value: 'Ago' }, { text: 'Set', value: 'Set' }, { text: 'Oct', value: 'Oct' }, { text: 'Nov', value: 'Nov' }, { text: 'Dic', value: 'Dic' }],
      valuesPendientes: [],
      valuesResueltos: [],
      lista: [],
      year: __WEBPACK_IMPORTED_MODULE_4_moment___default()().year(),
      years: []
    };
  },
  created: function created() {
    var vm = this;
    vm.llenarPeriodos(function () {
      vm.fetchTicketsPorAnio();
    });
  },

  methods: {
    fetchTicketsPorAnio: function fetchTicketsPorAnio() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obtener listado de tickets...' });
      vm.lista = [];
      vm.valuesPendientes = [];
      vm.valuesResueltos = [];
      var obj = {
        tipoTicket: vm.tipo,
        year: vm.year,
        tipoArea: vm.tipoArea
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/ticket/count/with/months', obj, function (data) {
        vm.lista.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ periodo: 'Resueltos' }, data.data.resueltos));
        vm.lista.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ periodo: 'Pendientes' }, data.data.pendientes));
        vm.lista.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ periodo: 'TOTAL' }, data.data.totales));

        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.data.pendientes).length; i++) {
          vm.valuesPendientes.push(data.data.pendientes[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.data.pendientes)[i]]);
        }
        for (var j = 0; j < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.data.resueltos).length; j++) {
          vm.valuesResueltos.push(data.data.resueltos[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.data.resueltos)[j]]);
        }
        vm.reRenderChart();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    llenarPeriodos: function llenarPeriodos(callback) {
      var vm = this;
      var periodoActual = __WEBPACK_IMPORTED_MODULE_4_moment___default()().year();
      var periodoInicial = 2021;
      var cantidadPeriodos = periodoActual - periodoInicial;
      console.log('cantidadPeriodos :>> ', cantidadPeriodos);
      vm.years.push(periodoInicial);
      for (var i = 0; i < cantidadPeriodos; i++) {
        periodoInicial++;
        console.log('periodoInicial :>> ', periodoInicial);
        vm.years.push(periodoInicial);
      }
      callback(null);
    },
    reRenderChart: function reRenderChart() {
      var vm = this;
      vm.renderChart = false;
      vm.$nextTick(function () {
        vm.renderChart = true;
      });
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_listado_tickets_seleccionar__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_listado_tickets_seleccionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__c_listado_tickets_seleccionar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'listado-tickets-seleccionar': __WEBPACK_IMPORTED_MODULE_2__c_listado_tickets_seleccionar___default.a
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    numeroTicket: {
      type: Number,
      default: 0
    },
    isCreacionExterno: {
      type: Boolean,
      default: false
    },
    noEstaEnAgenda: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isLoading: false,
      fechaPicker: '',
      cita: {},
      intervalo: 15,
      horas: [],
      perfilUsuario: localStorage.getItem('perfil'),
      isModalCancelarCita: false,
      comentarioParaCancelar: '',
      arrayEvents: []
    };
  },
  created: function created() {
    var vm = this;
    if (vm.isCreacionExterno) {
      if (!vm.numeroTicket) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El numero de ticket enviado no es valido');else vm.fetchTicket();
    } else {
      if (vm.id) vm.fetchCita();else {
        vm.cita.ingresadoAtaller = 0;
      }
    }
    vm.fetchDiasFestivos();
  },

  filters: {
    now: function now(value) {
      if (!value) return '';
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).fromNow();
    }
  },
  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    fetchDiasFestivos: function fetchDiasFestivos() {
      var vm = this;
      var obj = {
        formatoDate: 'YYYY-MM-DD'
        // vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener información de la cita' })
      };__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/dias_festivo/obtener', obj, function (data) {
        vm.arrayEvents = data.lista;
        console.log('dias deeeee', vm.arrayEvents);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        // vm.$store.dispatch('transaccion', { isProceso : false })
      });
    },
    openModalCancelarCita: function openModalCancelarCita() {
      var vm = this;
      vm.isModalCancelarCita = true;
      vm.comentarioParaCancelar = '';
    },
    closeModalCancelarCita: function closeModalCancelarCita() {
      var vm = this;
      vm.isModalCancelarCita = false;
      vm.comentarioParaCancelar = '';
    },
    verificarFechaYObtenerHoras: function verificarFechaYObtenerHoras() {
      var vm = this;
      var fecha = __WEBPACK_IMPORTED_MODULE_0_moment___default()(vm.cita.fechaDesde);
      vm.horas = [];
      if (fecha.isValid()) {
        vm.fetchHorasDisponibles();
      }
    },
    goTo: function goTo(page) {
      var vm = this;
      if (vm.perfilUsuario === 'usuario-contrato' || vm.perfilUsuario === 'usuario') {
        window.open(page, '_blank');
        // Router.push(page)
      } else {
        window.open(page, '_blank');
        // RouterDispatcher.push(page)
      }
    },
    close: function close() {
      var vm = this;
      vm.$emit('close');
    },
    clearTicketSeleccionado: function clearTicketSeleccionado() {
      var vm = this;
      vm.cita.numeroTicket = 0;
      vm.fechaPicker = '';
    },
    obtenerTicketSeleccionado: function obtenerTicketSeleccionado(ticket) {
      var vm = this;
      vm.$set(vm.cita, 'numeroTicket', ticket.numero);
      vm.$set(vm.cita, 'titulo', ticket.titulo);
      vm.fechaPicker = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
      // vm.cita.numeroTicket = ticket.numero
      // vm.cita.titulo       = ticket.titulo
    },
    updatedList: function updatedList() {
      var vm = this;
      vm.$emit('update');
    },
    fetchHorasDisponibles: function fetchHorasDisponibles() {
      var vm = this;
      if (!vm.fechaPicker) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'La fecha de programación no es valida');
        vm.horas = [];
        return;
      }
      var obj = {
        fecha: vm.fechaPicker
        // vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener información de la cita' })
      };__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/cita/verificar/horas', obj, function (data) {
        vm.horas = data.horasDisponibles;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        // vm.$store.dispatch('transaccion', { isProceso : false })
      });
    },
    fetchEliminarCita: function fetchEliminarCita() {
      var vm = this;
      if (!vm.comentarioParaCancelar) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un motivo por el cual deseas cancelar la cita ');
        vm.$refs.comentarioParaCancelar.focus();
        return;
      }

      var obj = {
        codigo: vm.id,
        motivo: vm.comentarioParaCancelar
      };
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Eliminando programación' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["e" /* apiDelete */])(vm, '/cita/eliminar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'La cita se eliminó correctamente');
        vm.updatedList();
        vm.close();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchCita: function fetchCita() {
      var vm = this;
      var obj = {
        codigo: vm.id
      };
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obtener información de la cita' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/cita/obtener', obj, function (data) {
        vm.cita = data.lista[0];
        vm.fechaPicker = __WEBPACK_IMPORTED_MODULE_0_moment___default()(vm.cita.fechaDesde).format('YYYY-MM-DD');
        vm.$set(vm.cita, 'horaCita', __WEBPACK_IMPORTED_MODULE_0_moment___default()(vm.cita.fechaDesde).format('HH:mm'));
        if (vm.fechaPicker) vm.fetchHorasDisponibles();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.close();
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchGuardarCita: function fetchGuardarCita() {
      var vm = this;
      var obj = {
        id: vm.id,
        titulo: vm.cita.titulo,
        fecha: vm.fechaPicker,
        hora: vm.cita.horaCita,
        ingresadoAtaller: vm.cita.ingresadoAtaller,
        numeroTicket: vm.cita.numeroTicket
      };
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Guardando datros de cita' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/cita/guardar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los datos de la cita se guardaron correctamente');
        vm.updatedList();
        vm.close();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchTicket: function fetchTicket() {
      var vm = this;
      vm.isLoading = true;
      var url = 'ticket/obtener';
      var obj = {
        numero: vm.numeroTicket
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        var info = data.lista[0];
        var titulo = '' + info.razonSocial;
        if (info.serie) titulo += ' - ' + info.serie;
        if (info.modelo) titulo += ' - ' + info.modelo;
        vm.$set(vm.cita, 'titulo', titulo);
        vm.$set(vm.cita, 'numeroTicket', info.numero);
        // vm.cita.titulo         = titulo
        // vm.cita.numeroTicket   = info.numero
        vm.fechaPicker = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
        if (vm.fechaPicker) vm.fetchHorasDisponibles();
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_dispatcher__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isGettingEquipos: false,
      isLoadingProceso: false,
      modeloSeleccionado: [],
      tiposTicket: [{
        id: 'solicitúd de insumo',
        name: 'Solicitud de insumo'
      }, {
        id: 'incidencia con equipo',
        name: 'Incidencia con equipo'
      }],
      modelosAgrupados: [],
      equiposDelModelo: [],
      usuariosContrato: [],
      usuarioSeleccionado: '',
      tipoTicketSeleccionado: 'incidencia con equipo',
      numeroContrato: '',
      serieSeleccionado: '',
      codigoFallaGeneral: 100000
    };
  },
  created: function created() {},

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    equiposDelModeloFiltrados: function equiposDelModeloFiltrados() {
      var vm = this;
      return vm.equiposDelModelo.filter(function (e) {
        return e.serie !== vm.serieSeleccionado;
      });
    }
  },
  methods: {
    limpiarSerie: function limpiarSerie() {
      var vm = this;
      vm.serieSeleccionado = '';
    },
    limpiarModelo: function limpiarModelo() {
      var vm = this;
      vm.equiposDelModelo = [];
    },
    limpiarTodo: function limpiarTodo() {
      var vm = this;
      vm.equiposDelModelo = [];
      vm.modeloSeleccionado = [];
      vm.numeroContrato = '';
      vm.serieSeleccionado = '';
      vm.usuarioSeleccionado = '';
      vm.usuariosContrato = [];
      vm.close();
    },
    seleccionarModelo: function seleccionarModelo(seleccionado) {
      var vm = this;
      if (seleccionado) vm.equiposDelModelo = seleccionado.equipos;
    },
    fetchEquipos: function fetchEquipos() {
      var vm = this;
      if (!vm.numeroContrato) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor ingrese el numero de contrato');
        return;
      }

      vm.isGettingEquipos = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo listado de equipos' });
      var obj = {
        numeroContrato: vm.numeroContrato
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/cliente/serie/agrupado/all', obj, function (data) {
        vm.modelosAgrupados = data.equiposAgrupados;
        vm.verificarUsuarioAntesCrearTicket(function (err, usuarios) {
          if (err) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
            vm.isLoadingProceso = false;
            return;
          }

          vm.usuariosContrato = usuarios;
          vm.usuarioSeleccionado = usuarios[0].usuario;

          vm.isGettingEquipos = false;
          vm.$store.dispatch('transaccion', { isProceso: false });
        });
      }, function (error) {
        vm.isGettingEquipos = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_0__router_dispatcher__["a" /* default */].push(page);
    },
    procesoGenerarTickets: function procesoGenerarTickets() {
      var vm = this;
      vm.isLoadingProceso = true;
      if (!vm.tipoTicketSeleccionado) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor seleccione una categoria para el ticket');
        vm.isLoadingProceso = false;
        return;
      }

      if (!vm.serieSeleccionado.serie) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor seleccione una serie');
        vm.isLoadingProceso = false;
        return;
      }

      if (!vm.usuarioSeleccionado) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Seleccione un usuario valido');
        vm.isLoadingProceso = false;
        return;
      }

      if (!vm.codigoFallaGeneral) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor seleccione una falla');
        vm.isLoadingProceso = false;
        return;
      }

      var obj = {
        ticket: {
          serie: vm.serieSeleccionado.serie,
          tipo: vm.tipoTicketSeleccionado.id,
          insumo: [],
          usuario: vm.usuarioSeleccionado,
          falla: {
            codigoFallaGeneral: vm.codigoFallaGeneral
          }
        },
        isPlantilla: 1,
        isGenerarIT: false
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/ticket/registrar', obj, function (data) {
        vm.isLoadingProceso = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los tickets se generarón correctamente');
        vm.close();
        vm.goTo('/ticket/' + data.numero);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    verificarUsuarioAntesCrearTicket: function verificarUsuarioAntesCrearTicket(callback) {
      var vm = this;
      var obj = {
        numeroContrato: vm.numeroContrato
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/usuario/obtener/por/contrato', obj, function (data) {
        callback(null, data.usuarios || []);
      }, function (error) {
        callback(error);
      });
    },
    close: function close() {
      var vm = this;
      vm.$emit('close');
    },
    onUnmounted: function onUnmounted() {
      var vm = this;
      vm.close();
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    serie: {
      type: String,
      default: ''
    },
    tipoTicket: {
      type: String,
      default: 0
    }
  },
  data: function data() {
    return {
      isLoading: false,
      isLoadingImage: false,
      datos: {},
      marcas: [],
      apiUpload: "https://api-sil.datacont.com",
      showImageMarca: false
    };
  },
  created: function created() {
    var vm = this;
    if (!vm.serie) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese una serie valida');
      vm.$emit('close');
      return;
    } else vm.fetch();
  },

  methods: {
    fetchGetDataMarcas: function fetchGetDataMarcas() {
      var vm = this;
      vm.showImageMarca = false;
      var obj = {
        octopus: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/articulo/marca-articulo', obj, function (data) {
        vm.marcas = data.lista;
        var iniciales = vm.datos.codigoArticuloNuevo.substring(3, 5);
        var datosMarca = vm.marcas.find(function (e) {
          return e.codigo === iniciales;
        });
        vm.datos.marca = datosMarca.descripcion;
        vm.datos.codigoMarca = datosMarca.codigo;
        vm.showImageMarca = true;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo información de la serie' });
      var obj = {
        serie: vm.serie,
        tipoTicket: vm.tipoTicket
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/integracion/serie/obtener', obj, function (data) {
        console.log('data', data.data[0]);
        vm.datos = data.data;
        if (vm.datos.codigoArticuloNuevo) {
          vm.fetchGetDataMarcas();
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
        vm.$emit('close');
      }, function () {
        vm.isLoading = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    close: function close() {
      var vm = this;
      vm.$emit('close');
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_card_informacion_usuario',
  components: {
    'avatar-perfil': __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil___default.a
  },
  props: {
    datos: {
      type: Object
    },
    descargarsctr: {
      type: Boolean,
      default: false
    },
    showDetails: {
      type: Boolean,
      default: false
    },
    isFetch: {
      type: Boolean,
      default: false
    },
    onlyTecnicos: {
      type: Boolean,
      default: false
    },
    codigoTecnico: {
      type: Number,
      default: 0
    },
    username: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      usuario: this.datos || {},
      isDescargar: this.descargarsctr,
      isLoading: false,
      showInfoUser: false,
      showTelefonoCliente: false,
      codigoClienteSAP: '', // C20100131359
      numeroTelefonoCliente: '',
      datosClienteSAP: null,
      showDetailsDataSAP: false,
      sivWebCliente: "http://siv.reprodata.com.pe",
      perfil: localStorage.getItem('perfil')
    };
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  created: function created() {
    var vm = this;
    if (vm.isFetch) vm.fetchUsuario();
  },

  methods: {
    enviarDatosDelUsuario: function enviarDatosDelUsuario() {
      var vm = this;
      var query = '';
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(vm.usuario).forEach(function (e) {
        if (e !== 'foto' && e !== 'password' && e !== 'emailConfirmado' && e !== 'rutaSctr' && e !== 'resetToken' && e !== 'tokenVerifyEmail' && e !== 'direccion') {
          query += e + '=' + vm.usuario[e] + '&';
        }
      });
      var ruta = vm.sivWebCliente + '/#/cliente-administrador?' + query;
      window.open(ruta, '_blank');
    },
    habilitarEdicionCodigoSAP: function habilitarEdicionCodigoSAP() {
      var vm = this;
      vm.codigoClienteSAP = vm.usuario.codigoSap;
      vm.usuario.codigoSap = '';
      vm.showDetailsDataSAP = false;
    },
    habilitarEdicionTelefono: function habilitarEdicionTelefono() {
      var vm = this;
      vm.numeroTelefonoCliente = vm.usuario.telefono;
      vm.usuario.telefono = '';
      vm.showTelefonoCliente = false;
    },
    limpiarDatosClienteSAP: function limpiarDatosClienteSAP() {
      var vm = this;
      vm.showDetailsDataSAP = false;
      vm.datosClienteSAP = null;
    },
    limpiarDatosTelefonoCliente: function limpiarDatosTelefonoCliente() {
      var vm = this;
      vm.showTelefonoCliente = false;
      vm.numeroTelefonoCliente = null;
    },
    fetchDescargarSCTR: function fetchDescargarSCTR() {
      var vm = this;
      if (!vm.usuario.rutaSctr) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'No cuenta con el SCTR actualizado');else window.open(vm.usuario.rutaSctr, '_blank');
    },
    fetchUsuario: function fetchUsuario() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      if (vm.username) obj.usuario = vm.username;else if (vm.codigoTecnico > 0) obj.codigoTecnico = vm.codigoTecnico;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/usuario/obtener', obj, function (data) {
        vm.usuario = data.lista[0] || {};
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    fetchSaveDatosCliente: function fetchSaveDatosCliente() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Asignando numero de telefono' });
      var obj = {
        usuario: vm.usuario.usuario,
        numeroTelefono: vm.numeroTelefonoCliente
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/usuario/actualizar/numero/telefono', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'La asignación del telefono se realizo de manera exitosa');
        vm.usuario.telefono = vm.numeroTelefonoCliente;
        vm.limpiarDatosTelefonoCliente();
        vm.numeroTelefonoCliente = '';
        // vm.fetchUsuario()
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchGetDatosSAP: function fetchGetDatosSAP() {
      var vm = this;
      if (!vm.codigoClienteSAP) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese el codigo de cliente SAP');
        vm.$refs.codigoClienteSAP.focus();
        return;
      }

      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo informacion de SAP' });
      var obj = {
        codigoCliente: vm.codigoClienteSAP
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/cliente/obtener/sap', obj, function (data) {
        var lista = data.lista[0];
        if (lista.codigoSAP === vm.codigoClienteSAP) {
          vm.datosClienteSAP = lista;
          vm.showDetailsDataSAP = true;
        } else vm.showDetailsDataSAP = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchAsignarCodigoSap: function fetchAsignarCodigoSap() {
      var vm = this;
      var obj = {
        usuario: vm.usuario.usuario,
        codigoSap: vm.codigoClienteSAP
      };

      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Asignando codigo SAP' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/usuario/actualizar/codigo/sap', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'La asignación del codigo SAP se realizo de manera exitosa');
        vm.usuario.codigoSap = vm.codigoClienteSAP;
        vm.limpiarDatosClienteSAP();
        vm.codigoClienteSAP = '';
        // vm.fetchUsuario()
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: {
    tipo: {
      type: String,
      default: 'garantia'
    },
    incluirCerrados: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      listaData: [],
      chartData: {
        labels: [],
        datasets: [{
          label: 'Cantidad',
          data: [],
          fill: false,
          borderColor: this.$vuetify.theme.themes.light.primary,
          backgroundColor: this.$vuetify.theme.themes.light.primary,
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: true
            },
            ticks: {
              fontSize: 10
            }
          }]
        },
        onClick: this.handle,
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchTicketsEnRecall();
  },

  methods: {
    handle: function handle(point, event) {
      var vm = this;
      var item = event[0];
      if (item) {
        var index = item._index;
        // console.log('index', index)
        // var numero       = vm.listaData[index].numero
        vm.$emit('click', vm.listaData[index]);
        // var url          = vm.$router.resolve({name  : 'detalle_ticket', params : { numero : numero }})
        // window.open(url.href, '_blank')
      }
    },
    render: function render() {
      var vm = this;
      vm.chartData.datasets[0].fill = !vm.$vuetify.theme.dark;
      vm.renderChart(vm.chartData, vm.options);
    },
    fetchTicketsEnRecall: function fetchTicketsEnRecall() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obtener listado de tickets abiertos en recall' });
      var obj = {
        tipo: vm.tipo.toLowerCase(),
        incluirCerrados: vm.incluirCerrados ? 1 : 0
      };
      console.log('obj', obj);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/ticket/abiertos/count/recall', obj, function (data) {
        vm.$emit('count', data.labels.length);
        console.log('data', data);
        vm.listaData = data.labels;
        vm.chartData.datasets[0].data = [];
        vm.chartData.labels = [];
        for (var i = 0; i < data.valores.length; i++) {
          vm.chartData.datasets[0].data.push(data.valores[i]);
        }

        for (var j = 0; j < data.labels.length; j++) {
          vm.chartData.labels.push('' + data.labels[j]);
        }

        vm.render();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: {
    tipo: {
      type: String,
      default: 'Garantia'
    },
    desde: {
      type: String,
      default: ''
    },
    hasta: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      listaData: [],
      query: {
        titulo: '',
        descripcion: '',
        tipo: '-1',
        desde: '',
        hasta: '',
        numero: '',
        estado: 0,
        codigoCliente: '',
        serie: '',
        modelo: '',
        zona: '-1',
        area: '-1',
        abierto: '-1',
        ingresoATaller: '-1',
        tipoReporte: 'basico'
      },
      chartData: {
        labels: [],
        datasets: [{
          label: 'Cantidad',
          data: [],
          fill: false,
          borderColor: this.$vuetify.theme.themes.light.primary,
          backgroundColor: this.$vuetify.theme.themes.light.secondary,
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontSize: 11
            }
          }]
        },
        onClick: this.handle,
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchEstados();
  },

  methods: {
    handle: function handle(point, event) {
      var vm = this;
      var item = event[0];
      if (item) {
        var index = item._index;
        var estado = vm.listaData[index];
        vm.query.estado = estado.estado;
        vm.query.abierto = 1;
        vm.query.tipo = vm.tipo.toLowerCase();
        var url = vm.$router.resolve({ name: 'reportes_view', params: { tipo: 'draft' }, query: vm.query });
        window.open(url.href, '_blank');
      }
    },
    render: function render() {
      var vm = this;
      vm.chartData.datasets[0].fill = !vm.$vuetify.theme.dark;
      vm.renderChart(vm.chartData, vm.options);
    },
    fetchEstados: function fetchEstados() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obtener listado de tickets abiertos' });
      var obj = {
        tipo: vm.tipo.toLowerCase(),
        desde: vm.desde,
        hasta: vm.hasta
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/ticket/abiertos/count/por/estado', obj, function (data) {
        vm.chartData.labels = data.labels;
        vm.listaData = data.valores;
        for (var i = 0; i < data.valores.length; i++) {
          var e = data.valores[i];
          vm.chartData.datasets[0].data.push(e.abiertos);
        }
        vm.render();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: {
    tipo: {
      type: String,
      default: 'Garantia'
    },
    desde: {
      type: String
    },
    hasta: {
      type: String
    }
  },
  data: function data() {
    return {
      listaData: [],
      chartData: {
        labels: [],
        datasets: [{
          label: 'Abierto',
          data: [],
          fill: false,
          borderColor: this.$vuetify.theme.themes.light.primary,
          backgroundColor: this.$vuetify.theme.themes.light.secondary,
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontSize: 11
            }
          }]
        },
        onClick: this.handle,
        legend: {
          display: false
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: this.footer
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchTicketsCerrados();
  },

  methods: {
    footer: function footer(context) {
      var label = context.value + ' dias activo';
      return label;
    },
    handle: function handle(point, event) {
      var vm = this;
      var item = event[0];
      if (item) {
        var index = item._index;
        var numero = vm.listaData[index].numero;
        var url = vm.$router.resolve({ name: 'detalle_ticket', params: { numero: numero } });
        window.open(url.href, '_blank');
      }
    },
    render: function render() {
      var vm = this;
      vm.chartData.datasets[0].fill = !vm.$vuetify.theme.dark;
      vm.renderChart(vm.chartData, vm.options);
    },
    fetchTicketsCerrados: function fetchTicketsCerrados() {
      var vm = this;
      vm.listaData = [];
      vm.chartData.labels = [];
      vm.chartData.datasets[0].data = [];
      vm.isLoading = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obtener listado de tickets cerrados' });
      var obj = {
        desde: vm.desde,
        hasta: vm.hasta,
        tipoTicket: vm.tipo.toLowerCase()
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/ticket/obtener/cerrados/duracion', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.listaData.push(data.lista[i]);
          vm.chartData.labels.push(data.lista[i].numero);
          vm.chartData.datasets[0].data.push(data.lista[i].diasAbierto);
        }

        vm.render();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(23);
//


/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: {
    resueltos: {
      type: Array,
      default: []
    },
    pendientes: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      listaData: [],
      chartData: {
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'],
        datasets: [{
          label: 'Resueltos',
          data: this.resueltos,
          fill: false,
          borderColor: this.$vuetify.theme.themes.light.success,
          backgroundColor: this.$vuetify.theme.themes.light.success,
          borderWidth: 1
        }, {
          label: 'Pendientes',
          data: this.pendientes,
          fill: false,
          borderColor: this.$vuetify.theme.themes.light.primary,
          backgroundColor: this.$vuetify.theme.themes.light.primary,
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontSize: 12
            }
          }]
        },
        onClick: this.handle,
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false,
        query: {
          titulo: '',
          descripcion: '',
          tipo: '-1',
          desde: '',
          hasta: '',
          numero: '',
          estado: 0,
          codigoCliente: '',
          serie: '',
          modelo: '',
          zona: '-1',
          area: '-1',
          abierto: '-1',
          ingresoATaller: '-1',
          tipoReporte: 'basico'
        }
      }
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.render();
  },

  methods: {
    handle: function handle(point, event) {
      // var vm = this
      var item = event[0];
      if (item) {
        console.log('item', item);
        // var index        = item._index
        // var estado       = vm.listaData[index]
        // vm.query.abierto = 1
        // vm.query.tipo    = vm.tipo.toLowerCase()
        // var url          = vm.$router.resolve({ name  : 'reportes_view', params : {tipo : 'draft'}, query : vm.query })
        // window.open(url.href, '_blank')
      }
      // var vm = this
      // var item = event[0]
      // if (item) {
      //   var index        = item._index
      //   var estado       = vm.listaData[index]
      //   vm.query.estado  = estado.estado
      //   vm.query.abierto = 1
      //   vm.query.tipo    = vm.tipo.toLowerCase()
      //   // vm.$router.push({ path: "/DetailsBook", query: { key } });
      //   var url          = vm.$router.resolve({ name  : 'reportes_view', params : {tipo : 'draft'}, query : vm.query })
      //   window.open(url.href, '_blank')
    },
    render: function render() {
      var vm = this;
      vm.chartData.datasets[0].fill = !vm.$vuetify.theme.dark;
      vm.renderChart(vm.chartData, vm.options);
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(23);
//


/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  name: 'c_chart_pie_tickets_pendientes_por_asesor',
  props: {
    resueltos: {
      type: Array,
      default: []
    },
    pendientes: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      listaData: [],
      chartData: {
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'],
        datasets: [{
          label: 'Andres Mesias',
          data: this.resueltos,
          fill: false,
          borderColor: this.$vuetify.theme.themes.light.success,
          backgroundColor: this.$vuetify.theme.themes.light.success,
          borderWidth: 1
        }, {
          label: 'Giancarlo Davila',
          data: this.pendientes,
          fill: false,
          borderColor: this.$vuetify.theme.themes.light.primary,
          backgroundColor: this.$vuetify.theme.themes.light.primary,
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontSize: 12
            }
          }]
        },
        onClick: this.handle,
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false,
        query: {
          titulo: '',
          descripcion: '',
          tipo: '-1',
          desde: '',
          hasta: '',
          numero: '',
          estado: 0,
          codigoCliente: '',
          serie: '',
          modelo: '',
          zona: '-1',
          area: '-1',
          abierto: '-1',
          ingresoATaller: '-1',
          tipoReporte: 'basico'
        }
      }
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.render();
  },

  methods: {
    handle: function handle(point, event) {
      // var vm = this
      var item = event[0];
      if (item) {
        console.log('item', item);
        // var index        = item._index
        // var estado       = vm.listaData[index]
        // vm.query.abierto = 1
        // vm.query.tipo    = vm.tipo.toLowerCase()
        // var url          = vm.$router.resolve({ name  : 'reportes_view', params : {tipo : 'draft'}, query : vm.query })
        // window.open(url.href, '_blank')
      }
      // var vm = this
      // var item = event[0]
      // if (item) {
      //   var index        = item._index
      //   var estado       = vm.listaData[index]
      //   vm.query.estado  = estado.estado
      //   vm.query.abierto = 1
      //   vm.query.tipo    = vm.tipo.toLowerCase()
      //   // vm.$router.push({ path: "/DetailsBook", query: { key } });
      //   var url          = vm.$router.resolve({ name  : 'reportes_view', params : {tipo : 'draft'}, query : vm.query })
      //   window.open(url.href, '_blank')
    },
    render: function render() {
      var vm = this;
      vm.chartData.datasets[0].fill = !vm.$vuetify.theme.dark;
      vm.renderChart(vm.chartData, vm.options);
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_theme_changer__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_theme_changer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__c_theme_changer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'theme-provider': __WEBPACK_IMPORTED_MODULE_1__c_theme_changer___default.a
  },
  data: function data() {
    return {
      search: '',
      filtered: [],
      configuraciones: [{
        titulo: 'General',
        subtitulo: 'Cambia el tema, parametros y demas',
        icon: 'settings',
        key: 'general'
      }],
      showDetails: false,
      isModalReload: false,
      showOptions: {},
      showAlertReload: false,
      isDark: false
    };
  },
  created: function created() {
    var vm = this;
    vm.filtered = vm.configuraciones;
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    settings: function settings() {
      var vm = this;
      return vm.$store.state.app.settings;
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.getConfigs();
  },

  watch: {
    settings: function settings(val) {
      var vm = this;
      vm.getConfigs();
    }
  },
  methods: {
    getConfigs: function getConfigs() {
      var vm = this;
      vm.isDark = vm.settings.general.theme.dark;
    },
    reloadPage: function reloadPage() {
      window.location.reload(true);
    },
    closeAlertReload: function closeAlertReload() {
      var vm = this;
      vm.showAlertReload = false;
    },
    fetchGuardarConfiguraciones: function fetchGuardarConfiguraciones() {
      var vm = this;
      vm.showAlertReload = false;
      var settingsObj = {
        general: {
          theme: {
            name: 'datacont',
            dark: vm.isDark
          }
        }
      };
      var obj = {
        configuraciones: settingsObj
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, 'usuario/actualizar/configuracion/app', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los cambios se guardarón exitosamente');
        var configs = data.configuraciones;
        vm.$store.dispatch('setSettings', configs);
        vm.$vuetify.theme.dark = configs.general.theme.dark;
        vm.showAlertReload = true;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    },
    openOpciones: function openOpciones(c) {
      var vm = this;
      vm.showOptions = c;
      vm.showDetails = true;
    },
    closeOpciones: function closeOpciones() {
      var vm = this;
      vm.keyOption = {};
      vm.showDetails = false;
    },
    close: function close() {
      var vm = this;
      vm.closeOpciones();
      vm.$emit('close');
    },
    buscarValor: function buscarValor(value) {
      var vm = this;
      if (value) {
        vm.configuraciones = vm.filtered;
        vm.configuraciones = vm.configuraciones.filter(function (e) {
          return e.titulo.toLowerCase().includes(value.toLowerCase()) || e.subtitulo.toLowerCase().includes(value.toLowerCase());
        });
      } else vm.configuraciones = vm.filtered;
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__c_procesos_handler_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__c_procesos_handler_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__c_procesos_handler_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'procesos-handler': __WEBPACK_IMPORTED_MODULE_0__c_procesos_handler_vue___default.a
  },
  data: function data() {
    return {};
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    showProcesos: function showProcesos() {
      var vm = this;
      return vm.$store.state.app.showProcesos;
    },
    openCentroDeDescargas: function openCentroDeDescargas() {
      var vm = this;
      return vm.$store.state.app.openPopupNotifications;
    },
    countDescargas: function countDescargas() {
      var vm = this;
      return vm.$store.state.app.countAllDownloands;
    }
  },
  methods: {
    openPopup: function openPopup() {
      var vm = this;
      vm.$store.dispatch('setOpenPopupNotifications', !vm.openCentroDeDescargas);
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import cargandoLoad         from './Component_Cargando'

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    // 'loading-global-sil': cargandoLoad
  },
  props: ['codigo', 'id'],
  data: function data() {
    return {
      isLoading: false,
      lista: [],
      filtro: '',
      idDireccion: this.id || '',
      empresa: "reprodata"
    };
  },

  watch: {
    filtro: function filtro() {
      var vm = this;
      vm.buscarValor();
    }
  },
  created: function created() {
    var vm = this;
    console.log('codigocodigo', vm.codigo);
    if (!vm.codigo) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', 'El codigo del cliente no esta definido');
      return;
    }
    vm.fetch();
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var url = '/cliente/direccion/obtener';
      var obj = {
        codigoCliente: vm.codigo ? vm.codigo.toString().trim() : '',
        octopus: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        console.log('data', data);
        vm.lista = data.lista;
        vm.filtered = data.lista;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionarClick: function seleccionarClick(o) {
      var vm = this;
      console.log('ooo', o);
      vm.idDireccion = o.id;
      vm.$emit('selected', o);
    },
    buscarValor: function buscarValor() {
      var vm = this;
      if (vm.filtro) {
        var value = vm.filtro + '';
        var valueBuscar = value ? value.toLowerCase() : '';
        vm.lista = vm.lista.filter(function (e) {
          var direccion = e.direccion ? e.direccion.toLowerCase() : '';
          var referencia = e.direccion ? e.direccion.toLowerCase() : '';
          return direccion.includes(valueBuscar) || referencia.includes(valueBuscar);
        });
      } else vm.lista = vm.filtered;
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__c_adjuntar_archivos__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__c_adjuntar_archivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__c_adjuntar_archivos__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'adjuntar-archivos': __WEBPACK_IMPORTED_MODULE_4__c_adjuntar_archivos___default.a
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    numero: {
      type: String,
      default: ''
    },
    numeroTelefonoCliente: {
      type: Number,
      default: 0
    },
    agente: {
      type: String,
      default: localStorage.getItem('usuario')
    }
  },
  data: function data() {
    return {
      comentario: '',
      isLoading: false,
      isUploadFiles: false,
      files: [],
      filesUploads: [],
      perfil: localStorage.getItem('perfil')
    };
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.isUploadFiles = false;
    },
    enviarComentario: function enviarComentario() {
      var vm = this;
      if (!vm.comentario) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor ingrese un mensaje en la casilla de texto');
        vm.focus();
      } else {
        vm.$emit('send', vm.comentario);
        vm.comentario = '';
        vm.focus();
      }
    },
    focus: function focus() {
      var vm = this;
      vm.$refs.mensaje.focus();
    },
    updateFetchTimeLine: function updateFetchTimeLine() {
      var vm = this;
      vm.$emit('update-time-line');
    },
    setFilesToSave: function setFilesToSave() {
      var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var vm = this;
      vm.files = files;
      vm.fetchUploadsFiles();
    },
    fetchUploadsFiles: function fetchUploadsFiles() {
      var vm = this;
      vm.$store.dispatch('transaccionForce', { force: true, message: 'Adjuntando archivos al ticket' });
      vm.fileUploadRecursivo(0, function (err) {
        if (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
          vm.$store.dispatch('transaccionForce', { force: false });
          return;
        }
        vm.fetchNotificarAdjuntos(function (err) {
          if (err) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
            vm.$store.dispatch('transaccionForce', { force: false });
            return;
          }

          vm.files = [];
          vm.filesUploads = [];
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'La imagen se adjuntó correctamente');
          vm.closeModalAdjuntar();
          vm.$store.dispatch('transaccionForce', { force: false });
        });
      });
    },
    fileUploadRecursivo: function fileUploadRecursivo(index, callback) {
      var _this = this;

      var vm = this;
      vm.uploadFile(vm.files[index], function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(err, response) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (err) {
                    callback(err);
                  } else {
                    vm.fetchInsertarActividad(response, function (err) {
                      if (err) callback(err);else {
                        index++;
                        if (index === vm.files.length) callback(null);else vm.fileUploadRecursivo(index, callback);
                      }
                    });
                  }

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    fetchInsertarActividad: function fetchInsertarActividad(adjunto, callback) {
      var vm = this;
      var obj = {
        numero: vm.numero,
        tipo: 'adjunto',
        contenido: adjunto.ruta,
        nombreAdjunto: adjunto.archivo,
        tipoAdjunto: adjunto.mimetype,
        usuario: vm.agente,
        noEnviarEmail: 1
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/ticket/registrar/actividad', obj, function (data) {
        vm.updateFetchTimeLine();
        callback && callback(null);
      }, function (error) {
        callback && callback(error);
      });
    },
    fetchNotificarAdjuntos: function fetchNotificarAdjuntos(callback) {
      var vm = this;
      var obj = {
        numeroTicket: vm.numero,
        fechaUltimoAdjunto: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('DD/MM/YYYY HH:ss'), // moment(fechaUltimoAdjunto).fromNow() + ' (' + moment(fechaUltimoAdjunto).format('DD/MM/YYYY HH:mm') + ')',
        files: vm.filesUploads
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/ticket/notificar/adjuntos', obj, function (data) {
        callback && callback(null);
      }, function (error) {
        callback && callback(error);
      });
    },
    uploadFile: function uploadFile(file, callback) {
      var vm = this;
      var fd = new FormData();
      var apiUploadRoute = "https://api-sil.datacont.com";
      var url = apiUploadRoute + '/upload';
      fd.append('file', file);
      var params = {
        carpeta: 'actividades',
        usuario: vm.agente
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["d" /* apiUploadWithParams */])(vm, url, fd, params, function (res) {
        callback(null, res);
      }, function (err) {
        callback(err);
      });
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    tipo: {
      type: String,
      default: ''
    },
    codigo: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    showClear: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    etapa: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      lista: [],
      estado: {},
      isLoading: false,
      codigoEnviado: this.codigo
    };
  },
  created: function created() {
    var vm = this;
    console.log('tipo', vm.tipo);
    vm.fetch();
  },

  computed: {
    estados: function estados() {
      // if (this.tipo === 'incidencia con equipo' && this.estado.codigo === 9) {
      //   return this.lista
      // } else {
      //   if (this.tipo === 'incidencia con equipo') {
      //     console.log('filtado...',  this.lista)
      //     return this.lista
      //   } else return this.lista
      // }
      return this.lista;
    }
  },
  methods: {
    reload: function reload() {
      var vm = this;
      vm.$forceUpdate();
    },
    limpiarEstado: function limpiarEstado() {
      var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var vm = this;
      vm.estado = {};
      vm.codigoEnviado = 0;
      if (emit) vm.$emit('selected', vm.estado);
    },
    selectEstado: function selectEstado(estado) {
      var vm = this;
      if (vm.readOnly) return;
      vm.estado = estado;
      vm.$emit('selected', estado);
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        tipo: vm.tipo
      };

      if (vm.etapa) obj.etapa = vm.etapa;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/estado/obtener', obj, function (data) {
        vm.lista = data.lista;
        if (vm.codigoEnviado > 0) {
          vm.estado = vm.lista.find(function (e) {
            return e.codigo === vm.codigoEnviado;
          });
          vm.estado && vm.selectEstado(vm.estado);
        }
        if (!vm.estado) {
          vm.estado = {
            codigo: 0,
            descripcion: 'Desconocido'
          };
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_avatar_perfil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_avatar_perfil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__c_avatar_perfil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_item_ticket_lista',
  components: {
    'avatar-perfil': __WEBPACK_IMPORTED_MODULE_1__c_avatar_perfil___default.a
    // 'estados-ticket': estadosTicket
  },
  props: ['ticket', 'isChart', 'handler', 'showNumeroInforme'],
  data: function data() {
    return {
      perfilUsuario: localStorage.getItem('perfil'),
      usuarioLogeado: localStorage.getItem('username')
    };
  },

  filters: {
    now: function now(value) {
      if (!value) return '';
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).fromNow();
    }
  },
  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    handlerClick: function handlerClick(numero) {
      var vm = this;
      if (vm.handler) vm.$emit('href');else {
        vm.$emit('goTo', '/ticket/' + numero);
      }
    },
    integrarTicket: function integrarTicket() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Integrando ticket ' + vm.ticket.numero });
      var obj = {
        numero: vm.ticket.numero
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/integracion/create', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Integrado correctamente con el numero ' + data.numeroInformeTecnico);
        vm.ticket.numeroInformeTecnico = data.numeroInformeTecnico;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_avatar_perfil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_avatar_perfil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_avatar_perfil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    actividad: {
      type: Object
    },
    isLog: {
      type: Boolean,
      default: false
    },
    group: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'avatar-perfil': __WEBPACK_IMPORTED_MODULE_0__components_c_avatar_perfil___default.a
  },
  data: function data() {
    return {
      showImageFull: false,
      imagePreview: {},
      rotateDeg: 0,
      show: false,
      perfilUsuario: localStorage.getItem('perfil'),
      isModalEliminarActividad: false,
      comentarioParaEliminarActividad: '',
      isGroupImagenes: [],
      indexGroupItem: ''
    };
  },

  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    fecha: function fecha(value) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(value).format('DD/MM/YYYY HH:MM');
    }
  },
  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    updatedList: function updatedList() {
      var vm = this;
      vm.$emit('update');
    },
    fetchEliminarActividad: function fetchEliminarActividad() {
      var vm = this;
      if (!vm.comentarioParaEliminarActividad) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un motivo por el cual deseas elimianr la actividad ');
        vm.$refs.comentarioParaEliminarActividad.focus();
        return;
      }

      var obj = {
        codigo: vm.group ? vm.imagePreview.id : vm.actividad.id,
        motivo: vm.comentarioParaEliminarActividad
      };

      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Eliminando actividad' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["e" /* apiDelete */])(vm, '/ticket/eliminar/actividad', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'La actividad se eliminó correctamente');
        if (vm.group) {
          vm.showImageFull = false;
        }
        vm.closeModalEliminarActividad();
        vm.updatedList();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    goTo: function goTo(page) {
      var vm = this;
      if (vm.perfilUsuario === 'usuario-contrato' || vm.perfilUsuario === 'usuario') {
        window.open(page, '_blank');
        // Router.push(page)
      } else {
        window.open(page, '_blank');
        // RouterDispatcher.push(page)
      }
    },
    returFormatComentario: function returFormatComentario(comentario) {
      return comentario.split('/br*');
    },
    openModalEliminarActividad: function openModalEliminarActividad() {
      var vm = this;
      vm.isModalEliminarActividad = true;
      vm.comentarioParaEliminarActividad = '';
    },
    closeModalEliminarActividad: function closeModalEliminarActividad() {
      var vm = this;
      vm.isModalEliminarActividad = false;
      vm.comentarioParaEliminarActividad = '';
    },
    rotateImage: function rotateImage() {
      var vm = this;
      if (vm.rotateDeg === 360) vm.rotateDeg = 0;else {
        vm.rotateDeg = vm.rotateDeg + 90;
      }
    },
    showDialogImage: function showDialogImage() {
      var isGroupItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var position = arguments[1];
      var item = arguments[2];

      var vm = this;
      console.log('isGroupItem', isGroupItem);
      console.log('position', position);
      console.log('item', item);
      console.log('vm.isGroupImagenes[position]', vm.isGroupImagenes[position]);
      vm.showImageFull = false;
      if (isGroupItem) {
        vm.indexGroupItem = position;
        vm.isGroupImagenes = item;
        vm.imagePreview = vm.isGroupImagenes[position];
        vm.showImageFull = true;
      } else {
        vm.isGroupImagenes = [];
        vm.indexGroupItem = '';
        vm.imagePreview = item;
        vm.showImageFull = true;
      }
    },
    seleccionarImagen: function seleccionarImagen(index) {
      var vm = this;
      vm.indexGroupItem = index;
      vm.imagePreview = vm.isGroupImagenes[index];
    },
    closeDialogImage: function closeDialogImage() {
      var vm = this;
      vm.showImageFull = false;
      vm.imagePreview = {};
      vm.rotateDeg = 0;
    },
    descargarImagen: function descargarImagen(urlImage, name) {
      fetch(urlImage).then(function (resp) {
        return resp.blob();
      }).then(function (blob) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }).catch(function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])('error', 'Error', 'Ocurrio un error al intentar descargar el archivo');
      });
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_avatar_perfil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_avatar_perfil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__c_avatar_perfil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_item_ticket_lista__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_item_ticket_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_item_ticket_lista__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'avatar-perfil': __WEBPACK_IMPORTED_MODULE_1__c_avatar_perfil___default.a,
    'ticket-summary-info': __WEBPACK_IMPORTED_MODULE_2__components_c_item_ticket_lista___default.a
  },
  props: {
    toCita: {
      type: Boolean,
      default: false
    },
    noAvatar: {
      type: Boolean,
      default: false
    },
    numero: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      numeroTicket: this.numero || 0,
      tickets: []
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchTickets();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    seleccionarTicket: function seleccionarTicket(data) {
      var vm = this;
      var titulo = '' + data.razonSocial;
      if (data.serie) titulo += ' - ' + data.serie;
      // if (data.modelo)  titulo += ` - ${data.modelo}`
      data.titulo = titulo;
      vm.$emit('selected', data);
    },
    fetchTickets: function fetchTickets() {
      var vm = this;
      var url = '';
      var obj = {};
      if (vm.toCita) {
        url = '/ticket/obtener/dispobibles/para/cita';
        obj = {};
      }
      if (!url) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Los parametros enviados no son validos');
        return;
      }
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo tickets disponibles' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.tickets.push(data.lista[i]);
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: {
      type: String,
      default: 'Transacción en curso'
    }
  },
  data: function data() {
    return {
      isTransaction: true,
      interval: {},
      value: 0,
      timer: 20
    };
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var vm = this;
    clearInterval(vm.interval);
  },
  mounted: function mounted() {
    var vm = this;
    vm.interval = setInterval(function () {
      if (vm.value === 100) {
        return vm.value = 0;
      }
      vm.value += 5;
      vm.timer -= 1;
    }, 1000);
  },

  methods: {
    reloadPage: function reloadPage() {
      location.reload();
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_preview_files',
  props: {
    archivos: {
      type: Array,
      default: []
    },
    isSetProfile: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      indexPreview: '',
      filePreview: {},
      imgSRC: '',
      contentText: '',
      files: this.archivos
    };
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  created: function created() {
    var vm = this;
    vm.previewFile();
  },

  methods: {
    clearFiles: function clearFiles() {
      var vm = this;
      vm.files = [];
    },
    removeFile: function removeFile() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var vm = this;
      var objFile = vm.files[index];
      for (var i = 0; i < vm.files.length; i++) {
        var file = vm.files[i];
        if (i === vm.indexPreview) vm.imgSRC = '';
        if (file.name === objFile.name) vm.files.splice(i, 1);
      }
      // if (index === vm.indexPreview) vm.imgSRC = ''
      // vm.files.splice(index, 1)
      vm.$emit('remove', objFile);
      vm.swipePrev();
    },
    previewFile: function previewFile() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var vm = this;
      if (index !== -1) {
        vm.indexPreview = index;
        var reader = new FileReader();
        vm.filePreview = vm.files[vm.indexPreview] || {};
        if (vm.filePreview && vm.filePreview.type === 'image/png' || vm.filePreview.type === 'image/jpg' || vm.filePreview.type === 'image/jpeg') {
          reader.onloadend = function () {
            vm.imgSRC = reader.result;
          };
          if (vm.filePreview) reader.readAsDataURL(vm.filePreview);else vm.imgSRC = '';
        } else {
          vm.imgSRC = '';
        }

        if (vm.filePreview && vm.filePreview.type === 'text/plain') {
          reader.onloadend = function () {
            var contents = reader.result;
            var lines = contents.split('\n');
            vm.contentText = lines;
          };
          if (vm.filePreview) reader.readAsText(vm.filePreview);else vm.contentText = '';
        } else {
          vm.contentText = '';
        }
      }
    },
    swipePrev: function swipePrev() {
      var vm = this;
      var anterior = vm.indexPreview - 1;
      vm.previewFile(anterior >= 0 ? anterior : vm.files.length - 1);
    },
    swipeNext: function swipeNext() {
      var vm = this;
      var siguiente = vm.indexPreview + 1;
      vm.previewFile(siguiente <= vm.files.length - 1 ? siguiente : 0);
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'procesos_handler',
  data: function data() {
    return {
      procesos: [],
      interval: ''
    };
  },
  created: function created() {
    var vm = this;
    vm.rebuildProcessInterval();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    eliminarTodosLosProcesos: function eliminarTodosLosProcesos() {
      var vm = this;
      vm.procesos.forEach(function (e) {
        e.done && vm.eliminar(e);
      });
    },
    openUrl: function openUrl(o) {
      var vm = this;
      window.open(o.return.path, o.return.target || '_blank');
      window.location.reload(true);
      vm.eliminar(o);
    },
    rebuildProcessInterval: function rebuildProcessInterval() {
      var vm = this;
      if (vm.interval) clearInterval(vm.interval);
      vm.fetchProcesos();
      vm.interval = setInterval(function () {
        vm.fetchProcesos();
      }, 3000);
    },
    clearProcessInterval: function clearProcessInterval() {
      var vm = this;
      if (vm.interval) clearInterval(vm.interval);
    },
    fetchProcesos: function fetchProcesos() {
      // No se si deberiamos ponerlo aca, pero aca es donde más se rellena
      var vm = this;
      var url = '/procesos/';
      var obj = {};
      // Antes de todo, cortar todos los interval de los procesos actuales
      for (var i = 0; i < vm.procesos.length; i++) {
        clearInterval(vm.procesos[i].interval);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        if (!data.lista || data.lista.length === 0) {
          vm.procesos = [];
          vm.$store.dispatch('setCountAllDownloands', vm.procesos.length);
          vm.clearProcessInterval();
          vm.$store.dispatch('closeProcesos');
        } else {
          // Empezar los intervals de los procesos para el cronometro
          vm.procesos = data.lista;
          vm.$store.dispatch('setCountAllDownloands', vm.procesos.length);
          for (var i = 0; i < vm.procesos.length; i++) {
            vm.procesos[i].time = vm.getTime(vm.procesos[i].fechaInicio);
            (function (i) {
              if (!vm.procesos[i].done) {
                vm.procesos[i].interval = setInterval(function () {
                  vm.procesos[i].time = vm.getTime(vm.procesos[i].fechaInicio);
                }, 1000);
              }
            })(i);
          }

          if (vm.procesos.length === 0) {
            vm.procesos = [];
            vm.clearProcessInterval();
            vm.$store.dispatch('closeProcesos');
          } else {
            // Si es que hay, hay que revisar si ya todos estan terminados
            // Si ya estan todos terminados ya no hay que ir a buscar procesos
            var hayAlgunoPendiente = false;
            for (var l = vm.procesos.length - 1; l >= 0; l--) {
              if (!vm.procesos[l].done) {
                hayAlgunoPendiente = true;
              }
              if (!hayAlgunoPendiente) {
                vm.clearProcessInterval();
              }
            }
          }
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {});
    },
    downloadFile: function downloadFile(o) {
      // Aca debe estar el path, una vez que descarga, tiene que ir a eliminar el proceso
      window.open(o.path);
      this.eliminar(o.id);
    },
    eliminar: function eliminar(id, callback) {
      var vm = this;
      var url = '/procesos/';
      var obj = {
        id: id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["e" /* apiDelete */])(vm, url, obj, function (data) {
        if (!callback) vm.rebuildProcessInterval();else callback(null);
      }, function (err) {
        callback ? callback(err) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    getTime: function getTime(fechaInicio) {
      var rightNow = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
      var milisecond = rightNow.diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(fechaInicio));
      var tempTime = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(milisecond);

      var hour = tempTime.hours() + '';
      if (hour === '0') hour = '00';else if (hour.length === 1) hour = '0' + hour;

      var minute = tempTime.minutes() + '';
      if (minute === '0') minute = '00';else if (minute.length === 1) minute = '0' + minute;

      var second = tempTime.seconds() + '';
      if (second === '0') second = '00';else if (second.length === 1) second = '0' + second;
      return hour + ':' + minute + ':' + second;
    },
    fetchEliminarNotificaciones: function fetchEliminarNotificaciones(index, callback) {
      var vm = this;
      vm.eliminar(vm.procesos[index].id, function (err) {
        if (err) {
          callback(err);
        } else {
          index++;
          if (index === vm.procesos.length) callback(null);else vm.fetchEliminarNotificaciones(index, callback);
        }
      });
    },
    eliminarTodasLasDescargas: function eliminarTodasLasDescargas() {
      var vm = this;
      vm.fetchEliminarNotificaciones(0, function (err) {
        if (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
          return;
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'success', 'Exito', 'Las descargas se eliminarón correctamente');
        vm.rebuildProcessInterval();
      });
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id', 'preview', 'tipo', 'filtros', 'tipoPredefinido', 'tipoticket'],
  components: {
    'lista-draggable': __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
  },
  data: function data() {
    return {
      tab: 0,
      idReporte: this.id || 0,
      columnasAExportar: [],
      columnasTicket: [],
      columnasEtapas: [],
      columnasEstados: [],
      columnasTiempos: [],
      formatosExportar: ['Excel'],
      formatoAExportar: 'Excel',
      tipoPreview: this.preview || 'draft',
      tipoReporte: this.tipo || '',
      filtrosDraft: this.filtros || {},
      isColumnasAllSeleccionadasTicket: false,
      isColumnasAllSeleccionadasEtapas: false,
      isColumnasAllSeleccionadasTiempos: false,
      isColumnasAllSeleccionadasEstados: false,
      descripcionPredefinido: this.tipoPredefinido ? 'tickets-' + this.tipoticket + '-' + this.tipoPredefinido.replace(' ', '-') : '',
      reportesPredefinidos: [],
      optionDragable: {
        animation: 0,
        group: 'description',
        handle: '.handle'
      }
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchColumnasDeLaTablaTicket();
    vm.fetchObtenerColumnsEtapasEstados('etapas');
    vm.fetchObtenerColumnsEtapasEstados('estados');
    vm.fetchObtenerColumnsEtapasEstados('tiempos');
    if (vm.descripcionPredefinido && vm.tipoticket) {
      vm.fetchObtenerListadoReportes();
    }
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    countLengthColumns: function countLengthColumns(tipo) {
      var vm = this;
      var ticketCount = 0;
      var estadoCount = 0;
      var etapaCount = 0;
      var tiempoCount = 0;
      for (var i = 0; i < vm.columnasAExportar.length; i++) {
        var e = vm.columnasAExportar[i];
        if (e.isTicket) ticketCount++;else if (e.isEstado) estadoCount++;else if (e.isEtapa) etapaCount++;else if (e.isTiempo) tiempoCount++;
      }

      if (tipo === 'ticket') return ticketCount;else if (tipo === 'estado') return estadoCount;else if (tipo === 'etapa') return etapaCount;else if (tipo === 'tiempo') return tiempoCount;
    },
    seleccionarTodasLasColumnasTicket: function seleccionarTodasLasColumnasTicket() {
      var vm = this;
      if (vm.isColumnasAllSeleccionadasTicket) {
        vm.columnasAExportar = vm.columnasAExportar.filter(function (e) {
          return !e.isTicket;
        });
        vm.columnasTicket.forEach(function (el, i) {
          vm.columnasAExportar.push(el);
        });
      } else {
        vm.columnasAExportar = vm.columnasAExportar.filter(function (e) {
          return !e.isTicket;
        });
      }
    },
    seleccionarTodasLasColumnasEstados: function seleccionarTodasLasColumnasEstados() {
      var vm = this;
      if (vm.isColumnasAllSeleccionadasEstados) {
        vm.columnasAExportar = vm.columnasAExportar.filter(function (e) {
          return !e.isEstado;
        });
        vm.columnasEstados.forEach(function (el, i) {
          vm.columnasAExportar.push(el);
        });
      } else {
        vm.columnasAExportar = vm.columnasAExportar.filter(function (e) {
          return !e.isEstado;
        });
      }
    },
    seleccionarTodasLasColumnasEtapas: function seleccionarTodasLasColumnasEtapas() {
      var vm = this;
      if (vm.isColumnasAllSeleccionadasEtapas) {
        vm.columnasAExportar = vm.columnasAExportar.filter(function (e) {
          return !e.isEtapa;
        });
        vm.columnasEtapas.forEach(function (el, i) {
          vm.columnasAExportar.push(el);
        });
      } else {
        vm.columnasAExportar = vm.columnasAExportar.filter(function (e) {
          return !e.isEtapa;
        });
      }
    },
    seleccionarTodasLasColumnasTiempos: function seleccionarTodasLasColumnasTiempos() {
      var vm = this;
      if (vm.isColumnasAllSeleccionadasTiempos) {
        vm.columnasAExportar = vm.columnasAExportar.filter(function (e) {
          return !e.isTiempo;
        });
        vm.columnasTiempos.forEach(function (el, i) {
          vm.columnasAExportar.push(el);
        });
      } else {
        vm.columnasAExportar = vm.columnasAExportar.filter(function (e) {
          return !e.isTiempo;
        });
      }
    },
    closeDialogExportar: function closeDialogExportar() {
      var vm = this;
      vm.$emit('close');
    },
    fetchExportarReporte: function fetchExportarReporte() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vm, url, reporteId, isAddColumnsTicket, isAddFechasEstado, isAddFechasEtapas, isAddFechasTiempos, obj;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this;

                if (vm.columnasAExportar.length) {
                  _context.next = 4;
                  break;
                }

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor seleccione algunas columnas para exportar');
                return _context.abrupt('return');

              case 4:
                url = 'ticket/obtener/reporte';

                if (vm.descripcionPredefinido) {
                  reporteId = vm.reportesPredefinidos.find(function (e) {
                    return e.descripcion === vm.descripcionPredefinido;
                  });

                  vm.idReporte = reporteId.id;
                }

                _context.next = 8;
                return vm.columnasAExportar.some(function (e) {
                  return e.isTicket;
                });

              case 8:
                isAddColumnsTicket = _context.sent;
                _context.next = 11;
                return vm.columnasAExportar.some(function (e) {
                  return e.isEstado;
                });

              case 11:
                isAddFechasEstado = _context.sent;
                _context.next = 14;
                return vm.columnasAExportar.some(function (e) {
                  return e.isEtapa;
                });

              case 14:
                isAddFechasEtapas = _context.sent;
                _context.next = 17;
                return vm.columnasAExportar.some(function (e) {
                  return e.isTiempo;
                });

              case 17:
                isAddFechasTiempos = _context.sent;
                obj = {
                  idReporte: vm.idReporte,
                  columnas: vm.columnasAExportar,
                  tipoPreview: vm.tipoPreview, // save o draft
                  tipoReporte: vm.tipoReporte, // basico o avanzado
                  filtrosDraft: vm.filtrosDraft, // filtros basicos o avanzados,
                  isExcel: true,
                  isAddFechasEstado: isAddFechasEstado,
                  isAddFechasEtapas: isAddFechasEtapas,
                  isAddFechasTiempos: isAddFechasTiempos,
                  isAddColumnsTicket: isAddColumnsTicket
                };


                console.log('obj', obj);

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, url, obj, function (data) {
                  vm.closeDialogExportar();
                  vm.$store.dispatch('setOpenPopupNotifications', true);
                  vm.$store.dispatch('openProcesos');
                }, function (err) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
                });

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchColumnasDeLaTablaTicket: function fetchColumnasDeLaTablaTicket() {
      var vm = this;
      var url = '/ticket/get/columns';
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo columnas predeterminadas' });
      var obj = {
        formateado: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.columnasTicket.push(data.lista[i]);
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchObtenerListadoReportes: function fetchObtenerListadoReportes() {
      var vm = this;
      var url = 'reporte/obtener';
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo listado de reportes' });
      var obj = {
        tipoListado: 1
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.reportesPredefinidos = data.lista;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchObtenerColumnsEtapasEstados: function fetchObtenerColumnsEtapasEstados(tipo) {
      var vm = this;
      var url = 'ticket/get/columns/etapas/estados';
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo columnas adicionales.' });
      var tipoTicketEnviar = '';
      if (vm.tipoPreview === 'draft') {
        if (vm.filtrosDraft.hasOwnProperty('tipo')) {
          if (vm.filtrosDraft.tipo !== '-1') {
            tipoTicketEnviar = vm.filtrosDraft.tipo;
          }
        }
      } else {
        tipoTicketEnviar = vm.tipoticket;
      }
      var obj = {
        tipo: tipo,
        tipoTicket: tipoTicketEnviar,
        idReporte: vm.id
      };

      console.log('envio estpas', obj);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        console.log('regreso etapas', data);
        for (var i = 0; i < data.columnas.length; i++) {
          if (tipo === 'etapas') vm.columnasEtapas.push(data.columnas[i]);else if (tipo === 'estados') vm.columnasEstados.push(data.columnas[i]);else if (tipo === 'tiempos') vm.columnasTiempos.push(data.columnas[i]);
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__c_reporte_parametros_exportacion__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__c_reporte_parametros_exportacion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__c_reporte_parametros_exportacion__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tipo'],
  components: {
    'parametros-exportacion': __WEBPACK_IMPORTED_MODULE_3__c_reporte_parametros_exportacion___default.a
  },
  data: function data() {
    return {
      headerTable: [{
        text: 'Numero',
        align: 'start',
        value: 'numero'
      }, {
        text: 'Fecha',
        align: 'start',
        value: 'fechaRegistro'
      }, {
        text: 'Tipo',
        align: 'start',
        value: 'tipoticket'
      }, {
        text: 'Abierto',
        align: 'start',
        value: 'abierto'
      }, {
        text: 'Etapa',
        align: 'start',
        value: 'etapaEstado'
      }, {
        text: 'Estado',
        align: 'start',
        value: 'descripcionEstado'
      }, {
        text: 'Cliente',
        align: 'start',
        value: 'razonSocial'
      },
      // {
      //   text: 'Cliente',
      //   align: 'start',
      //   value: 'razonSocial'
      // },
      // {
      //   text: 'Codigo falla',
      //   align: 'start',
      //   value: 'codigoFalla'
      // },
      // {
      //   text : 'Falla',
      //   align: 'start',
      //   value: 'descripcionFalla'
      // },
      // {
      //   text: 'Estado',
      //   align: 'start',
      //   value: 'estado'
      // },
      // {
      //   text: 'codigoTecnico',
      //   align: 'start',
      //   value: 'codigoTecnico'
      // },
      // {
      //   text: 'codigoTipoContrato',
      //   align: 'start',
      //   value: 'codigoTipoContrato'
      // },
      // {
      //   text: 'comentarioFalla',
      //   align: 'start',
      //   value: 'comentarioFalla'
      // },
      // {
      //   text: 'comentarioGeneral',
      //   align: 'start',
      //   value: 'comentarioGeneral'
      // },
      // {
      //   text: 'comproAqui',
      //   align: 'start',
      //   value: 'comproAqui'
      // },
      // {
      //   text: 'descripcion',
      //   align: 'start',
      //   value: 'descripcion'
      // },
      // {
      //   text: 'contrato',
      //   align: 'start',
      //   value: 'descripcionTipoContrato'
      // },
      // {
      //   text : 'Equipo',
      //   align: 'start',
      //   value: 'descripcionTipoEquipo'
      // },
      // {
      //   text: 'descripcionTipoInforme',
      //   align: 'start',
      //   value: 'descripcionTipoInforme'
      // },
      // {
      //   text: 'Anulará',
      //   align: 'start',
      //   value: 'diasParaAutoAnulacion'
      // },
      // {
      //   text: 'Direccion',
      //   align: 'start',
      //   value: 'direccion'
      // },
      // {
      //   text: 'emailTecnico',
      //   align: 'start',
      //   value: 'emailTecnico'
      // },
      {
        text: 'Taller',
        align: 'start',
        value: 'equipoIngresadoaATaller'
      },
      // {
      //   text: 'factura',
      //   align: 'start',
      //   value: 'factura'
      // },

      // {
      //   text: 'fechaUltimaActividad',
      //   align: 'start',
      //   value: 'fechaUltimaActividad'
      // },
      // {
      //   text: 'foto',
      //   align: 'start',
      //   value: 'foto'
      // },
      // {
      //   text: 'idCita',
      //   align: 'start',
      //   value: 'idCita'
      // },
      // {
      //   text: 'marca',
      //   align: 'start',
      //   value: 'marca'
      // },
      // {
      //   text: 'modelo',
      //   align: 'start',
      //   value: 'modelo'
      // },
      // {
      //   text: 'nombreTecnico',
      //   align: 'start',
      //   value: 'nombreTecnico'
      // },
      // {
      //   text: 'nombreUsuarioUltimaActividad',
      //   align: 'start',
      //   value: 'nombreUsuarioUltimaActividad'
      // },
      // {
      //   text: 'numeroContrato',
      //   align: 'start',
      //   value: 'numeroContrato'
      // },
      // {
      //   text : 'Informe',
      //   align: 'start',
      //   value: 'numeroInformeTecnico'
      // },
      // {
      //   text: 'origenUltimaActividad',
      //   align: 'start',
      //   value: 'origenUltimaActividad'
      // },
      {
        text: 'Serie',
        align: 'start',
        value: 'serie'
      },
      // {
      //   text: 'sigueEnGarantia',
      //   align: 'start',
      //   value: 'sigueEnGarantia'
      // },
      // {
      //   text: 'tiempoRespuesta',
      //   align: 'start',
      //   value: 'tiempoRespuesta'
      // },
      {
        text: 'Area',
        align: 'start',
        value: 'tipoArea'
      },
      // {
      //   text: 'Zona',
      //   align: 'start',
      //   value: 'tipoArea'
      // },
      // {
      //   text: 'tipoEquipo',
      //   align: 'start',
      //   value: 'tipoEquipo'
      // },
      // {
      //   text: 'tipoInforme',
      //   align: 'start',
      //   value: 'tipoInforme'
      // },
      // {
      //   text: 'usuario',
      //   align: 'start',
      //   value: 'usuario'
      // }
      // {
      //   text: 'Area',
      //   align: 'start',
      //   value: 'tipoArea'
      // },
      // {
      //   text: 'usuarioUltimaActividad',
      //   align: 'start',
      //   value: 'usuarioUltimaActividad'
      // },
      // {
      //   text: 'vigenciaContrato',
      //   align: 'start',
      //   value: 'vigenciaContrato'
      // },
      // {
      //   text: 'zona',
      //   align: 'start',
      //   value: 'zona'
      // },
      {
        text: 'Zona',
        align: 'start',
        value: 'zonaGarantia'
      }, { text: 'Acciones', value: 'actions', sortable: false, width: '50' }],
      lista: [],
      numeroRecnum: 0,
      disabledScrollExcecute: true,
      noMore: false,
      isScroll: true,
      idReporte: this.$route.query.id,
      tipoPreview: this.tipo || 'draft',
      filtrosDraft: null,
      tipoReporte: this.$route.query.tipoReporte,
      datosReporte: {},
      isModalExportar: false,
      columnasTicket: [],
      isSeleccionarTodoColumnas: false
    };
  },
  created: function created() {
    var vm = this;
    vm.handlerParseFormatQuerString(function (err) {
      if (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err);
        return;
      }

      if (vm.tipoPreview === 'save') vm.fetch();else vm.fetchDatosReporte();
    });
  },

  filters: {
    formatoFecha: function formatoFecha(value) {
      if (!value) return '';
      return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(value).format('DD/MM/YYYY HH:ss');
    }
  },
  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    handlerParseFormatQuerString: function handlerParseFormatQuerString(callback) {
      var vm = this;
      if (vm.tipoPreview === 'draft') {
        vm.filtrosDraft = null;
        var parametrosQuery = vm.$route.query;
        if (parametrosQuery.tipoReporte === 'basico') {
          vm.filtrosDraft = parametrosQuery;
          callback(null);
        } else if (parametrosQuery.tipoReporte === 'avanzado') {
          vm.filtrosDraft = [];
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(parametrosQuery).forEach(function (e) {
            var value = parametrosQuery[e].split(',');
            vm.filtrosDraft.push({
              columna: { valor: e },
              condicion: { valor: value[0] },
              value: value[1]
            });
          });
          callback(null);
        } else {
          callback('En los parametros no existe ningun tipo de reporte valido');
        }
      } else {
        callback(null);
      }
    },
    openDialogExportar: function openDialogExportar() {
      var vm = this;
      vm.isModalExportar = true;
    },
    closeDialogExportar: function closeDialogExportar() {
      var vm = this;
      vm.isModalExportar = false;
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetchDatosReporte: function fetchDatosReporte() {
      var vm = this;
      var url = 'ticket/obtener/reporte';
      if (!vm.isScroll) {
        vm.lista = [];
        vm.numeroRecnum = 0;
      }

      vm.disabledScrollExcecute = true;
      vm.noMore = false;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo listado de tickets' });
      var obj = {
        idReporte: vm.idReporte,
        numeroRecnum: vm.numeroRecnum,
        tipoPreview: vm.tipoPreview, // save or draft
        tipoReporte: vm.tipoReporte, // basico or avanzado
        filtrosDraft: vm.filtrosDraft // filtros basicos o avanzados
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExcecute = true;
        } else {
          vm.numeroRecnum = data.numeroRecnum;
          vm.disabledScrollExcecute = false;
        }
      }, function (err) {
        vm.disabledScrollExcecute = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isScroll = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.datosReporte = {};
      var url = 'reporte/obtener';
      vm.disabledScrollExcecute = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo datos del reporte' });
      vm.noMore = false;
      var parametrosQuery = vm.$route.query;
      var obj = {
        id: vm.idReporte,
        tipoListado: parametrosQuery.default
      };
      console.log('objjjj', obj);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        console.log('daaaaaaaaa', data);
        vm.datosReporte = data.lista[0];
        vm.fetchDatosReporte();
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    goTo: function goTo(page) {
      // var vm = this
      window.open(page, '_blank');
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_theme_changer',
  data: function data() {
    return {
      menu: false,
      empresaFull: "reprodata" || 'datacont',
      // empresaFull: 'reprodata',
      themes: [{
        name: 'datacont',
        light: {
          primary: '#d70b18',
          secondary: '#ffedef',
          error: '#f14668',
          background: '#ebeff3',
          success: '#00d370',
          opacity: '#d70b18c2'
        },
        dark: {
          primary: '#b80813',
          secondary: '#441115',
          error: '#f14668',
          background: '#272727',
          success: '#00d370',
          opacity: '#b80813cc'
        }
      }, {
        name: 'reprodata',
        light: {
          primary: '#e6007e',
          secondary: '#ffedf7',
          error: '#f14668',
          background: '#ebeff3',
          success: '#00d370',
          opacity: '#e6007ecc'
        },
        dark: {
          primary: '#e6007e',
          secondary: '#35272f',
          error: '#f14668',
          background: '#272727',
          success: '#00d370',
          opacity: '#e6007ecc'
        }
      }]
    };
  },
  created: function created() {
    var vm = this;
    var thema = vm.themes.find(function (e) {
      return e.name === vm.empresaFull;
    });
    vm.setTheme(thema);
  },

  methods: {
    setTheme: function setTheme(theme) {
      var vm = this;
      // cerrar menu
      vm.menu = false;
      var name = theme.name;
      var dark = theme.dark;
      var light = theme.light;
      // establecer temas
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dark).forEach(function (i) {
        vm.$vuetify.theme.themes.dark[i] = dark[i];
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(light).forEach(function (i) {
        vm.$vuetify.theme.themes.light[i] = light[i];
      });
      // también guarde el nombre del tema para deshabilitar la selección
      vm.$vuetify.theme.themes.name = name;
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_usuarios_involucrados_ticket__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_usuarios_involucrados_ticket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_usuarios_involucrados_ticket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_item_timeline__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_item_timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_item_timeline__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_timeline_actividades_ticket',
  components: {
    'usuarios-involucrados': __WEBPACK_IMPORTED_MODULE_4__components_c_usuarios_involucrados_ticket___default.a,
    'item-time-line': __WEBPACK_IMPORTED_MODULE_5__components_c_item_timeline___default.a
  },
  props: ['numero'],
  data: function data() {
    return {
      actividades: [],
      isLoading: false
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchActividades();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    textIsURL: function textIsURL(text) {
      var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
      return pattern.test(text);
    },
    fetchActividades: function fetchActividades() {
      var isLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var vm = this;
      console.log('fetch actividades.........................');
      if (isLoading) vm.actividades = [];
      // vm.isLoading = isLoading
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo actividades' });
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/ticket/' + vm.numero + '/actividades', obj, function (data) {
        var actividadesConsolidado = [];
        for (var i = 0; i < data.actividades.length; i++) {
          var e = data.actividades[i];
          if (e.tipo === 'adjunto' && e.tipoAdjunto.includes('image') && !e.oculto) {
            var fechaActividad = __WEBPACK_IMPORTED_MODULE_2_moment___default()(e.fecha).format('DD/MM/YYYY HH:mm');
            var similares = [];
            data.actividades.forEach(function (ac) {
              if (ac.tipo === 'adjunto' && ac.tipoAdjunto.includes('image') && fechaActividad === __WEBPACK_IMPORTED_MODULE_2_moment___default()(ac.fecha).format('DD/MM/YYYY HH:mm') && ac.origen === e.origen && !ac.oculto) {
                similares.push(ac);
              }
            });
            if (similares.length > 1) {
              var size = similares.length;

              actividadesConsolidado.push({
                group: true,
                imagenes: similares,
                origen: similares[0].origen,
                tipoAdjunto: similares[0].tipoAdjunto,
                fechaLegible: similares[0].fechaLegible,
                render1: size >= 1,
                render2: size >= 2,
                render3: size >= 3,
                render4: size >= 4,
                countMore: size > 4 ? size - 4 : 0,
                tipo: 'adjunto',
                nombre: similares[0].nombre,
                cargo: similares[0].cargo,
                accion: 'Ha adjutado ' + size + ' imagenes'
              });
            } else {
              actividadesConsolidado.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ group: false }, e));
            }
          } else {
            actividadesConsolidado.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ group: false }, e));
          }
        }

        vm.actividades = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqWith(actividadesConsolidado, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual);
        vm.$emit('updated', vm.actividades[0].fecha);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
        // vm.isLoading = false
      });
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_adjuntar_archivos__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_adjuntar_archivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_adjuntar_archivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'View_user_profile',
  props: {
    username: {
      type: String
    },
    validar: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'adjuntar-archivos': __WEBPACK_IMPORTED_MODULE_1__components_c_adjuntar_archivos___default.a,
    'avatar-perfil': __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil___default.a
  },
  data: function data() {
    return {
      currentPassword: '',
      newPassword: '',
      newPasswordRepeat: '',
      usuario: {},
      showPassword: false,
      showPassword1: false,
      showPassword2: false,
      perfil: localStorage.getItem('perfil'),
      usuarioLogged: localStorage.getItem('username'),
      tab: 0,
      isSetPassword: false,
      isUploadAvatar: false,
      isActiveAccount: false,
      file: null,
      isUsuarioEmpresa: false,
      perfiles: [{
        nombre: 'usuario',
        esUnPerfilDeLaEmpresa: false
      }, {
        nombre: 'usuario-contrato',
        esUnPerfilDeLaEmpresa: false
      }, {
        nombre: 'tecnico taller',
        esUnPerfilDeLaEmpresa: true
      },
      // {
      //   nombre : 'tecnico',
      //   esUnPerfilDeLaEmpresa : false
      // },
      {
        nombre: 'supervisor',
        esUnPerfilDeLaEmpresa: true
      }, {
        nombre: 'recepcion',
        esUnPerfilDeLaEmpresa: true
      }, {
        nombre: 'dispatcher',
        esUnPerfilDeLaEmpresa: true
      }, {
        nombre: 'sistemas',
        esUnPerfilDeLaEmpresa: true
      }],
      departamentos: [],
      provincias: [],
      distritos: [],
      ubigeos: [],
      zonasGarantia: ['lima', 'arequipa', 'sin asignacion'],
      tipoAreas: ['campo', 'taller', 'sin asignacion'],
      isLoadingDepartamentos: false,
      isLoadingProvincias: false,
      isLoadingDistritos: false,
      isLoadingActivating: false,
      isLoadingUbigeos: false,
      tiposUsuario: [{
        name: 'Persona Natural',
        value: 'persona natural',
        icon: 'person'
      }, {
        name: 'Empresa',
        value: 'empresa',
        icon: 'apartment'
      }]
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchUbigeos(false, function (err) {
      if (err) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un numero de RUC');
      vm.fetchUsuario();
    });
  },

  filters: {
    fecha: function fecha(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:MM');
    }
  },
  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    progress: function progress() {
      var vm = this;
      return Math.min(100, vm.newPassword.length * 16.7);
    },
    color: function color() {
      var vm = this;
      return ['error', 'warning', 'success'][Math.floor(vm.progress / 40)];
    }
  },
  methods: {
    lowercase: function lowercase(e) {
      var vm = this;
      vm.usuario.usuario = e.target.value.toLowerCase();
    },
    validateEmail: function validateEmail(email) {
      return (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      );
    },
    fetchGetDatosSunat: function fetchGetDatosSunat() {
      var vm = this;

      if (!vm.usuario.ruc) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un numero de RUC');
        vm.$refs.ruc.focus();
        return;
      }

      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo información de SUNAT' });
      var obj = {
        ruc: vm.usuario.ruc
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/cliente/sunat', obj, function (data) {
        if (data.empresa) {
          vm.usuario.direccion = data.empresa.direccion;
          vm.usuario.razonSocial = data.empresa.nombre_o_razon_social;
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    getImagenToProfile: function getImagenToProfile() {
      var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var vm = this;
      var objFile = file ? file[0] : {};
      vm.fetchUploadFile(objFile, function (err, response) {
        if (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
          return;
        }
        vm.file = null;
        vm.usuario.foto = response.ruta;
        vm.fetchActualizarFotoPerfil(function (err) {
          if (err) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
            return;
          }

          vm.$store.dispatch('transaccion', { isProceso: false });
          vm.closeModalAdjuntar();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Tu foto de perfil se actualizo correctamente');
        });
      });
    },
    openModalAdjuntar: function openModalAdjuntar() {
      var vm = this;
      vm.isUploadAvatar = true;
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.isUploadAvatar = false;
    },
    openModalIsActiveAccount: function openModalIsActiveAccount() {
      var vm = this;
      vm.isActiveAccount = true;
    },
    closeModalIsActiveAccount: function closeModalIsActiveAccount() {
      var vm = this;
      vm.isActiveAccount = false;
    },
    closeModalSetPassword: function closeModalSetPassword() {
      var vm = this;
      vm.isSetPassword = false;
      vm.currentPassword = '';
    },
    redirectProteccion: function redirectProteccion() {
      // var vm = this
      window.open('https://www.minjus.gob.pe/wp-content/uploads/2013/04/LEY-29733.pdf', '_blanck');
    },
    rellenarInformacion: function rellenarInformacion(tipo) {
      var vm = this;
      if (tipo === 'departamento') {
        vm.provincias = [];
        vm.usuario.provincia = '';
        vm.distritos = [];
        vm.usuario.distrito = '';
      } else if (tipo === 'provincia') {
        vm.distritos = [];
        vm.usuario.distrito = '';
      }

      for (var i = 0; i < vm.ubigeos.length; i++) {
        if (tipo === 'departamento') {
          if (vm.usuario.departamento === vm.ubigeos[i].departamento) {
            vm.provincias.push(vm.ubigeos[i].provincia);
          }
        } else if (tipo === 'provincia') {
          if (vm.usuario.provincia === vm.ubigeos[i].provincia) {
            vm.distritos.push(vm.ubigeos[i].distrito);
          }
        }
      }

      if (vm.usuario.departamento && vm.usuario.provincia && vm.usuario.distrito) {
        vm.usuario.ubigeo = vm.ubigeos.find(function (e) {
          return e.descripcion === vm.usuario.departamento + '-' + vm.usuario.provincia + '-' + vm.usuario.distrito;
        }).ubigeo;
      } else vm.usuario.ubigeo = '';
    },
    fetchUbigeos: function fetchUbigeos(ingresoUbigeo, callback) {
      var vm = this;
      vm.isLoadingUbigeos = true;
      var obj = {
        codigo: vm.usuario.ubigeo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/ubigeo/obtener', obj, function (data) {
        if (ingresoUbigeo) {
          var lista = data.lista[0];
          for (var j = 0; j < vm.ubigeos.length; j++) {
            if (lista.departamento === vm.ubigeos[j].departamento) {
              vm.provincias.push(vm.ubigeos[j].provincia);
            }

            if (lista.provincia === vm.ubigeos[j].provincia) {
              vm.distritos.push(vm.ubigeos[j].distrito);
            }
          }
          vm.usuario.departamento = lista.departamento;
          vm.usuario.provincia = lista.provincia;
          vm.usuario.distrito = lista.distrito;
        } else {
          vm.ubigeos = data.lista;
          for (var i = 0; i < data.lista.length; i++) {
            vm.departamentos.push(data.lista[i].departamento);
          }
        }
        callback && callback();
      }, function (error) {
        callback ? callback(error) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingUbigeos = false;
      });
    },
    fetchUsuario: function fetchUsuario() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo tus datos' });
      var obj = {
        usuario: vm.username
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/usuario/obtener', obj, function (data) {
        vm.usuario = data.lista[0];
        vm.usuario.puedeCambiarRucDeCliente = vm.usuario.puedeCambiarRucDeCliente === 1;
        vm.usuario.usuarioAntiguo = vm.usuario.usuario;
        var perfilEncontrado = vm.perfiles.find(function (e) {
          return e.nombre === vm.usuario.perfil;
        });
        vm.isUsuarioEmpresa = perfilEncontrado.esUnPerfilDeLaEmpresa;
        for (var i = 0; i < vm.ubigeos.length; i++) {
          if (vm.usuario.departamento) {
            if (vm.usuario.departamento === vm.ubigeos[i].departamento) {
              vm.provincias.push(vm.ubigeos[i].provincia);
            }
          }

          if (vm.usuario.provincia) {
            if (vm.usuario.provincia === vm.ubigeos[i].provincia) {
              vm.distritos.push(vm.ubigeos[i].distrito);
            }
          }
        }
        if (!vm.usuario.entidad) vm.usuario.entidad = 'persona natural';
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchGuardarCambios: function fetchGuardarCambios() {
      var isNotify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      var vm = this;
      var obj = {
        usuario: vm.usuario.usuario,
        usuarioAntiguo: vm.usuario.usuario,
        nombre: vm.usuario.nombre,
        telefono: vm.usuario.telefono,
        cargo: vm.usuario.cargo,
        direccion: vm.usuario.direccion,
        // tipoCliente                : vm.usuario.tipoCliente,
        entidad: vm.usuario.entidad,
        documento: vm.usuario.documento,
        razonSocial: vm.usuario.razonSocial,
        departamento: vm.usuario.departamento,
        provincia: vm.usuario.provincia,
        distrito: vm.usuario.distrito,
        ubigeo: vm.usuario.ubigeo,
        ruc: vm.usuario.ruc,
        perfil: vm.usuario.perfil,
        zonaGarantia: vm.usuario.zonaGarantia,
        tipoArea: vm.usuario.tipoArea,
        currentPassword: vm.currentPassword,
        puedeCambiarRucDeCliente: vm.usuario.puedeCambiarRucDeCliente ? 1 : 0,
        aceptaPoliticasDeprivacidad: vm.usuario.aceptaPoliticasDeprivacidad ? 1 : 0

        // Validamos
      };if (!vm.usuario.usuario) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor no deje el email en blanco');
        vm.$refs.email.focus();
        vm.closeModalSetPassword();
        return;
      } else {
        if (!vm.validateEmail(vm.usuario.usuario)) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El email no cumple con el formato adecuado');
          vm.$refs.email.focus();
          vm.closeModalSetPassword();
          return;
        }
      }

      if (vm.validar) {
        if (vm.usuario.entidad === 'empresa' && !vm.usuario.ruc && !vm.isUsuarioEmpresa) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor ingrese el numero de RUC');
          vm.$refs.ruc.focus();
          vm.closeModalSetPassword();
          return;
        }

        if (!vm.usuario.documento && !vm.isUsuarioEmpresa) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor no deje el documento en blanco');
          vm.$refs.documento.focus();
          vm.closeModalSetPassword();
          return;
        }

        if (vm.usuario.entidad !== 'empresa' && !vm.usuario.nombre && !vm.isUsuarioEmpresa) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor no deje el nombre en blanco');
          vm.$refs.nombreCompleto.focus();
          vm.closeModalSetPassword();
          return;
        }

        if (vm.usuario.entidad === 'empresa' && !vm.usuario.razonSocial) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor no deje la razon social en blanco');
          vm.$refs.razonsocial.focus();
          vm.closeModalSetPassword();
          return;
        }

        if (!vm.usuario.telefono && !vm.isUsuarioEmpresa) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor no deje el telefono en blanco');
          vm.$refs.telefono.focus();
          vm.closeModalSetPassword();
          return;
        }

        if (!vm.usuario.direccion && !vm.isUsuarioEmpresa) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor no deje la direccion en blanco');
          vm.$refs.direccion.focus();
          vm.closeModalSetPassword();
          return;
        }
      }

      if (vm.newPassword) {
        if (vm.newPassword !== vm.newPasswordRepeat) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Las contraseñas nuevas ingresadas no coinciden, por favor verifique');
          return;
        } else {
          obj.newPassword = vm.newPassword;
          obj.currentPassword = vm.currentPassword;
        }
      }

      if (!vm.currentPassword) {
        if (isNotify) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor ingrese su contraseña actual');
          vm.$refs.currentPassword.focus();
          return;
        } else {
          if (!vm.validar) vm.currentPassword = 'tukutin#40';
          vm.isSetPassword = true;
          return;
        }
      }

      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Actualizando tus datos' });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/usuario/actualizar', obj, function (data) {
        if (vm.validar) {
          localStorage.setItem('token', data.token);
          localStorage.setItem('perfil', data.datos.perfil);
          localStorage.setItem('username', data.datos.usuario);
          localStorage.setItem('codigoCliente', data.datos.codigoCliente);
          localStorage.setItem('nombre', data.datos.nombre);
          localStorage.setItem('razonSocial', data.datos.razonSocial);
          localStorage.setItem('entidad', data.datos.entidad);
        }
        if (callback) {
          callback(null);
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Datos guardados correctamente');
          vm.clearForm();
        }
      }, function (error) {
        callback ? callback(error) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchActualizarFotoPerfil: function fetchActualizarFotoPerfil(callback) {
      var vm = this;
      var obj = {
        username: vm.usuario.usuario,
        foto: vm.usuario.foto
      };
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Actualizando foto de perfil' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/usuario/actualizar/foto', obj, function (data) {
        callback(null, data);
      }, function (error) {
        callback(error);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchActivateAccount: function fetchActivateAccount() {
      var vm = this;
      vm.isLoadingActivating = true;
      var obj = {
        email: vm.usuario.usuario
      };
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Activando cuenta' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/usuario/activar/cuenta', obj, function (data) {
        vm.closeModalIsActiveAccount();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'La cuenta fue activada correctamente');
        vm.fetchUsuario();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
        vm.isLoadingActivating = false;
      });
    },
    clearForm: function clearForm() {
      var vm = this;
      vm.currentPassword = '';
      vm.newPassword = '';
      vm.newPasswordRepeat = '';
      vm.closeModalSetPassword();
    },
    fetchUploadFile: function fetchUploadFile(file, callback) {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Actualizando imagen de perfil' });
      var fd = new FormData();
      var apiUploadRoute = "https://api-sil.datacont.com";
      var url = apiUploadRoute + '/upload';
      fd.append('file', file);
      var params = {
        carpeta: 'img-perfiles',
        usuario: localStorage.getItem('usuario')
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["d" /* apiUploadWithParams */])(vm, url, fd, params, function (res) {
        callback(null, res);
      }, function (err) {
        vm.$store.dispatch('transaccion', { isProceso: false });
        callback(err);
      });
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    numero: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      involucrados: [],
      isLoading: false,
      model: null
    };
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/ticket/' + vm.numero + '/actividades/involucrados', obj, function (data) {
        vm.involucrados = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_usuarios_lista_seleccionar',
  props: {
    showChangeFoto: {
      type: Boolean,
      default: false
    },
    noSolo: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    modoLista: {
      type: Boolean,
      default: false
    },
    username: {
      type: String,
      default: ''
    },
    codigoTecnico: {
      type: Number,
      default: 0
    },
    perfiles: {
      type: Array
    }
  },
  data: function data() {
    return {
      isLoading: false,
      lista: [],
      seleccionado: this.multiple ? [] : {},
      menu: false,
      usuarioDetalles: {}
    };
  },
  created: function created() {
    this.fetch();
  },

  computed: {
    isMovil: function isMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    seleccionarFotoPerfil: function seleccionarFotoPerfil() {
      this.$emit('user-change-perfil', this.usuarioDetalles);
    },
    verPdfSctr: function verPdfSctr(rutaSctr) {
      var src = rutaSctr || this.usuarioDetalles.rutaSctr;
      if (src) window.open(src, '_blank');
    },
    showModal: function showModal(item) {
      this.usuarioDetalles = item;
      this.menu = true;
    },
    remove: function remove(item) {
      if (this.multiple) {
        var index = this.seleccionado.findIndex(function (e) {
          return e.codigoTecnico === item.codigoTecnico;
        });
        if (index >= 0) this.seleccionado.splice(index, 1);
      } else {
        this.seleccionado = {};
      }
      this.$emit('user-delete', item);
    },
    removeAll: function removeAll() {
      this.seleccionado = this.multiple ? [] : {};
    },
    seleccionarUsuario: function seleccionarUsuario(usuario) {
      if (this.modoLista) {
        this.seleccionado = usuario;
      }
      this.$emit('user-selected', this.seleccionado);
    },
    fetch: function fetch() {
      var _this = this;

      this.isLoading = true;
      var obj = {
        perfiles: this.perfiles || []
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(this, '/usuario/obtener', obj, function (data) {
        _this.lista = data.lista || [];

        // Buscar por código técnico
        if (_this.codigoTecnico !== 0) {
          var objUsuario = _this.lista.find(function (e) {
            return e.codigoTecnico === _this.codigoTecnico;
          });
          if (objUsuario) {
            if (_this.multiple) _this.seleccionado.push(objUsuario);else _this.seleccionado = objUsuario;
            _this.seleccionarUsuario(_this.seleccionado);
          }
        }

        // Buscar por username (múltiple o único)
        if (_this.username) {
          var usernames = _this.multiple ? _this.username.split(',').map(function (u) {
            return u.trim();
          }).filter(Boolean) : [_this.username.trim()];

          var encontrados = _this.lista.filter(function (e) {
            return usernames.includes(e.usuario);
          });

          if (_this.multiple) {
            var _seleccionado;

            (_seleccionado = _this.seleccionado).push.apply(_seleccionado, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(encontrados));
          } else if (encontrados.length > 0) {
            _this.seleccionado = encontrados[0];
          }

          _this.seleccionarUsuario(_this.seleccionado);
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(_this, 'error', 'Error', error.message);
      }, function () {
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'lista-draggable': __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  data: function data() {
    return {
      isModalEditarEstado: false,
      estados: [],
      filtered: [],
      ordersEstados: [],
      tipoEstado: 'garantia',
      estadoEditar: {
        codigo: 0,
        descripcion: '',
        accion: '',
        etapa: '',
        cerrado: false,
        orden: '',
        tipo: '',
        icono: '',
        iconoCambiar: null
      },
      etapasEstados: [],
      indexEstadoSeleccionado: '',
      apiUpload: "https://api-sil.datacont.com",
      isLoadingEtapas: false,
      listadoTiposEstado: [{
        name: 'Garantia',
        code: 'garantia'
      }, {
        name: 'Solicitud de insumo',
        code: 'solicitud de insumo'
      }, {
        name: 'Incidencia con equipo',
        code: 'incidencia con equipo'
      }]
    };
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    fetchUploadFile: function fetchUploadFile(file, callback) {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Guardando icono para estado' });
      var fd = new FormData();
      var url = vm.apiUpload + '/upload';
      fd.append('file', file);
      var params = {
        carpeta: 'img-estados',
        usuario: localStorage.getItem('usuario')
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["d" /* apiUploadWithParams */])(vm, url, fd, params, function (res) {
        console.log('termino guardar');
        callback(null, res);
      }, function (err) {
        vm.$store.dispatch('transaccion', { isProceso: false });
        callback(err);
      });
    },
    openDialogEditar: function openDialogEditar(e, i) {
      var vm = this;
      vm.estadoEditar.descripcion = e.descripcion || '';
      vm.estadoEditar.accion = e.accion || '';
      vm.estadoEditar.codigo = e.codigo || 0;
      vm.estadoEditar.etapa = e.etapa || 0;
      vm.estadoEditar.cerrado = e.cerrado || false;
      vm.estadoEditar.orden = e.orden || '';
      vm.estadoEditar.icono = e.icono || '';
      vm.estadoEditar.iconoCambiar = null;
      vm.indexEstadoSeleccionado = i;
      vm.isModalEditarEstado = true;
      vm.fetchEtapa();
    },
    closeDialogEditar: function closeDialogEditar() {
      var vm = this;
      vm.indexEstadoSeleccionado = '';
      vm.estadoEditar.codigo = 0;
      vm.estadoEditar.etapa = 0;
      vm.estadoEditar.descripcion = '';
      vm.estadoEditar.accion = '';
      vm.estadoEditar.icono = '';
      vm.estadoEditar.iconoCambiar = null;
      vm.estadoEditar.cerrado = 0;
      vm.estadoEditar.orden = '';
      vm.isModalEditarEstado = false;
    },
    fetchGuardarEstado: function fetchGuardarEstado() {
      var vm = this;
      if (vm.indexEstadoSeleccionado === '' && !vm.estadoEditar.descripcion) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un titulo para el estado');
        return;
      }

      if (vm.indexEstadoSeleccionado === '' && !vm.estadoEditar.accion) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese una descripcion para la accion  del estado');
        return;
      }

      if (vm.indexEstadoSeleccionado === '' && !vm.estadoEditar.etapa) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Seleccione una etapa para el estado');
        return;
      }

      if (vm.indexEstadoSeleccionado === '' && !vm.estadoEditar.iconoCambiar) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Seleccione un icono para las notificaciones ');
        return;
      }

      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Guardar datos de estado' });
      vm.estadoEditar.tipo = vm.tipoEstado.toLowerCase();

      if (vm.indexEstadoSeleccionado !== '') {
        var obj = {
          codigo: vm.estadoEditar.codigo,
          datos: vm.estadoEditar
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/estado/guardar', obj, function (data) {
          if (vm.estadoEditar.iconoCambiar) {
            vm.fetchUploadFile(vm.estadoEditar.iconoCambiar, function (err, res) {
              if (err) {
                vm.$store.dispatch('transaccion', { isProceso: false });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
                return;
              }

              var obj = {
                codigo: vm.estadoEditar.codigo,
                datos: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.estadoEditar, { icono: res.ruta })
              };

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/estado/guardar', obj, function (data) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los datos se guardaron correctamente');
                vm.closeDialogEditar();
                vm.fetch();
              }, function (error) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
              }, function () {
                vm.$store.dispatch('transaccion', { isProceso: false });
              });
            });
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los datos se guardaron correctamente');
            vm.$store.dispatch('transaccion', { isProceso: false });
            vm.closeDialogEditar();
            vm.fetch();
          }
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
          vm.$store.dispatch('transaccion', { isProceso: false });
        });
      } else {
        vm.fetchUploadFile(vm.estadoEditar.iconoCambiar, function (err, res) {
          if (err) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
            return;
          }

          var obj = {
            codigo: vm.estadoEditar.codigo,
            datos: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.estadoEditar, { icono: res.ruta })
          };

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/estado/guardar', obj, function (data) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los datos se guardaron correctamente');
            vm.closeDialogEditar();
            vm.fetch();
          }, function (error) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
          }, function () {
            vm.$store.dispatch('transaccion', { isProceso: false });
          });
        });
      }
    },
    fetchReordenarEstados: function fetchReordenarEstados() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Reordenar estados' });
      vm.estadoEditar.tipo = vm.tipoEstado.toLowerCase();
      var obj = {
        tipo: vm.tipoEstado,
        lista: vm.estados
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/estado/reordenar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los datos se guardaron correctamente');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obtener listado de estados' });
      var obj = {
        tipo: vm.tipoEstado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/estado/obtener', obj, function (data) {
        vm.estados = data.lista;
        vm.filtered = vm.estados;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchEtapa: function fetchEtapa() {
      var vm = this;
      vm.isLoadingEtapas = true;
      var obj = {
        tipo: vm.tipoEstado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/estado/obtener/etapas', obj, function (data) {
        vm.etapasEstados = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingEtapas = false;
      });
    },
    buscarValor: function buscarValor(value) {
      var vm = this;
      if (value) {
        vm.estados = vm.filtered;
        vm.estados = vm.estados.filter(function (e) {
          e.codigo += '';
          return e.codigo.toLowerCase().includes(value.toLowerCase()) || e.descripcion.toLowerCase().includes(value.toLowerCase());
        });
      } else vm.estados = vm.filtered;
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_avatar_perfil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_avatar_perfil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_avatar_perfil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_usuario_form_editar_datos__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_usuario_form_editar_datos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_usuario_form_editar_datos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_card_informacion_usuario__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_card_informacion_usuario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_card_informacion_usuario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_usuarios_lista_seleccionar__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_usuarios_lista_seleccionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_usuarios_lista_seleccionar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'avatar-perfil': __WEBPACK_IMPORTED_MODULE_1__components_c_avatar_perfil___default.a,
    'form-editar-usuario': __WEBPACK_IMPORTED_MODULE_2__components_c_usuario_form_editar_datos___default.a,
    'item-usuario': __WEBPACK_IMPORTED_MODULE_3__components_c_card_informacion_usuario___default.a,
    'usuario-seleccionar': __WEBPACK_IMPORTED_MODULE_4__components_c_usuarios_lista_seleccionar___default.a
  },
  data: function data() {
    return {
      lista: [],
      search: '',
      selected: null,
      isActiveManagerAccount: false,
      isAccountsList: false,
      listaCuentas: [],
      isRenderComponent: false,
      isModalCrearUsuario: false,
      isLoadingSaveAccounts: false,
      isLoadingGetAccounts: false,
      isLoadingActivating: false,
      isManagerAccount: false,
      showPassword: false,
      showPassword1: false,
      nuevoUsuario: {
        nombre: '',
        username: '',
        password: '',
        password1: '',
        aceptaPoliticasDePrivacidad: true
      },
      id: 0,
      usuariosRelacionados: '',
      isScroll: true,
      disabledScrollExcecute: true,
      noMore: false,
      isLoadingActivatingManager: false,
      totalUsuarios: 0,
      perfilUsuario: localStorage.getItem('perfil') || '',
      usuarioLogged: localStorage.getItem('username') || '',
      isCuentasPendientes: false,
      isActiveAccount: false,
      sivWebCliente: "http://siv.reprodata.com.pe"
    };
  },
  created: function created() {
    var vm = this;
    vm.fetch();
    if (vm.perfilUsuario === 'sistemas') vm.fetchCountUsuarios();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    progress: function progress() {
      var vm = this;
      return Math.min(100, vm.nuevoUsuario.password.length * 16.7);
    },
    color: function color() {
      var vm = this;
      return ['error', 'warning', 'success'][Math.floor(vm.progress / 40)];
    },
    countFilters: function countFilters() {
      var vm = this;
      var count = 0;
      if (vm.isCuentasPendientes) count++;
      return count;
    }
  },
  filters: {
    fecha: function fecha(value) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format('DD/MM/YYYY HH:mm');
    }
  },
  methods: {
    enviarDatosDelUsuario: function enviarDatosDelUsuario() {
      var vm = this;
      var query = '';
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(vm.selected).forEach(function (e) {
        if (e !== 'foto' && e !== 'password' && e !== 'emailConfirmado' && e !== 'rutaSctr' && e !== 'resetToken' && e !== 'tokenVerifyEmail' && e !== 'direccion') {
          query += e + '=' + vm.selected[e] + '&';
        }
      });
      var ruta = vm.sivWebCliente + '/#/cliente-administrador?' + query;
      window.open(ruta, '_blank');
    },
    fetchActivateManagerAccount: function fetchActivateManagerAccount() {
      var vm = this;
      vm.isLoadingActivatingManager = true;
      var url = '';
      if (!vm.isManagerAccount) url = '/usuario/desactivar/manager';else url = '/usuario/activar/manager';
      var obj = {
        email: vm.selected.usuario
      };
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Activando cuenta' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["a" /* apiPost */])(vm, url, obj, function (data) {
        vm.closeModalIsActiveManagerAccount();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los cambios se efectuaron correctamente');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
        vm.isLoadingActivatingManager = false;
      });
    },
    fetchActivateAccount: function fetchActivateAccount() {
      var vm = this;
      vm.isLoadingActivating = true;
      var obj = {
        email: vm.selected.usuario
      };
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Desactivar cuenta' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["a" /* apiPost */])(vm, '/usuario/activar/cuenta', obj, function (data) {
        vm.closeModalIsActiveAccount();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'La cuenta fue activada correctamente');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
        vm.isLoadingActivating = false;
      });
    },
    fetchGuardarCuentas: function fetchGuardarCuentas() {
      var vm = this;
      vm.isLoadingSaveAccounts = true;
      var seleccionados = vm.$refs.lista_usuarios_manager.seleccionado || [];
      var cuentas = seleccionados.map(function (e) {
        return { usuario: e.usuario, razonSocial: e.razonSocial };
      });
      var obj = {
        email: vm.selected.usuario,
        cuentas: cuentas
      };
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Desactivar cuenta' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["a" /* apiPost */])(vm, '/usuario/guardar/cuentas', obj, function (data) {
        vm.closeModalIsAccountsList();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'La cuenta fue activada correctamente');
        // vm.fetch()
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
        vm.isLoadingSaveAccounts = false;
      });
    },
    openModalIsActiveAccount: function openModalIsActiveAccount() {
      var vm = this;
      vm.isActiveAccount = true;
    },
    closeModalIsActiveAccount: function closeModalIsActiveAccount() {
      var vm = this;
      vm.isActiveAccount = false;
    },
    openModalIsAccountsList: function openModalIsAccountsList() {
      var vm = this;
      vm.isAccountsList = true;
      vm.fetchGetAccountsList();
    },
    closeModalIsAccountsList: function closeModalIsAccountsList() {
      var vm = this;
      vm.isAccountsList = false;
    },
    openModalIsActiveManagerAccount: function openModalIsActiveManagerAccount() {
      var vm = this;
      vm.isActiveManagerAccount = true;
    },
    closeModalIsActiveManagerAccount: function closeModalIsActiveManagerAccount() {
      var vm = this;
      vm.isActiveManagerAccount = false;
      vm.isManagerAccount = vm.selected.esCuentaAdministrador === 1;
    },
    obtenerUsuarioSeleccionado: function obtenerUsuarioSeleccionado(usuario) {
      var vm = this;
      vm.usuarioSeleccionado = usuario.usuario;
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    limpiarObjCreacion: function limpiarObjCreacion() {
      var vm = this;
      vm.nuevoUsuario.nombre = '';
      vm.nuevoUsuario.username = '';
      vm.nuevoUsuario.password = '';
      vm.nuevoUsuario.password1 = '';
      vm.nuevoUsuario.aceptaPoliticasDePrivacidad = true;
    },
    validateEmail: function validateEmail(email) {
      return (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      );
    },
    fetchRegistrar: function fetchRegistrar() {
      var vm = this;
      var url = '/usuario/registrar';
      if (!vm.nuevoUsuario.nombre) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un nombre u razon social valido');
        vm.$refs.nombre.focus();
        return;
      }

      if (!vm.nuevoUsuario.username) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un email valido');
        vm.$refs.username.focus();
        return;
      }

      if (vm.nuevoUsuario.username) {
        if (!vm.validateEmail(vm.nuevoUsuario.username)) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El email no cumple con el formato adecuado');
          vm.$refs.username.focus();
          return;
        }
      }

      if (!vm.nuevoUsuario.password) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un password valido');
        vm.$refs.password.focus();
        return;
      }

      if (vm.nuevoUsuario.password && vm.progress < 100) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'La contraseña debe de tener como minimo 6 caracteres');
        vm.$refs.password.focus();
        return;
      }

      if (!vm.nuevoUsuario.password1) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Repita la contraeña ingresada');
        vm.$refs.password1.focus();
        return;
      }

      if (vm.nuevoUsuario.password !== vm.nuevoUsuario.password1) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Las contraseñas ingresadas no coinciden');
        vm.nuevoUsuario.password1 = '';
        vm.$refs.password1.focus();
        return;
      }

      var obj = {
        nombre: vm.nuevoUsuario.nombre,
        username: vm.nuevoUsuario.username,
        password: vm.nuevoUsuario.password,
        // isUsuarioInterno           : true,
        aceptaPoliticasDePrivacidad: vm.nuevoUsuario.aceptaPoliticasDePrivacidad ? 1 : 0
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["a" /* apiPost */])(vm, url, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'El usuario se registro correctamente');
        vm.fetch();
        vm.renderEditar(vm.nuevoUsuario);
        vm.closeDialogCrearUsuario();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    openDialogCrearUsuario: function openDialogCrearUsuario() {
      var vm = this;
      vm.isModalCrearUsuario = true;
    },
    closeDialogCrearUsuario: function closeDialogCrearUsuario() {
      var vm = this;
      vm.limpiarObjCreacion();
      vm.isModalCrearUsuario = false;
    },
    fetchGetAccountsList: function fetchGetAccountsList() {
      var vm = this;
      vm.isLoadingGetAccounts = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obtener listado de cuentas' });
      var obj = {
        email: vm.selected.usuario
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["c" /* apiGet */])(vm, '/usuario/obtener/cuentas/relacionados', obj, function (data) {
        var users = data.lista.map(function (e) {
          return e.usuario;
        });
        vm.usuariosRelacionados = users.toString();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingGetAccounts = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetch: function fetch() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var vm = this;
      if (isClear) {
        vm.search = '';
      }
      if (!vm.isScroll) {
        vm.lista = [];
        vm.id = 0;
        vm.selected = null;
        vm.isRenderComponent = false;
      }

      vm.disabledScrollExcecute = true;
      vm.noMore = false;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obtener listado de usuarios' });

      var obj = {
        id: vm.id,
        razonSocial: vm.search,
        isIncludeAdmin: vm.perfilUsuario === 'sistemas' ? 1 : 0,
        isCuentasPendientes: vm.isCuentasPendientes ? 1 : 0
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["c" /* apiGet */])(vm, '/usuario/obtener/listado', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExcecute = true;
        } else {
          vm.id = data.id;
          vm.disabledScrollExcecute = false;
        }
      }, function (error) {
        vm.disabledScrollExcecute = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isScroll = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchCountUsuarios: function fetchCountUsuarios() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["c" /* apiGet */])(vm, '/usuario/count', obj, function (data) {
        console.log('data', data);
        vm.totalUsuarios = data.lista[0].cantidad;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    renderEditar: function renderEditar(item) {
      var vm = this;
      vm.selected = item;
      vm.isManagerAccount = item.esCuentaAdministrador === 1;
      vm.isRenderComponent = false;
      vm.$nextTick(function () {
        vm.isRenderComponent = true;
      });
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_item_timeline__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_item_timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_item_timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_item_ticket_lista__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_item_ticket_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_item_ticket_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'item-actividad': __WEBPACK_IMPORTED_MODULE_1__components_c_item_timeline___default.a,
    'ticket-summary-info': __WEBPACK_IMPORTED_MODULE_2__components_c_item_ticket_lista___default.a
  },
  data: function data() {
    return {
      numeroTicket: '',
      selectedItem: 1,
      lista: [],
      noMore: false,
      disabledScrollExcecute: false,
      isScroll: false,
      numeroRecnum: 0,
      logs: [],
      filteredLogs: [],
      actividad: {},
      isLoadingActividad: false,
      menu: false,
      isModalCambiosEnTicket: false,
      indexSeleccionado: '',
      tipo: 'todos',
      accionesActividades: [],
      estadosTicket: [],
      accion: '',
      isLoadingEstadosACambiar: false,
      estadoTicket: ''

    };
  },
  created: function created() {
    var vm = this;
    vm.fetchTickets();
  },

  filters: {
    now: function now(value) {
      if (!value) return '';
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).fromNow();
    },
    formatDate: function formatDate(value) {
      if (!value) return '';
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm');
    }
  },
  methods: {
    openDialogCambiosTicket: function openDialogCambiosTicket() {
      var vm = this;
      vm.estadoTicket = '';
      vm.isModalCambiosEnTicket = true;
      vm.fetchEstadosTicket();
    },
    closeDialogCambiosTicket: function closeDialogCambiosTicket() {
      var vm = this;
      vm.isModalCambiosEnTicket = false;
    },
    limpiarFiltros: function limpiarFiltros() {
      var vm = this;
      vm.tipo = 'todos';
      vm.numeroTicket = '';
      vm.resetLogsData();
      vm.fetchTickets();
    },
    resetLogsData: function resetLogsData() {
      var vm = this;
      vm.logs = [];
      vm.filteredLogs = [];
      vm.accion = '';
      vm.indexSeleccionado = '';
    },
    filtrarPorAccion: function filtrarPorAccion() {
      var vm = this;
      if (vm.accion !== 'Todos') {
        vm.logs = [];
        for (var i = 0; i < vm.filteredLogs.length; i++) {
          var e = vm.filteredLogs[i];
          if (e.accion === vm.accion) vm.logs.push(e);
        }
      } else vm.logs = vm.filteredLogs;
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetchTickets();
    },
    fetchLogs: function fetchLogs(numero, index) {
      var vm = this;
      vm.indexSeleccionado = index;
      var url = '/auditoria/obtener';
      var obj = {
        numero: numero
      };
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo Logs' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.logs = data.data.reverse();
        vm.filteredLogs = vm.logs;
        vm.accionesActividades = ['Todos'];
        vm.accion = 'Todos';
        for (var i = 0; i < vm.logs.length; i++) {
          if (!vm.accionesActividades.includes(vm.logs[i].accion)) vm.accionesActividades.push(vm.logs[i].accion);
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchActividad: function fetchActividad(numero) {
      var vm = this;
      var url = '/auditoria/obtener/actividad';
      vm.isLoadingActividad = true;
      var obj = {
        numeroActividad: numero
        // vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo actividad del log' })
      };__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.actividad = data.lista[0];
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        // vm.$store.dispatch('transaccion', { isProceso : false })
        vm.isLoadingActividad = false;
      });
    },
    fetchEstadosTicket: function fetchEstadosTicket() {
      var vm = this;
      var url = '/estado/obtener';
      vm.isLoadingEstadosACambiar = true;
      var obj = {
        tipo: vm.lista[vm.indexSeleccionado].tipoticket
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.estadosTicket = data.lista;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoadingEstadosACambiar = false;
      });
    },
    fetchCambiarEstadoTicket: function fetchCambiarEstadoTicket() {
      var vm = this;
      var url = '/ticket/cambiar/estado/sistemas';
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Cambiando estado de ticket' });
      var obj = {
        estado: vm.estadoTicket,
        numero: vm.lista[vm.indexSeleccionado].numero
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, url, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los cambios se realizaron con exito');
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchTickets: function fetchTickets() {
      var vm = this;
      var url = '/ticket/obtener';
      if (!vm.isScroll) {
        vm.lista = [];
        vm.numeroRecnum = 0;
      }
      vm.disabledScrollExcecute = true;
      var tiposTicket = [];
      if (vm.tipo === 'todos') tiposTicket.push('garantia', 'incidencia con equipo', 'solicitud de insumo');else tiposTicket.push(vm.tipo);

      var obj = {
        numero: vm.numeroTicket,
        tipoTicket: tiposTicket,
        numeroRecnum: vm.numeroRecnum,
        isLogs: true
      };
      vm.noMore = false;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo Logs' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExcecute = true;
        } else {
          vm.numeroRecnum = data.numeroRecnum;
          vm.disabledScrollExcecute = false;
        }
      }, function (err) {
        vm.disabledScrollExcecute = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isScroll = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_adjuntar_archivos__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_adjuntar_archivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_adjuntar_archivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_exceljs__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_exceljs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_exceljs__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'adjuntar-archivos': __WEBPACK_IMPORTED_MODULE_4__components_c_adjuntar_archivos___default.a
  },
  data: function data() {
    return {
      equiposLista: [],
      headers: [{ text: 'Usuario', align: 'start', value: 'usuario' }, { text: 'Tipo de ticket', align: 'start', value: 'tipo' }, { text: 'Serie', align: 'start', value: 'serie' },
      // {text: 'Marca', align: 'start', value: 'marca'},
      // {text: 'Modelo', align: 'start', value: 'modelo'},
      // {text: 'tipo', align: 'start', value: 'tipo'},
      // {text: 'tipoInforme', align: 'start', value: 'tipoInforme'},
      // {text: 'comentarioFalla', align: 'start', value: 'comentarioFalla'},
      // {text: 'comentarioGeneral', align: 'start', value: 'comentarioGeneral'},
      { text: '¿Compro aqui?', align: 'center', value: 'comproAqui' }, { text: '¿En garantia?', align: 'center', value: 'sigueEnGarantia' }, { text: 'Factura', align: 'start', value: 'numeroFactura' }, { text: 'Status', align: 'start', value: 'status'
        // {text: 'Sustento', align: 'start', value: 'files'}
        // {text: 'Tipo Equipo', align: 'start', value: 'tipoEquipo'},
        // {text: 'Falla', align: 'start', value: 'falla'},
        // {text: 'Acciones', align: 'center', value: 'actions'}
        // {text: 'departamente', align: 'start', value: 'departamente'},
        // {text: 'provincia', align: 'start', value: 'provincia'},
        // {text: 'distrito', align: 'start', value: 'distrito'},
        // {text: 'ubigeo', align: 'start', value: 'ubigeo'}
      }],
      ticket: {
        tipo: '',
        tipoInforme: 1,
        serie: '',
        falla: {},
        comentarioFalla: '',
        comentarioGeneral: '',
        files: [],
        sigueEnGarantia: false,
        numeroFactura: '',
        tipoEquipo: {},
        marca: '',
        modelo: '',
        comproAqui: false,
        departamente: '',
        provincia: '',
        distrito: '',
        ubigeo: '',
        usuario: '',
        status: 0,
        numero: ''
      },
      isModalConfirmacion: false,
      isModalErroresEncontrados: false,
      isUploadModal: false,
      erroresValidacion: [],
      filesTickets: [],
      isLoadingProceso: false,
      renderInputFile: true
    };
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    fetchProcesoGenerarTickets: function fetchProcesoGenerarTickets() {
      var vm = this;
      if (!vm.filesTickets.length) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Es necesario adjuntar el sustento pueder ser la boleta o la factura.');
        return;
      }

      // vm.$store.dispatch('transaccion', { isProceso : true, message : `Generando ticket` })
      vm.isLoadingProceso = true;
      vm.isModalConfirmacion = false;
      vm.uploadFile(vm.filesTickets[0], function (err, response) {
        if (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', err);
        } else {
          vm.guardarTicketRecursivo(0, response, function (err) {
            if (err) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
              vm.$store.dispatch('transaccion', { isProceso: false });
              vm.isLoadingProceso = false;
              return;
            }

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los tickets se generarón correctamente');
            vm.limpiarValoresConfirmacion();
            vm.notificarTicketsGenerados(function (err) {
              if (err) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', err);
              vm.volverASeleccionar();
            });
            vm.isLoadingProceso = false;
            // vm.$store.dispatch('transaccion', { isProceso : false })
          });
        }
      });
    },
    notificarTicketsGenerados: function notificarTicketsGenerados(callback) {
      var vm = this;
      var obj = { grupos: vm.equiposLista };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["a" /* apiPost */])(vm, '/ticket/plantilla/notificar', obj, function (data) {
        callback(null, data);
      }, function (error) {
        callback(error);
      });
    },
    limpiarValoresConfirmacion: function limpiarValoresConfirmacion() {
      var vm = this;
      vm.filesTickets = [];
      vm.isUploadModal = false;
      vm.isModalConfirmacion = false;
    },
    volverASeleccionar: function volverASeleccionar() {
      var vm = this;
      vm.equiposLista = [];
    },
    decodedExcel: function decodedExcel(event) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vm, data, consolidado, workbook;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this;

                console.log('event', event);
                data = event.target;
                consolidado = [];

                vm.erroresValidacion = [];
                vm.equiposLista = [];

                if (!data.files.length) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 7;
                _context.next = 10;
                return vm.getRowsFileExcel(data.files[0]);

              case 10:
                workbook = _context.sent;

                workbook.eachSheet(function (sheet, id) {
                  sheet.eachRow(function (row, rowIndex) {
                    if (rowIndex > 1) {
                      // console.log(row.values, rowIndex)
                      if (!row.values[1]) vm.erroresValidacion.push('[Fila ' + rowIndex + ']  El valor del campo usuario no puede estar vacio');
                      if (!row.values[2]) vm.erroresValidacion.push('[Fila ' + rowIndex + ']  El valor el campo tipo de ticket no puede estar vacio');
                      if (!row.values[3]) vm.erroresValidacion.push('[Fila ' + rowIndex + ']  La valor del campo compro aqui no puede estar vacio');
                      if (row.values[3] !== 'SI' && row.values[3] !== 'NO') vm.erroresValidacion.push('[Fila ' + rowIndex + ']  El valor del campo compro aqui no es valido, use SI o NO');
                      if (row.values[4] !== 'SI' && row.values[4] !== 'NO') vm.erroresValidacion.push('[Fila ' + rowIndex + ']  El valor del campo sigue en garantia no es valido, use SI o NO');
                      if (!row.values[5]) vm.erroresValidacion.push('[Fila ' + rowIndex + ']  La valor del campo serie no puede estar vacio');
                      if (!row.values[6] && row.values[4] === 1) vm.erroresValidacion.push('[Fila ' + rowIndex + ']  El valor del campo factura no puede estar vacio');
                      var newTicketObj = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, vm.ticket);
                      newTicketObj.usuario = row.values[1];
                      newTicketObj.tipo = row.values[2];
                      newTicketObj.comproAqui = row.values[3] === 'SI';
                      newTicketObj.sigueEnGarantia = row.values[4] === 'SI';
                      newTicketObj.serie = row.values[5];
                      newTicketObj.numeroFactura = row.values[6];
                      consolidado.push(newTicketObj);
                    }
                  });
                });
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](7);

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', _context.t0);

              case 17:
                _context.prev = 17;

                if (!vm.erroresValidacion.length) {
                  vm.equiposLista = consolidado;
                } else vm.openErroresEncontrados();
                return _context.finish(17);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[7, 14, 17, 20]]);
      }))();
    },
    getRowsFileExcel: function getRowsFileExcel(file) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var wb = new __WEBPACK_IMPORTED_MODULE_6_exceljs___default.a.Workbook();
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = function () {
          var buffer = reader.result;
          wb.xlsx.load(buffer).then(function (workbook) {
            resolve(workbook);
          });
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    adjuntarFileExcel: function adjuntarFileExcel() {
      var vm = this;
      vm.renderInputFile = false;
      vm.$nextTick(function () {
        vm.renderInputFile = true;
      });
      var fileElement = document.getElementById('fileElement');
      fileElement.click();
    },
    fetchDescargarPlantilla: function fetchDescargarPlantilla() {
      var vm = this;
      var url = '/ticket/plantilla';
      var obj = {};
      console.log('obj: ', obj);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["g" /* apiGetExcel */])(vm, url, obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);
        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = 'plantilla_tickets_generar' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {});
    },
    openModalValidarDatos: function openModalValidarDatos() {
      var vm = this;
      var alguno = vm.equiposLista.some(function (e) {
        return e.sigueEnGarantia;
      });
      if (alguno) vm.isUploadModal = true;
      vm.isModalConfirmacion = true;
    },
    openErroresEncontrados: function openErroresEncontrados() {
      var vm = this;
      vm.isModalErroresEncontrados = true;
    },
    clsoeErroresEncontrados: function clsoeErroresEncontrados() {
      var vm = this;
      vm.erroresValidacion = [];
      vm.isModalErroresEncontrados = false;
    },
    fetchGuardarTicket: function fetchGuardarTicket(ticket, callback) {
      var vm = this;
      console.log('ticket', ticket);
      var obj = {
        ticket: ticket,
        isPlantilla: 1
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["a" /* apiPost */])(vm, '/ticket/registrar', obj, function (data) {
        callback(null, data);
      }, function (error) {
        callback(error);
      });
    },
    fetchInsertarActividad: function fetchInsertarActividad(adjunto, numeroTicket, callback) {
      var vm = this;
      var obj = {
        numero: numeroTicket,
        tipo: 'adjunto',
        contenido: adjunto.ruta,
        nombreAdjunto: adjunto.archivo,
        tipoAdjunto: adjunto.mimetype,
        noEnviarEmail: 1
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["a" /* apiPost */])(vm, '/ticket/registrar/actividad', obj, function (data) {
        callback && callback(null);
      }, function (error) {
        callback && callback(error);
      });
    },
    uploadFile: function uploadFile(file, callback) {
      var vm = this;
      var fd = new FormData();
      var apiUploadRoute = "https://api-sil.datacont.com";
      var url = apiUploadRoute + '/upload';
      fd.append('file', file);
      var params = {
        carpeta: 'actividades',
        usuario: localStorage.getItem('usuario')
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["d" /* apiUploadWithParams */])(vm, url, fd, params, function (res) {
        callback(null, res);
      }, function (err) {
        callback(err);
      });
    },
    guardarTicketRecursivo: function guardarTicketRecursivo(index, datosAdjunto, callback) {
      var vm = this;
      vm.fetchGuardarTicket(vm.equiposLista[index], function (err, response) {
        if (err) callback(err);else {
          vm.equiposLista[index].status = 1;
          vm.equiposLista[index].numero = response.numero;
          vm.fetchInsertarActividad(datosAdjunto, response.numero, function (err) {
            if (err) callback(err);else {
              index++;
              if (index === vm.equiposLista.length) callback(null);else vm.guardarTicketRecursivo(index, datosAdjunto, callback);
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_dispatcher_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_timeline_actividades_ticket__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_timeline_actividades_ticket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_timeline_actividades_ticket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_enviar_mensaje_para_actividades__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_enviar_mensaje_para_actividades___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_enviar_mensaje_para_actividades__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_usuarios_lista_seleccionar__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_usuarios_lista_seleccionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_usuarios_lista_seleccionar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_c_card_informacion_usuario__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_c_card_informacion_usuario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_c_card_informacion_usuario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_c_estados_tickets__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_c_estados_tickets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_c_estados_tickets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_c_card_informacion_serie__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_c_card_informacion_serie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_c_card_informacion_serie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_c_card_form_programacion_cita__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_c_card_form_programacion_cita___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_c_card_form_programacion_cita__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_c_listado_tickets_seleccionar__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_c_listado_tickets_seleccionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_c_listado_tickets_seleccionar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_c_direcciones_cliente_seleccionar__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_c_direcciones_cliente_seleccionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_c_direcciones_cliente_seleccionar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_c_item_ticket_lista__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_c_item_ticket_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_c_item_ticket_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import Router                      from '../router/customer.js'












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'View_detalle_ticket',
  props: {
    numero: {
      type: String,
      default: ''
    }
  },
  components: {
    'time-line-actividades': __WEBPACK_IMPORTED_MODULE_3__components_c_timeline_actividades_ticket___default.a,
    'enviar-mensaje-para-actividad': __WEBPACK_IMPORTED_MODULE_4__components_c_enviar_mensaje_para_actividades___default.a,
    'usuario-seleccionar': __WEBPACK_IMPORTED_MODULE_5__components_c_usuarios_lista_seleccionar___default.a,
    'item-usuario': __WEBPACK_IMPORTED_MODULE_6__components_c_card_informacion_usuario___default.a,
    'estados-ticket': __WEBPACK_IMPORTED_MODULE_7__components_c_estados_tickets___default.a,
    'item-serie': __WEBPACK_IMPORTED_MODULE_8__components_c_card_informacion_serie___default.a,
    'form-cita': __WEBPACK_IMPORTED_MODULE_9__components_c_card_form_programacion_cita___default.a,
    'listado-tickets-seleccionar': __WEBPACK_IMPORTED_MODULE_10__components_c_listado_tickets_seleccionar___default.a,
    'listado-direcciones-seleccionar': __WEBPACK_IMPORTED_MODULE_11__components_c_direcciones_cliente_seleccionar___default.a,
    'ticket-summary-info': __WEBPACK_IMPORTED_MODULE_12__components_c_item_ticket_lista___default.a

  },
  data: function data() {
    return {
      tiposDocumentos: [{
        code: 'dni',
        name: 'DNI',
        active: true
      }, {
        code: 'permisos de vuelo de drone',
        name: 'PERMISOS DE VUELO DE DRONE',
        active: true
      }, {
        code: 'tarjeta de vacunacion',
        name: 'TARJETA DE VACUNACION',
        active: true
      }, {
        code: 'sctr',
        name: 'SCRT',
        active: true
      }],
      perfil: localStorage.getItem('perfil'),
      panel: [2, 0, 1, 2, 3, 4, 5],
      panel2: [2, 3, 4, 5],
      ticket: {},
      comentario: '',
      codigoTecnico: '',
      cliente: {},
      usuarioSeleccionado: localStorage.getItem('username'),
      fechaUltimaActividad: '',
      isModalAnularTicket: false,
      comentarioParaAnular: '',
      scrollInvoked: 0,
      tienePermisos: false,
      tabActive: 1,
      isAddMessageChanges: false,
      comentarioChanges: '',
      showModalDataSerie: false,
      isModalIntegracion: false,
      isLoadingChangeTipoArea: false,
      isLoadingChangeZonaGarantia: false,
      isLoadingChangeDiasAutoAnulacion: false,
      fechaProbableAnulacionAutomatica: '',
      tabAcciones: 0,
      tipoIntegracion: 1,
      isModalEditarCita: false,
      datosCita: {},
      ordenEstadoIngresadoTaller: 4,
      ordenDelEstadodelTicket: 0,
      isCreacionExterno: false,
      renderComponentEstados: true,
      showInfoUser: false,
      showPopoverFechasEstado: false,
      showPopoverFechasEtapa: false,
      isGettingFallas: false,
      fechasCambioEstado: [],
      fechasCambioEtapas: [],
      ubigeos: [],
      departamentos: [],
      fallas: [],
      marcas: [],
      listaEtapas: [],
      indexEtapaSeleccionada: 0,
      apiUpload: "https://api-sil.datacont.com",
      apiRouteSist: "https://sist.reprodata.com.pe",
      empresa: "reprodata",
      isModalAsignacionZona: false,
      isLoadingEtapas: false,
      isLoadingGetUser: false,
      isLoadingGetSerie: false,
      isLoadingUbigeos: false,
      datosContrato: {},
      datosSerieInforme: {
        serie: '',
        direccion: '',
        idDireccion: '',
        ubigeo: '',
        descripcionUbigeo: '',
        extra: '',
        telefono: '',
        email: '',
        codigoClienteSap: 0,
        contacto: '',
        codigoFalla: 100000,
        descripcionFalla: 'OTROS'
      },
      ticketsRelacionados: [],
      datosTecnico: null,
      fallaSeleccionada: {
        codigoFallaGeneral: 100000,
        descripcionFallaGeneral: 'OTROS'
      },
      ubigeoSeleccionado: {
        ubigeo: '',
        descripcion: ''
      },
      direccionSeleccionado: {
        id: '',
        direccion: ''
      },
      isGenerarITGarantia: false,
      tiposInforme: [{ id: 'emergencia', name: '1 - Emergencia', code: 1, ticket_type: ['incidencia con equipo'] }, { id: 'preventivo', name: '2 - Preventivo', code: 2, ticket_type: ['incidencia con equipo'] }, { id: 'toner', name: '7 - Toner', code: 7, ticket_type: ['solicitud de insumo'] }, { id: 'software_config', name: '11 - Configuracion de Software', code: 11, ticket_type: ['incidencia con equipo'] }, { id: 'instalacion_repuestos', name: '20 - Instalacion Repuestos', code: 20, ticket_type: ['incidencia con equipo'] }, { id: 'configuracion_equipo', name: '44 - Configuracion de Equipo', code: 44, ticket_type: ['incidencia con equipo'] }, { id: 'desinstalacion_equipo', name: '13 - Desinstalacion de Equipo', code: 13, ticket_type: ['incidencia con equipo'] }, { id: 'instalacion', name: '3 - Instalacion', code: 3, ticket_type: ['incidencia con equipo'] }, { id: 'revision', name: '24 - Revision', code: 24, ticket_type: ['incidencia con equipo'] }, { id: 'reparacion', name: '5 - Reparacion', code: 5, ticket_type: ['incidencia con equipo'] }, { id: 'papel', name: '8 - Papel', code: 8, ticket_type: ['solicitud de insumo'] }, { id: 'apoyo_tecnico', name: '42 - Apoyo Tecnico', code: 42, ticket_type: ['incidencia con equipo'] }, { id: 'supervision', name: '17 - Supervision', code: 17, ticket_type: ['incidencia con equipo'] }, { id: 'soporte_en_linea', name: '33 - Soporte en Linea', code: 33, ticket_type: ['garantia'] }, { id: 'entrega_cafe', name: '35 - Entrega de Cafe', code: 35, ticket_type: ['solicitud de insumo'] }, { id: 'traslado_repuestos', name: '41 - Traslado o Recojo de Repuestos', code: 41, ticket_type: ['incidencia con equipo'] }, { id: 'retiro_repuestos', name: '27 - Retiro de Repuestos', code: 27, ticket_type: ['incidencia con equipo'] }, { id: 'preparacion', name: '4 - Preparacion', code: 4, ticket_type: ['incidencia con equipo'] }, { id: 'recepcion_equipo', name: '18 - Recepcion Equipo', code: 18, ticket_type: ['garantia'] }, { id: 'mantenimiento', name: '25 - Mantenimiento', code: 25, ticket_type: ['incidencia con equipo'] }, { id: 'inspeccion', name: '12 - Inspeccion', code: 12, ticket_type: ['incidencia con equipo'] }, { id: 'traslado_equipo', name: '14 - Traslado de Equipo', code: 14, ticket_type: ['incidencia con equipo'] }, { id: 'instalacion_software', name: '32 - Instalacion Software', code: 32, ticket_type: ['incidencia con equipo'] }, { id: 'regularizacion_doc', name: '21 - Regularizacion Documentaria', code: 21, ticket_type: ['incidencia con equipo'] }, { id: 'termino_contrato', name: '34 - Termino de Contrato', code: 34, ticket_type: ['incidencia con equipo'] }]
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchCheckPermisos(function (err, data) {
      if (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', 'No tiene perfil definido');
        __WEBPACK_IMPORTED_MODULE_2__router_dispatcher_js__["a" /* default */].push('/tickets');
        __WEBPACK_IMPORTED_MODULE_2__router_dispatcher_js__["a" /* default */].go();
        return;
      }

      vm.tienePermisos = data.tienePermisos;
      if (data.tienePermisos) {
        vm.fetch();
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', 'No tienes permisos para visualizar los datos de este ticket');
        __WEBPACK_IMPORTED_MODULE_2__router_dispatcher_js__["a" /* default */].push('/tickets');
        __WEBPACK_IMPORTED_MODULE_2__router_dispatcher_js__["a" /* default */].go();
      }
    });

    vm.fetchGetDataParametros(function (err, parametros) {
      if (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      } else {
        vm.ordenEstadoIngresadoTaller = parametros.ordenEstadoIngresadoTaller;
      }
    });
    vm.fetchGetDataMarcas();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    tiposInformeFiltrado: function tiposInformeFiltrado() {
      var vm = this;
      return vm.tiposInforme.filter(function (e) {
        return e.ticket_type.includes(vm.ticket.tipoticket);
      });
    }
  },
  filters: {
    now: function now(val) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).fromNow();
    },
    formatoFecha: function formatoFecha(value) {
      if (!value) return '';
      return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(value).format('DD/MM/YYYY');
    }
  },
  methods: {
    fetchTicketsRelacionados: function fetchTicketsRelacionados() {
      var vm = this;
      var url = '';
      var obj = {};
      url = '/ticket/obtener/relacionados';
      obj = {
        numeroTicket: vm.ticket.numero,
        numeroTicketBase: vm.ticket.numeroTicketBase
      };
      if (!url) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Los parametros enviados no son validos');
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.ticketsRelacionados = data.lista;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {});
    },
    goToHistoriaTecnica: function goToHistoriaTecnica() {
      var vm = this;
      var url = vm.apiRouteSist + '/#/historia-tecnica/' + vm.ticket.serie;
      window.open(url, '_blank');
    },
    fetchGetContrato: function fetchGetContrato(numeroContrato) {
      var vm = this;
      var obj = {
        octopus: true,
        filtro: numeroContrato
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, '/contrato/obtener', obj, function (data) {
        console.log('data.lista', data.lista);
        if (data.lista.length) {
          vm.datosContrato = data.lista[0];
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    fetchGetSerie: function fetchGetSerie() {
      var vm = this;
      vm.isLoadingGetSerie = true;
      var obj = {
        serie: vm.ticket.serie,
        tipoTicket: vm.ticket.tipoticket
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, '/integracion/serie/obtener', obj, function (data) {
        var serie = data.data;
        console.log('serie', serie);
        vm.datosSerieInforme.serie = serie.serie;
        vm.datosSerieInforme.extra = serie.extra;
        vm.datosSerieInforme.telefono = serie.telefono;
        vm.datosSerieInforme.email = serie.email;
        vm.datosSerieInforme.contacto = serie.atencion;
        vm.datosSerieInforme.codigoClienteSap = serie.codigoClienteSap;
        vm.ubigeoSeleccionado.ubigeo = serie.ubigeo;
        vm.ubigeoSeleccionado.descripcion = serie.descripcionUbigeo;
        vm.direccionSeleccionado.id = serie.idDireccion;
        vm.direccionSeleccionado.direccion = serie.direccion;
        vm.direccionSeleccionado.observacion = '';
        var tipoProductoMaquina = serie.codigoArticuloNuevo ? serie.codigoArticuloNuevo.substring(0, 2) : '';
        vm.fetchFallas(tipoProductoMaquina);
        vm.fetchUbigeos(function (err) {
          if (err) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
        });
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoadingGetSerie = false;
      });
    },
    openInformeDeRecepcion: function openInformeDeRecepcion() {
      var vm = this;
      window.open(vm.ticket.urlGuiaRecepcionFirmada, '_blank');
    },
    fetchGetDataEtapasEstados: function fetchGetDataEtapasEstados() {
      var vm = this;
      vm.isLoadingEtapas = true;
      vm.listaEtapas = [];
      var obj = {
        tipo: vm.ticket.tipoticket
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, '/estado/obtener/etapas', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          var element = data.lista[i];
          vm.listaEtapas.push({
            id: element.codigo,
            descripcion: element.descripcion,
            tipoEstado: element.tipoEstado
          });
        }
        vm.$nextTick(function () {
          vm.indexEtapaSeleccionada = vm.ticket.etapaEstado;
        });
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoadingEtapas = false;
      });
    },
    fetchGetDataMarcas: function fetchGetDataMarcas() {
      var vm = this;
      var obj = {
        octopus: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, '/articulo/marca-articulo', obj, function (data) {
        vm.marcas = data.lista;
        console.log('marcas', vm.marcas);
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    fetchGetDataParametros: function fetchGetDataParametros(callback) {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, '/parametro/obtener', obj, function (data) {
        callback(null, data.lista[0]);
      }, function (error) {
        callback(error);
      });
    },
    openModalIntegracion: function openModalIntegracion(tipo) {
      var vm = this;
      vm.tipoIntegracion = tipo;
      var tipos = vm.tiposInforme.find(function (e) {
        return e.code === tipo;
      });
      if (!tipos) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El codigo de tipo de IT no existe');
        return;
      }
      vm.isGenerarITGarantia = tipos.ticket_type.includes('garantia');
      vm.isModalIntegracion = true;
      !vm.isGenerarITGarantia && vm.fetchGetSerie();
    },
    closeModalDataSerie: function closeModalDataSerie() {
      var vm = this;
      vm.showModalDataSerie = false;
    },
    obtenerUsuarioSeleccionado: function obtenerUsuarioSeleccionado(usuario) {
      var vm = this;
      vm.usuarioSeleccionado = usuario.usuario;
    },
    getDireccion: function getDireccion(direccion) {
      var vm = this;
      vm.direccionSeleccionado.id = direccion.id;
      vm.direccionSeleccionado.direccion = direccion.direccion;
      vm.ubigeoSeleccionado.ubigeo = direccion.ubigeo;
      var ubigeo = vm.ubigeos.filter(function (e) {
        return e.ubigeo === direccion.ubigeo;
      });
      if (!ubigeo.length) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El codigo de ubigeo de ka direccion no existe');
      vm.ubigeoSeleccionado.descripcion = ubigeo[0].descripcion;
    },
    openModalAddMessage: function openModalAddMessage() {
      var vm = this;
      vm.isAddMessageChanges = true;
    },
    closeModalAddMessage: function closeModalAddMessage() {
      var vm = this;
      vm.isAddMessageChanges = false;
      vm.comentarioChanges = '';
    },
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_2__router_dispatcher_js__["a" /* default */].push(page);
    },
    fetchCheckPermisos: function fetchCheckPermisos(callback) {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Verificando permisos' });
      var url = 'ticket/verificar/permiso';
      var obj = {
        numero: vm.numero
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        callback(null, data);
      }, function (err) {
        callback(err);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchVerificarfechasCambioEstado: function fetchVerificarfechasCambioEstado() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Verificando fechas de cambio' });
      var url = 'ticket/obtener/fecha/estados';
      var obj = {
        numero: vm.numero
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        console.log('data', data);
        vm.fechasCambioEstado = data.data;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchVerificarfechasCambioEtapa: function fetchVerificarfechasCambioEtapa() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Verificando fechas de cambio' });
      var url = 'ticket/obtener/fecha/etapas';
      var obj = {
        numero: vm.numero
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        console.log('data', data);
        vm.fechasCambioEtapas = data.data;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    onScroll: function onScroll(e) {
      var vm = this;
      vm.scrollInvoked = e.target.scrollTop;
    },
    scrollToTop: function scrollToTop() {
      document.getElementById('scrolling-time-line').scrollTop = 0;
    },
    closeModalAnular: function closeModalAnular() {
      var vm = this;
      vm.comentarioParaAnular = '';
      vm.isModalAnularTicket = false;
    },
    fetchCloseTicket: function fetchCloseTicket() {
      var vm = this;
      if (!vm.comentarioParaAnular) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor ingrese un mensaje para conocer la razón de la anulación');
        vm.$refs.comentarioParaAnular.focus();
        return;
      }

      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Anulando ticket ' + vm.ticket.numero });
      var obj = {
        numero: vm.ticket.numero,
        mensaje: vm.comentarioParaAnular,
        tipoTicket: vm.ticket.tipoticket
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["a" /* apiPost */])(vm, '/ticket/' + vm.ticket.numero + '/anular', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'success', '', 'Ticket anulado exitosamente');
        vm.fetchCantidadTicketsAbiertos();
        vm.closeModalAnular();
        vm.fetch();
        vm.$refs.activity.fetchActividades();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchIntegrarTicket: function fetchIntegrarTicket() {
      var vm = this;
      vm.fetchGuardarCambiosArchivoMaquinas(function (error) {
        if (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
          return;
        }

        vm.$store.dispatch('transaccion', { isProceso: true, message: 'Integrando ticket de ' + vm.ticket.tipoticket + ' ' + vm.ticket.numero });
        var obj = {
          numero: vm.ticket.numero,
          observacion: vm.datosSerieInforme.observacion,
          tipoIntegracion: vm.tipoIntegracion
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["a" /* apiPost */])(vm, '/integracion/crear/informe/tecnico', obj, function (data) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Integrado correctamente con el numero ' + data.numeroInformeTecnico);
          vm.ticket.numeroInformeTecnico = data.numeroInformeTecnico;
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.cambios).length) {
            vm.$refs.activity.fetchActividades();
            if (data.cambios.estado) {
              vm.ticket.estado = data.cambios.estado;
              vm.forceRerenderEstados();
            }
            if (data.cambios.modelo) {
              vm.ticket.modelo = data.cambios.modelo;
            }
          }
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        }, function () {
          vm.$store.dispatch('transaccion', { isProceso: false });
          vm.isModalIntegracion = false;
        });
      });
    },
    fetchGuardarCambiosArchivoMaquinas: function fetchGuardarCambiosArchivoMaquinas(callback) {
      var vm = this;
      if (vm.isGenerarITGarantia) callback(null);else {
        if (!vm.datosSerieInforme.serie) {
          callback({ message: 'Ingrese una serie valida' });
          return;
        }

        if (!vm.direccionSeleccionado.direccion || !vm.direccionSeleccionado.id) {
          callback({ message: 'La serie no cuenta con una direccion valida' });
          return;
        }

        if (!vm.ubigeoSeleccionado.ubigeo || !vm.ubigeoSeleccionado.descripcion) {
          callback({ message: 'La serie no cuenta con un codigo de ubigeo valido' });
          return;
        }

        if (!vm.datosSerieInforme.extra) {
          callback({ message: 'La serie no cuenta con una ubicacion valida' });
          return;
        }

        if (!vm.datosSerieInforme.telefono) {
          callback({ message: 'La serie no cuenta con un telefono valido' });
          return;
        }

        if (!vm.datosSerieInforme.contacto) {
          callback({ message: 'La serie no cuenta con un contacto valido' });
          return;
        }

        if (!vm.datosSerieInforme.email) {
          callback({ message: 'El contacto no cuenta con un email valido' });
          return;
        }

        if (!vm.datosSerieInforme.observacion) {
          callback({ message: 'El informe no cuenta con una observacion valida' });
          return;
        }

        var obj = {
          serie: vm.datosSerieInforme.serie,
          idDireccion: vm.direccionSeleccionado.id,
          direccion: vm.direccionSeleccionado.direccion,
          extra: vm.datosSerieInforme.extra,
          telefono: vm.datosSerieInforme.telefono,
          contacto: vm.datosSerieInforme.contacto,
          email: vm.datosSerieInforme.email,
          ubigeo: vm.ubigeoSeleccionado.ubigeo,
          descripcionUbigeo: vm.ubigeoSeleccionado.descripcion
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["a" /* apiPost */])(vm, '/integracion/serie/actualizar/datos', obj, function (data) {
          callback();
        }, function (error) {
          callback(error);
        });
      }
    },
    fetchFallas: function fetchFallas(tipoProductoMaquina) {
      var vm = this;
      vm.isGettingFallas = true;
      var obj = {
        codigoTipoEquipo: tipoProductoMaquina
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, '/falla/por/tipo/producto', obj, function (data) {
        vm.fallas = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isGettingFallas = false;
      });
    },
    fetchUbigeos: function fetchUbigeos(callback) {
      var vm = this;
      vm.isLoadingUbigeos = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, '/ubigeo/obtener', obj, function (data) {
        vm.ubigeos = data.lista;
        for (var i = 0; i < data.lista.length; i++) {
          if (!vm.departamentos.includes(data.lista[i].departamento)) vm.departamentos.push(data.lista[i].departamento);
        }
        callback && callback();
      }, function (error) {
        callback ? callback(error) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingUbigeos = false;
      });
    },
    fetchDescargarSCTR: function fetchDescargarSCTR() {
      var vm = this;
      window.open(vm.datosTecnico.ruta, '_blanck');
    },
    getSCTRTecnico: function getSCTRTecnico() {
      var vm = this;
      var obj = {
        octopus: true,
        tipoDocumento: 'sctr',
        codigo: vm.ticket.codigoTecnico
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, '/tecnico/obtenerAdjunto', obj, function (data) {
        console.log('data', data);
        if (data.lista.length) {
          vm.datosTecnico = data.lista[0];
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    forceRerenderEstados: function forceRerenderEstados() {
      var vm = this;
      vm.renderComponentEstados = false;
      vm.$nextTick(function () {
        vm.renderComponentEstados = true;
      });
    },
    obtenerFechaUltimaActividad: function obtenerFechaUltimaActividad(fecha) {
      var vm = this;
      vm.fechaUltimaActividad = __WEBPACK_IMPORTED_MODULE_1_moment___default()(fecha).format('DD/MM/YYYY');
      if (vm.fechaUltimaActividad) {
        vm.fechaProbableAnulacionAutomatica = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(vm.fechaUltimaActividad, 'DD/MM/YYYY').add(vm.ticket.diasParaAutoAnulacion, 'days').format('DD/MM/YYYY');
      }
      vm.scrollToTop();
    },
    obtenerEstado: function obtenerEstado(estado) {
      var vm = this;
      if (!vm.ticket.abierto) return;
      vm.ticket.estado = estado.codigo;
      vm.ticket.descripcionEstado = estado.descripcion;
      vm.ordenDelEstadodelTicket = estado.orden;
    },
    fetch: function fetch() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo detalle de ticket' });
      var url = 'ticket/obtener';
      var obj = {
        numero: vm.numero
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.ticket = data.lista[0];
        vm.fallaSeleccionada.codigoFallaGeneral = vm.ticket.codigoFalla || 100000;
        vm.fallaSeleccionada.descripcionFallaGeneral = vm.ticket.descripcionFalla || 'OTROS';
        vm.datosSerieInforme.observacion = vm.ticket.comentarioGeneral;

        if (vm.ticket.insumo) {
          vm.ticket.insumo = vm.ticket.insumo.split(',');
        }

        vm.fetchGetDataUser(vm.ticket.usuario);
        if ((vm.ticket.zonaGarantia === 'sin asignacion' || vm.ticket.tipoArea === 'sin asignacion') && (vm.perfil === 'dispatcher' || vm.perfil === 'recepcion') && vm.ticket.tipoticket === 'garantia') {
          vm.isModalAsignacionZona = true;
        }
        if (vm.ticket.numeroInformeTecnico) {
          vm.fetchTicketsRelacionados();
        }
        vm.fetchGetDataEtapasEstados();
        if (vm.ticket.idCita) {
          vm.fetchCita();
          vm.isCreacionExterno = true;
        } else {
          vm.isCreacionExterno = false;
        }
        vm.forceRerenderEstados();
        vm.ticket.codigoTecnico && vm.getSCTRTecnico();
        vm.ticket.numeroContrato && vm.fetchGetContrato(vm.ticket.numeroContrato);
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchGetDataUser: function fetchGetDataUser(usuario) {
      var vm = this;
      vm.isLoadingGetUser = true;
      var obj = {
        usuario: usuario
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, '/usuario/obtener', obj, function (data) {
        vm.cliente = data.lista[0];
        console.log('vm.cliente', vm.cliente);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingGetUser = false;
      });
    },
    fetchInsertarActividad: function fetchInsertarActividad(comentario) {
      var vm = this;
      // Validamos
      if (!comentario) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor ingrese un mensaje en la casilla de texto');
        return;
      }

      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Enviando comentario' });
      var obj = {
        numero: vm.ticket.numero,
        usuarioSeleccionado: vm.usuarioSeleccionado,
        mensaje: comentario
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["a" /* apiPost */])(vm, '/ticket/registrar/actividad', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Mensaje enviado exitosamente');
        vm.$refs.activity.fetchActividades();
        vm.$refs.enviarMensaje.focus();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchActualizarDatosTicket: function fetchActualizarDatosTicket() {
      var vm = this;
      if (!vm.ticket.estado) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor seleccione un estado de la lista');
        return;
      }

      if (!vm.usuarioSeleccionado) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor seleccione al usuario que realiza la accion');
        return;
      }

      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Actualizando datos de ticket' });
      var obj = {
        numero: vm.ticket.numero,
        estadoSeleccionado: vm.ticket.estado,
        codigoTecnico: vm.ticket.codigoTecnico,
        comentario: vm.comentarioChanges,
        usuarioSeleccionado: vm.usuarioSeleccionado,
        marca: vm.ticket.marca,
        modelo: vm.ticket.modelo,
        serie: vm.ticket.serie,
        esCobrable: vm.ticket.esCobrable,
        tipoTallerIngresado: vm.ticket.tipoTallerIngresado,
        permisosDocumentosTecnico: vm.tiposDocumentos.filter(function (e) {
          return e.active;
        }).map(function (e) {
          return e.code;
        })
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["a" /* apiPost */])(vm, 'ticket/actualizar/datos', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'success', '', 'Accion registrada exitosamente');
        !vm.isMovil && vm.$refs.activity.fetchActividades();
        !vm.isMovil && vm.fetch();
        vm.closeModalAddMessage();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        if (error.showModalArea) {
          vm.isModalAsignacionZona = true;
        }
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchActualizarTipoTallerIngresado: function fetchActualizarTipoTallerIngresado() {
      var vm = this;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Actualizando tipo de taller ingresado' });
      var obj = {
        tipo: vm.ticket.tipoTallerIngresado,
        numero: vm.ticket.numero,
        zonaGarantia: vm.ticket.zonaGarantia,
        tipoArea: vm.ticket.tipoArea
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["a" /* apiPost */])(vm, 'ticket/actualizar/tipo/taller/ingresado', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'success', '', 'cambio registrado exitosamente');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchActualizarTipoArea: function fetchActualizarTipoArea() {
      var vm = this;
      vm.isLoadingChangeTipoArea = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Actualizando tipo area del ticket' });
      var obj = {
        numero: vm.ticket.numero,
        tipoArea: vm.ticket.tipoArea
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["a" /* apiPost */])(vm, 'ticket/actualizar/tipo/area', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'success', '', 'cambio registrado exitosamente');
        vm.fetchCantidadTicketsAbiertos();
        if (vm.ticket.zonaGarantia !== 'sin asignacion' && vm.ticket.tipoArea !== 'sin asignacion') {
          vm.isModalAsignacionZona = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
        vm.isLoadingChangeTipoArea = false;
      });
    },
    fetchActualizaDiasAutoAnulacion: function fetchActualizaDiasAutoAnulacion() {
      var vm = this;
      vm.isLoadingChangeDiasAutoAnulacion = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Actualizando dias para autoanulacion' });
      var obj = {
        numero: vm.ticket.numero,
        dias: vm.ticket.diasParaAutoAnulacion
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["a" /* apiPost */])(vm, 'ticket/actualizar/dias/autoanulacion', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'success', '', 'cambio registrado exitosamente');
        if (vm.fechaUltimaActividad) {
          vm.fechaProbableAnulacionAutomatica = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(vm.fechaUltimaActividad, 'DD/MM/YYYY').add(vm.ticket.diasParaAutoAnulacion, 'days').format('DD/MM/YYYY');
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
        vm.isLoadingChangeDiasAutoAnulacion = false;
      });
    },
    fetchActualizaZonaGarantia: function fetchActualizaZonaGarantia() {
      var vm = this;
      vm.isLoadingChangeZonaGarantia = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Actualizando zona  del ticket' });
      var obj = {
        numero: vm.ticket.numero,
        zonaGarantia: vm.ticket.zonaGarantia
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["a" /* apiPost */])(vm, 'ticket/actualizar/zona/garantia', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'success', '', 'cambio registrado exitosamente');
        if (vm.ticket.zonaGarantia !== 'sin asignacion' && vm.ticket.tipoArea !== 'sin asignacion') {
          vm.isModalAsignacionZona = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
        vm.isLoadingChangeZonaGarantia = false;
      });
    },
    fetchCantidadTicketsAbiertos: function fetchCantidadTicketsAbiertos(callback) {
      var vm = this;
      var url = 'ticket/abiertos/count';
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        var ticketsAbiertos = {};
        if (vm.perfil === 'usuario-contrato' || vm.perfil === 'usuario') {
          ticketsAbiertos.all_usuario_o_cliente = 0;
        } else {
          var cantidades = data.lista[0];
          ticketsAbiertos.incidencia_con_equipo = cantidades.ticketsAbiertosIncidenciaConEquipo;
          ticketsAbiertos.solicitud_de_insumo = cantidades.ticketsAbiertosSolicitudInsumo;
          ticketsAbiertos.garantia_sin_asignar = cantidades.ticketsAbiertosGaratiaSinAsignacion;
          ticketsAbiertos.garantia_campo = cantidades.ticketsAbiertosGarantiaCampo;
          ticketsAbiertos.garantia_taller = cantidades.ticketsAbiertosGarantiaTaller;
          ticketsAbiertos.garantia_sin_atencion = cantidades.ticketsAbiertosGarantiaSinAtencion;
        }
        vm.$store.dispatch('setContadores', ticketsAbiertos);
        callback && callback(null);
      }, function (err) {
        callback ? callback(err) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    closeModalEditarCita: function closeModalEditarCita() {
      var vm = this;
      vm.isModalEditarCita = false;
    },
    fetchCita: function fetchCita() {
      var vm = this;
      var obj = {
        codigo: vm.ticket.idCita
        // vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener información de la cita' })
      };__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["c" /* apiGet */])(vm, '/cita/obtener', obj, function (data) {
        vm.datosCita = data.lista[0];
        vm.datosCita.fechaCita = __WEBPACK_IMPORTED_MODULE_1_moment___default()(vm.datosCita.fechaDesde).format('YYYY-MM-DD');
        vm.datosCita.horaCita = __WEBPACK_IMPORTED_MODULE_1_moment___default()(vm.datosCita.fechaDesde).format('HH:mm');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        // vm.$store.dispatch('transaccion', { isProceso : false })
      });
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      items: [{
        title: 'Parametros',
        icon: 'room_preferences',
        descripcion: 'Administrador de parametros de la aplicacion',
        path: '/manager/parametros'
      }, {
        title: 'Estados',
        icon: 'linear_scale',
        descripcion: 'Administrador de estados de tipos de ticket',
        path: '/manager/estados'
      }, {
        title: 'Usuarios',
        icon: 'supervised_user_circle',
        descripcion: 'Administrador usuarios de la aplicacion',
        path: '/manager/usuarios'
        // {
        //   title: 'Roles (permisos)',
        //   icon: 'admin_panel_settings',
        //   descripcion : 'Administrador de roles y permisos',
        //   path : '/manager/roles'
        // }
      }],
      drawer: null,
      indexItems: ''
    };
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      type: 99,
      types: [{
        label: 'Enviados',
        value: 1
      }, {
        label: 'Pendientes',
        value: 0
      }, {
        label: 'Todos',
        value: 99
      }],
      headerTable: [{
        text: 'Id',
        align: 'start',
        value: 'id'
      }, {
        text: 'Registro',
        align: 'start',
        value: 'fechaRegistro'
      }, {
        text: 'Envio',
        align: 'start',
        value: 'fechaEnvio'
      }, {
        text: 'Usuario',
        align: 'start',
        value: 'usuario'
      }, {
        text: 'Asunto',
        align: 'start',
        value: 'asunto'
      },
      // {
      //   text : 'Contenido',
      //   align: 'start',
      //   value: 'contenido'
      // },
      {
        text: 'Plantilla',
        align: 'start',
        value: 'plantilla'
      }, {
        text: 'Con copia',
        align: 'start',
        value: 'conCopia'
      }, {
        text: 'CC Oculta',
        align: 'start',
        value: 'conCopiaOculta'
      }, {
        text: 'Enviado',
        align: 'start',
        value: 'enviado'
      }, { text: 'To', value: 'data-table-expand' }, {
        text: 'Accion',
        align: 'start',
        value: 'actions'
      }],
      lista: [],
      disabledScrollExcecute: true,
      isScroll: true,
      noMore: false,
      id: 0,
      isDialogEmail: false,
      isLoadingHTML: false,
      bodyHTML: ''
    };
  },
  created: function created() {
    var vm = this;
    vm.getFetch();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  filters: {
    formatoFecha: function formatoFecha(val) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(val).format('DD/MM/YYYY HH:mm');
    }
  },
  methods: {
    openDialog: function openDialog(id) {
      var vm = this;
      vm.fetchHTML(id);
      vm.isDialogEmail = true;
    },
    closeDialog: function closeDialog() {
      var vm = this;
      vm.isDialogEmail = false;
      vm.bodyHTML = '';
    },
    getFetch: function getFetch() {
      var vm = this;
      vm.id = 0;
      vm.fetch();
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      var url = 'mail/obtener';
      if (!vm.isScroll) {
        vm.lista = [];
        vm.id = 0;
      }
      vm.disabledScrollExcecute = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo emails' });
      vm.noMore = false;
      var obj = {
        tipo: vm.type,
        id: vm.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExcecute = true;
        } else {
          vm.id = data.id;
          vm.disabledScrollExcecute = false;
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isScroll = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchHTML: function fetchHTML(id) {
      var vm = this;
      vm.bodyHTML = false;
      vm.isLoadingHTML = true;
      var url = 'mail/obtener/html';
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo plantilla' });
      var obj = {
        id: id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.bodyHTML = data.html;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoadingHTML = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      lista: []
    };
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    fetch: function fetch() {
      var vm = this;
      var url = '/parametro/obtener';
      var obj = {};
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo parametros' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.lista = data.lista;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchGuardar: function fetchGuardar() {
      var vm = this;
      var url = '/parametro/guardar';
      var obj = {
        columns: vm.lista[0]
      };
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Actualizando parametros' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, url, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Los parametros fuerón cambiados');
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_card_form_programacion_cita__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_card_form_programacion_cita___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_card_form_programacion_cita__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'form-cita': __WEBPACK_IMPORTED_MODULE_0__components_c_card_form_programacion_cita___default.a
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      type: 'week',
      types: [{
        label: 'Dia',
        value: 'day'
      }, {
        label: 'Semana',
        value: 'week'
      }],
      weekday: [1, 2, 3, 4, 5],
      value: '',
      events: [],
      showModalFormEvent: false,
      idCita: 0,
      countIntervals: 0,
      countHorasParaCalcularIntervalo: 13, // horas de trabajo
      horaInicioDeIntervalo: '08:30',
      intervaloProgramacionCitas: 15
    };
  },
  created: function created() {
    var vm = this;
    vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo parametros para agenda' });
    vm.fetchGetDataParametros(function (err, parametros) {
      if (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
        vm.$store.dispatch('transaccion', { isProceso: false });
      } else {
        vm.intervaloProgramacionCitas = parametros.intervaloProgramacionCitas;
        vm.$store.dispatch('transaccion', { isProceso: false });
      }
      vm.calculateIntervalCount();
    });
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  mounted: function mounted() {
    var vm = this;
    if (vm.id) {
      vm.idCita = +vm.id;
      vm.showModalFormEvent = true;
    }
  },

  filters: {
    hora: function hora(val) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(val, 'YYYY-MM-DD HH:mm').format('HH:mm');
    }
  },
  methods: {
    checkBGColorEvent: function checkBGColorEvent(item) {
      console.log(item);
      return !item.ingresadoAtaller ? '' : '';
    },
    checkColorEvent: function checkColorEvent(item) {
      console.log(item);
      return !item.ingresadoAtaller ? 'grey--text' : 'dark--text';
    },
    fetchGetDataParametros: function fetchGetDataParametros(callback) {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/parametro/obtener', obj, function (data) {
        callback(null, data.lista[0]);
      }, function (error) {
        callback(error);
      });
    },
    calculateIntervalCount: function calculateIntervalCount() {
      var vm = this;
      if (vm.intervaloProgramacionCitas) {
        var cantidad = vm.countHorasParaCalcularIntervalo * 60;
        vm.countIntervals = cantidad / vm.intervaloProgramacionCitas;
      }
    },
    intervalFormatter: function intervalFormatter(locale, getOptions) {
      // return `${locale.time} ${locale.hour <= 12 ? 'AM' : 'PM'}`;
      return '' + locale.time;
    },
    showDay: function showDay(details) {
      var vm = this;
      vm.type = 'day';
      vm.value = details.date;
    },
    showEvent: function showEvent(data) {
      var vm = this;
      if (data) {
        vm.idCita = data.event ? data.event.id : 0;
      } else vm.idCita = 0;
      vm.showModalFormEvent = true;
    },
    getEvents: function getEvents(date) {
      var vm = this;
      var obj = {};
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo citas programadas' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/cita/obtener', obj, function (data) {
        var lista = data.lista;
        vm.events = [];
        for (var i = 0; i < lista.length; i++) {
          var c = lista[i];
          var obj = {
            id: c.id,
            name: c.titulo,
            start: __WEBPACK_IMPORTED_MODULE_1_moment___default()(c.fechaDesde).format('YYYY-MM-DD HH:mm'),
            end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(c.fechaHasta).format('YYYY-MM-DD HH:mm'),
            numeroTicket: c.numeroTicket,
            ingresadoAtaller: c.ingresadoAtaller
          };
          vm.events.push(obj);
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    closeModalEventSelected: function closeModalEventSelected() {
      var vm = this;
      vm.showModalFormEvent = false;
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_estados_tickets__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_estados_tickets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_estados_tickets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_reporte_parametros_exportacion__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_reporte_parametros_exportacion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_reporte_parametros_exportacion__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {
    'estados-ticket': __WEBPACK_IMPORTED_MODULE_3__components_c_estados_tickets___default.a,
    'parametros-exportacion': __WEBPACK_IMPORTED_MODULE_4__components_c_reporte_parametros_exportacion___default.a
  },
  data: function data() {
    return {
      tabActive: 1,
      reporteAEliminar: {},
      headersFiltrosAvanzados: [{ text: 'Columna', value: 'columna' }, { text: 'Criterio', value: 'condicion' }, { text: 'Valor', value: 'value' }, { text: 'Acciones', value: 'actions', sortable: false, width: '100' }],
      idReporteSeleccionado: '',
      indexTipoListadoReportes: 0,
      showFiltroEstados: true,
      listado: [],
      tiposReporte: [{
        name: 'Basico',
        description: 'Informes de evaluacion',
        icon: 'addchart',
        id: 0
      }, {
        name: 'Avanzado',
        description: 'Indicadores (Analisis)',
        icon: 'donut_small',
        id: 1
      }],
      tiposListados: [{
        name: 'Mis reportes guardados',
        description: 'Usa para informes de evaluacion',
        icon: 'addchart',
        id: 0
      }, {
        name: 'Reportes predefinidos',
        description: 'Usa para indicadores (Analisis)',
        icon: 'donut_small',
        id: 1
      }],
      itemsCondiciones: [{
        name: 'Es igual a',
        valor: '='
      }, {
        name: 'Es diferente a',
        valor: '<>'
      }, {
        name: 'Mayor que',
        valor: '>'
      }, {
        name: 'Mayor igual que',
        valor: '>='
      }, {
        name: 'Menor que',
        valor: '<'
      }, {
        name: 'Menor igual que',
        valor: '<='
      }],
      reporteAvanzado: {
        campo: {},
        criterio: {},
        valor: ''
      },
      query: {
        titulo: '',
        descripcion: '',
        tipo: '-1',
        desde: '',
        hasta: '',
        numero: '',
        estado: 0,
        codigoCliente: '',
        serie: '',
        modelo: '',
        zona: '-1',
        area: '-1',
        abierto: '-1',
        ingresoATaller: '-1'
      },
      indexReporte: 0,
      isModalEliminar: false,
      queryAvanzados: [],
      columnasTicket: [],
      valorType: 'text',
      isModalExportar: false,
      idReporteExportar: 0,
      isModalGuardarReporte: false
    };
  },
  created: function created() {
    var vm = this;
    vm.fetchObtenerListadoReportes();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  filters: {
    now: function now(value) {
      if (!value) return '';
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).fromNow();
    }
  },
  methods: {
    openDialogExportar: function openDialogExportar(idReporte) {
      var vm = this;
      vm.idReporteExportar = idReporte;
      vm.isModalExportar = true;
    },
    closeModalGuardarReporte: function closeModalGuardarReporte() {
      var isBorrarTitulo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var vm = this;
      if (isBorrarTitulo) {
        vm.query.titulo = '';
        vm.query.descripcion = '';
      }
      vm.isModalGuardarReporte = false;
    },
    verificarSiEsReporteNuevo: function verificarSiEsReporteNuevo() {
      var vm = this;
      if (vm.idReporteSeleccionado !== '') vm.fetchGuardarReporte();else vm.openModalGuardarReporte();
    },
    openModalGuardarReporte: function openModalGuardarReporte() {
      var vm = this;
      vm.isModalGuardarReporte = true;
    },
    closeDialogExportar: function closeDialogExportar() {
      var vm = this;
      vm.isModalExportar = false;
    },
    openDialogEliminar: function openDialogEliminar(reporte) {
      var vm = this;
      vm.reporteAEliminar = reporte;
      vm.isModalEliminar = true;
    },
    closeDialogEliminar: function closeDialogEliminar() {
      var vm = this;
      vm.reporteAEliminar = {};
      vm.isModalEliminar = false;
    },
    obtenerEstado: function obtenerEstado(estado) {
      var vm = this;
      vm.query.estado = estado.codigo;
    },
    goToPrevisualizarReporte: function goToPrevisualizarReporte() {
      var idReporte = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var esReporteDefinido = arguments[1];

      var vm = this;
      var url = null;
      var query = {};
      var params = {};
      if (idReporte !== '') {
        query.id = idReporte;
        if (esReporteDefinido) query.default = 1;
        params.tipo = 'save';
        url = vm.$router.resolve({ name: 'reportes_view', params: params, query: query });
        window.open(url.href, '_blank');
      } else {
        if (vm.idReporteSeleccionado !== '') {
          query.id = vm.idReporteSeleccionado;
          var definido = vm.listado.find(function (e) {
            return e.id === vm.idReporteSeleccionado;
          });
          if (definido.esReporteDefinido) query.default = definido.esReporteDefinido;
          params.tipo = 'save';
          url = vm.$router.resolve({ name: 'reportes_view', params: params, query: query });
          window.open(url.href, '_blank');
        } else {
          params.tipo = 'draft';
          var reporteDraft = vm.tiposReporte[vm.indexReporte];
          var filtrosDraft = null;
          if (reporteDraft.name === 'Basico') {
            filtrosDraft = vm.query;
          } else if (reporteDraft.name === 'Avanzado') {
            filtrosDraft = vm.queryAvanzados;
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El tipo de reporte es invalido');
            return;
          }

          vm.handlerFormatearFiltrosDraft(reporteDraft, filtrosDraft, function (err, filtrosQuery) {
            if (err) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err);
              return;
            }

            query = filtrosQuery;
            url = vm.$router.resolve({ name: 'reportes_view', params: params, query: query });
            window.open(url.href, '_blank');
          });
        }
      }
    },
    handlerFormatearFiltrosDraft: function handlerFormatearFiltrosDraft(reporte, filtros, callback) {
      if (reporte.name === 'Basico') {
        filtros.tipoReporte = reporte.name.toLowerCase();
        callback(null, filtros);
      } else if (reporte.name === 'Avanzado') {
        var jsonFiltros = {
          tipoReporte: reporte.name.toLowerCase()
        };
        filtros.forEach(function (e, i) {
          jsonFiltros[e.columna.valor] = e.condicion.valor + ',' + e.value;
        });
        callback(null, jsonFiltros);
      } else {
        callback('El tipo de reporte es invalido');
      }
    },
    definirNuevoReporte: function definirNuevoReporte() {
      var vm = this;
      vm.indexReporte = 0;
      vm.idReporteSeleccionado = '';
      vm.queryAvanzados = [];
      vm.query.titulo = '';
      vm.query.descripcion = '';
      vm.query.tipo = '-1';
      vm.query.desde = '';
      vm.query.hasta = '';
      vm.query.numero = '';
      vm.query.estado = 0;
      vm.query.codigoCliente = '';
      vm.query.serie = '';
      vm.query.modelo = '';
      vm.query.zona = '-1';
      vm.query.area = '-1';
      vm.query.abierto = '-1';
      vm.query.ingresoATaller = '-1';
      vm.reporteAvanzado.campo = {};
      vm.reporteAvanzado.criterio = {};
      vm.reporteAvanzado.valor = '';
      if (vm.isMovil) {
        vm.$nextTick(function () {
          vm.tabActive = 2;
        });
      }
    },
    editarReporte: function editarReporte(reporte, idReporte) {
      var vm = this;
      if (vm.isMovil) vm.tabActive = 2;
      vm.definirNuevoReporte();
      vm.idReporteSeleccionado = idReporte;
      if (reporte.tipo === 'basico') {
        vm.indexReporte = 0;
        vm.query = JSON.parse(reporte.filtros);
      } else if (reporte.tipo === 'avanzado') {
        if (vm.indexTipoListadoReportes !== 1) vm.fetchColumnasDeLaTablaTicket();
        vm.indexReporte = 1;
        vm.query.titulo = reporte.titulo;
        vm.query.descripcion = reporte.descripcion;
        vm.queryAvanzados = JSON.parse(reporte.filtros);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El tipo de reporte no esta definido');
      }
    },
    validarDataType: function validarDataType() {
      var vm = this;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(vm.reporteAvanzado.campo).length) {
        if (vm.reporteAvanzado.campo.type === 'nvarchar' || vm.reporteAvanzado.campo.type === 'varchar' || vm.reporteAvanzado.campo.type === 'ntext') vm.valorType = 'text';else if (vm.reporteAvanzado.campo.type === 'int' || vm.reporteAvanzado.campo.type === 'decimal') vm.valorType = 'number';else if (vm.reporteAvanzado.campo.type === 'datetime') vm.valorType = 'date';
      }
    },
    eliminarRowFiltrosAvanzados: function eliminarRowFiltrosAvanzados(index) {
      var vm = this;
      vm.queryAvanzados.splice(index, 1);
    },
    editarRowFiltrosAvanzados: function editarRowFiltrosAvanzados(index) {
      var vm = this;
      vm.reporteAvanzado.campo = vm.queryAvanzados[index].columna;
      vm.reporteAvanzado.criterio = vm.queryAvanzados[index].condicion;
      vm.reporteAvanzado.valor = vm.queryAvanzados[index].value;
      vm.eliminarRowFiltrosAvanzados(index);
      vm.validarDataType();
    },
    seleccionarTipoReporte: function seleccionarTipoReporte(id) {
      var vm = this;
      vm.indexReporte = id;
      if (vm.indexReporte === 1) {
        vm.fetchColumnasDeLaTablaTicket();
      }
    },
    agregarQueryAvanzado: function agregarQueryAvanzado() {
      var vm = this;
      if (!vm.reporteAvanzado.campo) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Seleccione un campo para agregar el filtro');
        return;
      }
      if (!vm.reporteAvanzado.criterio) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Seleccione un criterio para agregar el filtro');
        return;
      }
      if (!vm.reporteAvanzado.valor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un valor para el criterio  y continuar agregando el filtro');
        return;
      }

      var obj = {
        columna: vm.reporteAvanzado.campo,
        condicion: vm.reporteAvanzado.criterio,
        value: vm.reporteAvanzado.valor
      };

      vm.queryAvanzados.push(obj);
    },
    reRenderEstados: function reRenderEstados() {
      var vm = this;
      vm.query.estado = 0;
      vm.showFiltroEstados = false;
      vm.$nextTick(function () {
        vm.showFiltroEstados = true;
      });
    },
    fetchRealizarConsulta: function fetchRealizarConsulta() {
      var vm = this;
      vm.fetch();
    },
    fetchEliminarReporte: function fetchEliminarReporte() {
      var vm = this;
      var url = 'reporte/eliminar';
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Eliminando  el reporte' });
      var obj = {
        id: vm.reporteAEliminar.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["e" /* apiDelete */])(vm, url, obj, function (data) {
        vm.closeDialogEliminar();
        vm.fetchObtenerListadoReportes();
        vm.definirNuevoReporte();
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchObtenerListadoReportes: function fetchObtenerListadoReportes(callback) {
      var vm = this;
      var url = 'reporte/obtener';
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo listado de reportes' });
      var obj = {
        tipoListado: vm.tiposListados[vm.indexTipoListadoReportes].id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.listado = data.lista;
        if (vm.indexTipoListadoReportes === 1 && vm.listado.length) {
          vm.editarReporte(vm.listado[0], vm.listado[0].id);
        }
        callback && callback();
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
        callback && callback();
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchGuardarReporte: function fetchGuardarReporte() {
      var vm = this;
      if (!vm.query.titulo) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un titulo para el reporte');
        if (vm.idReporteSeleccionado !== '') {
          vm.$refs.tituloCreado.$refs.input.focus();
        } else {
          vm.$refs.tituloModal.$refs.input.focus();
        }
        return;
      }

      var url = 'reporte/guardar';
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Guardando cambios de reporte' });
      var obj = {
        filtrosBasicos: vm.query,
        filtrosAvanzados: vm.queryAvanzados,
        tipo: vm.tiposReporte[vm.indexReporte].name.toLowerCase(),
        titulo: vm.query.titulo,
        descripcion: vm.query.descripcion,
        id: vm.idReporteSeleccionado || ''
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, url, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'El reporte se guardó correctamente');
        vm.closeModalGuardarReporte(vm.idReporteSeleccionado === '');
        vm.fetchObtenerListadoReportes(function () {
          if (vm.idReporteSeleccionado === '') {
            var item = vm.listado.find(function (e) {
              return e.id === data.id;
            });
            vm.editarReporte(item, data.id);
          }
        });
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso: false });
      });
    },
    fetchColumnasDeLaTablaTicket: function fetchColumnasDeLaTablaTicket() {
      var vm = this;
      var url = '/ticket/get/columns';
      vm.isLoadingColumsTickets = true;
      vm.columnasTicket = [];
      var obj = {
        formateado: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.columnasTicket.push(data.lista[i]);
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoadingColumsTickets = false;
      });
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_dispatcher_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_configuraciones_app__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_configuraciones_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_configuraciones_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_descargas_procesos_app__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_descargas_procesos_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_descargas_procesos_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_card_generate_ticket__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_card_generate_ticket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_card_generate_ticket__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['usuario'],
  components: {
    'avatar-perfil': __WEBPACK_IMPORTED_MODULE_2__components_c_avatar_perfil___default.a,
    'configuraciones-app': __WEBPACK_IMPORTED_MODULE_3__components_c_configuraciones_app___default.a,
    'notificaciones-app': __WEBPACK_IMPORTED_MODULE_4__components_c_descargas_procesos_app___default.a,
    'card-generate-ticket': __WEBPACK_IMPORTED_MODULE_5__components_c_card_generate_ticket___default.a
  },
  data: function data() {
    return {
      search: null,
      caseSensitive: false,
      showNewTicketDispatcher: false,
      selectedItem: null,
      menu3: false,
      drawer_settings: false,
      isGettingEquipos: false,
      equiposDelModeloFiltrados: [],
      modelosAgrupados: [],
      menuUsuario: [{
        name: 'Mis Tickets',
        path: '/tickets',
        icon: 'style',
        key: 'all_usuario_o_cliente',
        notify: ''
      }],
      menuCustomer: [{
        name: 'Mis Tickets',
        path: '/tickets',
        icon: 'style',
        key: 'all_usuario_o_cliente',
        notify: ''
      }],
      menuDispatcher: [{
        name: 'Tickets de Contrato',
        icon: 'style',
        notify: '',
        children: [{
          name: 'Incidencias con equipo',
          path: '/tickets/contrato/incidencia_con_equipo',
          key: 'incidencia_con_equipo',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Solicitud de insumo',
          path: '/tickets/contrato/solicitud_de_insumo',
          key: 'solicitud_de_insumo',
          icon: 'circle',
          notify: ''
        }]
      }, {
        name: 'Tickets de Garantias',
        icon: 'style',
        notify: '',
        children: [{
          name: 'Sin atención',
          path: '/tickets/garantia/sin atencion',
          key: 'garantia_sin_atencion',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Sin asignación',
          path: '/tickets/garantia/sin asignacion',
          key: 'garantia_sin_asignar',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Campo',
          path: '/tickets/garantia/campo',
          key: 'garantia_campo',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Taller',
          path: '/tickets/garantia/taller',
          key: 'garantia_taller',
          icon: 'circle',
          notify: ''
        }]
      }, {
        name: 'Programacion de citas',
        path: '/programacion/citas',
        key: 'citas',
        icon: 'insert_invitation',
        notify: ''
      }, {
        name: 'Reportes (Analitycs)',
        path: '/reportes',
        key: 'citas',
        icon: 'addchart',
        notify: ''
      }, {
        name: 'Cuentas de usuario',
        path: '/manager/usuarios',
        key: 'manager_usuarios',
        icon: 'people',
        notify: ''
      }],
      menuSupervisor: [{
        name: 'Tickets de Contrato',
        icon: 'style',
        notify: '',
        children: [{
          name: 'Incidencias con equipo',
          path: '/tickets/contrato/incidencia_con_equipo',
          key: 'incidencia_con_equipo',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Solicitud de insumo',
          path: '/tickets/contrato/solicitud_de_insumo',
          key: 'solicitud_de_insumo',
          icon: 'circle',
          notify: ''
        }]
      }, {
        name: 'Tickets de Garantias',
        icon: 'style',
        notify: '',
        children: [{
          name: 'Sin atención',
          path: '/tickets/garantia/sin atencion',
          key: 'garantia_sin_atencion',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Sin asignacion',
          path: '/tickets/garantia/sin asignacion',
          key: 'garantia_sin_asignar',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Campo',
          path: '/tickets/garantia/campo',
          key: 'garantia_campo',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Taller',
          path: '/tickets/garantia/taller',
          key: 'garantia_taller',
          icon: 'circle',
          notify: ''
        }]
      }, {
        name: 'Reportes (Analitycs)',
        path: '/reportes',
        key: 'citas',
        icon: 'addchart',
        notify: ''
      }],
      menuRecepcion: [{
        name: 'Tickets de Garantias',
        icon: 'style',
        notify: '',
        children: [{
          name: 'Sin atención',
          path: '/tickets/garantia/sin atencion',
          key: 'garantia_sin_atencion',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Sin asignación',
          path: '/tickets/garantia/sin asignacion',
          key: 'garantia_sin_asignar',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Campo',
          path: '/tickets/garantia/campo',
          key: 'garantia_campo',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Taller',
          path: '/tickets/garantia/taller',
          key: 'garantia_taller',
          icon: 'circle',
          notify: ''
        }]
      }, {
        name: 'Programacion de citas',
        path: '/programacion/citas',
        key: 'citas',
        icon: 'insert_invitation',
        notify: ''
      }, {
        name: 'Reportes (Analitycs)',
        path: '/reportes',
        key: 'citas',
        icon: 'addchart',
        notify: ''
      }],
      menuTecnicoTaller: [{
        name: 'Tickets de Garantias',
        icon: 'style',
        notify: '',
        children: [{
          name: 'Sin atención',
          path: '/tickets/garantia/sin atencion',
          key: 'garantia_sin_atencion',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Sin asignación',
          path: '/tickets/garantia/sin asignacion',
          key: 'garantia_sin_asignar',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Campo',
          path: '/tickets/garantia/campo',
          key: 'garantia_campo',
          icon: 'circle',
          notify: ''
        }, {
          name: 'Taller',
          path: '/tickets/garantia/taller',
          key: 'garantia_taller',
          icon: 'circle',
          notify: ''
        }]
      }, {
        name: 'Reportes (Analitycs)',
        path: '/reportes',
        key: 'citas',
        icon: 'addchart',
        notify: ''
      }],
      mini: false,
      menu: [],
      username: localStorage.getItem('username'),
      perfil: localStorage.getItem('perfil'),
      nombre: localStorage.getItem('nombre'),
      razonSocial: localStorage.getItem('razonSocial'),
      codigoCliente: localStorage.getItem('codigoCliente')
    };
  },
  created: function created() {
    var vm = this;
    vm.mini = !vm.isMovil;
    vm.fetchCantidadTicketsAbiertos(function (err) {
      if (err) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);else {
        if (vm.perfil === 'dispatcher') vm.menu = vm.menuDispatcher;else if (vm.perfil === 'recepcion') vm.menu = vm.menuRecepcion;else if (vm.perfil === 'usuario-contrato') vm.menu = vm.menuCustomer;else if (vm.perfil === 'usuario') vm.menu = vm.menuUsuario;else if (vm.perfil === 'supervisor') vm.menu = vm.menuSupervisor;else if (vm.perfil === 'tecnico taller') vm.menu = vm.menuTecnicoTaller;else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'El perfil no posee ninguna opcion para su menu');
          return;
        }
      }
    });
    vm.fetchProcesos();
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    },
    abiertos: function abiertos() {
      var vm = this;
      return vm.$store.state.ticket.abiertos;
    }
  },
  methods: {
    generarNuevoTicket: function generarNuevoTicket() {
      var vm = this;
      vm.showNewTicketDispatcher = !vm.showNewTicketDispatcher;
    },
    closeGenerarNuevoTicket: function closeGenerarNuevoTicket() {
      var vm = this;
      vm.showNewTicketDispatcher = false;
    },
    goToGenerarTicket: function goToGenerarTicket() {
      __WEBPACK_IMPORTED_MODULE_0__router_dispatcher_js__["a" /* default */].push('/ticket-contrato/nuevo');
    },
    fetchProcesos: function fetchProcesos() {
      var vm = this;
      var url = '/procesos/';
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        if (data.lista) {
          vm.$store.dispatch('setCountAllDownloands', data.lista.length);
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {});
    },
    fetchCantidadTicketsAbiertos: function fetchCantidadTicketsAbiertos(callback) {
      var vm = this;
      var url = 'ticket/abiertos/count';
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        var ticketsAbiertos = {};
        var cantidades = data.lista[0];
        if (vm.perfil === 'usuario-contrato' || vm.perfil === 'usuario') {
          ticketsAbiertos.all_usuario_o_cliente = cantidades.ticketsAbiertos;
        } else {
          // const cantidades = data.lista[0]
          ticketsAbiertos.incidencia_con_equipo = cantidades.ticketsAbiertosIncidenciaConEquipo;
          ticketsAbiertos.solicitud_de_insumo = cantidades.ticketsAbiertosSolicitudInsumo;
          ticketsAbiertos.garantia_sin_asignar = cantidades.ticketsAbiertosGaratiaSinAsignacion;
          ticketsAbiertos.garantia_campo = cantidades.ticketsAbiertosGarantiaCampo;
          ticketsAbiertos.garantia_taller = cantidades.ticketsAbiertosGarantiaTaller;
          ticketsAbiertos.garantia_sin_atencion = cantidades.ticketsAbiertosGarantiaSinAtencion;
        }
        vm.$store.dispatch('setContadores', ticketsAbiertos);
        callback && callback(null);
      }, function (err) {
        callback ? callback(err) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    logout: function logout() {
      localStorage.clear();
      window.location.href = '/';
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_customer_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_item_ticket_lista__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_item_ticket_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_item_ticket_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_estados_tickets__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_estados_tickets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_estados_tickets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_reporte_parametros_exportacion__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_reporte_parametros_exportacion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_reporte_parametros_exportacion__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ticket_list',
  components: {
    'ticket-summary-info': __WEBPACK_IMPORTED_MODULE_3__components_c_item_ticket_lista___default.a,
    'estados-ticket': __WEBPACK_IMPORTED_MODULE_4__components_c_estados_tickets___default.a,
    'parametros-de-exportacion': __WEBPACK_IMPORTED_MODULE_5__components_c_reporte_parametros_exportacion___default.a
  },
  props: {
    tipo: {
      type: String,
      default: ''
    },
    tipoDeArea: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      showFiltros: false,
      showAnulados: false,
      perfilUsuario: localStorage.getItem('perfil'),
      username: localStorage.getItem('username'),
      esCuentaAdministrador: +localStorage.getItem('esCuentaAdministrador') || 0,
      codigoCliente: '',
      isScroll: false,
      lista: [],
      cuentasRelacionadas: [],
      numeroRecnum: 0,
      disabledScrollExcecute: false,
      noMore: false,
      numero: '',
      desde: '',
      hasta: '',
      serie: '',
      estado: 0,
      zonaGarantia: 'sin asignacion',
      isClosed: false,
      isLoading: false,
      messageError: {},
      isModalErrorToCreateTicket: false,
      countFiltros: 0,
      tipoArea: this.tipoDeArea || 'sin asignacion',
      isUltimaAccionCliente: false,
      isModalExportar: false,
      isLoadingGetAccounts: false,
      idReporte: '',
      dictionary: {
        incidencia_con_equipo: 'incidencia con equipo',
        solicitud_de_insumo: 'solicitud de insumo',
        garantia: 'garantia'
      },
      tiposTicket: []
    };
  },
  created: function created() {
    var vm = this;
    if (vm.tipo === 'garantia') {
      vm.tiposTicket = ['garantia'];
    } else {
      if (!vm.tipoDeArea) {
        if (vm.perfilUsuario === 'usuario-contrato') {
          vm.tiposTicket = ['incidencia con equipo', 'solicitud de insumo'];
        } else if (vm.perfilUsuario === 'usuario') {
          vm.tiposTicket = ['garantia'];
        } else {
          if (vm.tipo === 'garantia') {
            vm.tiposTicket = ['garantia'];
          } else {
            vm.tiposTicket = ['incidencia con equipo', 'solicitud de insumo'];
          }
        }
      } else {
        var tipos = vm.dictionary[vm.tipoDeArea] ? [vm.dictionary[vm.tipoDeArea]] : [];
        if (!tipos.length) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'La categoria seleccionada es invalida');
          return;
        } else {
          vm.tiposTicket = tipos;
        }
      }
    }
    if (vm.esCuentaAdministrador) vm.fetchGetAccountsList(function () {
      return vm.fetch();
    });
  },

  computed: {
    isMovil: function isMovil() {
      var vm = this;
      return vm.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    tipoDeArea: function tipoDeArea(val) {
      var vm = this;
      vm.isClosed = false;
      if (vm.tipo === 'garantia') {
        vm.tiposTicket = ['garantia'];
      } else {
        if (!vm.tipoDeArea) {
          if (vm.perfilUsuario === 'usuario-contrato') {
            vm.tiposTicket = ['incidencia con equipo', 'solicitud de insumo'];
          } else if (vm.perfilUsuario === 'usuario') {
            vm.tiposTicket = ['garantia'];
          } else {
            if (vm.tipo === 'garantia') {
              vm.tiposTicket = ['garantia'];
            } else {
              vm.tiposTicket = ['incidencia con equipo', 'solicitud de insumo'];
            }
          }
        } else {
          var tipos = vm.dictionary[vm.tipoDeArea] ? [vm.dictionary[vm.tipoDeArea]] : [];
          if (!tipos.length) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'La categoria seleccionada es invalida');
            return;
          } else {
            vm.tiposTicket = tipos;
          }
        }
      }
      vm.limpiarFiltros();
    }
  },
  methods: {
    fetchGetAccountsList: function fetchGetAccountsList(callback) {
      var vm = this;
      // console.log('Entro a fetchGetAccountsList....')
      vm.isLoadingGetAccounts = true;
      vm.cuentasRelacionadas = [];
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obtener listado de cuentas' });
      var obj = {
        email: vm.username
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/usuario/obtener/cuentas/relacionados', obj, function (data) {
        var users = data.lista.map(function (e) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, e, { active: true });
        });
        vm.cuentasRelacionadas = users;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingGetAccounts = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
        callback && callback();
        // console.log('Regreso a fetchGetAccountsList....')
      });
    },
    getTicketGoTo: function getTicketGoTo(path) {
      window.open(path, '_blank');
    },
    closeDialogExportar: function closeDialogExportar() {
      var vm = this;
      vm.isModalExportar = false;
    },
    openDialogExportar: function openDialogExportar() {
      var vm = this;
      if (vm.perfilUsuario === 'usuario-contrato' || vm.perfilUsuario === 'usuario') {
        alert('Bad request');
      } else {
        vm.isModalExportar = true;
      }
    },
    addCountFiltros: function addCountFiltros() {
      var vm = this;
      vm.countFiltros = 0;
      if (vm.estado) vm.countFiltros++;
      if (vm.desde) vm.countFiltros++;
      if (vm.hasta) vm.countFiltros++;
      if (vm.serie) vm.countFiltros++;
      if (vm.numero) vm.countFiltros++;
      if (vm.codigoCliente) vm.countFiltros++;
      if (vm.zonaGarantia !== 'sin asignacion') vm.countFiltros++;
    },
    limpiarFiltros: function limpiarFiltros() {
      var vm = this;
      vm.countFiltros = 0;
      vm.estado = 0;
      vm.desde = '';
      vm.hasta = '';
      vm.serie = '';
      vm.numero = '';
      vm.zonaGarantia = 'sin asignacion';
      vm.tipoArea = vm.tipoDeArea || 'sin asignacion';
      if (vm.perfilUsuario === 'dispatcher' || vm.perfilUsuario === 'recepcion') vm.codigoCliente = '';
      vm.showFiltros && vm.$refs.estados.limpiarEstado();
      vm.fetch();
    },
    closeModalErrorToCreateTicket: function closeModalErrorToCreateTicket() {
      var vm = this;
      vm.isModalErrorToCreateTicket = false;
      vm.messageError = {};
    },
    fetchUsuario: function fetchUsuario() {
      var vm = this;
      vm.closeModalErrorToCreateTicket();
      var obj = {
        usuario: vm.username
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/usuario/obtener', obj, function (data) {
        var datos = data.lista[0];
        if (!datos.emailConfirmado) {
          vm.messageError.msg = 'Al momento de realizar el registro de su cuenta se le envio un email de verificación, Por favor ingrese a su bandeja de email y siga las instrucciones para verficar su cuenta';
          vm.isModalErrorToCreateTicket = true;
          vm.messageError.type = 'verificar_email';
          return;
        }

        if (!datos.fechaCuentaActivada && datos.perfil === 'usuario-contrato') {
          vm.messageError.msg = 'Cuenta no activada, Los datos de esta cuenta todavia estan en proceso de revision.';
          vm.isModalErrorToCreateTicket = true;
          vm.messageError.type = 'verificar_email';
          return;
        }

        if (!datos.documento && datos.perfil === 'usuario') {
          vm.messageError.msg = 'Faltan rellenar algunos datos importantes en tu perfil, click en la siguiente opcion';
          vm.messageError.type = 'datos_incompletos';
          vm.isModalErrorToCreateTicket = true;
          return;
        }

        if (!datos.ruc && datos.perfil === 'usuario-contrato') {
          vm.messageError.msg = 'Faltan rellenar el RUC, click en la siguiente opcion';
          vm.messageError.type = 'datos_incompletos';
          vm.isModalErrorToCreateTicket = true;
          return;
        }

        if (datos.perfil === 'usuario') vm.goTo('/ticket/nuevo');else vm.goTo('/ticket-contrato/nuevo');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_2__router_customer_js__["a" /* default */].push(page);
    },
    selectEstado: function selectEstado(e) {
      var vm = this;
      vm.estado = e.codigo;
      vm.addCountFiltros();
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      console.log('Entro a fetch....');
      var url = 'ticket/obtener';
      vm.isLoading = true;
      vm.showFiltros = false;
      if (!vm.isScroll) {
        vm.lista = [];
        vm.numeroRecnum = 0;
      }
      vm.disabledScrollExcecute = true;
      vm.$store.dispatch('transaccion', { isProceso: true, message: 'Obteniendo listado de tickets' });
      vm.noMore = false;
      if (!vm.tiposTicket.length) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Los parametros son invalidos');
        return;
      }
      console.log('vm.cuentasRelacionadas', vm.cuentasRelacionadas);
      var cuentas = vm.cuentasRelacionadas.filter(function (e) {
        return e.active;
      }).map(function (e) {
        return e.usuario;
      });
      var obj = {
        numero: vm.numero,
        desde: vm.desde,
        hasta: vm.hasta,
        serie: vm.serie,
        estado: vm.estado,
        codigoCliente: vm.codigoCliente,
        isClosed: vm.isClosed,
        tipoTicket: vm.tiposTicket,
        tipoArea: vm.tipoArea,
        zonaGarantia: vm.zonaGarantia,
        numeroRecnum: vm.numeroRecnum,
        isUltimaAccionCliente: vm.isUltimaAccionCliente,
        cuentasRelacionados: cuentas,
        cantidadRegistros: 20
      };

      console.log('obkj', obj);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExcecute = true;
        } else {
          vm.numeroRecnum = data.numeroRecnum;
          vm.disabledScrollExcecute = false;
        }
      }, function (err) {
        vm.disabledScrollExcecute = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isScroll = false;
        vm.$store.dispatch('transaccion', { isProceso: false });
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_usuario_form_editar_datos__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_usuario_form_editar_datos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_usuario_form_editar_datos__);
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'editar-datos-usuario': __WEBPACK_IMPORTED_MODULE_0__components_c_usuario_form_editar_datos___default.a
  },
  data: function data() {
    return {
      usuario: localStorage.getItem('username')
    };
  },
  created: function created() {},

  methods: {}
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_dispatcher_js__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'View_welcome_dispatcher',
  data: function data() {
    return {
      empresa: "reprodata",
      empresa_full: "Reprodata S.A.C.",
      nombre: localStorage.getItem('nombre'),
      openTickets: [{
        number: 0,
        label: 'Tickets abiertos',
        key: 'all_usuario_o_cliente'
      }]
    };
  },

  computed: {
    abiertos: function abiertos() {
      var vm = this;
      return vm.$store.state.ticket.abiertos;
    }
  },
  methods: {
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_0__router_dispatcher_js__["a" /* default */].push(page);
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_dispatcher_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_chart_line_cantidad_total_tickets_por_estados__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_chart_line_cantidad_total_tickets_por_estados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_card_chart_line_cantidad_total_tickets_por_estados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_card_chart_pie_cantidad_total_tickets_por_meses__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_card_chart_pie_cantidad_total_tickets_por_meses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_card_chart_pie_cantidad_total_tickets_por_meses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_card_chart_bar_tickets_en_recall__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_card_chart_bar_tickets_en_recall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_card_chart_bar_tickets_en_recall__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_card_chart_line_tickets_cerrados_por_horas_activo__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_card_chart_line_tickets_cerrados_por_horas_activo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_card_chart_line_tickets_cerrados_por_horas_activo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_card_chart_bar_tickets_pendientes_por_asesor__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_card_chart_bar_tickets_pendientes_por_asesor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_card_chart_bar_tickets_pendientes_por_asesor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'View_welcome_dispatcher',
  components: {
    'card-tickets-recall': __WEBPACK_IMPORTED_MODULE_3__components_c_card_chart_bar_tickets_en_recall___default.a,
    'card-tickets-por-estado': __WEBPACK_IMPORTED_MODULE_1__components_c_card_chart_line_cantidad_total_tickets_por_estados___default.a,
    'card-tickets-por-meses': __WEBPACK_IMPORTED_MODULE_2__components_c_card_chart_pie_cantidad_total_tickets_por_meses___default.a,
    'card-tickets-cerrados-horas': __WEBPACK_IMPORTED_MODULE_4__components_c_card_chart_line_tickets_cerrados_por_horas_activo___default.a,
    'card-tickets-pendientes-por-asesor': __WEBPACK_IMPORTED_MODULE_5__components_c_card_chart_bar_tickets_pendientes_por_asesor___default.a
  },
  data: function data() {
    return {
      reveal: false,
      ticketsRecall: false,
      empresa: "reprodata",
      empresa_full: "Reprodata S.A.C.",
      nombre: localStorage.getItem('nombre'),
      tipoTicket: 'garantia',
      isReadyCharts: true,
      tipos: [{
        value: 'garantia',
        label: 'Garantia'
      }, {
        value: 'incidencia con equipo',
        label: 'Incidencia con equipo - Contrato'
      }, {
        value: 'solicitud de insumo',
        label: 'Solicitud de insumo - Contrato'
      }]
    };
  },

  computed: {
    abiertos: function abiertos() {
      var vm = this;
      return vm.$store.state.ticket.abiertos;
    }
  },
  methods: {
    goTo: function goTo(page) {
      __WEBPACK_IMPORTED_MODULE_0__router_dispatcher_js__["a" /* default */].push(page);
    },
    changeTipo: function changeTipo() {
      var vm = this;
      vm.isReadyCharts = false;
      vm.$nextTick(function () {
        vm.isReadyCharts = true;
      });
    }
  }
});

/***/ }),
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */,
/* 423 */,
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 79,
	"./af.js": 79,
	"./ar": 86,
	"./ar-dz": 80,
	"./ar-dz.js": 80,
	"./ar-kw": 81,
	"./ar-kw.js": 81,
	"./ar-ly": 82,
	"./ar-ly.js": 82,
	"./ar-ma": 83,
	"./ar-ma.js": 83,
	"./ar-sa": 84,
	"./ar-sa.js": 84,
	"./ar-tn": 85,
	"./ar-tn.js": 85,
	"./ar.js": 86,
	"./az": 87,
	"./az.js": 87,
	"./be": 88,
	"./be.js": 88,
	"./bg": 89,
	"./bg.js": 89,
	"./bm": 90,
	"./bm.js": 90,
	"./bn": 92,
	"./bn-bd": 91,
	"./bn-bd.js": 91,
	"./bn.js": 92,
	"./bo": 93,
	"./bo.js": 93,
	"./br": 94,
	"./br.js": 94,
	"./bs": 95,
	"./bs.js": 95,
	"./ca": 96,
	"./ca.js": 96,
	"./cs": 97,
	"./cs.js": 97,
	"./cv": 98,
	"./cv.js": 98,
	"./cy": 99,
	"./cy.js": 99,
	"./da": 100,
	"./da.js": 100,
	"./de": 103,
	"./de-at": 101,
	"./de-at.js": 101,
	"./de-ch": 102,
	"./de-ch.js": 102,
	"./de.js": 103,
	"./dv": 104,
	"./dv.js": 104,
	"./el": 105,
	"./el.js": 105,
	"./en-au": 106,
	"./en-au.js": 106,
	"./en-ca": 107,
	"./en-ca.js": 107,
	"./en-gb": 108,
	"./en-gb.js": 108,
	"./en-ie": 109,
	"./en-ie.js": 109,
	"./en-il": 110,
	"./en-il.js": 110,
	"./en-in": 111,
	"./en-in.js": 111,
	"./en-nz": 112,
	"./en-nz.js": 112,
	"./en-sg": 113,
	"./en-sg.js": 113,
	"./eo": 114,
	"./eo.js": 114,
	"./es": 22,
	"./es-do": 115,
	"./es-do.js": 115,
	"./es-mx": 116,
	"./es-mx.js": 116,
	"./es-us": 117,
	"./es-us.js": 117,
	"./es.js": 22,
	"./et": 118,
	"./et.js": 118,
	"./eu": 119,
	"./eu.js": 119,
	"./fa": 120,
	"./fa.js": 120,
	"./fi": 121,
	"./fi.js": 121,
	"./fil": 122,
	"./fil.js": 122,
	"./fo": 123,
	"./fo.js": 123,
	"./fr": 126,
	"./fr-ca": 124,
	"./fr-ca.js": 124,
	"./fr-ch": 125,
	"./fr-ch.js": 125,
	"./fr.js": 126,
	"./fy": 127,
	"./fy.js": 127,
	"./ga": 128,
	"./ga.js": 128,
	"./gd": 129,
	"./gd.js": 129,
	"./gl": 130,
	"./gl.js": 130,
	"./gom-deva": 131,
	"./gom-deva.js": 131,
	"./gom-latn": 132,
	"./gom-latn.js": 132,
	"./gu": 133,
	"./gu.js": 133,
	"./he": 134,
	"./he.js": 134,
	"./hi": 135,
	"./hi.js": 135,
	"./hr": 136,
	"./hr.js": 136,
	"./hu": 137,
	"./hu.js": 137,
	"./hy-am": 138,
	"./hy-am.js": 138,
	"./id": 139,
	"./id.js": 139,
	"./is": 140,
	"./is.js": 140,
	"./it": 142,
	"./it-ch": 141,
	"./it-ch.js": 141,
	"./it.js": 142,
	"./ja": 143,
	"./ja.js": 143,
	"./jv": 144,
	"./jv.js": 144,
	"./ka": 145,
	"./ka.js": 145,
	"./kk": 146,
	"./kk.js": 146,
	"./km": 147,
	"./km.js": 147,
	"./kn": 148,
	"./kn.js": 148,
	"./ko": 149,
	"./ko.js": 149,
	"./ku": 150,
	"./ku.js": 150,
	"./ky": 151,
	"./ky.js": 151,
	"./lb": 152,
	"./lb.js": 152,
	"./lo": 153,
	"./lo.js": 153,
	"./lt": 154,
	"./lt.js": 154,
	"./lv": 155,
	"./lv.js": 155,
	"./me": 156,
	"./me.js": 156,
	"./mi": 157,
	"./mi.js": 157,
	"./mk": 158,
	"./mk.js": 158,
	"./ml": 159,
	"./ml.js": 159,
	"./mn": 160,
	"./mn.js": 160,
	"./mr": 161,
	"./mr.js": 161,
	"./ms": 163,
	"./ms-my": 162,
	"./ms-my.js": 162,
	"./ms.js": 163,
	"./mt": 164,
	"./mt.js": 164,
	"./my": 165,
	"./my.js": 165,
	"./nb": 166,
	"./nb.js": 166,
	"./ne": 167,
	"./ne.js": 167,
	"./nl": 169,
	"./nl-be": 168,
	"./nl-be.js": 168,
	"./nl.js": 169,
	"./nn": 170,
	"./nn.js": 170,
	"./oc-lnc": 171,
	"./oc-lnc.js": 171,
	"./pa-in": 172,
	"./pa-in.js": 172,
	"./pl": 173,
	"./pl.js": 173,
	"./pt": 175,
	"./pt-br": 174,
	"./pt-br.js": 174,
	"./pt.js": 175,
	"./ro": 176,
	"./ro.js": 176,
	"./ru": 177,
	"./ru.js": 177,
	"./sd": 178,
	"./sd.js": 178,
	"./se": 179,
	"./se.js": 179,
	"./si": 180,
	"./si.js": 180,
	"./sk": 181,
	"./sk.js": 181,
	"./sl": 182,
	"./sl.js": 182,
	"./sq": 183,
	"./sq.js": 183,
	"./sr": 185,
	"./sr-cyrl": 184,
	"./sr-cyrl.js": 184,
	"./sr.js": 185,
	"./ss": 186,
	"./ss.js": 186,
	"./sv": 187,
	"./sv.js": 187,
	"./sw": 188,
	"./sw.js": 188,
	"./ta": 189,
	"./ta.js": 189,
	"./te": 190,
	"./te.js": 190,
	"./tet": 191,
	"./tet.js": 191,
	"./tg": 192,
	"./tg.js": 192,
	"./th": 193,
	"./th.js": 193,
	"./tk": 194,
	"./tk.js": 194,
	"./tl-ph": 195,
	"./tl-ph.js": 195,
	"./tlh": 196,
	"./tlh.js": 196,
	"./tr": 197,
	"./tr.js": 197,
	"./tzl": 198,
	"./tzl.js": 198,
	"./tzm": 200,
	"./tzm-latn": 199,
	"./tzm-latn.js": 199,
	"./tzm.js": 200,
	"./ug-cn": 201,
	"./ug-cn.js": 201,
	"./uk": 202,
	"./uk.js": 202,
	"./ur": 203,
	"./ur.js": 203,
	"./uz": 205,
	"./uz-latn": 204,
	"./uz-latn.js": 204,
	"./uz.js": 205,
	"./vi": 206,
	"./vi.js": 206,
	"./x-pseudo": 207,
	"./x-pseudo.js": 207,
	"./yo": 208,
	"./yo.js": 208,
	"./zh-cn": 209,
	"./zh-cn.js": 209,
	"./zh-hk": 210,
	"./zh-hk.js": 210,
	"./zh-mo": 211,
	"./zh-mo.js": 211,
	"./zh-tw": 212,
	"./zh-tw.js": 212
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;

/***/ }),
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mp4.eb6badd.png";

/***/ }),
/* 431 */,
/* 432 */,
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(396)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(498),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(415)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(523),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a59820b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(412)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(520),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-90000332",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(414)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(522),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a4114d76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(502),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d65c577",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(528),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c42577ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(400)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(503),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60b915c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(416)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(525),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b0895652",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(507),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72e1e830",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(388)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(489),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c8e5492",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(381)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(481),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c7b890f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(533),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(524),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(484),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(480),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(521),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a12a614",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(413)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a3c86a12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(410)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d17eaee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e4eaac86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f9c8b0a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(515),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bc3e4aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(394)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(495),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-454554ee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(499),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(527),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(397)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(500),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-535c7e18",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(512),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76a08422",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(486),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27e85b6b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(487),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a20d2dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(483),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2133cdb0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(492),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38dfe84a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73736754",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(501),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(475),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(497),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(529),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-daab5dfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(479),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-15fde3bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(482),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1cd6f4c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ma-3"
  }, [_c('v-dialog', {
    attrs: {
      "width": "350",
      "min-height": "500",
      "persist": _vm.isLoadingCambiarRuc
    },
    model: {
      value: (_vm.isChangeCustomer),
      callback: function($$v) {
        _vm.isChangeCustomer = $$v
      },
      expression: "isChangeCustomer"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "px-4 pt-4"
  }, [_c('div', {
    staticClass: "font-weight-700 font-size-18"
  }, [_vm._v("Parametros")])]), _c('div', {
    staticClass: "px-4 ai-center jc-center pb-4 fd-column pt-2"
  }, [_c('span', {
    staticClass: "font-size-11"
  }, [_vm._v(" Ingrese el ruc de un cliente con contrato")]), _c('div', {
    staticClass: "d-flex ai-center mb-4"
  }, [_c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "type": "number",
      "placeholder": "Numero de ruc",
      "solo": "solo"
    },
    model: {
      value: (_vm.rucEditCliente),
      callback: function($$v) {
        _vm.rucEditCliente = $$v
      },
      expression: "rucEditCliente"
    }
  }), _c('v-btn', {
    attrs: {
      "color": "info",
      "disabled": isNaN(_vm.rucEditCliente) || _vm.rucEditCliente.length < 11 || _vm.rucEditCliente.length > 11,
      "loading": _vm.isLoadingCambiarRuc
    },
    on: {
      "click": function($event) {
        return _vm.fetchCambiarRUCCuenta()
      }
    }
  }, [_c('v-icon', [_vm._v("check")])], 1)], 1), _c('strong', {
    staticClass: "font-size-15"
  }, [_vm._v(_vm._s(_vm.nombreEditCliente))])]), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "block",
      "loading": _vm.isLoadingCambiarRuc,
      "disabled": isNaN(_vm.rucEditCliente) || _vm.rucEditCliente.length < 11 || _vm.rucEditCliente.length > 11
    },
    on: {
      "click": function($event) {
        return _vm.fetchCambiarRUCCuenta(true)
      }
    }
  }, [_c('small', [_vm._v("Guardar cambios")])])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-auto pa-3 flex fd-column",
    attrs: {
      "elevation": "1"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('div', {
    staticClass: "flex fd-column"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Tipo de ticket que desea generar")]), _c('v-slide-group', {
    staticClass: "flex-1",
    attrs: {
      "mandatory": "mandatory",
      "show-arrows": ""
    },
    model: {
      value: (_vm.tipoTicket),
      callback: function($$v) {
        _vm.tipoTicket = $$v
      },
      expression: "tipoTicket"
    }
  }, _vm._l((_vm.categoriasTicket), function(n, index) {
    return _c('v-slide-item', {
      key: index,
      staticClass: "animated fadeInLeft faster",
      attrs: {
        "value": n.value
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "elevation-1 ma-1 d-flex ai-center jc-center text-center",
            attrs: {
              "color": active ? 'primary' : 'secondary primary--text',
              "height": "60",
              "dark": active,
              "width": "140"
            },
            on: {
              "click": toggle
            }
          }, [_c('span', {
            staticClass: "font-size-12 font-weight-600"
          }, [_vm._v(_vm._s(n.name))])])]
        }
      }], null, true)
    })
  }), 1)], 1), (_vm.usuarioLogged && _vm.usuarioLogged.puedeCambiarRucDeCliente) ? _c('div', {
    staticClass: "d-flex fd-column px-2"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.isLoadingProceso,
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.openDialogIsChangeCustomer()
      }
    }
  }, [_vm._v("Cambiar cliente")])], 1) : _vm._e()]), _c('div', {
    staticClass: "pa-1 d-flex ai-center jc-center"
  }, [_c('div', {
    staticClass: "fd-column flex-1"
  }, [(!_vm.ruc || _vm.perfilUsuario === 'dispatcher') ? _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('div', {
    staticClass: "d-flex mb-3 ai-center jc-center"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Ingrese un valor valido")]), _c('div', {
    staticClass: "flex-1 d-flex justify-end"
  }, [_c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "hide-details",
      "row": "row"
    },
    model: {
      value: (_vm.tipoFiltroBusquedaEquipo),
      callback: function($$v) {
        _vm.tipoFiltroBusquedaEquipo = $$v
      },
      expression: "tipoFiltroBusquedaEquipo"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Serie",
      "value": "serie",
      "hide-details": "hide-details"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "RUC",
      "value": "ruc",
      "hide-details": "hide-details"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.tipoFiltroBusquedaEquipo === 'ruc') ? _c('v-text-field', {
    ref: "documento",
    staticClass: "mb-4",
    attrs: {
      "solo": "solo",
      "dense": "dense",
      "type": "number",
      "label": "Ingrese un numero de ruc valido",
      "hide-details": "hide-details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchEquipos()
      }
    },
    model: {
      value: (_vm.ruc),
      callback: function($$v) {
        _vm.ruc = $$v
      },
      expression: "ruc"
    }
  }) : (_vm.tipoFiltroBusquedaEquipo === 'serie') ? _c('v-text-field', {
    ref: "serie",
    staticClass: "mb-4",
    attrs: {
      "solo": "solo",
      "dense": "dense",
      "type": "text",
      "label": "Ingrese una serie valida",
      "hide-details": "hide-details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchEquipos()
      }
    },
    model: {
      value: (_vm.serieFiltro),
      callback: function($$v) {
        _vm.serieFiltro = $$v
      },
      expression: "serieFiltro"
    }
  }) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "info",
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchEquipos()
      }
    }
  }, [_vm._v("buscar")])], 1)]) : _vm._e(), (_vm.usuariosContrato.length && _vm.perfilUsuario === 'dispatcher ') ? _c('div', {
    staticClass: "d-flex fd-column mb-4"
  }, [_c('span', {
    staticClass: "font-size-11"
  }, [_vm._v("Cuentas registradas para este cliente")]), (_vm.usuarioSeleccionado.length > 1) ? _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.usuarioSeleccionado),
      callback: function($$v) {
        _vm.usuarioSeleccionado = $$v
      },
      expression: "usuarioSeleccionado"
    }
  }, _vm._l((_vm.usuariosContrato), function(usuario, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "label": ((usuario.razonSocial) + " (" + (usuario.usuario) + ")"),
        "value": usuario.usuario,
        "hide-details": "hide-details"
      }
    })
  }), 1) : _vm._e()], 1) : _vm._e(), (_vm.modelosAgrupados.length) ? _c('div', {
    staticClass: "d-flex mb-1"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Listado de equipos en contrato")])]) : _vm._e(), (_vm.modelosAgrupados.length) ? _c('div', {
    staticClass: "d-flex"
  }, [(!_vm.modelosAgrupadosFiltrados.length) ? _c('div', {
    staticClass: "flex-1"
  }, [_c('v-autocomplete', {
    attrs: {
      "loading": _vm.isGettingEquipos,
      "items": _vm.modelosAgrupados,
      "label": "Listado de modelos que tienes en contrato",
      "placeholder": "Realiza la busqueda por el modelo",
      "item-value": "equipos",
      "dense": "dense",
      "hide-details": "hide-details",
      "solo": "solo"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('span', {
          staticClass: "font-weight-700 font-size-12"
        }, [_vm._v(_vm._s(data.item.modelo))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-700",
          domProps: {
            "innerHTML": _vm._s(data.item.modelo)
          }
        }), _c('v-list-item-subtitle', [_c('span', {
          staticClass: "font-size-11 text-muted"
        }, [_vm._v(_vm._s(((data.item.cantidad) + " Equipo(s)")))])])], 1)]
      }
    }], null, false, 3179395255),
    model: {
      value: (_vm.equiposDelModelo),
      callback: function($$v) {
        _vm.equiposDelModelo = $$v
      },
      expression: "equiposDelModelo"
    }
  })], 1) : _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex ai-center",
    class: _vm.isMovil && 'fd-column'
  }, [_c('v-btn', {
    class: _vm.isMovil && 'mb-2',
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.limpiarModelo()
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _c('v-autocomplete', {
    attrs: {
      "items": _vm.modelosAgrupadosFiltrados,
      "label": "Listado de equipos del modelo",
      "placeholder": "Realiza la busqueda por la descripción",
      "dense": "dense",
      "item-value": "serie",
      "item-text": "serie",
      "return-object": "return-object",
      "hide-details": "hide-details",
      "solo": "solo"
    },
    on: {
      "change": _vm.agregarNuevoTicket
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-700",
          domProps: {
            "innerHTML": _vm._s(data.item.serie)
          }
        }), _c('v-list-item-subtitle', [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(_vm._s(data.item.descripcionArticulo))])])], 1)]
      }
    }], null, false, 2870585779)
  })], 1)])]) : _vm._e()])]), _c('div', {
    staticClass: "box-new-ticket pa-1"
  }, [_c('div', {
    staticClass: "elevation-0 py-0 mt-2 px-0"
  }, _vm._l((_vm.tickets), function(t, index) {
    return _c('v-list-group', {
      key: index,
      staticClass: "border-bottom-2px",
      class: {
        'pb-3 background': t.active
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function() {
          return [_c('v-list-item-content', {
            staticClass: "px-0 py-0"
          }, [_c('v-list-item-title', [_c('v-list', {
            staticClass: "py-2",
            attrs: {
              "dense": "dense",
              "color": t.active ? 'background' : ''
            }
          }, [_c('v-list-item', [_c('v-list-item-avatar', {
            attrs: {
              "color": "primary"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white"
            }
          }, [_vm._v("print")])], 1), _c('v-list-item-content', {
            staticClass: "py-0"
          }, [_c('v-list-item-title', [_c('span', {
            staticClass: "font-weight-700"
          }, [_vm._v(_vm._s(("#" + (t.numeroContrato))) + " -  ")]), _c('span', {
            staticClass: "font-weight-700"
          }, [_vm._v(_vm._s(t.modelo) + " -  ")]), _c('span', {
            staticClass: "font-weight-700 primary--text"
          }, [_vm._v(_vm._s(t.serie))])]), _c('v-list-item-subtitle', {
            staticClass: "info--text font-weight-700"
          }, [_vm._v(_vm._s(t.descripcion))]), (!t.active) ? _c('v-list-item-subtitle', {
            staticClass: "font-weight-700"
          }, [_vm._v(_vm._s(t.direccion) + " - (" + _vm._s(t.distrito) + " - " + _vm._s(t.provincia) + " - " + _vm._s(t.departamento) + ")")]) : _vm._e()], 1), _c('v-list-item-action', [_c('v-btn', {
            attrs: {
              "color": "error",
              "small": "small"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.eliminarItemSerie(index)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "size": "17"
            }
          }, [_vm._v("delete")]), _c('span', [_vm._v("Eliminar")])], 1)], 1)], 1)], 1)], 1)], 1)]
        },
        proxy: true
      }], null, true),
      model: {
        value: (t.active),
        callback: function($$v) {
          _vm.$set(t, "active", $$v)
        },
        expression: "t.active"
      }
    }, [_c('v-list-item', {
      key: index,
      staticClass: "px-4"
    }, [_c('v-list-item-content', {
      staticClass: "py-0"
    }, [(_vm.tipoTicket === 'solicitud de insumo' && t.clasificacion) ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("Insumos disponibles para el equipo " + _vm._s(t.clasificacion))]), (t.incluyePapel && t.clasificacion === 'multifuncional') ? _c('v-radio-group', {
      staticClass: "mb-2",
      attrs: {
        "row": "",
        "hide-details": "hide-details"
      },
      on: {
        "change": function (valor) { return _vm.recalcularInsumos(t); }
      },
      model: {
        value: (t.grupoPedidoInsumo),
        callback: function($$v) {
          _vm.$set(t, "grupoPedidoInsumo", $$v)
        },
        expression: "t.grupoPedidoInsumo"
      }
    }, [_c('v-radio', {
      attrs: {
        "label": "Consumible",
        "value": "consumible"
      }
    }), _c('v-radio', {
      attrs: {
        "label": "Papel",
        "value": "papel"
      }
    })], 1) : _vm._e(), (t.grupoPedidoInsumo === 'consumible') ? _c('div', {
      staticClass: "d-flex fd-column my-2"
    }, _vm._l((t.insumo), function(item, i) {
      return _c('div', {
        staticClass: "d-flex ai-center"
      }, [_c('v-checkbox', {
        staticClass: "ma-0",
        attrs: {
          "name": item.code,
          "id": item.code,
          "color": "primary",
          "hide-details": "hide-details"
        },
        model: {
          value: (item.active),
          callback: function($$v) {
            _vm.$set(item, "active", $$v)
          },
          expression: "item.active"
        }
      }), _c('label', {
        staticClass: "font-size-11",
        class: {
          '!primary--text font-weight-700': item.active
        },
        attrs: {
          "for": item.code
        }
      }, [_vm._v(_vm._s(item.name))])], 1)
    }), 0) : _vm._e(), (t.grupoPedidoInsumo === 'papel') ? _c('div', {
      staticClass: "d-flex fd-column mb-2"
    }, [_c('small', {
      staticClass: "font-size-11 primary--text"
    }, [_vm._v("Se solicitará papel para el equipo seleccionado")])]) : _vm._e()], 1) : _vm._e(), (_vm.tipoTicket === 'incidencia con equipo') ? _c('div', {
      staticClass: "mt-0"
    }, [_c('span', {
      staticClass: "font-size-11"
    }, [_vm._v(" ¿Cual es la falla que presenta el equipo?")]), _c('v-select', {
      staticClass: "mt-1",
      attrs: {
        "loading": _vm.isGettingFallas,
        "dense": "dense",
        "hide-details": "hide-details",
        "item-text": "descripcionFallaGeneral",
        "item-value": "codigoFallaGeneral",
        "return-object": "return-object",
        "items": _vm.fallas,
        "placeholder": ("Listado de fallas para la serie " + (t.serie)),
        "solo": "solo"
      },
      model: {
        value: (t.falla),
        callback: function($$v) {
          _vm.$set(t, "falla", $$v)
        },
        expression: "t.falla"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo' && t.serie) ? _c('div', {
      staticClass: "mt-0"
    }, [_c('v-text-field', {
      attrs: {
        "dense": "dense",
        "hide-details": "hide-details",
        "placeholder": "Ingresa una dirección valida",
        "solo": "solo"
      },
      model: {
        value: (t.direccion),
        callback: function($$v) {
          _vm.$set(t, "direccion", $$v)
        },
        expression: "t.direccion"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo') ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Departamento")]), _c('v-autocomplete', {
      staticClass: "mt-1",
      attrs: {
        "items": t.departamentos,
        "dense": "",
        "label": "Departamento",
        "hide-details": "hide-details",
        "solo": "solo"
      },
      on: {
        "change": function($event) {
          return _vm.rellenarInformacion('departamento', index)
        }
      },
      model: {
        value: (t.departamento),
        callback: function($$v) {
          _vm.$set(t, "departamento", $$v)
        },
        expression: "t.departamento"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo') ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Provicia")]), _c('v-autocomplete', {
      staticClass: "mt-1",
      attrs: {
        "items": t.provincias,
        "dense": "",
        "label": "Provincia",
        "hide-details": "hide-details",
        "solo": "solo"
      },
      on: {
        "change": function($event) {
          return _vm.rellenarInformacion('provincia', index)
        }
      },
      model: {
        value: (t.provincia),
        callback: function($$v) {
          _vm.$set(t, "provincia", $$v)
        },
        expression: "t.provincia"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo') ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Distrito")]), _c('v-autocomplete', {
      staticClass: "mt-1",
      attrs: {
        "items": t.distritos,
        "dense": "",
        "label": "Distrito",
        "hide-details": "hide-details",
        "solo": "solo"
      },
      on: {
        "change": function($event) {
          return _vm.rellenarInformacion('distrito', index)
        }
      },
      model: {
        value: (t.distrito),
        callback: function($$v) {
          _vm.$set(t, "distrito", $$v)
        },
        expression: "t.distrito"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo' && t.serie) ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Nombre completo de la persona de contacto")]), _c('v-text-field', {
      staticClass: "mt-1",
      attrs: {
        "dense": "dense",
        "hide-details": "hide-details",
        "placeholder": "Ingresa el nombre del contacto",
        "solo": "solo"
      },
      model: {
        value: (t.nombreContacto),
        callback: function($$v) {
          _vm.$set(t, "nombreContacto", $$v)
        },
        expression: "t.nombreContacto"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo' && t.serie) ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Numero de telefono celular de la persona de contacto")]), _c('v-text-field', {
      staticClass: "mt-1",
      attrs: {
        "dense": "dense",
        "hide-details": "hide-details",
        "placeholder": "Ingresa el numero de telefono  del contacto",
        "solo": "solo",
        "type": "number"
      },
      model: {
        value: (t.numeroTelefono),
        callback: function($$v) {
          _vm.$set(t, "numeroTelefono", $$v)
        },
        expression: "t.numeroTelefono"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo' && t.clasificacion === 'multifuncional') ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Contador actual del equipo (opcional)")]), _c('v-text-field', {
      staticClass: "mt-1",
      attrs: {
        "dense": "dense",
        "hide-details": "hide-details",
        "placeholder": "Ingresa el contador actual",
        "solo": "solo",
        "type": "number"
      },
      model: {
        value: (t.contadorActual),
        callback: function($$v) {
          _vm.$set(t, "contadorActual", $$v)
        },
        expression: "t.contadorActual"
      }
    })], 1) : _vm._e(), (t.tipo === 'incidencia con equipo') ? _c('v-alert', {
      staticClass: "my-4",
      attrs: {
        "icon": "warning",
        "type": "warning",
        "text": "text"
      }
    }, [_c('div', {
      staticClass: "d-flex fd-column"
    }, [_c('span', {
      staticClass: "font-size-14 font-weight-700"
    }, [_vm._v("Explicanos un poco más de la falla de tu equipo")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("Ejemplos")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("- La parte superior izquierda de la hoja sale manchada de rojo")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("- Si el equipo mostrara un código de error, por favor ingreselo aquí")])])]) : _c('v-alert', {
      staticClass: "my-4",
      attrs: {
        "icon": "info",
        "type": "info",
        "text": "text"
      }
    }, [_c('div', {
      staticClass: "d-flex fd-column"
    }, [_c('span', {
      staticClass: "font-size-14 font-weight-700"
    }, [_vm._v("Alguna observación adicional")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("Ejemplos")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("- Acercarse de 2pm a 6pm que se encuentra el encargado")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("- Solo enviar el color negro y amarillo")])])]), _c('div', [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Ingrese un comentario adicional (opcional)")]), _c('v-textarea', {
      attrs: {
        "placeholder": "Comentario adicional  (opcional)",
        "solo": "solo",
        "dense": "dense",
        "rows": "4"
      },
      model: {
        value: (t.comentarioGeneral),
        callback: function($$v) {
          _vm.$set(t, "comentarioGeneral", $$v)
        },
        expression: "t.comentarioGeneral"
      }
    })], 1)], 1)], 1)], 1)
  }), 1)]), _c('v-divider'), _c('div', {
    staticClass: "d-flex pa-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": !_vm.tickets.length,
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil,
      "loading": _vm.isLoadingProceso
    },
    on: {
      "click": function($event) {
        return _vm.procesoGenerarTickets()
      }
    }
  }, [_vm._v("Generar ticket")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "fullscreen"
    },
    model: {
      value: (_vm.isDialogEmail),
      callback: function($$v) {
        _vm.isDialogEmail = $$v
      },
      expression: "isDialogEmail"
    }
  }, [_c('v-card', {
    staticClass: "position-relative",
    attrs: {
      "width": "550",
      "height": "800"
    }
  }, [(!_vm.isLoadingHTML) ? _c('v-card', {
    attrs: {
      "loading": _vm.isLoadingHTML,
      "width": "100%",
      "height": "100%"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.bodyHTML)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "return"
  }, [_c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "dark": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-auto elevation-1"
  }, [_c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Notificaciones email")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Listado general de notificaciones por email")])], 1), (_vm.isMovil) ? _c('v-divider') : _vm._e(), _c('v-card', {
    staticClass: "d-flex elevation-0 ai-center",
    class: {
      'ma-2': !_vm.isMovil
    }
  }, [_c('v-select', {
    staticClass: "ma-1",
    attrs: {
      "items": _vm.types,
      "item-text": "label",
      "item-value": "value",
      "dense": "",
      "solo": "solo",
      "hide-details": "",
      "label": "Visualizar por"
    },
    on: {
      "change": function($event) {
        return _vm.getFetch()
      }
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.getFetch()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1)], 1)], 1), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "box-table",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, [_c('v-data-table', {
    staticClass: "overflow-y-auto",
    attrs: {
      "headers": _vm.headerTable,
      "dense": "dense",
      "fixed-header": "fixed-header",
      "items": _vm.lista,
      "disable-pagination": true,
      "hide-default-footer": "hide-default-footer",
      "show-expand": "show-expand",
      "single-expand": "single-expand"
    },
    scopedSlots: _vm._u([{
      key: "item.id",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-10"
        }, [_vm._v(_vm._s(item.id))])]
      }
    }, {
      key: "item.fechaRegistro",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-10"
        }, [_vm._v(_vm._s(_vm._f("formatoFecha")(item.fechaRegistro)))])]
      }
    }, {
      key: "item.fechaEnvio",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          attrs: {
            "color": "background"
          }
        }, [(item.enviado) ? _c('span', {
          staticClass: "font-weight-700 font-size-10 success--text"
        }, [_vm._v(_vm._s(_vm._f("formatoFecha")(item.fechaEnvio)))]) : _c('span', {
          staticClass: "font-weight-700 font-size-10 warning--text"
        }, [_vm._v("Todavia no se envia")])])]
      }
    }, {
      key: "item.enviado",
      fn: function(ref) {
        var item = ref.item;

        return [(item.enviado) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("check_circle")]) : _c('v-icon', {
          attrs: {
            "color": "warning"
          }
        }, [_vm._v("watch_later")])]
      }
    }, {
      key: "item.asunto",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(_vm._s(item.asunto))])]
      }
    }, {
      key: "item.usuario",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(_vm._s(item.usuario))])]
      }
    }, {
      key: "item.conCopiaOculta",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(_vm._s(item.conCopiaOculta))])]
      }
    }, {
      key: "item.plantilla",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(_vm._s(item.plantilla))])]
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [_c('div', {
          staticClass: "pa-4"
        }, [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(_vm._s(item.destinatarios))])])]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('div', {
          staticClass: "d-flex ai-center",
          class: {
            'ma-1': !_vm.isMovil
          }
        }, [_c('v-btn', {
          staticClass: "mr-2",
          attrs: {
            "x-small": "x-small",
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(item.id)
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "size": "15"
          }
        }, [_vm._v("info")]), _vm._v("plantilla")], 1)], 1)])]
      }
    }])
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "fullscreen": _vm.isMovil,
      "hide-overlay": _vm.isMovil,
      "transition": "dialog-bottom-transition",
      "width": _vm.isMovil ? '100%' : '500'
    },
    model: {
      value: (_vm.showInfoUser),
      callback: function($$v) {
        _vm.showInfoUser = $$v
      },
      expression: "showInfoUser"
    }
  }, [_c('item-usuario', {
    attrs: {
      "is-fetch": "is-fetch",
      "username": _vm.ticket.usuario,
      "show-details": "show-details"
    }
  })], 1), _c('v-dialog', {
    attrs: {
      "width": "500",
      "min-height": "500"
    },
    model: {
      value: (_vm.isModalIntegracion),
      callback: function($$v) {
        _vm.isModalIntegracion = $$v
      },
      expression: "isModalIntegracion"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "px-2 pt-2"
  }, [_c('div', {
    staticClass: "text-center font-weight-700 font-size-18"
  }, [_vm._v("GENERAR INFORME TECNICO - " + _vm._s(_vm.ticket.serie))])]), (_vm.isLoadingGetSerie) ? _c('v-card-text', [_c('span', [_vm._v("Cargando ...")])]) : _c('v-card-text', [_c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.tiposInformeFiltrado,
      "item-text": "name",
      "item-value": "code",
      "label": "Tipo",
      "dense": "",
      "hide-details": "hide-details",
      "disabled": _vm.isGenerarITGarantia
    },
    model: {
      value: (_vm.tipoIntegracion),
      callback: function($$v) {
        _vm.tipoIntegracion = $$v
      },
      expression: "tipoIntegracion"
    }
  })], 1)], 1), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-autocomplete', {
    staticClass: "mt-1",
    attrs: {
      "loading": _vm.isGettingFallas,
      "dense": "dense",
      "hide-details": "hide-details",
      "item-text": "descripcionFallaGeneral",
      "item-value": "codigoFallaGeneral",
      "return-object": "return-object",
      "items": _vm.fallas,
      "placeholder": "Falla"
    },
    model: {
      value: (_vm.fallaSeleccionada),
      callback: function($$v) {
        _vm.fallaSeleccionada = $$v
      },
      expression: "fallaSeleccionada"
    }
  })], 1)], 1) : _vm._e(), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [(_vm.isModalIntegracion) ? _c('listado-direcciones-seleccionar', {
    attrs: {
      "codigo": _vm.datosSerieInforme.codigoClienteSap,
      "id": _vm.direccionSeleccionado.id
    },
    on: {
      "selected": _vm.getDireccion
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-autocomplete', {
    staticClass: "mt-1",
    attrs: {
      "loading": _vm.isLoadingUbigeos,
      "dense": "dense",
      "hide-details": "hide-details",
      "item-text": "descripcion",
      "item-value": "ubigeo",
      "return-object": "return-object",
      "items": _vm.ubigeos,
      "placeholder": "Ubigeo"
    },
    model: {
      value: (_vm.ubigeoSeleccionado),
      callback: function($$v) {
        _vm.ubigeoSeleccionado = $$v
      },
      expression: "ubigeoSeleccionado"
    }
  })], 1)], 1) : _vm._e(), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Ubicacion equipo *",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.datosSerieInforme.extra),
      callback: function($$v) {
        _vm.$set(_vm.datosSerieInforme, "extra", $$v)
      },
      expression: "datosSerieInforme.extra"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Telefono contacto *",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.datosSerieInforme.telefono),
      callback: function($$v) {
        _vm.$set(_vm.datosSerieInforme, "telefono", $$v)
      },
      expression: "datosSerieInforme.telefono"
    }
  })], 1)], 1) : _vm._e(), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Email contacto*",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.datosSerieInforme.email),
      callback: function($$v) {
        _vm.$set(_vm.datosSerieInforme, "email", $$v)
      },
      expression: "datosSerieInforme.email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Nombre contacto *",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.datosSerieInforme.contacto),
      callback: function($$v) {
        _vm.$set(_vm.datosSerieInforme, "contacto", $$v)
      },
      expression: "datosSerieInforme.contacto"
    }
  })], 1)], 1) : _vm._e(), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Observacion para el informe*",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.datosSerieInforme.observacion),
      callback: function($$v) {
        _vm.$set(_vm.datosSerieInforme, "observacion", $$v)
      },
      expression: "datosSerieInforme.observacion"
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-card-actions', [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "primary",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.fetchIntegrarTicket()
      }
    }
  }, [_c('small', [_vm._v("Continuar")])])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "350",
      "min-height": "350"
    },
    model: {
      value: (_vm.isModalAsignacionZona),
      callback: function($$v) {
        _vm.isModalAsignacionZona = $$v
      },
      expression: "isModalAsignacionZona"
    }
  }, [_c('v-card', {
    staticClass: "pa-6"
  }, [_c('div', {
    staticClass: "px-4 py-3"
  }, [_c('div', {
    staticClass: "text-center font-weight-700 font-size-18"
  }, [_vm._v("Actualiza el area y zona de garantia")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-13"
  }, [_vm._v("Area")]), (_vm.ticket.numero) ? _c('v-radio-group', {
    staticClass: "py-0 mb-6 mt-2",
    attrs: {
      "column": "column",
      "hide-details": "hide-details",
      "disabled": _vm.isLoadingChangeTipoArea || _vm.perfil === 'supervisor'
    },
    on: {
      "change": function($event) {
        return _vm.fetchActualizarTipoArea()
      }
    },
    model: {
      value: (_vm.ticket.tipoArea),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "tipoArea", $$v)
      },
      expression: "ticket.tipoArea"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "campo"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.tipoArea === 'campo'
          }
        }, [_vm._v("Campo")])]
      },
      proxy: true
    }], null, false, 1258975406)
  }), _c('v-radio', {
    attrs: {
      "value": "taller"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.tipoArea === 'taller'
          }
        }, [_vm._v("Taller")])]
      },
      proxy: true
    }], null, false, 2907251278)
  }), _c('v-radio', {
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.tipoArea === 'sin asignacion'
          }
        }, [_vm._v("Sin asignación")])]
      },
      proxy: true
    }], null, false, 3030543634)
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-13"
  }, [_vm._v("Zona")]), (_vm.ticket.numero) ? _c('v-radio-group', {
    staticClass: "py-0 mt-2",
    attrs: {
      "column": "column",
      "hide-details": "hide-details",
      "disabled": _vm.isLoadingChangeZonaGarantia || _vm.perfil === 'supervisor'
    },
    on: {
      "change": function($event) {
        return _vm.fetchActualizaZonaGarantia()
      }
    },
    model: {
      value: (_vm.ticket.zonaGarantia),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "zonaGarantia", $$v)
      },
      expression: "ticket.zonaGarantia"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "lima"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.zonaGarantia === 'lima'
          }
        }, [_vm._v("Lima")])]
      },
      proxy: true
    }], null, false, 416770790)
  }), _c('v-radio', {
    attrs: {
      "value": "arequipa"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.zonaGarantia === 'arequipa'
          }
        }, [_vm._v("Arequipa")])]
      },
      proxy: true
    }], null, false, 3209553030)
  }), _c('v-radio', {
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.zonaGarantia === 'sin asignacion'
          }
        }, [_vm._v("Sin asignación")])]
      },
      proxy: true
    }], null, false, 831268698)
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex mt-8"
  }, [_c('p', {
    staticClass: "font-size-11 text-muted my-2 mb-0"
  }, [_vm._v("Al realizar el cambio de area y zona se le notificará a los dispatcher que pertenezcan a la zona que selecciones.")])])])])])], 1), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": _vm.isMovil ? '100%' : '450',
      "fullscreen": _vm.isMovil,
      "hide-overlay": _vm.isMovil
    },
    model: {
      value: (_vm.isModalEditarCita),
      callback: function($$v) {
        _vm.isModalEditarCita = $$v
      },
      expression: "isModalEditarCita"
    }
  }, [(_vm.isModalEditarCita) ? _c('form-cita', {
    attrs: {
      "id": _vm.ticket.idCita,
      "is-creacion-externo": !_vm.isCreacionExterno,
      "no-esta-en-agenda": "no-esta-en-agenda",
      "numero-ticket": _vm.ticket.numero
    },
    on: {
      "close": function($event) {
        return _vm.closeModalEditarCita()
      },
      "update": function($event) {
        _vm.fetch();
        _vm.$refs.activity.fetchActividades(true)
      }
    }
  }) : _vm._e()], 1), (_vm.isMovil) ? _c('v-tabs', {
    staticClass: "elevation-1 position-sticky",
    attrs: {
      "fixed-tabs": ""
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabActive = 1
      }
    }
  }, [_c('small', [_vm._v("detalles")])]), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabActive = 2
      }
    }
  }, [_c('small', [_vm._v("actividades")])]), (_vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario-contrato' && _vm.ticket.abierto) ? _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabActive = 3
      }
    }
  }, [_c('small', [_vm._v("acciones")])]) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "pa-3"
  }, [_c('v-dialog', {
    attrs: {
      "width": "450",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalAddMessage()
      }
    },
    model: {
      value: (_vm.isAddMessageChanges),
      callback: function($$v) {
        _vm.isAddMessageChanges = $$v
      },
      expression: "isAddMessageChanges"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-18 py-2"
  }, [_vm._v("¿Deseas agregar algún comentario para los cambios que se van a realizar?")]), _c('div', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    ref: "comentarioChanges",
    attrs: {
      "hide-details": "hide-details",
      "autofocus": "autofocus",
      "placeholder": "Describe (opcional)",
      "color": "primary",
      "solo": "solo",
      "dense": "dense",
      "rows": "6"
    },
    model: {
      value: (_vm.comentarioChanges),
      callback: function($$v) {
        _vm.comentarioChanges = $$v
      },
      expression: "comentarioChanges"
    }
  })], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "success",
      "block": "block",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchActualizarDatosTicket()
      }
    }
  }, [_vm._v("Confirmar los cambios")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "450",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalAnular()
      }
    },
    model: {
      value: (_vm.isModalAnularTicket),
      callback: function($$v) {
        _vm.isModalAnularTicket = $$v
      },
      expression: "isModalAnularTicket"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-18 py-2"
  }, [_vm._v("¿Estas seguro que deseas anular el ticket?")]), _c('div', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    ref: "comentarioParaAnular",
    attrs: {
      "hide-details": "hide-details",
      "autofocus": "autofocus",
      "placeholder": "Describe un motivo por el cual deseas anular el ticket",
      "color": "primary",
      "solo": "solo",
      "dense": "dense",
      "rows": "6"
    },
    model: {
      value: (_vm.comentarioParaAnular),
      callback: function($$v) {
        _vm.comentarioParaAnular = $$v
      },
      expression: "comentarioParaAnular"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.closeModalAnular()
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchCloseTicket()
      }
    }
  }, [_vm._v("Anular ticket")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.isMovil,
      "hide-overlay": _vm.isMovil,
      "transition": "dialog-bottom-transition",
      "width": _vm.isMovil ? '100%' : '500'
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalDataSerie()
      }
    },
    model: {
      value: (_vm.showModalDataSerie),
      callback: function($$v) {
        _vm.showModalDataSerie = $$v
      },
      expression: "showModalDataSerie"
    }
  }, [(_vm.showModalDataSerie) ? _c('v-card', [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('item-serie', {
    attrs: {
      "serie": _vm.ticket.serie,
      "tipo-ticket": _vm.ticket.tipoticket
    },
    on: {
      "close": function($event) {
        return _vm.closeModalDataSerie()
      }
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-row', [(!_vm.isMovil || _vm.isMovil && _vm.tabActive === 1) ? _c('v-col', {
    attrs: {
      "md": _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario' && _vm.ticket.abierto ? '3' : '4'
    }
  }, [(_vm.ticket.numero && (_vm.perfil === 'usuario-contrato' || _vm.perfil === 'usuario') && _vm.ticket.abierto) ? _c('div', {
    staticClass: "flex-1 mb-4"
  }, [_c('v-btn', {
    staticClass: "width-full",
    attrs: {
      "color": "primary",
      "disabled": _vm.ticket.estado >= 13 && _vm.ticket.tipoticket === 'garantia',
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        _vm.isModalAnularTicket = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v(" block")]), _vm._v("Anular ticket")], 1), (_vm.ticket.estado >= 13 && _vm.ticket.tipoticket === 'garantia') ? _c('strong', {
    staticClass: "font-size-11"
  }, [_vm._v("No se puede anular el ticket por que el equipo ya ingreso al taller")]) : _vm._e()], 1) : _vm._e(), (_vm.ticket.numero && !_vm.ticket.abierto) ? _c('v-alert', {
    attrs: {
      "icon": "error",
      "outlined": "outlined",
      "text": "",
      "dense": "dense",
      "type": "error"
    }
  }, [_c('span', {
    staticClass: "font-size-15 font-weight-700"
  }, [_vm._v("El ticket se encuentra cerrado")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('small', {
    staticClass: "font-weight-700"
  }, [_vm._v("fecha de cierre " + _vm._s(_vm._f("formatoFecha")(_vm.ticket.fechaQueSeCerro)))])])]) : _vm._e(), _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [(_vm.ticket.usuario && _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario-contrato') ? _c('v-expansion-panel', {
    key: "usuario"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [_c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("perm_identity")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Información del usuario")])], 1)])]), _c('v-expansion-panel-content', [_c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    domProps: {
      "textContent": _vm._s(_vm.ticket.razonSocial)
    }
  }), _c('v-list-item-subtitle', {
    domProps: {
      "textContent": _vm._s(_vm.ticket.usuario)
    }
  })], 1)], 1), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        _vm.showInfoUser = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v(" visibility")]), _vm._v("mas Información")], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), (_vm.ticket.idCita) ? _c('v-expansion-panel', {
    key: "cita_programada"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("date_range")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Información de la cita")])], 1)])], 1), _c('v-expansion-panel-content', [_c('v-card', {
    key: "ticketSeleccionada",
    staticClass: "elevation-0"
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-title', [_c('span', {
    staticClass: "font-weight-700 font-size-14 primary--text"
  }, [_vm._v(_vm._s(_vm.datosCita.fechaCita) + " " + _vm._s(_vm.datosCita.horaCita))])]), _c('v-list-item-subtitle', {
    staticClass: "grey--text font-size-11"
  }, [_vm._v("Fué programado  " + _vm._s(_vm._f("now")(_vm.datosCita.fechaRegistro)))])], 1), _c('v-list-item-action', [(_vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario-contrato') ? _c('v-btn', {
    attrs: {
      "color": "success",
      "fab": "fab",
      "small": "small",
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": function($event) {
        _vm.isModalEditarCita = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _c('v-expansion-panel', {
    key: "ticket"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("info_outline")]), _c('strong', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v("Información del ticket")]), _c('small', {
    staticClass: "text-muted font-size-11 ml-2"
  }, [_vm._v("(se registró " + _vm._s(_vm._f("now")(_vm.ticket.fechaRegistro)) + ")")])], 1)], 1), _c('v-expansion-panel-content', [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "card"
    }
  }) : _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', [_c('h2', {
    staticClass: "primary--text font-weight-700"
  }, [_vm._v(_vm._s(("#" + (_vm.ticket.numero))))]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_c('strong', {
    staticClass: "font-size-11"
  }, [_vm._v("   " + _vm._s(_vm.ticket.tipoticket ? _vm.ticket.tipoticket.toUpperCase() : ''))])])], 1)], 1), (_vm.perfil !== 'usuario' && _vm.perfil !== 'usuario-contrato') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Numero informe tecnico")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.numeroInformeTecnico
    }
  }, [_vm._v(_vm._s(_vm.ticket.numeroInformeTecnico ? _vm.ticket.numeroInformeTecnico : '--'))])], 1)], 1) : _vm._e(), (_vm.perfil !== 'usuario' && _vm.perfil !== 'usuario-contrato' && _vm.ticket.tipoticket === 'garantia') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Numero solicitud orden de compra")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.numeroSolicitudOrdenCompra
    }
  }, [_vm._v(_vm._s(_vm.ticket.numeroSolicitudOrdenCompra ? _vm.ticket.numeroSolicitudOrdenCompra : '--'))])], 1)], 1) : _vm._e(), (_vm.perfil !== 'usuario' && _vm.perfil !== 'usuario-contrato' && _vm.ticket.tipoticket === 'garantia') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Numero solicitud parte de ingreso")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.numeroParteIngreso
    }
  }, [_vm._v(_vm._s(_vm.ticket.numeroParteIngreso ? _vm.ticket.numeroParteIngreso : '--'))])], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'solicitud de insumo') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Insumos solicitados")]), _c('div', {
    staticClass: "d-flex fd-column"
  }, _vm._l((_vm.ticket.insumo), function(insumo, index) {
    return _c('strong', {
      key: index,
      staticClass: "font-size-12"
    }, [_vm._v("- " + _vm._s(insumo))])
  }), 0)], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'solicitud de insumo') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Dirección de entrega")]), _c('v-list-item-title', [_c('span', [_vm._v(_vm._s(_vm.ticket.direccion) + " - (" + _vm._s(_vm.ticket.departamento) + "/" + _vm._s(_vm.ticket.provincia) + "/" + _vm._s(_vm.ticket.distrito) + ")")])])], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'solicitud de insumo') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Nombre contacto")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.nombreContacto
    }
  }, [_vm._v(_vm._s(_vm.ticket.nombreContacto ? _vm.ticket.nombreContacto : '--'))])], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'solicitud de insumo') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Telefono contacto")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.numeroTelefono
    }
  }, [_vm._v(_vm._s(_vm.ticket.numeroTelefono ? _vm.ticket.numeroTelefono : '--'))])], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'solicitud de insumo') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Ultimo contador")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.contadorActual
    }
  }, [_vm._v(_vm._s(_vm.ticket.contadorActual ? _vm.ticket.contadorActual : '--'))])], 1)], 1) : _vm._e(), _c('v-divider'), _c('div', {
    staticClass: "d-flex fd-column mt-2"
  }, [_c('span', {
    staticClass: "font-size-12 gray--text font-weight-700"
  }, [_vm._v("Descripción de la falla")]), (_vm.ticket.descripcionFalla) ? _c('v-alert', {
    staticClass: "my-1 word-break-message",
    attrs: {
      "icon": "handyman",
      "text": "",
      "dense": "dense",
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-size-14 font-weight-700"
  }, [_vm._v(_vm._s(_vm.ticket.descripcionFalla))]), _c('span', {
    staticClass: "font-size-11 font-italic pt-2"
  }, [_vm._v("\"" + _vm._s(_vm.ticket.comentarioFalla) + "\"")])])]) : _c('span', {
    staticClass: "font-weight-700 font-size-12",
    class: {
      'error--text': !_vm.ticket.comentarioFalla
    }
  }, [_vm._v("No se especificado")])], 1), _c('div', {
    staticClass: "d-flex fd-column mt-2"
  }, [_c('span', {
    staticClass: "font-size-12 gray--text font-weight-700"
  }, [_vm._v("Comentario general")]), (_vm.ticket.comentarioGeneral) ? _c('v-alert', {
    staticClass: "my-1 word-break-message",
    attrs: {
      "icon": "mark_chat_unread",
      "text": "",
      "type": "info"
    }
  }, [_c('span', {
    staticClass: "font-size-11 font-italic"
  }, [_vm._v("\"" + _vm._s(_vm.ticket.comentarioGeneral) + "\"")])]) : _c('span', {
    staticClass: "font-weight-700 font-size-12",
    class: {
      'error--text': !_vm.ticket.comentarioGeneral
    }
  }, [_vm._v("No se especificado")])], 1), _c('div', {
    staticClass: "d-flex fd-column mt-2"
  }, [_c('span', {
    staticClass: "font-size-12 gray--text font-weight-700"
  }, [_vm._v("Estado actual del ticket")]), _c('span', {
    staticClass: "font-weight-700 font-size-12 primary--text text-uppercase"
  }, [_vm._v(_vm._s(_vm.ticket.descripcionEstado))])]), (_vm.ticket.numeroInformeTecnico && _vm.ticket.urlGuiaRecepcionFirmada) ? _c('v-list-item', {
    staticClass: "px-0",
    on: {
      "click": function($event) {
        return _vm.openInformeDeRecepcion()
      }
    }
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Informe de recepción")]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_c('v-btn', {
    staticClass: "animated fadeInUp faster",
    attrs: {
      "small": "small",
      "block": "block",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.openInformeDeRecepcion()
      }
    }
  }, [_c('v-icon', [_vm._v(" visibility")]), _vm._v("   Visualizar")], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _c('v-expansion-panel', {
    key: "equipo"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("category")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Información del equipo")])], 1)])], 1), _c('v-expansion-panel-content', [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  }) : _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [(_vm.ticket.marca) ? _c('v-list-item', [_c('v-img', {
    attrs: {
      "src": (_vm.apiUpload + "/upload/octopus/marcas/" + (_vm.ticket.marca) + ".jpg"),
      "width": "70",
      "height": "70",
      "contain": "contain"
    }
  })], 1) : _vm._e(), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Marca")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.marca
    }
  }, [_vm._v(_vm._s(_vm.ticket.marca ? _vm.ticket.marca : '--'))])], 1)], 1), (_vm.ticket.numero) ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Serie")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.serie
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.ticket.serie ? _vm.ticket.serie : '--'))]), _c('v-spacer'), (_vm.perfil !== 'usuario' && _vm.perfil !== 'usuario-contrato' && _vm.ticket.serie) ? _c('v-btn', {
    staticClass: "ml-2 elevation-1",
    attrs: {
      "color": "info",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.goToHistoriaTecnica()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "size": "14"
    }
  }, [_vm._v(" link")]), _c('small', [_vm._v("Historia tecnica")])], 1) : _vm._e()], 1)])], 1)], 1) : _vm._e(), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Descripcion equipo")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.descripcion
    }
  }, [_vm._v(_vm._s(_vm.ticket.descripcion ? _vm.ticket.descripcion : '--'))])], 1)], 1), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Modelo equipo")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.modelo
    }
  }, [_vm._v(_vm._s(_vm.ticket.modelo ? _vm.ticket.modelo : '--'))])], 1)], 1), (_vm.ticket.tipoticket === 'garantia') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v("Factura electronica")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.factura
    }
  }, [_vm._v(_vm._s(_vm.ticket.factura ? _vm.ticket.factura : 'No asignado'))])], 1)], 1) : _vm._e(), (_vm.ticket.ubigeo) ? _c('v-divider') : _vm._e(), (_vm.ticket.ubigeo) ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "background"
  }, [_vm._v("location_on")])], 1), _c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.ticket.direccion))]), _c('v-list-item-subtitle', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v("(" + _vm._s(_vm.ticket.ubigeo) + ") / " + _vm._s(_vm.ticket.departamento) + " - " + _vm._s(_vm.ticket.provincia) + " - " + _vm._s(_vm.ticket.distrito))])], 1)], 1) : _vm._e()], 1)], 1)], 1), (_vm.ticket.tipoticket !== 'garantia') ? _c('v-expansion-panel', {
    key: "contrato"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("receipt_long")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Información del contrato")]), _c('span', {
    staticClass: "font-size-12 info--text ml-2"
  }, [_vm._v("# " + _vm._s(_vm.datosContrato.numeroContrato))])], 1)])], 1), _c('v-expansion-panel-content', [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  }) : _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Empresa")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.datosContrato.empresa
    }
  }, [_vm._v(_vm._s(_vm.datosContrato.empresa ? _vm.datosContrato.empresa : '--'))])], 1)], 1), (_vm.ticket.numero) ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Tipo")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.datosContrato.descripcionTipoContrato
    }
  }, [_vm._v(_vm._s(_vm.datosContrato.descripcionTipoContrato ? _vm.datosContrato.descripcionTipoContrato : '--'))])], 1)], 1) : _vm._e(), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Vigencia")]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm._f("formatoFecha")(_vm.datosContrato.fechaDesde)) + " - " + _vm._s(_vm._f("formatoFecha")(_vm.datosContrato.fechaHasta)))])], 1)], 1), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" ¿Incluye papel?")]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.datosContrato.incluyePapel ? 'Si incluye' : 'No incluye'))])], 1)], 1)], 1)], 1)], 1) : _vm._e(), (_vm.ticket.codigoTecnico && _vm.perfil === 'usuario-contrato') ? _c('v-expansion-panel', {
    key: "tecnico"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [_c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("perm_identity")]), _c('small', [_vm._v("Tecnico asignado para su atención")])], 1)])]), _c('v-expansion-panel-content', [_c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "background"
  }, [_vm._v("perm_identity")])], 1), _c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-title', {
    staticClass: "uppercase bold is-bold"
  }, [_c('strong', [_vm._v(_vm._s(_vm.ticket.nombreTecnico))])]), _c('v-list-item-subtitle', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v("Tecnico de campo")])], 1)], 1), (_vm.datosTecnico) ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', [_c('v-btn', {
    attrs: {
      "color": "info",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchDescargarSCTR()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v(" get_app")]), _vm._v("Descarga SCTR")], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), (!_vm.isMovil || _vm.isMovil && _vm.tabActive === 2) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario' && _vm.ticket.abierto ? '6' : '8'
    }
  }, [_c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll.self",
      value: (_vm.onScroll),
      expression: "onScroll",
      modifiers: {
        "self": true
      }
    }],
    staticClass: "content-time-line",
    class: {
      'is-movil-time-line': _vm.isMovil && _vm.ticket.abierto, 'is-closed-desktop': !_vm.isMovil && !_vm.ticket.abierto, 'is-closed-movil': _vm.isMovil && !_vm.ticket.abierto
    },
    attrs: {
      "id": "scrolling-time-line"
    }
  }, [(_vm.fechaUltimaActividad) ? _c('v-chip', {
    staticClass: "animated fadeInDown faster count",
    class: !_vm.isMovil ? 'left-45' : '',
    attrs: {
      "color": "primary"
    }
  }, [_c('small', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.fechaUltimaActividad))])]) : _vm._e(), (_vm.ticket.numero) ? _c('time-line-actividades', {
    ref: "activity",
    attrs: {
      "numero": _vm.ticket.numero
    },
    on: {
      "updated": _vm.obtenerFechaUltimaActividad
    }
  }) : _vm._e(), (_vm.ticket.numero) ? _c('div', {
    staticClass: "floating"
  }, [(_vm.scrollInvoked > 1000) ? _c('v-btn', {
    staticClass: "mr-2 animated fadeInUp faster",
    attrs: {
      "small": "small",
      "fab": "fab",
      "color": "ligth"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToTop()
      }
    }
  }, [_c('v-icon', [_vm._v(" keyboard_arrow_up")])], 1) : _vm._e(), _c('v-menu', {
    attrs: {
      "transition": "slide-x-transition",
      "bottom": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "animated fadeInUp faster",
          attrs: {
            "small": "small",
            "fab": "fab",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" more_vert")])], 1)]
      }
    }], null, false, 819448673)
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$refs.activity.fetchActividades(true)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Actualizar listado de actividades")])], 1), ((_vm.perfil === 'dispatcher' || _vm.perfil === 'recepcion') && _vm.ticket.tipoticket === 'garantia') ? _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.isModalAsignacionZona = true
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Delimitacion de zona garantia")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1), (_vm.ticket.abierto && !_vm.isLoadingGetUser) ? _c('enviar-mensaje-para-actividad', {
    ref: "enviarMensaje",
    attrs: {
      "numero": _vm.numero,
      "numero-telefono-cliente": _vm.cliente.telefono ? +_vm.cliente.telefono : 0,
      "agente": _vm.usuarioSeleccionado,
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "send": _vm.fetchInsertarActividad,
      "update-time-line": function($event) {
        return _vm.$refs.activity.fetchActividades()
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), ((!_vm.isMovil && _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario' && _vm.ticket.abierto) || (_vm.isMovil && _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario' && _vm.ticket.abierto && _vm.tabActive === 3)) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.ticket.numero && !_vm.ticket.numeroInformeTecnico && _vm.perfil !== 'usuario-contrato' && _vm.ticket.abierto) ? _c('div', {
    staticClass: "flex-1 mb-3"
  }, [_c('v-btn', {
    staticClass: "width-full",
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil,
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": function($event) {
        return _vm.openModalIntegracion(_vm.ticket.tipoticket === 'garantia' ? 18 : 2)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v(" link")]), _vm._v(_vm._s(_vm.ticket.tipoticket === 'garantia' ? 'Recepción' : 'Integrar'))], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'garantia' && _vm.ticket.numero && !_vm.ticket.numeroInformeTecnico && _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario-contrato' && _vm.ticket.abierto) ? _c('div', {
    staticClass: "flex-1 ml-2 mb-3"
  }, [_c('v-btn', {
    staticClass: "width-full",
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil,
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": function($event) {
        return _vm.openModalIntegracion(33)
      }
    }
  }, [_vm._v("Soporte linea")])], 1) : _vm._e()]), (_vm.ticket.tipoticket === 'garantia' && !_vm.ticket.idCita && _vm.ordenDelEstadodelTicket && _vm.ordenDelEstadodelTicket < _vm.ordenEstadoIngresadoTaller) ? _c('div', {
    staticClass: "flex-1 mb-3"
  }, [_c('v-btn', {
    staticClass: "width-full",
    attrs: {
      "color": "info",
      "small": !_vm.isMovil,
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": function($event) {
        _vm.isModalEditarCita = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v(" date_range")]), _vm._v("Programar una cita")], 1)], 1) : _vm._e(), _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panel2),
      callback: function($$v) {
        _vm.panel2 = $$v
      },
      expression: "panel2"
    }
  }, [_c('v-expansion-panel', {
    key: "usuarios"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("group")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Agente en atención")])], 1)])], 1), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "box-agentes elevation-0",
    attrs: {
      "disabled": _vm.perfil === 'supervisor'
    }
  }, [_c('usuario-seleccionar', {
    attrs: {
      "username": _vm.usuarioSeleccionado,
      "perfiles": ['dispatcher', 'recepcion'],
      "modo-lista": "modo-lista"
    },
    on: {
      "user-selected": _vm.obtenerUsuarioSeleccionado
    }
  })], 1)], 1)], 1), (_vm.ticketsRelacionados.length) ? _c('v-expansion-panel', {
    key: "tickets_relacionados"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("style")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Tickets relacionados")])], 1)])], 1), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "width": "520"
    }
  }, _vm._l((_vm.ticketsRelacionados), function(tk, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex"
    }, [_c('ticket-summary-info', {
      key: tk.numero,
      staticClass: "animated fadeInUp faster",
      attrs: {
        "ticket": tk,
        "is-chart": true,
        "show-numero-informe": true
      },
      on: {
        "goTo": _vm.goTo
      }
    })], 1)
  }), 0)], 1)], 1) : _vm._e(), _c('v-expansion-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ticket.tipoticket === 'garantia' && _vm.ticket.estado <= 2),
      expression: "ticket.tipoticket === 'garantia' && ticket.estado <= 2"
    }],
    key: "zona",
    staticClass: "animated slideInRight faster"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("cancel")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Programar autoanulación por inactividad")])], 1)])], 1), _c('v-expansion-panel-content', [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  }) : _c('v-select', {
    attrs: {
      "dense": "dense",
      "items": Array.from({
        length: 20
      }, function (_, i) { return i + 1; }),
      "label": ("Anulacion automaticamente en " + (_vm.ticket.diasParaAutoAnulacion ? _vm.ticket.diasParaAutoAnulacion : '?') + " dias"),
      "persistent-hint": "",
      "disabled": _vm.isLoadingChangeDiasAutoAnulacion || _vm.perfil === 'supervisor',
      "hide-details": "hide-details"
    },
    on: {
      "change": _vm.fetchActualizaDiasAutoAnulacion
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('small', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(data.item) + " " + _vm._s(data.item > 1 ? 'días' : 'día'))])]
      }
    }], null, false, 905677095),
    model: {
      value: (_vm.ticket.diasParaAutoAnulacion),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "diasParaAutoAnulacion", $$v)
      },
      expression: "ticket.diasParaAutoAnulacion"
    }
  }), _c('v-alert', {
    staticClass: "mt-3 mb-0",
    attrs: {
      "text": "",
      "type": "info",
      "dense": "dense"
    }
  }, [_c('small', {
    staticClass: "font-size-11 mt-2"
  }, [_c('span', [_vm._v("El ticket se anulará automaticamente")]), _c('span', [_vm._v("   si permanece en estado")]), _c('span', {
    staticClass: "info--text font-weight-700"
  }, [_vm._v("   \"Registrado\" o \"Revisado por agente\"")]), _c('span', [_vm._v("  y no hay actividad en los proximos " + _vm._s(_vm.ticket.diasParaAutoAnulacion) + " dias")])])]), _c('small', {
    staticClass: "font-weight-700"
  }, [_vm._v("Fecha autoanulación : " + _vm._s(_vm.fechaProbableAnulacionAutomatica))])], 1)], 1), _c('v-expansion-panel', {
    key: "ticket"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("linear_scale")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Seguimiento de etapas")])], 1)])], 1), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "disabled": _vm.perfil === 'supervisor'
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap"
  }, [_c('div', {
    staticClass: "flex-1 mx-1"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mb-3",
          attrs: {
            "color": "primary",
            "small": !_vm.isMovil,
            "block": "block"
          },
          on: {
            "click": function($event) {
              return _vm.fetchVerificarfechasCambioEstado()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-1"
        }, [_vm._v(" history_toggle_off")]), _vm._v("Hist. estados")], 1)]
      }
    }], null, false, 87533802),
    model: {
      value: (_vm.showPopoverFechasEstado),
      callback: function($$v) {
        _vm.showPopoverFechasEstado = $$v
      },
      expression: "showPopoverFechasEstado"
    }
  }, [_c('v-card', {
    staticClass: "overflow-y-auto",
    attrs: {
      "width": "380",
      "max-height": "500"
    }
  }, _vm._l((_vm.fechasCambioEstado), function(f, index) {
    return _c('v-list', {
      key: index,
      staticClass: "py-0",
      attrs: {
        "dense": "dense"
      }
    }, [_c('v-list-item', [_c('v-list-item-content', {
      staticClass: "py-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-size-12 font-weight-700"
    }, [_c('div', {
      staticClass: "d-flex fd-column"
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('span', [_c('v-icon', {
      attrs: {
        "size": "13",
        "color": "success"
      }
    }, [_vm._v("east")]), _c('span', {
      staticClass: "mx-2"
    }, [_vm._v(_vm._s(f.nuevo))])], 1)]), _c('div', {
      staticClass: "flex-1"
    }, [_c('span', [_c('v-icon', {
      attrs: {
        "size": "13",
        "color": "error"
      }
    }, [_vm._v("west")]), _c('span', {
      staticClass: "mx-2"
    }, [_vm._v(_vm._s(f.anterior))])], 1)])])]), _c('v-list-item-subtitle', {
      staticClass: "font-size-11"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('span', [_vm._v(_vm._s(f.now) + " - " + _vm._s(f.fecha))]), _c('v-spacer'), _c('span', [_vm._v(_vm._s(f.usuario))])], 1)])], 1)], 1)], 1)
  }), 1)], 1)], 1), _c('div', {
    staticClass: "flex-1 mx-1"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mb-3",
          attrs: {
            "color": "primary",
            "small": !_vm.isMovil,
            "block": "block"
          },
          on: {
            "click": function($event) {
              return _vm.fetchVerificarfechasCambioEtapa()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-1"
        }, [_vm._v(" history_toggle_off")]), _vm._v("Hist. etapas")], 1)]
      }
    }], null, false, 3291730314),
    model: {
      value: (_vm.showPopoverFechasEtapa),
      callback: function($$v) {
        _vm.showPopoverFechasEtapa = $$v
      },
      expression: "showPopoverFechasEtapa"
    }
  }, [_c('v-card', {
    staticClass: "overflow-y-auto",
    attrs: {
      "width": "380",
      "max-height": "500"
    }
  }, _vm._l((_vm.fechasCambioEtapas), function(f, index) {
    return _c('v-list', {
      key: index,
      staticClass: "py-0",
      attrs: {
        "dense": "dense"
      }
    }, [_c('v-list-item', [_c('v-list-item-content', {
      staticClass: "py-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-size-12 font-weight-700"
    }, [_c('div', {
      staticClass: "d-flex fd-column"
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('span', [_c('v-icon', {
      attrs: {
        "size": "13",
        "color": "success"
      }
    }, [_vm._v("east")]), _c('span', {
      staticClass: "mx-2"
    }, [_vm._v(_vm._s(f.nuevo))])], 1)]), _c('div', {
      staticClass: "flex-1"
    }, [_c('span', [_c('v-icon', {
      attrs: {
        "size": "13",
        "color": "error"
      }
    }, [_vm._v("west")]), _c('span', {
      staticClass: "mx-2"
    }, [_vm._v(_vm._s(f.anterior))])], 1)])])]), _c('v-list-item-subtitle', {
      staticClass: "font-size-11"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('span', [_vm._v(_vm._s(f.now) + " - " + _vm._s(f.fecha))]), _c('v-spacer'), _c('span', [_vm._v(_vm._s(f.usuario))])], 1)])], 1)], 1)], 1)
  }), 1)], 1)], 1)]), _c('v-stepper', {
    staticClass: "elevation-0 pb-0",
    attrs: {
      "vertical": "",
      "dense": "dense",
      "disabled": _vm.isLoadingEtapas
    },
    model: {
      value: (_vm.indexEtapaSeleccionada),
      callback: function($$v) {
        _vm.indexEtapaSeleccionada = $$v
      },
      expression: "indexEtapaSeleccionada"
    }
  }, [_vm._l((_vm.listaEtapas), function(n, index) {
    return [_c('v-stepper-step', {
      key: ((n.id) + "-step"),
      staticClass: "cursor-step pt-2 pb-1 pl-1",
      class: n.id < _vm.ticket.etapaEstado && 'pointer-events',
      attrs: {
        "dense": "dense",
        "step": n.id,
        "complete": _vm.indexEtapaSeleccionada > n.id,
        "color": _vm.indexEtapaSeleccionada > n.id ? 'success' : 'primary'
      },
      nativeOn: {
        "click": function($event) {
          _vm.indexEtapaSeleccionada = n.id
        }
      }
    }, [_c('small', {
      staticClass: "font-weight-700"
    }, [_vm._v(_vm._s(n.descripcion))]), (n.id < _vm.ticket.etapaEstado) ? _c('small', {
      staticClass: "font-weight-700 font-size-10 success--text"
    }, [_vm._v("etapa cerrada")]) : _vm._e()]), _c('v-stepper-content', {
      key: ((n.id) + "-step-content"),
      staticClass: "pa-3 ml-4",
      attrs: {
        "step": n.id
      }
    }, [(_vm.renderComponentEstados) ? _c('estados-ticket', {
      attrs: {
        "tipo": _vm.ticket.tipoticket,
        "codigo": _vm.ticket.estado,
        "etapa": n.id
      },
      on: {
        "selected": _vm.obtenerEstado
      }
    }) : _vm._e()], 1)]
  })], 2), (_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "mt-8"
  }, [_c('v-select', {
    attrs: {
      "items": ['propio', 'tercerizado'],
      "label": "¿A que taller ingreso el equipo?",
      "dense": "",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.fetchActualizarTipoTallerIngresado()
      }
    },
    model: {
      value: (_vm.ticket.tipoTallerIngresado),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "tipoTallerIngresado", $$v)
      },
      expression: "ticket.tipoTallerIngresado"
    }
  })], 1) : _vm._e(), (_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "mt-6"
  }, [_c('v-switch', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "dense",
      "label": "¿Es servicio cobrable?",
      "value": 1,
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.ticket.esCobrable),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "esCobrable", $$v)
      },
      expression: "ticket.esCobrable"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), (_vm.ticket.tipoticket === 'garantia') ? _c('v-expansion-panel', {
    key: "equipo_cambiar"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("print")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Actualización de datos de equipo")])], 1)])], 1), _c('v-expansion-panel-content', [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  }) : _c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "disabled": _vm.perfil === 'supervisor'
    }
  }, [(_vm.ticket.tipoticket === 'garantia' && _vm.ticket.comproAqui) ? _c('v-alert', {
    staticClass: "mb-6",
    attrs: {
      "text": "",
      "type": _vm.ticket.sigueEnGarantia ? 'success' : 'error',
      "dense": "dense"
    }
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Al registrarse el ticket el usuario indico que el equipo " + _vm._s(_vm.ticket.sigueEnGarantia ? 'todavia se encuentra ' : 'ya no se encuentra ') + " en garantía")])]) : _vm._e(), (_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "flex-1"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Ingrese la serie del equipo "
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-btn', {
          staticClass: "mb-2",
          attrs: {
            "x-small": "x-small",
            "fab": "fab",
            "color": "info"
          },
          on: {
            "click": function($event) {
              _vm.showModalDataSerie = true
            }
          }
        }, [_c('v-icon', [_vm._v(" visibility")])], 1)]
      },
      proxy: true
    }], null, false, 254630055),
    model: {
      value: (_vm.ticket.serie),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "serie", $$v)
      },
      expression: "ticket.serie"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex",
    class: _vm.isMovil && 'fd-column'
  }, [(_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "flex-1"
  }, [_c('v-select', {
    attrs: {
      "dense": "dense",
      "items": _vm.marcas,
      "label": "Seleccionar marca",
      "item-text": "descripcion",
      "item-value": "descripcion",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.ticket.marca),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "marca", $$v)
      },
      expression: "ticket.marca"
    }
  })], 1) : _vm._e(), (_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "flex-1",
    class: !_vm.isMovil && 'px-6'
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Ingrese el modelo del equipo "
    },
    model: {
      value: (_vm.ticket.modelo),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "modelo", $$v)
      },
      expression: "ticket.modelo"
    }
  })], 1) : _vm._e()])], 1)], 1)], 1) : _vm._e(), (_vm.ticket.codigoTecnico && _vm.ticket.tipoticket !== 'contrato') ? _c('v-expansion-panel', {
    key: "permisos_tecnico"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("style")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Permisos para documentos de tecnico")])], 1)])], 1), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "width": "520"
    }
  }, _vm._l((_vm.tiposDocumentos), function(item, i) {
    return _c('div', {
      staticClass: "d-flex ai-center"
    }, [_c('v-checkbox', {
      staticClass: "ma-0",
      attrs: {
        "name": item.code,
        "id": item.code,
        "color": "primary",
        "hide-details": "hide-details"
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          _vm.$set(item, "active", $$v)
        },
        expression: "item.active"
      }
    }), _c('label', {
      staticClass: "font-size-11",
      class: {
        '!primary--text font-weight-700': item.active
      },
      attrs: {
        "for": item.code
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 0)], 1)], 1) : _vm._e(), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "block": "block",
      "color": "success",
      "disabled": !_vm.ticket.abierto || _vm.perfil === 'supervisor',
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.openModalAddMessage()
      }
    }
  }, [_vm._v("Confirmar cambios")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex fd-column flex-1"
  }, [_c('v-progress-linear', {
    attrs: {
      "color": "primary",
      "indeterminate": "",
      "rounded": "",
      "height": "3"
    }
  }), _c('small', {
    staticClass: "text-muted font-size-10"
  }, [_vm._v("obteniendo lista...")])], 1)]) : _vm._e(), (!_vm.isLoading && !_vm.small) ? _c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l((_vm.estados), function(e, index) {
    return _c('div', {
      staticClass: "estado-dot",
      on: {
        "click": function($event) {
          return _vm.selectEstado(e)
        }
      }
    }, [_c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [(_vm.tipo === 'garantia') ? _c('v-icon', _vm._g(_vm._b({
            attrs: {
              "size": _vm.small ? 14 : 28,
              "color": e.orden <= _vm.estado.orden ? ("" + (!_vm.small  && 'primary')) : 'background'
            }
          }, 'v-icon', attrs, false), on), [_vm._v("fiber_manual_record")]) : _c('v-icon', _vm._g(_vm._b({
            attrs: {
              "size": _vm.small ? 14 : 28,
              "color": e.codigo <= _vm.estado.codigo ? ("" + (!_vm.small  && 'primary')) : 'background'
            }
          }, 'v-icon', attrs, false), on), [_vm._v("fiber_manual_record")])]
        }
      }], null, true)
    }, [_c('small', [_vm._v(_vm._s(e.descripcion))])])], 1)
  }), 0) : _vm._e(), (!_vm.isLoading) ? _c('div', {
    staticClass: "d-flex",
    class: {
      'jc-center ai-center': _vm.showClear
    }
  }, [(_vm.estado && _vm.estado.descripcion) ? _c('div', {
    staticClass: "text-left"
  }, [(_vm.small) ? _c('small', {
    staticClass: "font-size-10 text-muted"
  }, [_vm._v(_vm._s(("Etapa: " + _vm.etapa)) + " / " + _vm._s(_vm.estado.descripcion.substring(0, 30)))]) : _c('small', {
    staticClass: "font-size-13 primary--text font-weight-700"
  }, [_vm._v(" " + _vm._s(_vm.estado.descripcion))])]) : _vm._e(), (_vm.showClear) ? _c('v-divider', {
    staticClass: "mx-2"
  }) : _vm._e(), (_vm.showClear) ? _c('div', {
    staticClass: "ml-3"
  }, [_c('v-btn', {
    attrs: {
      "link": "link",
      "disabled": !_vm.estado.codigo,
      "x-small": "x-small",
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.limpiarEstado(true)
      }
    }
  }, [_vm._v("Limpiar")])], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": "flat"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "400",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalAnular()
      }
    },
    model: {
      value: (_vm.isModalCancelarCita),
      callback: function($$v) {
        _vm.isModalCancelarCita = $$v
      },
      expression: "isModalCancelarCita"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-20 py-4"
  }, [_vm._v("¿Estas seguro que deseas cancelar la cita?")]), _c('div', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    ref: "comentarioParaCancelar",
    attrs: {
      "hide-details": "hide-details",
      "autofocus": "autofocus",
      "placeholder": "Describe un motivo por el cual deseas cancelar la cita",
      "color": "primary",
      "solo": "solo",
      "dense": "dense",
      "rows": "8"
    },
    model: {
      value: (_vm.comentarioParaCancelar),
      callback: function($$v) {
        _vm.comentarioParaCancelar = $$v
      },
      expression: "comentarioParaCancelar"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.closeModalCancelarCita()
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchEliminarCita()
      }
    }
  }, [_vm._v("Cancelar cita")])], 1)], 1)], 1), _c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [(_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _vm._e(), _c('v-toolbar-title', {
    staticClass: "font-size-15"
  }, [(!_vm.id) ? _c('div', {
    staticClass: "d-flex jc-center fd-column"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Nueva programación " + _vm._s(_vm.fechaPicker))]), _c('span', {
    staticClass: "font-size-11"
  }, [_vm._v("Programa ahora y luego podras visualizarlo en el modulo principal")])]) : _c('div', {
    staticClass: "d-flex jc-center fd-column"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Editando programacion  de cita" + _vm._s(("#" + _vm.id)))]), _c('span', {
    staticClass: "font-size-11"
  }, [_vm._v("Verifica bien los cambios antes de reprogramar")])])]), _c('v-spacer'), _c('v-menu', {
    attrs: {
      "transition": "slide-x-transition",
      "bottom": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(_vm.id) ? _c('v-btn', _vm._g(_vm._b({
          staticClass: "animated fadeInUp faster",
          attrs: {
            "icon": "icon",
            "dark": "dark"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" more_vert")])], 1) : _vm._e()]
      }
    }])
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    attrs: {
      "disabled": _vm.cita.ingresadoAtaller === 1
    },
    on: {
      "click": function($event) {
        return _vm.openModalCancelarCita()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Eliminar esta programación")])], 1), (_vm.noEstaEnAgenda) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.goTo(("/programacion/citas/" + (_vm.cita.id)))
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Visualizar cita en agenda")])], 1) : _vm._e()], 1)], 1)], 1), (!_vm.isLoading) ? _c('div', {
    staticClass: "pa-4"
  }, [(_vm.cita.ingresadoAtaller) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('v-alert', {
    staticClass: "flex-1 mb-2",
    attrs: {
      "border": "left",
      "color": "success",
      "dark": "",
      "outlined": "outlined",
      "icon": "check_circle",
      "dense": "dense"
    }
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Esta cita ya fue cerrada por que el equipo ya ingreso a taller")])])], 1) : _vm._e(), (_vm.cita.numeroTicket && !_vm.noEstaEnAgenda) ? _c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "color": "secondary primary--text",
      "small": "small",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/ticket/' + _vm.cita.numeroTicket)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("visibility")]), _vm._v("ver detalles de ticket")], 1) : _vm._e(), (_vm.cita.numeroTicket) ? _c('v-card', {
    key: "ticketSeleccionada",
    staticClass: "elevation-1 mb-4"
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', [_c('v-chip', {
    staticClass: "mr-2",
    attrs: {
      "color": _vm.cita.ingresadoAtaller ? 'success' : 'orange',
      "label": "label",
      "small": "small",
      "text-color": "white"
    }
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-11",
    domProps: {
      "innerHTML": _vm._s(_vm.cita.numeroTicket)
    }
  })]), _c('v-list-item-content', [_c('v-list-item-title', [_c('span', {
    staticClass: "font-weight-700 font-size-14"
  }, [_vm._v(_vm._s(_vm.cita.titulo))])]), (_vm.cita.fechaRegistro) ? _c('v-list-item-subtitle', {
    staticClass: "grey--text font-size-11"
  }, [_vm._v("fué creado hace " + _vm._s(_vm._f("now")(_vm.cita.fechaRegistro)))]) : _c('v-list-item-subtitle', {
    staticClass: "grey--text font-size-11"
  }, [_vm._v("En proceso de creación")])], 1), (!_vm.noEstaEnAgenda && !_vm.cita.ingresadoAtaller) ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "small"
    },
    on: {
      "click": _vm.clearTicketSeleccionado
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _c('span', [_vm._v("Cambiar")])], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), (!_vm.cita.numeroTicket) ? _c('listado-tickets-seleccionar', {
    staticClass: "mb-6",
    attrs: {
      "toCita": true,
      "numero": _vm.cita.numeroTicket
    },
    on: {
      "selected": _vm.obtenerTicketSeleccionado
    }
  }) : _vm._e(), (_vm.fechaPicker) ? _c('div', {
    staticClass: "d-flex mb-3"
  }, [_c('small', {
    staticClass: "primary--text font-size-11"
  }, [_vm._v("*Los puntos de color en el calendario hacen referencia a las fechas festivas.*")])]) : _vm._e(), (_vm.fechaPicker) ? _c('v-date-picker', {
    attrs: {
      "events": _vm.arrayEvents,
      "full-width": "full-width",
      "landscape": false,
      "no-title": "no-title",
      "color": "primary",
      "disabled": _vm.cita.ingresadoAtaller === 1,
      "event-color": "primary"
    },
    on: {
      "change": function($event) {
        return _vm.verificarFechaYObtenerHoras()
      }
    },
    model: {
      value: (_vm.fechaPicker),
      callback: function($$v) {
        _vm.fechaPicker = $$v
      },
      expression: "fechaPicker"
    }
  }) : _vm._e(), (_vm.fechaPicker) ? _c('v-select', {
    attrs: {
      "disabled": !_vm.horas.length || _vm.cita.ingresadoAtaller === 1,
      "item-text": "hora",
      "items": _vm.horas,
      "label": "Horas disponibles para la fecha seleccionada",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.cita.horaCita),
      callback: function($$v) {
        _vm.$set(_vm.cita, "horaCita", $$v)
      },
      expression: "cita.horaCita"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "d-flex mt-2"
  }, [(!_vm.cita.ingresadoAtaller) ? _c('v-btn', {
    attrs: {
      "block": _vm.isMovil,
      "small": !_vm.isMovil,
      "block": "block",
      "color": "success",
      "disabled": !_vm.cita.numeroTicket || !_vm.fechaPicker || !_vm.cita.horaCita
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarCita()
      }
    }
  }, [(_vm.id) ? _c('span', [_vm._v("reprogramar cita")]) : _c('span', [_vm._v("generar cita")])]) : _vm._e()], 1)], 1) : _c('div', [_c('div', {
    staticClass: "pa-4"
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-three-line"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "card-heading"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "card-heading"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "fluid": "fluid",
      "grid-list-md": "grid-list-md"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "wrap"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "xs12",
      "md4": "md4"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "wrap"
    }
  }, _vm._l((_vm.openTickets), function(t, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs6": "xs6"
      }
    }, [_c('v-card', {
      staticClass: "elevation-1 text-xs-center",
      attrs: {
        "height": "100%"
      }
    }, [_c('v-card-text', [_c('div', {
      staticClass: "d-flex ai-center jc-center"
    }, [_c('div', {
      staticClass: "display-1 mb-2 font-weight-700"
    }, [_vm._v(_vm._s(_vm.abiertos[t.key]))])]), _c('span', {
      staticClass: "font-size-13"
    }, [_vm._v(_vm._s(t.label))])])], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-6",
    attrs: {
      "max-width": "500",
      "max-height": "calc(100vh - 150px)"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('h3', [_vm._v("Nuevo ticket")])]), _c('div', {
    staticClass: "fd-column flex-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.tiposTicket,
      "label": "Tipos de ticket",
      "placeholder": "Selecciona una opcion",
      "item-text": "name",
      "return-object": "return-object",
      "item-value": "id",
      "dense": "dense"
    },
    model: {
      value: (_vm.tipoTicketSeleccionado),
      callback: function($$v) {
        _vm.tipoTicketSeleccionado = $$v
      },
      expression: "tipoTicketSeleccionado"
    }
  })], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1 d-flex"
  }, [_c('v-text-field', {
    ref: "documento",
    attrs: {
      "dense": "dense",
      "type": "number",
      "label": "Numero de contrato",
      "hide-details": "hide-details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchEquipos()
      }
    },
    model: {
      value: (_vm.numeroContrato),
      callback: function($$v) {
        _vm.numeroContrato = $$v
      },
      expression: "numeroContrato"
    }
  }), _c('v-btn', {
    attrs: {
      "color": "info",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": _vm.fetchEquipos
    }
  }, [_vm._v("buscar")])], 1)]), (_vm.usuariosContrato.length) ? _c('div', {
    staticClass: "d-flex fd-column mt-4"
  }, [_c('span', {
    staticClass: "font-size-11"
  }, [_vm._v("Cuentas registradas para este cliente")]), (_vm.usuarioSeleccionado.length > 1) ? _c('v-radio-group', {
    staticClass: "my-1",
    attrs: {
      "row": "row",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.usuarioSeleccionado),
      callback: function($$v) {
        _vm.usuarioSeleccionado = $$v
      },
      expression: "usuarioSeleccionado"
    }
  }, _vm._l((_vm.usuariosContrato), function(usuario, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "label": ((usuario.razonSocial) + " (" + (usuario.usuario) + ")"),
        "value": usuario.usuario,
        "hide-details": "hide-details"
      }
    })
  }), 1) : _c('span', {
    staticClass: "font-size-12 text-muted"
  }, [_vm._v("El ticket se generará con el usuario " + _vm._s(_vm.usuarioSeleccionado))])], 1) : _vm._e(), (_vm.modelosAgrupados.length) ? _c('div', {
    staticClass: "d-flex"
  }, [(!_vm.equiposDelModeloFiltrados.length) ? _c('div', {
    staticClass: "flex-1 mt-4"
  }, [_c('v-autocomplete', {
    attrs: {
      "loading": _vm.isGettingEquipos,
      "items": _vm.modelosAgrupados,
      "label": "Listado de modelos que tienes en contrato",
      "placeholder": "Realiza la busqueda por el modelo",
      "item-value": "modelo",
      "return-object": "return-object",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": _vm.seleccionarModelo
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('span', {
          staticClass: "font-weight-700 font-size-12"
        }, [_vm._v(_vm._s(data.item.modelo))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-700",
          domProps: {
            "innerHTML": _vm._s(data.item.modelo)
          }
        }), _c('v-list-item-subtitle', [_c('span', {
          staticClass: "font-size-11 text-muted"
        }, [_vm._v(_vm._s(((data.item.cantidad) + " Equipo(s)")))])])], 1)]
      }
    }], null, false, 3179395255),
    model: {
      value: (_vm.modeloSeleccionado),
      callback: function($$v) {
        _vm.modeloSeleccionado = $$v
      },
      expression: "modeloSeleccionado"
    }
  })], 1) : _vm._e(), (!_vm.serieSeleccionado && _vm.equiposDelModeloFiltrados.length) ? _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex ai-center mt-4",
    class: _vm.isMovil && 'fd-column'
  }, [_c('v-btn', {
    class: _vm.isMovil && 'mb-2',
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.limpiarModelo()
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _c('v-autocomplete', {
    staticClass: "mx-4",
    attrs: {
      "items": _vm.equiposDelModeloFiltrados,
      "label": ("Listado de equipos del modelo " + (_vm.modeloSeleccionado.modelo)),
      "placeholder": "Realiza la busqueda por la descripción",
      "dense": "dense",
      "item-value": "serie",
      "item-text": "serie",
      "return-object": "return-object",
      "hide-details": "hide-details"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-700",
          domProps: {
            "innerHTML": _vm._s(data.item.serie)
          }
        }), _c('v-list-item-subtitle', [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(_vm._s(data.item.descripcionArticulo))])])], 1)]
      }
    }], null, false, 2870585779),
    model: {
      value: (_vm.serieSeleccionado),
      callback: function($$v) {
        _vm.serieSeleccionado = $$v
      },
      expression: "serieSeleccionado"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), (_vm.serieSeleccionado) ? _c('v-card', {
    staticClass: "pa-2 mt-4",
    attrs: {
      "dense": "dense",
      "color": "background"
    }
  }, [_c('v-list-item', [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-title', [_c('small', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(("#" + (_vm.serieSeleccionado.numeroContrato))) + " -  ")]), _c('small', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.serieSeleccionado.modelo) + " -  ")]), _c('small', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v(_vm._s(_vm.serieSeleccionado.serie))])]), _c('v-list-item-subtitle', {
    staticClass: "info--text font-weight-700 font-size-12"
  }, [_vm._v(_vm._s(_vm.serieSeleccionado.descripcionArticulo))]), _c('v-list-item-subtitle', {
    staticClass: "font-weight-700 font-size-12"
  }, [_vm._v(_vm._s(_vm.serieSeleccionado.direccionMaquina) + " - (" + _vm._s(_vm.serieSeleccionado.descripcionUbigeoMaquina) + ")")])], 1), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.limpiarSerie()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "17"
    }
  }, [_vm._v("keyboard_arrow_left")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex mt-8"
  }, [_c('v-btn', {
    staticClass: "flex-1 mr-5",
    attrs: {
      "color": "primary",
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.limpiarTodo()
      }
    }
  }, [_c('small', [_vm._v("Cancelar")])]), _c('v-btn', {
    staticClass: "flex-1",
    attrs: {
      "color": "success",
      "block": _vm.isMovil,
      "disabled": !_vm.serieSeleccionado
    },
    on: {
      "click": function($event) {
        return _vm.procesoGenerarTickets()
      }
    }
  }, [_c('small', [_vm._v("Registrar")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Series en")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  recall ")]), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.tipo && _vm.tipo.toLowerCase()))])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Listado  de tickets que  ingresar con la misma serie")])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.pieChart.fetchTicketsEnRecall()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v("Actualizar")], 1)], 1), _c('v-divider'), (_vm.count) ? _c('div', {
    staticClass: "d-flex mx-1"
  }, [_c('div', {
    staticClass: "flex-1 ma-2"
  }, [_c('v-card', {
    staticClass: "pa-2 text-xs-center elevation-1",
    attrs: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center jc-center fd-column"
  }, [_c('div', {
    staticClass: "display-1 font-weight-700"
  }, [_vm._v(_vm._s(_vm.cantidadTicketsEnRecall))]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Total de tickets")])])])], 1)]) : _vm._e(), _c('div', {
    staticClass: "d-flex mx-4"
  }, [_c('v-switch', {
    attrs: {
      "dense": "dense",
      "label": "Incluir busqueda en tickets cerrados"
    },
    on: {
      "change": function($event) {
        return _vm.reRenderChart()
      }
    },
    model: {
      value: (_vm.incluirCerrados),
      callback: function($$v) {
        _vm.incluirCerrados = $$v
      },
      expression: "incluirCerrados"
    }
  })], 1), (_vm.renderChart) ? _c('pie-chart', {
    ref: "pieChart",
    attrs: {
      "tipo": _vm.tipo,
      "incluir-cerrados": _vm.incluirCerrados
    },
    on: {
      "count": _vm.obtenerCantidad,
      "click": _vm.obtenerSeleccionado
    }
  }) : _vm._e(), _c('v-expand-transition', [(_vm.reveal) ? _c('v-card', {
    staticClass: "transition-fast-in-fast-out v-card--reveal elevation-0",
    attrs: {
      "height": "100%",
      "loading": _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "fab",
      "x-small": "x-small"
    },
    on: {
      "click": function($event) {
        _vm.reveal = false
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _c('span', {
    staticClass: "font-weight-700 ml-3"
  }, [_vm._v("Tickets con la serie")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  " + _vm._s(_vm.serieRecall) + " ")])], 1)], 1), _c('v-card', {
    staticClass: "elevation-0 overflow-y-auto",
    attrs: {
      "height": "300"
    }
  }, _vm._l((_vm.ticketsEnRecall), function(o, index) {
    return _c('ticket-summary-info', {
      key: index,
      staticClass: "animated fadeInUp faster",
      attrs: {
        "ticket": o,
        "is-chart": true
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-4"
  }, [_c('v-card', {
    staticClass: "elevation-1 mb-4 pr-4"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("KPI por tipo de ticket")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Seleccione un tipo de ticket valido")])], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-select', {
    attrs: {
      "solo": "solo",
      "items": _vm.tipos,
      "disabled": _vm.isLoading,
      "item-text": "label",
      "item-value": "value",
      "label": "Tipo",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.changeTipo()
      }
    },
    model: {
      value: (_vm.tipoTicket),
      callback: function($$v) {
        _vm.tipoTicket = $$v
      },
      expression: "tipoTicket"
    }
  })], 1)])]), (_vm.isReadyCharts) ? _c('card-tickets-por-meses', {
    staticClass: "mb-6",
    attrs: {
      "tipo": _vm.tipoTicket,
      "tipo-area": _vm.tipoTicket === 'garantia' ? 'taller' : ''
    }
  }) : _vm._e(), (_vm.isReadyCharts) ? _c('card-tickets-pendientes-por-asesor', {
    staticClass: "mb-6",
    attrs: {
      "tipo": _vm.tipoTicket,
      "tipo-area": _vm.tipoTicket === 'garantia' ? 'taller' : ''
    }
  }) : _vm._e(), (_vm.isReadyCharts) ? _c('card-tickets-por-estado', {
    staticClass: "mb-6",
    attrs: {
      "tipo": _vm.tipoTicket,
      "tipo-area": _vm.tipoTicket === 'garantia' ? 'taller' : ''
    }
  }) : _vm._e(), (_vm.isReadyCharts) ? _c('card-tickets-cerrados-horas', {
    staticClass: "mb-6",
    attrs: {
      "tipo": _vm.tipoTicket,
      "tipo-area": _vm.tipoTicket === 'garantia' ? 'taller' : ''
    }
  }) : _vm._e(), (_vm.isReadyCharts && _vm.tipoTicket !== 'solicitud de insumo') ? _c('card-tickets-recall', {
    staticClass: "mb-6",
    attrs: {
      "tipo": _vm.tipoTicket,
      "tipo-area": _vm.tipoTicket === 'garantia' ? 'taller' : ''
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-slide-group', {
    attrs: {
      "active-class": "success",
      "show-arrows": ""
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.involucrados), function(i, index) {
    return _c('v-slide-item', {
      key: index,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "mr-2",
            attrs: {
              "width": "85"
            },
            on: {
              "click": function () {}
            }
          }, [_c('v-img', {
            staticClass: "white--text align-end",
            attrs: {
              "height": _vm.isMovil ? 100 : 110,
              "src": i.foto ? i.foto : '/static/nobody.jpg',
              "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85"
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [(i.isCreador) ? _c('v-icon', _vm._g(_vm._b({
                  staticClass: "position"
                }, 'v-icon', attrs, false), on), [_vm._v("info")]) : _vm._e()]
              }
            }], null, true)
          }, [_c('small', [_vm._v("Creador del ticket")])]), _c('div', {
            staticClass: "d-flex fd-column pa-3"
          }, [_c('span', {
            class: _vm.isMovil ? 'font-size-11' : 'font-size-12'
          }, [_vm._v(_vm._s(i.nombre))]), (!_vm.isMovil) ? _c('span', {
            staticClass: "font-size-11 text-muted"
          }, [_vm._v(_vm._s(i.cargo))]) : _vm._e()])], 1)], 1)]
        }
      }], null, true)
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Total de tickets de")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  " + _vm._s(_vm.tipo) + " ")]), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v(" del año")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  " + _vm._s(_vm.year) + " ")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Listado general de todos los ticketsregistrados en el año")])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchTicketsPorAnio()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v("Actualizar")], 1)], 1), _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('div', {
    staticClass: "d-flex ml-3 mb-2"
  }, [_c('div', {
    staticClass: "d-flex mx-2"
  }, [_c('v-select', {
    attrs: {
      "solo": "solo",
      "items": _vm.years,
      "disabled": _vm.isLoading,
      "label": "Periodo",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.fetchTicketsPorAnio()
      }
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1), (_vm.tipo === 'garantia') ? _c('div', {
    staticClass: "d-flex mx-2"
  }, [_c('v-select', {
    attrs: {
      "solo": "solo",
      "items": ['taller', 'campo', 'sin asignacion'],
      "disabled": _vm.isLoading,
      "label": "Area",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.fetchTicketsPorAnio()
      }
    },
    model: {
      value: (_vm.tipoArea),
      callback: function($$v) {
        _vm.tipoArea = $$v
      },
      expression: "tipoArea"
    }
  })], 1) : _vm._e()]), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "dense": "dense",
      "item-key": "codigo",
      "items": _vm.lista,
      "hide-default-footer": "hide-default-footer",
      "loading": _vm.isLoading,
      "disable-pagination": "disable-pagination"
    }
  }), (_vm.renderChart) ? _c('Pie-Chart', {
    ref: "lineChart",
    attrs: {
      "pendientes": _vm.valuesPendientes,
      "resueltos": _vm.valuesResueltos
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "align-with-title": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-spacer'), _c('v-tabs-slider', {
    attrs: {
      "color": "primary"
    }
  }), _c('v-tab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.multiple || !_vm.files.length && !_vm.multiple),
      expression: "multiple || !files.length && !multiple"
    }],
    key: "upload"
  }, [_c('span', [_vm._v("Adjuntar")])]), (_vm.files.length) ? _c('v-tab', {
    key: "archivos"
  }, [_c('span', [_vm._v(_vm._s(_vm.files.length) + " Archivo(s)")])]) : _vm._e()], 1), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.multiple || !_vm.files.length && !_vm.multiple),
      expression: "multiple || !files.length && !multiple"
    }],
    key: "adjuntar",
    attrs: {
      "disabled": _vm.isMovil
    }
  }, [_c('v-card', {
    staticClass: "elevation-0 d-flex jc-center ai-center fd-column",
    class: {
      'opacity-5': _vm.$upload.dropzone(_vm.name).active
    },
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 118px)' : '500',
      "id": "dropzone"
    },
    on: {
      "click": _vm.select
    }
  }, [_c('div', [(_vm.accept && _vm.accept[0] === 'image/*') ? _c('div', {
    staticClass: "d-flex transform-icons"
  }, [(!_vm.$upload.dropzone(_vm.name).active) ? _c('v-icon', {
    staticClass: "center",
    attrs: {
      "size": _vm.modeInsert ? 70 : 100,
      "color": "primary"
    }
  }, [_vm._v("image_search")]) : _vm._e()], 1) : _c('div', {
    staticClass: "d-flex transform-icons"
  }, [(!_vm.$upload.dropzone(_vm.name).active) ? _c('v-icon', {
    staticClass: "left",
    attrs: {
      "size": _vm.modeInsert ? 40 : 60,
      "color": "primary"
    }
  }, [_vm._v("picture_as_pdf")]) : _vm._e(), (!_vm.$upload.dropzone(_vm.name).active) ? _c('v-icon', {
    staticClass: "center",
    attrs: {
      "size": _vm.modeInsert ? 40 : 60,
      "color": "primary"
    }
  }, [_vm._v("insert_photo")]) : _vm._e(), (!_vm.$upload.dropzone(_vm.name).active) ? _c('v-icon', {
    staticClass: "right",
    attrs: {
      "size": _vm.modeInsert ? 40 : 60,
      "color": "primary"
    }
  }, [_vm._v("text_snippet")]) : _vm._e()], 1), (_vm.$upload.dropzone(_vm.name).active) ? _c('v-icon', {
    attrs: {
      "size": "80px",
      "color": "primary"
    }
  }, [_vm._v("preview")]) : _vm._e()], 1), _c('v-card-text', {
    staticClass: "text-center"
  }, [(!_vm.isMovil) ? [(!_vm.$upload.dropzone(_vm.name).active) ? _c('h2', {
    staticClass: "primary--text"
  }, [(_vm.multiple) ? [_vm._v("Arrastra y suelta tus archivos aquí")] : [_vm._v("Arrastra y suelta el archivo aquí")]], 2) : _c('h2', {
    staticClass: "primary--text"
  }, [(_vm.multiple) ? [_vm._v("Suelta tus archivos para visualizarlos")] : [_vm._v("Suelta el archivo para visualizarlo")]], 2)] : [_c('h2', {
    staticClass: "primary--text"
  }, [_vm._v("Busca tus archivos en tu galeria")])], _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('small', [_vm._v("*Subir archivos con un peso no mayor a 10MB*")]), _c('small', {
    staticClass: "primary--text font-weight-700"
  }, [_vm._v(_vm._s(_vm.extensionsAllow.toString()))])])], 2)], 1)], 1), _c('v-tab-item', {
    key: "archivos",
    attrs: {
      "disabled": _vm.isMovil
    }
  }, [(_vm.$upload.errors(_vm.name).length > 0) ? _c('v-alert', {
    staticClass: "mb-0",
    attrs: {
      "dense": "",
      "text": "text",
      "type": "error"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, _vm._l((_vm.$upload.errors(_vm.name)), function(e, i) {
    return _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" • " + _vm._s(e.msg) + "  "), _c('span', {
      staticClass: "font-weight-700"
    }, [_vm._v("(" + _vm._s(e.file.name) + ")")])])
  }), 0)]) : _vm._e(), (_vm.files.length) ? _c('preview-files', {
    ref: "previsualizador",
    attrs: {
      "archivos": _vm.files,
      "mode-insert": _vm.modeInsert,
      "is-set-profile": _vm.isSetProfile
    },
    on: {
      "remove": _vm.removeFile
    }
  }) : _vm._e()], 1)], 1), (!_vm.modeInsert) ? _c('div', {
    staticClass: "pa-4 d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [(_vm.tab) ? _c('v-btn', {
    class: {
      'mb-3': _vm.isMovil
    },
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.volverASeleccionar()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("arrow_back")]), (!_vm.multiple) ? _c('span', [_vm._v("Volver a seleccionar")]) : _c('span', [_vm._v("Seguir seleccionando")])], 1) : _vm._e(), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), (_vm.files.length && _vm.tab) ? _c('v-btn', {
    class: {
      'mb-3': _vm.isMovil
    },
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.sendFilesToSave()
      }
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), (_vm.isMovil || !_vm.tab) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("cancelar")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "fullscreen"
    },
    model: {
      value: (_vm.isModalExportar),
      callback: function($$v) {
        _vm.isModalExportar = $$v
      },
      expression: "isModalExportar"
    }
  }, [(_vm.isModalExportar) ? _c('parametros-exportacion', {
    attrs: {
      "id": _vm.idReporte,
      "preview": _vm.tipoPreview,
      "tipo": _vm.tipoReporte,
      "filtros": _vm.filtrosDraft
    },
    on: {
      "close": _vm.closeDialogExportar
    }
  }) : _vm._e()], 1), _c('v-card', {
    staticClass: "mx-auto elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Visualizador de reportes")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Configura los parametros y exporta")])], 1)]), _c('v-divider'), _c('v-sheet', [_c('div', {
    staticClass: "pa-1",
    attrs: {
      "dense": "dense"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [(_vm.tipoPreview === 'save') ? _c('div', {
    staticClass: "flex-1"
  }, [_c('strong', {
    staticClass: "font-size-13 is-bold ml-4"
  }, [_vm._v(_vm._s(_vm.datosReporte.titulo))])]) : _c('div', {
    staticClass: "flex-1"
  }, [_c('strong', {
    staticClass: "font-size-13 is-bold ml-4"
  }, [_vm._v("Reporte de tipo draft")])]), _c('v-card', {
    staticClass: "d-flex elevation-0 ai-center"
  }, [_c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "fab": "fab",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.fetchDatosReporte()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "fab": "fab",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.openDialogExportar()
      }
    }
  }, [_c('v-icon', [_vm._v("import_export")])], 1)], 1)], 1)]), _c('v-divider'), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "box-table",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, [_c('v-data-table', {
    staticClass: "overflow-y-auto",
    attrs: {
      "headers": _vm.headerTable,
      "dense": "dense",
      "fixed-header": "fixed-header",
      "items": _vm.lista,
      "disable-pagination": true,
      "hide-default-footer": "hide-default-footer"
    },
    scopedSlots: _vm._u([{
      key: "item.descripcionFalla",
      fn: function(ref) {
        var item = ref.item;

        return [(item.codigoFalla) ? _c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(_vm._s(item.codigoFalla))]) : _vm._e(), _c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(" - " + _vm._s(item.descripcionFalla))])]
      }
    }, {
      key: "item.descripcionEstado",
      fn: function(ref) {
        var item = ref.item;

        return [(item.estado) ? _c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(_vm._s(item.estado))]) : _vm._e(), _c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(" - " + _vm._s(item.descripcionEstado))])]
      }
    }, {
      key: "item.tipoticket",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.tipoticket))])]
      }
    }, {
      key: "item.fechaRegistro",
      fn: function(ref) {
        var item = ref.item;

        return [_c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(_vm._s(_vm._f("formatoFecha")(item.fechaRegistro)))])]
      }
    }, {
      key: "item.numeroInformeTecnico",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.numeroInformeTecnico))])]
      }
    }, {
      key: "item.serie",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.serie))])]
      }
    }, {
      key: "item.area",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.area))])]
      }
    }, {
      key: "item.tipoArea",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.tipoArea))])]
      }
    }, {
      key: "item.zonaGarantia",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.zonaGarantia))])]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('div', {
          staticClass: "d-flex ai-center",
          class: {
            'ma-1': !_vm.isMovil
          }
        }, [_c('v-btn', {
          staticClass: "mr-2",
          attrs: {
            "x-small": "x-small",
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.goTo('/ticket/' + item.numero)
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "size": "15"
          }
        }, [_vm._v("visibility")]), _vm._v("ver ticket")], 1)], 1)]
      }
    }, {
      key: "item.razonSocial",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex fd-column"
        }, [(item.codigoCliente) ? _c('span', {
          staticClass: "text-muted font-size-11"
        }, [_vm._v(_vm._s(item.codigoCliente))]) : _vm._e(), _c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.razonSocial))])])]
      }
    }, {
      key: "item.abierto",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          attrs: {
            "small": "small",
            "color": item.abierto ? 'success' : 'error'
          }
        }, [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(" " + _vm._s(item.abierto ? 'Abierto' : 'Cerrado'))])])]
      }
    }])
  })], 1), _c('v-divider'), _c('v-card', {
    staticClass: "pa-2 elevation-0"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(_vm._s(_vm.lista.length) + " registros encontrados")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [(_vm.actividades.length) ? _c('v-timeline', {
    attrs: {
      "dense": _vm.$vuetify.breakpoint.smAndDown
    }
  }, _vm._l((_vm.actividades), function(o, index) {
    return _c('v-timeline-item', {
      key: index + o,
      staticClass: "animated faster pb-3",
      attrs: {
        "small": "small",
        "right": o.origen === '' || o.origen === null,
        "left": o.origen === 'empresa'
      }
    }, [(!_vm.isMovil) ? _c('span', {
      attrs: {
        "slot": "opposite"
      },
      slot: "opposite"
    }, [_c('small', {
      staticClass: "font-size-11 text-muted"
    }, [_vm._v(_vm._s(o.fechaLegible))])]) : _vm._e(), _c('item-time-line', {
      attrs: {
        "actividad": o,
        "group": o.group
      },
      on: {
        "update": _vm.fetchActividades
      }
    })], 1)
  }), 1) : _vm._l((5), function(a) {
    return _c('div', [_c('v-row', [_c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-skeleton-loader', {
      attrs: {
        "type": "list-item-avatar-two-line",
        "max-width": "350"
      }
    })], 1), _c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    })], 1), _c('v-row', [_c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }), _c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-skeleton-loader', {
      attrs: {
        "type": "list-item-avatar-three-line",
        "max-width": "350"
      }
    })], 1)], 1)], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', [_c('side-bar'), _c('v-main', {
    style: (!_vm.$vuetify.theme.dark ? ("background: " + (_vm.$vuetify.theme.themes.light.background)) : ''),
    attrs: {
      "transition": "slide-y-transition"
    }
  }, [_c('router-view')], 1), _c('notifications', {
    class: _vm.isMovil ? 'width-full' : '',
    attrs: {
      "position": "top right"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('v-alert', {
          staticClass: "elevation-2 py-3 ma-1 animated fadeInRight faster",
          attrs: {
            "dense": "dense",
            "border": "left",
            "type": props.item.type
          }
        }, [_c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "grow"
        }, [_c('small', {
          staticClass: "font-size-11 font-weight-700"
        }, [_vm._v(_vm._s(props.item.text))])])], 1)], 1)]
      }
    }])
  }), (_vm.transaction.isProceso) ? _c('loading-transaction', {
    attrs: {
      "label": _vm.transaction.message
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "align-center": "align-center",
      "justify-center": "justify-center"
    }
  }, [_c('v-flex', {
    staticClass: "forgot-password-form text-xs-center"
  }, [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "color": !_vm.$vuetify.theme.dark ? 'white' : ''
    }
  }, [_c('v-card-text', [_c('v-alert', {
    attrs: {
      "icon": "info",
      "dense": "dense",
      "text": "",
      "border": "left",
      "type": "info"
    }
  }, [_c('span', [_c('span', {
    staticClass: "font-size-11"
  }, [_vm._v("El cambio de la contraseña sera efectuado para el usuario: ")]), _c('span', {
    staticClass: "font-size-13 font-weight-700"
  }, [_vm._v(_vm._s(_vm.$route.query.email))])])]), _c('v-form', [_c('v-text-field', {
    ref: "password",
    attrs: {
      "prepend-icon": "lock",
      "label": "Ingrese nueva contraseña",
      "type": _vm.showPassword ? 'text' : 'password',
      "append-icon": !_vm.showPassword ? 'visibility' : 'visibility_off'
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _c('v-text-field', {
    ref: "password1",
    attrs: {
      "prepend-icon": "lock",
      "label": "Repetir nueva contraseña",
      "type": _vm.showPassword1 ? 'text' : 'password',
      "append-icon": !_vm.showPassword1 ? 'visibility' : 'visibility_off'
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "click:append": function($event) {
        _vm.showPassword1 = !_vm.showPassword1
      }
    },
    model: {
      value: (_vm.repeatNewPassword),
      callback: function($$v) {
        _vm.repeatNewPassword = $$v
      },
      expression: "repeatNewPassword"
    }
  }), _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.restablecer()
      }
    }
  }, [_vm._v("Cambiar mi contraseña")])], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [_c('small', [_vm._v("¿Deseas iniciar sesión?")]), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "small": "small",
      "color": "secondary primary--text"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/login')
      }
    }
  }, [_vm._v("click aqui")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', [_c('theme-provider'), _c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "rounded": "0",
      "color": "background"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "white",
      "dark": "",
      "flat": ""
    },
    scopedSlots: _vm._u([{
      key: "extension",
      fn: function() {
        return [_c('v-tabs', {
          attrs: {
            "align-with-title": "",
            "background-color": "primary"
          },
          model: {
            value: (_vm.tab),
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        }, [_c('v-tabs-slider', {
          attrs: {
            "color": "white"
          }
        }), _vm._l((_vm.menu), function(item, index) {
          return _c('v-tab', {
            key: item.key,
            attrs: {
              "to": item.path
            }
          }, [_vm._v(_vm._s(item.name))])
        })], 2)]
      },
      proxy: true
    }])
  }, [_c('v-toolbar-title', {
    staticClass: "font-weight-700"
  }, [_c('v-list', {
    attrs: {
      "dense": "dense",
      "color": "white"
    }
  }, [_c('v-list-item', {
    attrs: {
      "to": "/",
      "active-class": "white white--text"
    }
  }, [_c('v-list-item-title', [_c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/logo.png",
      "width": "150"
    }
  }), _c('v-spacer'), _c('v-chip', {
    staticClass: "ml-3",
    attrs: {
      "color": "primary",
      "small": "small"
    }
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Help Desk")])])], 1)])], 1)], 1)], 1), _c('v-spacer'), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-chip', _vm._g(_vm._b({
          staticClass: "pa-4",
          attrs: {
            "color": "background  black--text"
          }
        }, 'v-chip', attrs, false), on), [_c('v-avatar', {
          attrs: {
            "left": "left"
          }
        }, [_c('avatar-perfil', {
          attrs: {
            "usuario": _vm.username,
            "is-fetch": true
          }
        })], 1), _c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(_vm.nombre))])], 1)]
      }
    }])
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Perfil de tu cuenta")])]), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-2",
          attrs: {
            "fab": "",
            "dark": "",
            "small": "",
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.logout()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("logout")])], 1)]
      }
    }])
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Cerrar sesión")])])], 1), _c('v-tabs-items', [_c('div', {
    staticClass: "calc-height background"
  }, [_c('router-view')], 1), _c('notifications', {
    class: _vm.isMovil ? 'width-full' : '',
    attrs: {
      "position": "top right"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('v-alert', {
          staticClass: "elevation-2 py-3 ma-1 animated fadeInRight faster",
          attrs: {
            "dense": "dense",
            "border": "left",
            "type": props.item.type
          }
        }, [_c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "grow"
        }, [_c('small', {
          staticClass: "font-size-11 font-weight-700"
        }, [_vm._v(_vm._s(props.item.text))])])], 1)], 1)]
      }
    }])
  }), (_vm.transaction.isProceso) ? _c('loading-transaction', {
    attrs: {
      "label": _vm.transaction.message
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "fullscreen"
    },
    model: {
      value: (_vm.isModalExportar),
      callback: function($$v) {
        _vm.isModalExportar = $$v
      },
      expression: "isModalExportar"
    }
  }, [(_vm.isModalExportar) ? _c('parametros-de-exportacion', {
    attrs: {
      "preview": "save",
      "tipo-predefinido": _vm.tipoArea,
      "tipoticket": _vm.tiposTicket[0]
    },
    on: {
      "close": _vm.closeDialogExportar
    }
  }) : _vm._e()], 1), _c('v-card', [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Tickets abiertos")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12"
  }, [_vm._v("Listado general de tickets activos")])], 1), (_vm.perfilUsuario === 'usuario' || _vm.perfilUsuario === 'usuario-contrato') ? _c('v-switch', {
    staticClass: "mx-4",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "label": "Cerrados"
    },
    on: {
      "change": function($event) {
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.isClosed),
      callback: function($$v) {
        _vm.isClosed = $$v
      },
      expression: "isClosed"
    }
  }) : _vm._e(), _c('v-menu', {
    attrs: {
      "offset-y": "offset-y",
      "close-on-content-click": false,
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-3",
          attrs: {
            "color": _vm.countFiltros ? 'primary' : 'background',
            "small": "small",
            "fab": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("filter_alt")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showFiltros),
      callback: function($$v) {
        _vm.showFiltros = $$v
      },
      expression: "showFiltros"
    }
  }, [_c('v-card', {
    attrs: {
      "width": "550"
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [(_vm.tipoArea !== 'sin atencion' && _vm.tipo === 'garantia') ? _c('div', [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-size-12 grey--text"
  }, [_vm._v("Estados")])]), (_vm.showFiltros) ? _c('estados-ticket', {
    ref: "estados",
    staticClass: "mb-1",
    attrs: {
      "tipo": _vm.tipo,
      "show-clear": "show-clear",
      "codigo": _vm.estado
    },
    on: {
      "selected": _vm.selectEstado
    }
  }) : _vm._e()], 1) : _vm._e(), _c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Numero de ticket",
      "type": "number"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "blur": function($event) {
        return _vm.addCountFiltros()
      }
    },
    model: {
      value: (_vm.numero),
      callback: function($$v) {
        _vm.numero = $$v
      },
      expression: "numero"
    }
  }), _c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Desde la fecha",
      "type": "date"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "blur": function($event) {
        return _vm.addCountFiltros()
      }
    },
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  }), _c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Hasta la fecha",
      "type": "date"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "blur": function($event) {
        return _vm.addCountFiltros()
      }
    },
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  }), (_vm.perfilUsuario !== 'usuario' && _vm.perfilUsuario !== 'usuario-contrato') ? _c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Codigo de Cliente - Interno/Sap",
      "type": "number"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "blur": function($event) {
        return _vm.addCountFiltros()
      }
    },
    model: {
      value: (_vm.codigoCliente),
      callback: function($$v) {
        _vm.codigoCliente = $$v
      },
      expression: "codigoCliente"
    }
  }) : _vm._e(), _c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Serie",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "blur": function($event) {
        return _vm.addCountFiltros()
      }
    },
    model: {
      value: (_vm.serie),
      callback: function($$v) {
        _vm.serie = $$v
      },
      expression: "serie"
    }
  }), (_vm.tipo === 'garantia') ? _c('v-radio-group', {
    staticClass: "py-0",
    attrs: {
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.addCountFiltros()
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Zona garantia")])]
      },
      proxy: true
    }], null, false, 3922478954),
    model: {
      value: (_vm.zonaGarantia),
      callback: function($$v) {
        _vm.zonaGarantia = $$v
      },
      expression: "zonaGarantia"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "lima",
      "row": "row"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.zonaGarantia === 'lima'
          }
        }, [_vm._v("Lima")])]
      },
      proxy: true
    }], null, false, 1929651564)
  }), _c('v-radio', {
    attrs: {
      "value": "arequipa"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.zonaGarantia === 'arequipa'
          }
        }, [_vm._v("Arequipa")])]
      },
      proxy: true
    }], null, false, 3340764236)
  }), _c('v-radio', {
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.zonaGarantia === 'sin asignacion'
          }
        }, [_vm._v("Sin asignación")])]
      },
      proxy: true
    }], null, false, 2373507216)
  })], 1) : _vm._e(), (_vm.tipo === 'garantia' && _vm.tipoDeArea === 'sin atencion') ? _c('v-radio-group', {
    staticClass: "py-0",
    attrs: {
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.addCountFiltros()
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Area en atención")])]
      },
      proxy: true
    }], null, false, 4264449154),
    model: {
      value: (_vm.tipoArea),
      callback: function($$v) {
        _vm.tipoArea = $$v
      },
      expression: "tipoArea"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "campo"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.tipoArea === 'campo'
          }
        }, [_vm._v("Campo")])]
      },
      proxy: true
    }], null, false, 631998500)
  }), _c('v-radio', {
    attrs: {
      "value": "taller"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.tipoArea === 'taller'
          }
        }, [_vm._v("Taller")])]
      },
      proxy: true
    }], null, false, 1509186308)
  }), _c('v-radio', {
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.tipoArea === 'sin asignacion'
          }
        }, [_vm._v("Sin asignación")])]
      },
      proxy: true
    }], null, false, 2196436312)
  })], 1) : _vm._e(), (_vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario') ? _c('v-switch', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Ultima actividad por cliente"
    },
    on: {
      "change": function($event) {
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.isUltimaAccionCliente),
      callback: function($$v) {
        _vm.isUltimaAccionCliente = $$v
      },
      expression: "isUltimaAccionCliente"
    }
  }) : _vm._e(), _c('v-switch', {
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "label": "Cerrados"
    },
    on: {
      "change": function($event) {
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.isClosed),
      callback: function($$v) {
        _vm.isClosed = $$v
      },
      expression: "isClosed"
    }
  })], 1), (_vm.esCuentaAdministrador) ? _c('div', {
    staticClass: "flex-1 ml-6"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Cuentas relacionadas")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "info",
      "small": "small",
      "fab": "",
      "loading": _vm.isLoadingGetAccounts
    },
    on: {
      "click": function($event) {
        return _vm.fetchGetAccountsList()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1)], 1), _c('div', {
    staticClass: "d-flex mt-4 fd-column"
  }, _vm._l((_vm.cuentasRelacionadas), function(item, i) {
    return _c('div', {
      staticClass: "d-flex ai-center"
    }, [_c('v-checkbox', {
      staticClass: "ma-0",
      attrs: {
        "name": item.usuario,
        "id": item.usuario,
        "color": "primary",
        "hide-details": "hide-details"
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          _vm.$set(item, "active", $$v)
        },
        expression: "item.active"
      }
    }), _c('label', {
      staticClass: "font-size-11",
      class: {
        '!primary--text font-weight-700': item.active
      },
      attrs: {
        "for": item.usuario
      }
    }, [_vm._v(_vm._s(item.razonSocial))])], 1)
  }), 0)]) : _vm._e()]), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "primary",
      "text": "text",
      "small": "small",
      "disabled": !_vm.countFiltros
    },
    on: {
      "click": function($event) {
        return _vm.limpiarFiltros()
      }
    }
  }, [_vm._v("Limpiar")]) : _vm._e(), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        _vm.fetch(), _vm.showFiltros = false
      }
    }
  }, [_vm._v("filtrar tickets")])], 1)], 1)], 1)], 1), _c('v-btn', {
    staticClass: "ma-3 mr-3",
    attrs: {
      "color": "primary",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.fetch()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1), (_vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario') ? _c('v-btn', {
    staticClass: "mt-3 mr-3",
    attrs: {
      "color": "success",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDialogExportar()
      }
    }
  }, [_c('v-icon', [_vm._v("import_export")])], 1) : _vm._e(), (!_vm.isMovil && (_vm.perfilUsuario === 'usuario' || _vm.perfilUsuario === 'usuario-contrato')) ? _c('v-btn', {
    staticClass: "mt-3 mr-3",
    attrs: {
      "color": "success",
      "fab": "fab",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchUsuario()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _c('v-snackbar', {
    attrs: {
      "absolute": "absolute",
      "top": "top",
      "color": "warning"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var attrs = ref.attrs;

        return [(_vm.messageError.type === 'datos_incompletos') ? _c('v-btn', _vm._b({
          attrs: {
            "color": "white warning--text",
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.goTo('/profile')
            }
          }
        }, 'v-btn', attrs, false), [_vm._v("Ir a perfil")]) : _c('v-btn', _vm._b({
          attrs: {
            "color": "white warning--text",
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.closeModalErrorToCreateTicket()
            }
          }
        }, 'v-btn', attrs, false), [_vm._v("Entendido")])]
      }
    }]),
    model: {
      value: (_vm.isModalErrorToCreateTicket),
      callback: function($$v) {
        _vm.isModalErrorToCreateTicket = $$v
      },
      expression: "isModalErrorToCreateTicket"
    }
  }, [_vm._v(_vm._s(_vm.messageError.msg))])], 1), (!_vm.lista.length && _vm.isLoading) ? _c('div', {
    staticClass: "content-tickets-loading"
  }, _vm._l((15), function(a) {
    return _c('div', [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-skeleton-loader', {
      attrs: {
        "type": "list-item-avatar-two-line"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    })], 1), _c('v-skeleton-loader', {
      attrs: {
        "type": "divider"
      }
    })], 1)
  }), 0) : _vm._e(), _c('v-sheet', {
    staticClass: "overflow-y-auto",
    attrs: {
      "id": "data-tickets"
    }
  }, [_c('div', {
    class: {
      'content-tickets': _vm.lista.length
    }
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('ticket-summary-info', {
      key: index,
      staticClass: "animated fadeInUp faster",
      attrs: {
        "ticket": o
      },
      on: {
        "goTo": _vm.getTicketGoTo
      }
    })
  }), 1)]), (_vm.isMovil && (_vm.perfilUsuario === 'usuario' || _vm.perfilUsuario === 'usuario-contrato')) ? _c('v-btn', {
    staticClass: "floating-add",
    attrs: {
      "color": "success",
      "dark": "",
      "absolute": "",
      "large": "large",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.fetchUsuario()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1), (!_vm.lista.length && !_vm.isLoading) ? _c('div', {
    staticClass: "content-tickets d-flex jc-center ai-center"
  }, [(_vm.perfilUsuario === 'dispatcher' || _vm.perfilUsuario === 'recepcion') ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("format_list_bulleted")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No existen tickets para mostrar")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("No se encontro ningun ticket registrado")])], 1) : _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No existen tickets para mostrar")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("No se encontraron coincidencias para esta busqueda")])], 1)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "overflow-hidden elevation-0"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "450"
    },
    model: {
      value: (_vm.isModalEditarEstado),
      callback: function($$v) {
        _vm.isModalEditarEstado = $$v
      },
      expression: "isModalEditarEstado"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v(_vm._s(_vm.indexEstadoSeleccionado ? 'Editar estado' : 'Nuevo estado'))])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12"
  }, [_vm._v("Los cambios que se realicen afectaràn en todo las secciones usadas (filtros, procesos node-cron, listas y notificaciones por email)")]), _c('div', {
    staticClass: "pa-4"
  }, [(_vm.indexEstadoSeleccionado) ? _c('v-text-field', {
    ref: "codigoModal",
    staticClass: "mb-6",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Codigo estado  ",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.estadoEditar.codigo),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "codigo", $$v)
      },
      expression: "estadoEditar.codigo "
    }
  }) : _vm._e(), _c('v-text-field', {
    ref: "tituloModal",
    staticClass: "mb-6",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Nombre estado  "
    },
    model: {
      value: (_vm.estadoEditar.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "descripcion", $$v)
      },
      expression: "estadoEditar.descripcion"
    }
  }), _c('v-text-field', {
    ref: "accionModal",
    staticClass: "mb-6",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Accion  "
    },
    model: {
      value: (_vm.estadoEditar.accion),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "accion", $$v)
      },
      expression: "estadoEditar.accion"
    }
  }), _c('v-select', {
    attrs: {
      "loading": _vm.isLoadingEtapas,
      "hide-details": "hide-details",
      "items": _vm.etapasEstados,
      "label": "Etapa del estado",
      "dense": "",
      "item-text": "descripcion",
      "item-value": "id"
    },
    model: {
      value: (_vm.estadoEditar.etapa),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "etapa", $$v)
      },
      expression: "estadoEditar.etapa"
    }
  }), _c('v-checkbox', {
    staticClass: "mb-4",
    attrs: {
      "color": "primary",
      "hide-details": "hide-details",
      "label": "Este estado cierra el ticket"
    },
    model: {
      value: (_vm.estadoEditar.cerrado),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "cerrado", $$v)
      },
      expression: "estadoEditar.cerrado"
    }
  }), (_vm.estadoEditar.icono) ? _c('v-card', {
    staticClass: "my-1"
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85",
      "src": _vm.estadoEditar.icono,
      "max-height": "150",
      "content": "content"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "px-4 py-2 font-size-11 text-muted"
  }, [_vm._v(_vm._s(_vm.estadoEditar.icono))])], 1)])], 1) : _vm._e(), _c('v-file-input', {
    staticClass: "mt-2",
    attrs: {
      "color": "primary",
      "prepend-icon": "",
      "label": _vm.indexEstadoSeleccionado ? 'Seleccionar para cambiar el icono' : 'Seleccionar para agregar icono',
      "placeholder": "Seleccione el archivo",
      "outlined": "",
      "hide-details": "hide-details",
      "show-size": 1000
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var index = ref.index;
        var text = ref.text;

        return [_c('v-chip', {
          attrs: {
            "color": "primary",
            "dark": "",
            "label": "",
            "small": ""
          }
        }, [_vm._v(_vm._s(text))])]
      }
    }]),
    model: {
      value: (_vm.estadoEditar.iconoCambiar),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "iconoCambiar", $$v)
      },
      expression: "estadoEditar.iconoCambiar"
    }
  })], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "color": "ligth",
      "small": "small"
    },
    on: {
      "click": _vm.closeDialogEditar
    }
  }, [_vm._v("cancelar")]), _c('v-btn', {
    attrs: {
      "color": "success",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarEstado()
      }
    }
  }, [_vm._v(_vm._s(_vm.indexEstadoSeleccionado ? 'Guardar cambios' : 'Generar estado'))])], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Estados")])]), _c('v-card-subtitle', {
    staticClass: "font-size-12 pb-1"
  }, [_vm._v("Administrador de estados")])], 1), _c('v-btn', {
    staticClass: "ma-5 mr-3",
    attrs: {
      "color": "primary",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.fetch('garantia')
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1), _c('v-btn', {
    staticClass: "mt-5 mr-3",
    attrs: {
      "color": "success",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDialogEditar({}, '')
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('v-select', {
    attrs: {
      "hide-details": "hide-details",
      "items": _vm.listadoTiposEstado,
      "label": "Seleccionar ",
      "item-value": "code",
      "item-text": "name",
      "dense": "",
      "solo": ""
    },
    on: {
      "change": function($event) {
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.tipoEstado),
      callback: function($$v) {
        _vm.tipoEstado = $$v
      },
      expression: "tipoEstado"
    }
  })], 1), _c('v-sheet', {
    staticClass: "overflow-y-auto"
  }, [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "height": "calc(100vh - 298px)"
    }
  }, [_c('lista-draggable', {
    attrs: {
      "options": {
        handle: '.handle'
      },
      "ghost-class": "ghost",
      "chosen-class": "chosen",
      "drag-class": "drag"
    },
    model: {
      value: (_vm.estados),
      callback: function($$v) {
        _vm.estados = $$v
      },
      expression: "estados"
    }
  }, _vm._l((_vm.estados), function(item, i) {
    return _c('v-list', {
      key: i,
      staticClass: "pa-0",
      attrs: {
        "nav": "",
        "dense": ""
      }
    }, [_c('v-list-item', {
      staticClass: "mx-1"
    }, [_c('v-list-item-content', {
      staticClass: "py-0"
    }, [_c('v-list-item-title', [_c('div', {
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('span', {
      staticClass: "font-weight-700"
    }, [_vm._v(_vm._s(item.orden) + "   -")]), _c('span', {
      staticClass: "font-size-12"
    }, [_vm._v("  " + _vm._s(item.descripcion) + " (" + _vm._s(item.codigo) + ")")])]), (item.cerrado) ? _c('v-chip', {
      attrs: {
        "label": "label",
        "color": "background"
      }
    }, [_vm._v("Cierra el ticket")]) : _vm._e()], 1)])], 1), _c('v-list-item-icon', {
      staticClass: "handle"
    }, [_c('v-btn', {
      staticClass: "mx-2",
      attrs: {
        "fab": "",
        "dark": "",
        "x-small": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.openDialogEditar(item, i)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("edit")])], 1)], 1), _c('v-list-item-icon', {
      staticClass: "handle"
    }, [_c('v-icon', {
      attrs: {
        "color": "background",
        "size": "30"
      }
    }, [_vm._v("drag_indicator")])], 1)], 1), _c('v-divider')], 1)
  }), 1)], 1)], 1), _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-text', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(!_vm.isMovil) ? _c('small', {
    staticClass: "text-muted font-size-11"
  }, [_vm._v("Mostrando " + _vm._s(_vm.estados.length) + " estados")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "block": _vm.isMovil,
      "color": "success",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchReordenarEstados()
      }
    }
  }, [_vm._v("Reordenar estados")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1 pa-2",
    attrs: {
      "color": _vm.actividad.oculto ? 'secondary primary--text' : '',
      "dark": _vm.actividad.oculto === 1,
      "max-width": "500"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "450",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalEliminarActividad()
      }
    },
    model: {
      value: (_vm.isModalEliminarActividad),
      callback: function($$v) {
        _vm.isModalEliminarActividad = $$v
      },
      expression: "isModalEliminarActividad"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-20 py-4"
  }, [_vm._v("¿Estas seguro que deseas eliminar esta actividad?")]), _c('div', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    ref: "comentarioParaEliminarActividad",
    attrs: {
      "hide-details": "hide-details",
      "autofocus": "autofocus",
      "placeholder": "Describe un motivo por el cual deseas eliminar la actividad",
      "color": "primary",
      "solo": "solo",
      "dense": "dense",
      "rows": "6"
    },
    model: {
      value: (_vm.comentarioParaEliminarActividad),
      callback: function($$v) {
        _vm.comentarioParaEliminarActividad = $$v
      },
      expression: "comentarioParaEliminarActividad"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.closeModalEliminarActividad()
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchEliminarActividad()
      }
    }
  }, [_vm._v("Eliminar actividad")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "transition": "dialog-bottom-transition",
      "fullscreen": true
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeDialogImage()
      }
    },
    model: {
      value: (_vm.showImageFull),
      callback: function($$v) {
        _vm.showImageFull = $$v
      },
      expression: "showImageFull"
    }
  }, [(_vm.imagePreview) ? _c('v-card', {
    staticClass: "overflow-hidden"
  }, [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "height": _vm.isMovil ? ("calc(100vh - " + (!_vm.imagePreview.group ? '225px' : '170px') + ")") : ("calc(100vh - " + (!_vm.imagePreview.group ? '160px' : '100px') + ")")
    }
  }, [_c('v-img', {
    staticClass: "background-filter position-relative",
    style: (("-webkit-transform: rotate(" + _vm.rotateDeg + "deg);")),
    attrs: {
      "src": _vm.imagePreview.contenido
    }
  }), _c('div', {
    staticClass: "box-preview-image d-flex jc-center ai-center"
  }, [_c('v-img', {
    staticClass: "text-end",
    style: (("-webkit-transform: rotate(" + _vm.rotateDeg + "deg);")),
    attrs: {
      "src": _vm.imagePreview.contenido,
      "height": _vm.isMovil ? 400 : 780,
      "contain": "contain"
    }
  }), _c('div', {
    staticClass: "d-flex rotates ai-center jc-center"
  }, [_c('div', {
    staticClass: "ma-1 ml-8"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "fab": ""
    },
    on: {
      "click": _vm.rotateImage
    }
  }, [_c('v-icon', [_vm._v("rotate_90_degrees_ccw")])], 1), _c('small', {
    staticClass: "font-weight-700 ml-2"
  }, [_vm._v(_vm._s(_vm.rotateDeg) + "°")])], 1), _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(!_vm.actividad.oculto && _vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario' && _vm.actividad.origen === 'empresa') ? _c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-4",
          attrs: {
            "icon": "icon",
            "small": "small"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("more_vert")])], 1) : _vm._e()]
      }
    }], null, false, 2840589149)
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openModalEliminarActividad()
      }
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "grey lighten-1",
    attrs: {
      "dark": "",
      "size": "20"
    }
  }, [_vm._v("delete_sweep")])], 1), _c('v-list-item-title', [_vm._v("Eliminar esta actividad")])], 1)], 1)], 1)], 1), (!_vm.isMovil) ? _c('div', {
    staticClass: "d-flex return"
  }, [_c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "dark": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogImage()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1)], 1) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [_c('v-slide-group', {
    attrs: {
      "active-class": "success",
      "show-arrows": ""
    }
  }, _vm._l((_vm.isGroupImagenes), function(n, index) {
    return _c('v-slide-item', {
      key: index,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "ma-1",
            class: {
              'border': _vm.indexGroupItem === index
            },
            attrs: {
              "hover": "hover"
            },
            on: {
              "click": function($event) {
                return _vm.seleccionarImagen(index)
              }
            }
          }, [_c('v-img', {
            attrs: {
              "src": n.contenido,
              "height": "55",
              "width": "55",
              "contain": "contain"
            }
          })], 1)]
        }
      }], null, true)
    })
  }), 1)], 1), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-avatar', [_c('avatar-perfil', {
    attrs: {
      "is-fetch": true,
      "usuario": _vm.imagePreview.usuario
    }
  })], 1)], 1), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-700",
    domProps: {
      "textContent": _vm._s(_vm.imagePreview.nombre)
    }
  }), _c('v-list-item-subtitle', {
    staticClass: "font-size-12",
    domProps: {
      "textContent": _vm._s(_vm.imagePreview.fechaLegible)
    }
  })], 1), _c('v-list-item-action', [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "color": "primary",
      "href": _vm.imagePreview.contenido,
      "target": "_blanck",
      "small": "small"
    }
  }, [_c('v-icon', [_vm._v("fullscreen")])], 1), _c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "fab": "fab",
      "color": "success white--text",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.descargarImagen(_vm.imagePreview.contenido, _vm.imagePreview.nombreAdjunto)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_downward")])], 1)], 1)])], 1)], 1), (_vm.isMovil) ? _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogImage()
      }
    }
  }, [_vm._v("cerrar")])], 1) : _vm._e()], 1) : _vm._e()], 1), (!_vm.actividad.oculto) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "fd-column d-flex"
  }, [_c('small', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v(" " + _vm._s(_vm.actividad.nombre))]), _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" " + _vm._s(_vm.actividad.cargo))])]), _c('v-spacer'), _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(!_vm.actividad.group && !_vm.actividad.oculto && _vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario' && _vm.actividad.origen === 'empresa') ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "icon",
            "color": "grey",
            "small": "small"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("more_vert")])], 1) : _vm._e()]
      }
    }], null, false, 2665882338)
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openModalEliminarActividad()
      }
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "grey lighten-1",
    attrs: {
      "dark": "",
      "size": "20"
    }
  }, [_vm._v("delete_sweep")])], 1), _c('v-list-item-title', [_vm._v("Eliminar esta actividad")])], 1)], 1)], 1)], 1) : _vm._e(), _c('div', [(_vm.actividad.oculto) ? _c('div', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": "18"
    }
  }, [_vm._v("do_not_disturb")]), _c('span', {
    staticClass: "font-size-11 font-italic"
  }, [_vm._v("  Esta actividad fue eliminada :  "), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("\"" + _vm._s(_vm.actividad.mensajeOculto) + "\"")])])], 1) : _c('div', [(_vm.actividad.tipo === 'adjunto') ? [_c('span', {
    staticClass: "font-size-11 grey--text"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.actividad.accion)))]), (_vm.actividad.tipoAdjunto === 'image/png' || _vm.actividad.tipoAdjunto === 'image/jpg' || _vm.actividad.tipoAdjunto === 'image/jpeg') ? _c('div', [(!_vm.actividad.group) ? _c('v-card', {
    staticClass: "mt-1 elevation-1",
    attrs: {
      "max-height": "230"
    },
    on: {
      "click": function($event) {
        return _vm.showDialogImage(false, 0, _vm.actividad)
      }
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85",
      "src": _vm.actividad.contenido,
      "max-height": "150",
      "content": "content"
    }
  }, [_c('v-btn', {
    staticClass: "position-get",
    attrs: {
      "fab": "fab",
      "color": "success white--text",
      "x-small": "x-small"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.descargarImagen(_vm.imagePreview.contenido, _vm.imagePreview.nombreAdjunto)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_downward")])], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "px-4 py-2 font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.nombreAdjunto))])], 1)], 1)], 1) : _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-row', {
    attrs: {
      "dense": "dense"
    }
  }, [(_vm.actividad.render1) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": function($event) {
        return _vm.showDialogImage(true, 0, _vm.actividad.imagenes)
      }
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85",
      "src": _vm.actividad.imagenes[0].contenido,
      "max-height": "150",
      "height": "110",
      "content": "content"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "px-2 py-2 font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.imagenes[0].nombreAdjunto))])], 1)])], 1)], 1) : _vm._e(), (_vm.actividad.render2) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": function($event) {
        return _vm.showDialogImage(true, 1, _vm.actividad.imagenes)
      }
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85",
      "src": _vm.actividad.imagenes[1].contenido,
      "max-height": "150",
      "height": "110",
      "content": "content"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "px-2 py-2 font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.imagenes[1].nombreAdjunto))])], 1)])], 1)], 1) : _vm._e(), (_vm.actividad.render3) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": function($event) {
        return _vm.showDialogImage(true, 2, _vm.actividad.imagenes)
      }
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85",
      "src": _vm.actividad.imagenes[2].contenido,
      "max-height": "150",
      "height": "110",
      "content": "content"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "px-2 py-2 font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.imagenes[2].nombreAdjunto))])], 1)])], 1)], 1) : _vm._e(), (_vm.actividad.render4) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": function($event) {
        return _vm.showDialogImage(true, 3, _vm.actividad.imagenes)
      }
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": _vm.actividad.countMore ? 'to bottom, #000000a8, #161f2b' : 'to bottom, rgba(0,0,0,.1),#161f2b85',
      "src": _vm.actividad.imagenes[3].contenido,
      "max-height": "150",
      "height": "110",
      "content": "content"
    }
  }, [_c('div', {
    staticClass: "d-flex",
    class: {
      '': _vm.actividad.countMore
    }
  }, [(!_vm.actividad.countMore) ? _c('v-spacer') : _vm._e(), (_vm.actividad.countMore) ? _c('div', {
    staticClass: "px-4 py-4"
  }, [_c('span', {
    staticClass: "font-size-30 font-weight-700"
  }, [_vm._v("+ " + _vm._s(_vm.actividad.countMore))])]) : _c('small', {
    staticClass: "px-4 py-2 font-size-11 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.imagenes[3].nombreAdjunto))])], 1)])], 1)], 1) : _vm._e()], 1)], 1)], 1) : (_vm.actividad.tipoAdjunto === 'video/mp4') ? _c('v-card', {
    staticClass: "mt-2 elevation-0",
    attrs: {
      "height": "100%"
    }
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.actividad.contenido,
      "type": "video/mp4"
    }
  })])]) : _c('v-card', {
    staticClass: "mt-1 elevation-0"
  }, [_c('v-divider', {
    staticClass: "pa-0 ma-0"
  }), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "two-line": "",
      "dense": "dense",
      "color": _vm.actividad.origen !== 'empresa' ? '' : ''
    }
  }, [_c('v-list-item', {
    staticClass: "px-2",
    on: {
      "click": function () {}
    }
  }, [_c('v-list-item-action', {
    staticClass: "mr-3"
  }, [(_vm.actividad.tipoAdjunto === 'application/pdf') ? _c('img', {
    attrs: {
      "src": __webpack_require__(217),
      "width": "45"
    }
  }) : (_vm.actividad.tipoAdjunto === 'text/plain') ? _c('img', {
    attrs: {
      "src": __webpack_require__(219),
      "width": "45"
    }
  }) : (_vm.actividad.tipoAdjunto === 'application/x-msdownload') ? _c('img', {
    attrs: {
      "src": __webpack_require__(216),
      "width": "45"
    }
  }) : (_vm.actividad.tipoAdjunto === 'application/x-zip-compressed') ? _c('img', {
    attrs: {
      "src": __webpack_require__(221),
      "width": "45"
    }
  }) : (_vm.actividad.tipoAdjunto === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ? _c('img', {
    attrs: {
      "src": __webpack_require__(220),
      "width": "45"
    }
  }) : (_vm.actividad.tipoAdjunto === 'application/msword' || _vm.actividad.tipoAdjunto === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') ? _c('img', {
    attrs: {
      "src": __webpack_require__(215),
      "width": "45"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(218),
      "width": "45"
    }
  })]), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-size-12",
    domProps: {
      "textContent": _vm._s(_vm.actividad.nombreAdjunto)
    }
  }), _c('v-list-item-subtitle', {
    staticClass: "font-size-11",
    domProps: {
      "textContent": _vm._s(_vm.actividad.tipoAdjunto)
    }
  })], 1), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "x-small": "x-small",
      "color": "success",
      "href": _vm.actividad.contenido,
      "target": "_blanck"
    }
  }, [_c('v-icon', [_vm._v("arrow_downward")])], 1)], 1)], 1)], 1)], 1)] : _vm._e(), (_vm.actividad.tipo === 'cambio') ? [_c('span', {
    staticClass: "font-size-11 grey--text"
  }, [_vm._v(_vm._s(_vm.actividad.accion))]), (_vm.actividad.comentario) ? _c('v-card', {
    staticClass: "pa-3 elevation-0",
    attrs: {
      "color": "#fb8c0021"
    }
  }, [_c('div', {
    staticClass: "font-size-11 font-italic warning--text"
  }, [_vm._v(_vm._s(("\"" + (_vm.actividad.comentario) + "\"")))])]) : _vm._e(), _vm._l((JSON.parse(_vm.actividad.contenido)), function(a, e, i) {
    return _c('div', [_c('v-list-item', {
      staticClass: "px-0"
    }, [_c('v-list-item-content', {
      staticClass: "py-1"
    }, [_c('v-list-item-title', {
      staticClass: "font-size-12 font-weight-700"
    }, [_vm._v(_vm._s(_vm._f("capitalize")(e)))]), _c('div', {
      staticClass: "font-size-11 font-weight-700 white-space-none"
    }, [_c('div', {
      staticClass: "d-flex",
      class: {
        'fd-column': _vm.isMovil, 'jc-center ai-center': !_vm.isMovil
      }
    }, [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(a[0]))]), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), (!_vm.isMovil) ? _c('v-icon', {
      staticClass: "px-2",
      attrs: {
        "color": "background",
        "size": "18"
      }
    }, [_vm._v("east")]) : _vm._e(), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), _c('span', {
      staticClass: "success--text"
    }, [_vm._v(" " + _vm._s(a[1]))])], 1)])], 1)], 1), (i < Object.keys(JSON.parse(_vm.actividad.contenido)).length - 1) ? _c('v-divider', {
      staticClass: "pa-0 ma-0"
    }) : _vm._e()], 1)
  })] : _vm._e(), (_vm.actividad.tipo === 'cita') ? [_c('span', {
    staticClass: "font-size-11 grey--text"
  }, [_vm._v(_vm._s(_vm.actividad.accion))]), _c('v-card', {
    staticClass: "elevation-1"
  }, [_vm._l((JSON.parse(_vm.actividad.contenido)), function(a, e, i) {
    return _c('div', [_c('v-list-item', {
      staticClass: "px-0"
    }, [_c('v-list-item-content', {
      staticClass: "py-1"
    }, [_c('v-list-item-title', {
      staticClass: "font-size-12 font-weight-700"
    }, [_vm._v(_vm._s(_vm._f("capitalize")(e)))]), _c('div', {
      staticClass: "font-size-11 font-weight-700 white-space-none"
    }, [_c('div', {
      staticClass: "d-flex",
      class: {
        'fd-column': _vm.isMovil, 'jc-center ai-center': !_vm.isMovil
      }
    }, [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(a[0]))]), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), (!_vm.isMovil) ? _c('v-icon', {
      staticClass: "px-2",
      attrs: {
        "color": "background",
        "size": "18"
      }
    }, [_vm._v("east")]) : _vm._e(), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), _c('span', {
      staticClass: "success--text"
    }, [_vm._v(" " + _vm._s(a[1]))])], 1)])], 1)], 1), (i < Object.keys(JSON.parse(_vm.actividad.contenido)).length - 1) ? _c('v-divider', {
      staticClass: "pa-0 ma-0"
    }) : _vm._e()], 1)
  }), (!_vm.actividad.comentario) ? _c('v-list', {
    staticClass: "py-1",
    attrs: {
      "subheader": "",
      "dense": "dense",
      "color": "background",
      "dark": "dark"
    }
  }, [_c('v-list-item', [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "grey",
      "size": "35"
    }
  }, [_vm._v("insert_invitation")]), _c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "grey--text font-size-11"
  }, [_vm._v("Cita programada para el")]), _c('v-list-item-title', {
    staticClass: "font-size-16 font-weight-700 primary--text"
  }, [_vm._v(_vm._s(_vm.actividad.tipoAdjunto))])], 1), (_vm.isLog) ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "x-small": "x-small",
      "color": "info white--text"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)], 1) : _vm._e(), (!_vm.isLog && _vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario') ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "x-small": "x-small",
      "color": "primary white--text",
      "disabled": _vm.perfilUsuario === 'supervisor'
    },
    on: {
      "click": function($event) {
        return _vm.goTo(("/programacion/citas/" + (_vm.actividad.nombreAdjunto)))
      }
    }
  }, [_c('v-icon', [_vm._v("north_east")])], 1)], 1) : _vm._e()], 1)], 1) : _c('v-list', {
    staticClass: "py-1",
    attrs: {
      "subheader": "",
      "dense": "dense",
      "color": "secondary "
    }
  }, [_c('v-list-item', [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "size": "35"
    }
  }, [_vm._v("event_busy")]), _c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "primary--text font-size-12"
  }, [_vm._v("La cita programada fue cancelada")])], 1), (_vm.isLog) ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "x-small": "x-small",
      "color": "info white--text"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)], 1) : _vm._e()], 1)], 1), (_vm.actividad.comentario) ? _c('v-card', {
    staticClass: "pa-3 elevation-0",
    attrs: {
      "color": "#fb8c0021"
    }
  }, [_c('div', {
    staticClass: "font-size-11 font-italic warning--text"
  }, [_vm._v(_vm._s(("\"" + (_vm.actividad.comentario) + "\"")))])]) : _vm._e(), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_c('v-card-text', {
    staticClass: "py-1 px-2"
  }, _vm._l((JSON.parse(_vm.actividad.contenido)), function(a, e, i) {
    return _c('div', [_c('v-list-item', {
      staticClass: "px-0"
    }, [_c('v-list-item-content', {
      staticClass: "py-1"
    }, [_c('v-list-item-title', {
      staticClass: "font-size-12 font-weight-700"
    }, [_vm._v(_vm._s(_vm._f("capitalize")(e)))]), _c('div', {
      staticClass: "font-size-11 font-weight-700 white-space-none"
    }, [_c('div', {
      staticClass: "d-flex",
      class: {
        'fd-column': _vm.isMovil, 'jc-center ai-center': !_vm.isMovil
      }
    }, [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(a[0]))]), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), (!_vm.isMovil) ? _c('v-icon', {
      staticClass: "px-2",
      attrs: {
        "color": "background",
        "size": "18"
      }
    }, [_vm._v("east")]) : _vm._e(), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), _c('span', {
      staticClass: "success--text"
    }, [_vm._v(" " + _vm._s(a[1]))])], 1)])], 1)], 1)], 1)
  }), 0)], 1)])], 2)] : _vm._e(), (_vm.actividad.tipo === null || _vm.actividad.tipo === '') ? [_c('span', {
    staticClass: "font-size-11 grey--text"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.actividad.accion)))]), (_vm.actividad.comentario) ? _c('v-card', {
    staticClass: "pa-3 elevation-0",
    attrs: {
      "color": "#fb8c0021"
    }
  }, [_c('div', {
    staticClass: "font-size-11 font-italic warning--text"
  }, _vm._l((_vm.returFormatComentario(_vm.actividad.comentario)), function(m, index) {
    return _c('span', [(m) ? _c('span', [_vm._v(_vm._s(m)), _c('br')]) : _vm._e()])
  }), 0)]) : _vm._e()] : _vm._e(), (_vm.isMovil) ? _c('div', {
    staticClass: "d-flex mt-1"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.fechaLegible))])], 1) : _vm._e()], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', [_c('side-bar'), _c('v-main', {
    style: (!_vm.$vuetify.theme.dark ? ("background: " + (_vm.$vuetify.theme.themes.light.background)) : ''),
    attrs: {
      "transition": "slide-y-transition"
    }
  }, [_c('router-view')], 1), _c('notifications', {
    class: _vm.isMovil ? 'width-full' : '',
    attrs: {
      "position": "top right"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('v-alert', {
          staticClass: "elevation-2 py-3 ma-1 animated fadeInRight faster",
          attrs: {
            "dense": "dense",
            "border": "left",
            "type": props.item.type
          }
        }, [_c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "grow"
        }, [_c('small', {
          staticClass: "font-size-11 font-weight-700"
        }, [_vm._v(_vm._s(props.item.text))])])], 1)], 1)]
      }
    }])
  }), (_vm.transaction.isProceso) ? _c('loading-transaction', {
    attrs: {
      "label": _vm.transaction.message
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "450",
      "max-height": "calc(100vh - 150px)",
      "origin": "top right",
      "offset-y": "offset-y",
      "transition": "slide-y-transition"
    },
    on: {
      "click:outside": _vm.openPopup
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-badge', {
          attrs: {
            "color": "success",
            "offset-x": _vm.countDescargas ? 26 : -15,
            "offset-y": _vm.countDescargas ? 22 : -15,
            "content": _vm.countDescargas,
            "bordered": "bordered",
            "overlap": "overlap"
          }
        }, [_c('v-btn', {
          staticClass: "mx-1",
          attrs: {
            "icon": "icon",
            "depressed": ""
          },
          on: {
            "click": function($event) {
              return _vm.openPopup()
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "28"
          }
        }, [_vm._v("cloud_download")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.openCentroDeDescargas),
      callback: function($$v) {
        _vm.openCentroDeDescargas = $$v
      },
      expression: "openCentroDeDescargas"
    }
  }, [_c('v-card', {
    attrs: {
      "max-width": "450",
      "max-height": "calc(100vh - 150px)"
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('strong', [_vm._v("Procesos pendientes")])]), (_vm.showProcesos) ? _c('procesos-handler') : _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-8"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("Ningún proceso en curso")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("No se encontraron procesos disponibles para mostrar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense",
      "color": !_vm.ticket.abierto ? 'secondary' : ''
    }
  }, [_c('v-divider', {
    attrs: {
      "inset": "inset"
    }
  }), _c('v-list-item', {
    key: _vm.ticket.title,
    on: {
      "click": function($event) {
        return _vm.handlerClick(_vm.ticket.numero)
      }
    }
  }, [(_vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario' && !_vm.isChart) ? _c('v-avatar', {
    staticClass: "mr-4",
    attrs: {
      "color": "secondary",
      "size": "30"
    }
  }, [_c('avatar-perfil', {
    attrs: {
      "is-fetch": true,
      "usuario": _vm.ticket.usuario
    }
  })], 1) : _vm._e(), _c('v-list-item-content', {
    staticClass: "py-2"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-chip', {
    staticClass: "mr-1",
    attrs: {
      "color": _vm.ticket.numeroInformeTecnico && _vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario' ? 'success-chip' : 'secondary primary--text',
      "small": "small",
      "label": "label"
    }
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-11"
  }, [_vm._v(_vm._s(_vm.ticket.numero))])]), (_vm.showNumeroInforme) ? _c('v-chip', {
    staticClass: "mx-1",
    attrs: {
      "color": "secondary primary--text",
      "small": "small",
      "label": "label"
    }
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-11"
  }, [_vm._v("IT: " + _vm._s(_vm.ticket.numeroInformeTecnico))])]) : _vm._e(), _c('div', {
    staticClass: "d-flex fd-column text-left"
  }, [(_vm.perfilUsuario === 'dispatcher') ? _c('span', [(_vm.ticket.tipoticket === 'contrato') ? _c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v(_vm._s(_vm.ticket.codigoClienteSap) + " ")]) : _vm._e()]) : _vm._e(), _c('span', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v(_vm._s(_vm.ticket.razonSocial))]), _c('span', {
    staticClass: "font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.ticket.usuario))])])], 1)]), _c('v-spacer')], 1), _c('div', {
    staticClass: "d-flex fd-column"
  }, [(_vm.ticket.serie || _vm.ticket.modelo) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "14"
    }
  }, [_vm._v("home_repair_service")]), _c('small', {
    staticClass: "font-size-10 text-muted"
  }, [_vm._v("Serie registrada "), _c('small', {
    staticClass: "font-size-10 font-weight-700 grey--text"
  }, [_vm._v(" " + _vm._s(_vm.ticket.serie) + " ")])]), (_vm.ticket.modelo) ? _c('small', {
    staticClass: "font-size-10 text-muted"
  }, [_vm._v("con modelo "), _c('small', {
    staticClass: "font-size-10 font-weight-700 grey--text"
  }, [_vm._v(" " + _vm._s(_vm.ticket.modelo))])]) : _vm._e()], 1) : _vm._e(), (_vm.ticket.recall && !_vm.isChart) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "14",
      "color": "primary"
    }
  }, [_vm._v("repeat")]), _c('small', {
    staticClass: "font-size-10 text-muted primary--text font-weight-700"
  }, [_vm._v("Cuenta con " + _vm._s(_vm.ticket.recall) + " recall")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil, 'ai-center': !_vm.isMovil
    }
  }, [_c('small', {
    staticClass: "font-size-10 font-weight-700",
    class: _vm.usuarioLogeado !== _vm.ticket.usuarioUltimaActividad ? 'info--text' : 'grey--text'
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "14",
      "color": _vm.usuarioLogeado !== _vm.ticket.usuarioUltimaActividad ? 'info' : ''
    }
  }, [_vm._v("visibility_off")]), _vm._v("Ultima actividad " + _vm._s(_vm._f("now")(_vm.ticket.fechaUltimaActividad)) + " por " + _vm._s(_vm.ticket.nombreUsuarioUltimaActividad))], 1), _c('v-spacer'), (!_vm.isChart) ? _c('small', {
    staticClass: "font-size-10 text-muted font-weight-700"
  }, [_vm._v(" Creado " + _vm._s(_vm._f("now")(_vm.ticket.fechaRegistro)))]) : _vm._e()], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "height": "calc(100vh - 112px)"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center jc-center mt-4"
  }, _vm._l((_vm.lista), function(a, index) {
    return _c('v-card-text', {
      key: index,
      staticClass: "pa-0"
    }, _vm._l((Object.keys(a)), function(r, index2) {
      return _c('div', [_c('v-text-field', {
        attrs: {
          "label": r,
          "dense": "dense"
        },
        model: {
          value: (a[r]),
          callback: function($$v) {
            _vm.$set(a, r, $$v)
          },
          expression: "a[r]"
        }
      })], 1)
    }), 0)
  }), 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "py-2",
    attrs: {
      "block": _vm.isMovil,
      "color": "success",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardar()
      }
    }
  }, [_vm._v("Guardar cambios")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "half-width margin-auto"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("!Hola, " + _vm._s(_vm.username) + "¡")])])])
},staticRenderFns: []}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.lista,
      "label": "Direccion",
      "placeholder": "Realiza la busqueda por la desripción",
      "dense": "dense",
      "item-value": "id",
      "item-text": "direccion",
      "return-object": "return-object",
      "hide-details": "hide-details"
    },
    on: {
      "change": _vm.seleccionarClick
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list', {
          staticClass: "my-0 py-0",
          attrs: {
            "dense": "dense"
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-size-12",
          domProps: {
            "innerHTML": _vm._s(data.item.id)
          }
        }), _c('v-list-item-subtitle', {
          staticClass: "font-size-11",
          domProps: {
            "innerHTML": _vm._s(data.item.direccion)
          }
        })], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.idDireccion),
      callback: function($$v) {
        _vm.idDireccion = $$v
      },
      expression: "idDireccion"
    }
  }), (_vm.idDireccion) ? _c('small', {
    staticClass: "mt-1 text-muted"
  }, [_vm._v(_vm._s(_vm.idDireccion))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mx-auto swipe",
    attrs: {
      "elevation": "0"
    }
  }, [(!_vm.isSetProfile) ? _c('v-slide-group', {
    attrs: {
      "show-arrows": "",
      "mandatory": "mandatory"
    },
    model: {
      value: (_vm.indexPreview),
      callback: function($$v) {
        _vm.indexPreview = $$v
      },
      expression: "indexPreview"
    }
  }, _vm._l((_vm.files), function(f, index) {
    return _c('v-slide-item', {
      key: index,
      staticClass: "mb-2",
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-chip', {
            staticClass: "ma-1 elevation-2 py-4",
            attrs: {
              "close": "close",
              "color": active ? 'primary ' : 'white grey--text'
            },
            on: {
              "click:close": function($event) {
                return _vm.removeFile(index)
              },
              "click": function($event) {
                toggle,
                _vm.previewFile(index)
              }
            }
          }, [_c('v-avatar', {
            attrs: {
              "left": "",
              "color": !active ? 'secondary primary--text' : 'white primary--text'
            }
          }, [(f.type === 'image/png' || f.type === 'image/jpg' || f.type === 'image/jpeg') ? _c('v-icon', {
            attrs: {
              "size": "16"
            }
          }, [_vm._v("insert_photo")]) : (f.type === 'application/pdf') ? _c('v-icon', {
            attrs: {
              "size": "16"
            }
          }, [_vm._v("picture_as_pdf")]) : (f.type === 'text/plain') ? _c('v-icon', {
            attrs: {
              "size": "16"
            }
          }, [_vm._v("description")]) : _c('v-icon', {
            attrs: {
              "size": "16"
            }
          }, [_vm._v("description")])], 1), _vm._v(_vm._s(f.name))], 1)]
        }
      }], null, true)
    })
  }), 1) : _vm._e(), (!_vm.isSetProfile) ? _c('v-btn', {
    staticClass: "left",
    attrs: {
      "color": "primary",
      "fab": "fab",
      "large": "large"
    },
    on: {
      "click": function($event) {
        return _vm.swipePrev()
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1) : _vm._e(), (!_vm.isSetProfile) ? _c('v-btn', {
    staticClass: "right",
    attrs: {
      "color": "primary",
      "fab": "fab",
      "large": "large"
    },
    on: {
      "click": function($event) {
        return _vm.swipeNext()
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1) : _vm._e(), _c('v-expand-transition', [_c('v-card', {
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 258px)' : 500
    }
  }, [(_vm.imgSRC) ? _c('div', {
    staticClass: "background-filter position-relative",
    style: (("background-image : url(" + _vm.imgSRC + ")"))
  }) : _vm._e(), _c('div', {
    staticClass: "box-preview-image",
    class: {
      'position-center': _vm.filePreview.type !== 'image/png' && _vm.filePreview.type !== 'image/jpg' && _vm.filePreview.type !== 'image/jpeg'
    }
  }, [(_vm.filePreview.type === 'image/png' || _vm.filePreview.type === 'image/jpg' || _vm.filePreview.type === 'image/jpeg' && _vm.imgSRC) ? _c('v-img', {
    staticClass: "text-end",
    attrs: {
      "src": _vm.imgSRC,
      "height": "400",
      "contain": "contain"
    }
  }) : _c('div', {
    staticClass: "d-flex ai-center jc-center fd-column"
  }, [(_vm.filePreview.type === 'application/pdf') ? _c('img', {
    attrs: {
      "src": __webpack_require__(217),
      "width": "70"
    }
  }) : (_vm.filePreview.type === 'text/plain') ? _c('img', {
    attrs: {
      "src": __webpack_require__(219),
      "width": "100"
    }
  }) : (_vm.filePreview.type === 'application/x-msdownload') ? _c('img', {
    attrs: {
      "src": __webpack_require__(216),
      "width": "100"
    }
  }) : (_vm.filePreview.type === 'application/x-zip-compressed') ? _c('img', {
    attrs: {
      "src": __webpack_require__(221),
      "width": "100"
    }
  }) : (_vm.filePreview.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ? _c('img', {
    attrs: {
      "src": __webpack_require__(220),
      "width": "100"
    }
  }) : (_vm.filePreview.type === 'video/mp4') ? _c('img', {
    attrs: {
      "src": __webpack_require__(430),
      "width": "100"
    }
  }) : (_vm.filePreview.type === 'application/msword' || _vm.filePreview.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') ? _c('img', {
    attrs: {
      "src": __webpack_require__(215),
      "width": "100"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(218),
      "width": "85"
    }
  }), _c('small', {
    staticClass: "grey--text font-weight-700 font-size-15 mt-4"
  }, [_vm._v(_vm._s(_vm.filePreview.name))])], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "d-flex ai-center jc-center",
    class: {
      'fd-column': _vm.isMovil
    },
    attrs: {
      "height": "calc(100vh - 112px)",
      "color": "background"
    }
  }, _vm._l((_vm.items), function(r, index) {
    return _c('v-card', {
      key: index,
      staticClass: "pa-2 ma-4",
      attrs: {
        "name": index,
        "id": _vm.items.length - 1,
        "color": r.id === _vm.indexItems ? 'primary white--text' : '',
        "to": r.path,
        "height": "100",
        "width": "300",
        "hover": "hover"
      }
    }, [_c('div', {
      staticClass: "d-flex ai-center"
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "57",
        "color": "primary"
      }
    }, [_vm._v(_vm._s(r.icon))]), _c('div', {
      staticClass: "flex-1 d-flex fd-column"
    }, [_c('span', {
      staticClass: "font-weight-700 font-size-20",
      class: {
        'font-size-17': _vm.isMovil
      }
    }, [_vm._v(_vm._s(r.title))]), _c('small', {
      staticClass: "font-size-12",
      class: {
        'white--text': r.id === _vm.indexItems
      }
    }, [_vm._v(_vm._s(r.descripcion))])])], 1)])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-0 pa-4 py-6",
    attrs: {
      "disabled": _vm.isLoading
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "align-center",
      "justify-center": "justify-center"
    }
  }, [(!_vm.showInfo) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-alert', {
    attrs: {
      "text": "",
      "border": "left",
      "type": "info",
      "icon": "info",
      "dense": "dense"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('small', {
    staticClass: "font-size-12 font-weight-600"
  }, [_vm._v(" Requerimiento de cambio de contraseña")]), _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("  Te enviaremos un link con las instrucciones para restablecer tu contraseña.")])])]), _c('v-form', [_c('v-text-field', {
    ref: "usuarioResetPassword",
    attrs: {
      "light": "light",
      "prepend-icon": "email",
      "label": "Ingresa un usuario valido (email)",
      "type": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.fetchRestablecerContraseña()
      }
    }
  }, [_c('small', [_vm._v("Continuar")])])], 1), _c('div', {
    staticClass: "d-flex jc-center ai-center mt-4"
  }, [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("¿Deseas Iniciar sesión?")]), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "small": "small",
      "color": "secondary primary--text"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/')
      }
    }
  }, [_vm._v("click aquí")])], 1)], 1) : _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('v-alert', {
    attrs: {
      "color": "success",
      "text": "text",
      "border": "left"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('small', {
    staticClass: "font-size-15 font-weight-700 mb-1"
  }, [_vm._v("¡Casi terminamos!")]), _c('small', {
    staticClass: "font-size-12 mt-2"
  }, [_vm._v(" Consulta tu correo electrónico, te hemos enviado las instrucciones necesarias para recuperar tu contraseña.")])])]), _c('v-btn', {
    staticClass: "mt-1",
    attrs: {
      "block": "block",
      "color": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/')
      }
    }
  }, [_c('small', [_vm._v("Iniciar sesión")])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "elevation": "1"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "dense": "dense"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "font-weight-700 font-size-12"
  }, [_vm._v(" Nuevo ticket de garantia")]), _c('v-spacer')], 1), _c('v-divider'), _c('div', {
    staticClass: "box-new-ticket pa-3"
  }, [_c('v-slide-group', {
    attrs: {
      "mandatory": "mandatory",
      "show-arrows": ""
    },
    model: {
      value: (_vm.ticket.comproAqui),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "comproAqui", $$v)
      },
      expression: "ticket.comproAqui"
    }
  }, _vm._l((_vm.acciones), function(n, index) {
    return _c('v-slide-item', {
      key: index,
      staticClass: "animated fadeInLeft faster",
      attrs: {
        "value": n.value
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "elevation-1 ma-1 d-flex ai-center jc-center text-center pa-2",
            attrs: {
              "color": active ? 'primary' : 'secondary primary--text',
              "height": "60",
              "dark": active,
              "width": "140"
            },
            on: {
              "click": toggle
            }
          }, [_c('span', {
            staticClass: "font-size-13 font-weight-700"
          }, [_vm._v(_vm._s(n.name))])])]
        }
      }], null, true)
    })
  }), 1), (_vm.ticket.comproAqui === 1) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "hide-details",
      "label": "¿Tu equipo se encuentra en garantia?"
    },
    model: {
      value: (_vm.ticket.sigueEnGarantia),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "sigueEnGarantia", $$v)
      },
      expression: "ticket.sigueEnGarantia"
    }
  })], 1) : _vm._e(), (_vm.ticket.comproAqui && _vm.ticket.sigueEnGarantia) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('v-alert', {
    staticClass: "mt-4",
    attrs: {
      "icon": "info",
      "text": "text",
      "dense": "dense",
      "type": "info"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-size-13 font-weight-700"
  }, [_vm._v("Es requerido adjuntar la Boleta o Factura para verificar la garantia, use la opción de adjuntar que se encuentra en la parte inferior de este formulario.")])])])], 1) : _vm._e(), (_vm.ticket.comproAqui === 1) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('v-text-field', {
    ref: "numeroFactura",
    staticClass: "mt-6",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "type": "text",
      "label": ("Numero de boleta o factura " + (!_vm.ticket.sigueEnGarantia ? '(Opcional)' : ''))
    },
    model: {
      value: (_vm.ticket.numeroFactura),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "numeroFactura", $$v)
      },
      expression: "ticket.numeroFactura"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "mt-2"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" ¿Que tipo de equipo posee?")]), _c('v-select', {
    staticClass: "mt-1",
    attrs: {
      "loading": _vm.isGettingTiposEquipo,
      "dense": "dense",
      "hide-details": "hide-details",
      "items": _vm.tiposEquipo,
      "return-object": "return-object",
      "item-text": "descripcion",
      "placeholder": "Listados de tipos de equipos",
      "solo": "solo"
    },
    on: {
      "change": _vm.fetchFallas
    },
    model: {
      value: (_vm.ticket.tipoEquipo),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "tipoEquipo", $$v)
      },
      expression: "ticket.tipoEquipo"
    }
  })], 1), _c('div', {
    staticClass: "pt-2"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" ¿Que esta fallando?")]), _c('v-select', {
    staticClass: "mt-2",
    attrs: {
      "loading": _vm.isGettingFallas,
      "dense": "dense",
      "hide-details": "hide-details",
      "return-object": "return-object",
      "item-value": "codigoFallaGeneral",
      "item-text": "descripcionFallaGeneral",
      "items": _vm.fallas,
      "placeholder": ("Listado de fallas para la serie " + (_vm.ticket.serie)),
      "solo": "solo"
    },
    model: {
      value: (_vm.ticket.falla),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "falla", $$v)
      },
      expression: "ticket.falla"
    }
  }), _c('v-alert', {
    staticClass: "mt-4",
    attrs: {
      "icon": "info",
      "outlined": "outlined",
      "text": "",
      "dense": "dense",
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-size-14 font-weight-700"
  }, [_vm._v("Explicanos un poco más de la falla de tu equipo")]), _c('span', {
    staticClass: "font-size-11"
  }, [_vm._v(" Ejemplos")]), _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" - La parte superior izquierda de la hoja sale manchada de rojo")]), _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" - Si el equipo mostrara un código de error, por favor ingreselo aquí")])])]), _c('v-textarea', {
    staticClass: "mt-3",
    attrs: {
      "placeholder": "Comentario adicional sobre la falla (opcional)",
      "solo": "solo",
      "dense": "dense",
      "rows": "3"
    },
    model: {
      value: (_vm.ticket.comentarioFalla),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "comentarioFalla", $$v)
      },
      expression: "ticket.comentarioFalla"
    }
  })], 1), _c('div', {
    staticClass: "d-flex my-4 mx-2",
    class: _vm.isMovil && 'fd-column'
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-select', {
    attrs: {
      "dense": "dense",
      "items": _vm.marcas,
      "label": "Marca del equipo (Opcional)",
      "item-text": "descripcion",
      "item-value": "descripcion",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.ticket.marca),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "marca", $$v)
      },
      expression: "ticket.marca"
    }
  })], 1), (_vm.ticket.tipo === 'garantia') ? _c('div', {
    staticClass: "flex-1",
    class: !_vm.isMovil && 'px-6'
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Modelo del equipo o factura (Opcional)"
    },
    model: {
      value: (_vm.ticket.modelo),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "modelo", $$v)
      },
      expression: "ticket.modelo"
    }
  })], 1) : _vm._e(), (_vm.ticket.tipo === 'garantia') ? _c('div', {
    staticClass: "flex-1"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Serie del equipo o factura (Opcional)"
    },
    model: {
      value: (_vm.ticket.serie),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "serie", $$v)
      },
      expression: "ticket.serie"
    }
  })], 1) : _vm._e()]), (_vm.ticket.tipo === 'garantia') ? _c('v-row', {
    staticClass: "my-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": "Ubigeo",
      "type": "number",
      "loading": _vm.isLoadingUbigeos,
      "hide-details": "hide-details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchUbigeos(true)
      }
    },
    model: {
      value: (_vm.ticket.ubigeo),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "ubigeo", $$v)
      },
      expression: "ticket.ubigeo"
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "color": "primary",
            "small": "small",
            "disabled": _vm.isLoadingUbigeos || !_vm.ticket.ubigeo
          },
          on: {
            "click": function($event) {
              return _vm.fetchUbigeos(true)
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("search")])], 1)]
      }
    }], null, false, 3378669583)
  }, [_c('small', [_vm._v("Obtener ubigeo")])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.departamentos,
      "dense": "",
      "label": "Departamento",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('departamento')
      }
    },
    model: {
      value: (_vm.ticket.departamento),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "departamento", $$v)
      },
      expression: "ticket.departamento"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.provincias,
      "dense": "",
      "label": "Provincia",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('provincia')
      }
    },
    model: {
      value: (_vm.ticket.provincia),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "provincia", $$v)
      },
      expression: "ticket.provincia"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.distritos,
      "dense": "",
      "label": "Distrito",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('distrito')
      }
    },
    model: {
      value: (_vm.ticket.distrito),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "distrito", $$v)
      },
      expression: "ticket.distrito"
    }
  })], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "pt-0"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" ¿Alguna observación adicional?")]), _c('v-textarea', {
    staticClass: "ma-1 mt-3",
    attrs: {
      "hide-details": "hide-details",
      "placeholder": "Comentario general  (Opcional)",
      "solo": "solo",
      "dense": "dense",
      "rows": "3"
    },
    model: {
      value: (_vm.ticket.comentarioGeneral),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "comentarioGeneral", $$v)
      },
      expression: "ticket.comentarioGeneral"
    }
  })], 1), (_vm.ticket.tipo === 'garantia') ? _c('div', {
    staticClass: "pt-0"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" Adjuntar sustento a la solicitud (Boleta, Guia o Factura de compra)")]), _c('adjuntar-archivos', {
    ref: "archivos",
    attrs: {
      "mode-insert": "mode-insert"
    }
  })], 1) : _vm._e()], 1), _c('v-divider'), _c('div', {
    staticClass: "d-flex pa-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": _vm.fetchGuardarTicket
    }
  }, [_vm._v("Generar ticket")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    class: !_vm.isMovil ? 'box-data-user' : 'box-data-movil',
    attrs: {
      "nav": "nav",
      "dense": "dense"
    }
  }, [(_vm.usuario.codigoSap) ? _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("account_box")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Codigo SAP")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.codigoSap
    }
  }, [_vm._v(_vm._s(_vm.usuario.codigoSap ? _vm.usuario.codigoSap.toUpperCase() : 'No asignado'))])], 1), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "small": "small",
      "color": "primary",
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": function($event) {
        return _vm.habilitarEdicionCodigoSAP()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1) : _c('v-sheet', {
    attrs: {
      "color": _vm.showDetailsDataSAP ? '' : 'secondary'
    }
  }, [(_vm.showDetailsDataSAP) ? _c('v-list', {
    staticClass: "elevation-4",
    attrs: {
      "two-line": "",
      "dense": "dense",
      "color": "background"
    }
  }, [_c('v-list-item', [_c('v-btn', {
    attrs: {
      "color": "error",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.limpiarDatosClienteSAP()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("Volver")], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.datosClienteSAP.nombreCliente)
    }
  }), _c('v-list-item-subtitle', {
    domProps: {
      "innerHTML": _vm._s(_vm.datosClienteSAP.direccion)
    }
  })], 1)], 1), _c('v-list-item', [_c('v-btn', {
    class: {
      'mt-4': _vm.isMovil
    },
    attrs: {
      "color": "success",
      "block": "block",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchAsignarCodigoSap()
      }
    }
  }, [_vm._v("Asignar codigo SAP")])], 1)], 1) : _c('div', {
    staticClass: "d-flex pa-4"
  }, [_c('v-text-field', {
    ref: "codigoClienteSAP",
    attrs: {
      "solo": "solo",
      "disabled": _vm.perfil === 'supervisor',
      "dense": "dense",
      "label": "Ingresa un codigo SAP para esta cuenta",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGetDatosSAP()
      }
    },
    model: {
      value: (_vm.codigoClienteSAP),
      callback: function($$v) {
        _vm.codigoClienteSAP = $$v
      },
      expression: "codigoClienteSAP"
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "color": "info",
            "disabled": _vm.perfil === 'supervisor',
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fetchGetDatosSAP()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("person_search")])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Obtener datos de SAP")])])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), (_vm.usuario.telefono) ? _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("call")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Telefono")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.telefono
    }
  }, [_vm._v(_vm._s(_vm.usuario.telefono ? _vm.usuario.telefono : 'No asignado'))])], 1), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "small": "small",
      "color": "primary",
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": _vm.habilitarEdicionTelefono
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1) : _c('v-sheet', {
    attrs: {
      "color": _vm.showTelefonoCliente ? '' : 'secondary'
    }
  }, [(_vm.showTelefonoCliente) ? _c('v-list', {
    staticClass: "elevation-4",
    attrs: {
      "two-line": "",
      "dense": "dense",
      "color": "background"
    }
  }, [_c('v-list-item', [_c('v-btn', {
    attrs: {
      "color": "error",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.limpiarDatosTelefonoCliente()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("Volver")], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.datosClienteSAP.nombreCliente)
    }
  }), _c('v-list-item-subtitle', {
    domProps: {
      "innerHTML": _vm._s(_vm.datosClienteSAP.direccion)
    }
  })], 1)], 1), _c('v-list-item', [_c('v-btn', {
    class: {
      'mt-4': _vm.isMovil
    },
    attrs: {
      "color": "success",
      "block": "block",
      "small": !_vm.isMovil
    }
  }, [_vm._v("Asignar codigo SAP")])], 1)], 1) : _c('div', {
    staticClass: "d-flex pa-4"
  }, [_c('v-text-field', {
    ref: "numeroTelefonoCliente",
    attrs: {
      "solo": "solo",
      "disabled": _vm.perfil === 'supervisor',
      "dense": "dense",
      "label": "Ingresa un numero de telefono para enlazar este usuario",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.numeroTelefonoCliente),
      callback: function($$v) {
        _vm.numeroTelefonoCliente = $$v
      },
      expression: "numeroTelefonoCliente"
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "color": "info ",
            "disabled": _vm.perfil === 'supervisor',
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fetchSaveDatosCliente()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("check")])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Guardar cambios")])])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("apartment")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Entidad")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.entidad
    }
  }, [_vm._v(_vm._s(_vm.usuario.entidad ? _vm.usuario.entidad.toUpperCase() : 'No definido'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("alternate_email")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Usuario / Email")]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.usuario.usuario))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), (_vm.usuario.entidad === 'empresa') ? _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("badge")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Razon Social")]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.usuario.razonSocial))])], 1)], 1) : _vm._e(), (_vm.usuario.entidad === 'empresa') ? _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }) : _vm._e(), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("person")])], 1), _c('v-list-item-content', [(_vm.usuario.entidad === 'empresa') ? _c('v-list-item-title', [_vm._v("Nombre contacto")]) : _c('v-list-item-title', [_vm._v("Nombre")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.nombre
    }
  }, [_vm._v(_vm._s(_vm.usuario.nombre))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("portrait")])], 1), _c('v-list-item-content', [(_vm.usuario.entidad === 'empresa') ? _c('v-list-item-title', [_vm._v("Documento contacto")]) : _c('v-list-item-title', [_vm._v("Documento")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.documento
    }
  }, [_vm._v(_vm._s(_vm.usuario.documento ? _vm.usuario.documento : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("work")])], 1), _c('v-list-item-content', [(_vm.usuario.entidad === 'empresa') ? _c('v-list-item-title', [_vm._v("Cargo contacto")]) : _c('v-list-item-title', [_vm._v("Cargo")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.cargo
    }
  }, [_vm._v(_vm._s(_vm.usuario.cargo ? _vm.usuario.cargo : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), (_vm.usuario.entidad === 'empresa') ? _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("gavel")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("RUC")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.ruc
    }
  }, [_vm._v(_vm._s(_vm.usuario.ruc ? _vm.usuario.ruc : 'No asignado'))])], 1)], 1) : _vm._e(), (_vm.usuario.entidad === 'empresa') ? _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }) : _vm._e(), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("place")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Direccion")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.direccion
    }
  }, [_vm._v(_vm._s(_vm.usuario.direccion ? _vm.usuario.direccion : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("circle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Ubigeo")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.ubigeo
    }
  }, [_vm._v(_vm._s(_vm.usuario.ubigeo ? _vm.usuario.ubigeo : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("circle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Departamento")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.departamento
    }
  }, [_vm._v(_vm._s(_vm.usuario.departamento ? _vm.usuario.departamento : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("circle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Provincia")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.provincia
    }
  }, [_vm._v(_vm._s(_vm.usuario.provincia ? _vm.usuario.provincia : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("circle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Distrito")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.distrito
    }
  }, [_vm._v(_vm._s(_vm.usuario.distrito ? _vm.usuario.distrito : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("folder_shared")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Acepta compartir sus datos personales")]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.usuario.aceptaPoliticasDeprivacidad ? 'SI' : 'NO'))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-row', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-dialog', {
    attrs: {
      "max-width": _vm.isMovil ? '100%' : '500px',
      "transition": "dialog-bottom-transition",
      "fullscreen": _vm.isMovil
    },
    model: {
      value: (_vm.isModalCrearUsuario),
      callback: function($$v) {
        _vm.isModalCrearUsuario = $$v
      },
      expression: "isModalCrearUsuario"
    }
  }, [_c('v-card', {
    staticClass: "pa-6"
  }, [_c('h1', {
    staticClass: "h1-nuevo"
  }, [_vm._v("Nuevo usuario")]), _c('v-layout', {
    attrs: {
      "align-center": "align-center",
      "justify-center": "justify-center"
    }
  }, [_c('v-flex', {
    staticClass: "login-form text-xs-center"
  }, [_c('v-form', [_c('v-text-field', {
    ref: "nombre",
    attrs: {
      "light": "light",
      "prepend-icon": "person",
      "label": "Nombre completo / Razon social",
      "type": "text"
    },
    on: {
      "keyup": [function (e) {
        _vm.nuevoUsuario.nombre = e.target.value.toUpperCase()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrar()
      }]
    },
    model: {
      value: (_vm.nuevoUsuario.nombre),
      callback: function($$v) {
        _vm.$set(_vm.nuevoUsuario, "nombre", $$v)
      },
      expression: "nuevoUsuario.nombre"
    }
  }), _c('v-text-field', {
    ref: "username",
    attrs: {
      "light": "light",
      "prepend-icon": "email",
      "label": "Email (Requerido)",
      "type": "email"
    },
    on: {
      "keyup": [function (e) {
        _vm.nuevoUsuario.username = e.target.value.toLowerCase()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrar()
      }]
    },
    model: {
      value: (_vm.nuevoUsuario.username),
      callback: function($$v) {
        _vm.$set(_vm.nuevoUsuario, "username", $$v)
      },
      expression: "nuevoUsuario.username"
    }
  }), _c('v-text-field', {
    ref: "password",
    attrs: {
      "prepend-icon": "lock",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password',
      "label": "Ingrese una contraseña",
      "loading": "loading",
      "hint": "La contraseña que usted ingrese sera encriptada para mayor seguridad",
      "persistent-hint": "persistent-hint"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrar()
      }
    },
    scopedSlots: _vm._u([{
      key: "progress",
      fn: function() {
        return [_c('v-progress-linear', {
          attrs: {
            "value": _vm.progress,
            "color": _vm.color,
            "absolute": "",
            "height": "2"
          }
        })]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nuevoUsuario.password),
      callback: function($$v) {
        _vm.$set(_vm.nuevoUsuario, "password", $$v)
      },
      expression: "nuevoUsuario.password"
    }
  }), _c('v-text-field', {
    ref: "password1",
    attrs: {
      "prepend-icon": "lock",
      "append-icon": _vm.showPassword1 ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword1 ? 'text' : 'password',
      "label": "Repita la contraseña"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword1 = !_vm.showPassword1
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrar()
      }
    },
    model: {
      value: (_vm.nuevoUsuario.password1),
      callback: function($$v) {
        _vm.$set(_vm.nuevoUsuario, "password1", $$v)
      },
      expression: "nuevoUsuario.password1"
    }
  }), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "color": "primary",
      "label": "Protección de datos personales (LEY Nº 29733)"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("¿Aceptas compartir tus datos personales?  "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.redirectProteccion()
            }
          }
        }, [_vm._v("LEY Nº 29733")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nuevoUsuario.aceptaPoliticasDePrivacidad),
      callback: function($$v) {
        _vm.$set(_vm.nuevoUsuario, "aceptaPoliticasDePrivacidad", $$v)
      },
      expression: "nuevoUsuario.aceptaPoliticasDePrivacidad"
    }
  }), _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "success",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchRegistrar()
      }
    }
  }, [_vm._v("Registrar")])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex pa-4 pb-1"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "label": "Busca por email, nombre",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close",
      "solo": "solo"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "click:clear": function($event) {
        return _vm.fetch(true)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('v-card', {
    staticClass: "d-flex elevation-0 ai-center"
  }, [_c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "fab": "fab",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.fetch(), _vm.fetchCountUsuarios()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1), (_vm.perfilUsuario === 'sistemas') ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "fab": "fab",
      "color": "success"
    },
    on: {
      "click": _vm.openDialogCrearUsuario
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition",
      "close-on-content-click": false,
      "location": "end"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-badge', {
          attrs: {
            "value": _vm.countFilters ? 1 : 0,
            "content": _vm.countFilters ? _vm.countFilters : 0,
            "overlap": "overlap"
          }
        }, [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-1",
          attrs: {
            "fab": "fab"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("filter_list")])], 1)], 1)]
      }
    }])
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "d-flex ai-center mb-2"
  }, [_c('v-checkbox', {
    staticClass: "ma-0",
    attrs: {
      "name": "pendingActive",
      "id": "pendingActive",
      "color": "primary",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.isCuentasPendientes),
      callback: function($$v) {
        _vm.isCuentasPendientes = $$v
      },
      expression: "isCuentasPendientes"
    }
  }), _c('label', {
    staticClass: "font-size-12",
    class: {
      '!primary--text font-weight-700': _vm.isCuentasPendientes
    },
    attrs: {
      "for": "pendingActive"
    }
  }, [_vm._v("Usuarios pendientes de activación")])], 1)])], 1)], 1)], 1), _c('v-card', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "mx-auto overflow-y-auto elevation-0",
    attrs: {
      "height": "calc(100vh - 127px)",
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0",
      attrs: {
        "dense": "dense",
        "color": _vm.selected && (_vm.selected.usuario === item.usuario) ? 'bg-secondary primary--text' : ''
      },
      on: {
        "click": function($event) {
          return _vm.renderEditar(item)
        }
      }
    }, [_c('v-list-item-avatar', {
      staticClass: "my-1 me-2"
    }, [_c('v-avatar', {
      attrs: {
        "color": "secondary",
        "size": "34"
      }
    }, [_c('avatar-perfil', {
      attrs: {
        "path": item.foto
      }
    })], 1)], 1), _c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      class: {
        'primary--text': (_vm.selected && _vm.selected.usuario === item.usuario)
      }
    }, [_c('div', {
      staticClass: "d-flex fd-column"
    }, [_c('small', {
      staticClass: "font-size-11 font-weight-700"
    }, [_vm._v(_vm._s(item.nombre))]), _c('div', {
      staticClass: "d-flex"
    }, [_c('small', {
      staticClass: "font-size-11 text-muted"
    }, [_vm._v(_vm._s(item.usuario))]), _c('small', {
      staticClass: "font-size-11 ml-1",
      class: {
        'blue--text': item.perfil === 'usuario-contrato', 'primary--text': item.perfil === 'usuario'
      }
    }, [_vm._v("(" + _vm._s(item.perfil) + ")")])])])])], 1), (item.perfil !== 'usuario-contrato') ? _c('v-list-item-action', [_c('v-fade-transition', {
      attrs: {
        "leave-absolute": ""
      }
    }, [_c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-icon', _vm._g(_vm._b({
            attrs: {
              "center": "",
              "size": "20",
              "color": item.emailConfirmado ? 'success' : 'background'
            }
          }, 'v-icon', attrs, false), on), [_vm._v(_vm._s(item.emailConfirmado ? 'check_circle' : 'timer'))])]
        }
      }], null, true)
    }, [_c('small', [_vm._v(_vm._s(item.emailConfirmado ? 'Verificado' : 'No verificado'))])])], 1)], 1) : _c('v-list-item-action', [_c('v-fade-transition', [_vm._v("(leave-absolute='')"), _c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-icon', _vm._g(_vm._b({
            attrs: {
              "center": "",
              "size": "20",
              "color": item.emailConfirmado && item.fechaCuentaActivada ? 'success' : 'background'
            }
          }, 'v-icon', attrs, false), on), [_vm._v(_vm._s(item.emailConfirmado && item.fechaCuentaActivada ? 'check_circle' : 'timer'))])]
        }
      }], null, true)
    }, [_c('small', [_vm._v(_vm._s(item.emailConfirmado && item.fechaCuentaActivada ? 'Verificado' : 'No verificado'))])])], 1)], 1)], 1)
  }), 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "9"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "680",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalIsAccountsList()
      }
    },
    model: {
      value: (_vm.isAccountsList),
      callback: function($$v) {
        _vm.isAccountsList = $$v
      },
      expression: "isAccountsList"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "d-flex mx-4"
  }, [_c('h1', {
    staticClass: "text-left font-weight-700 font-size-15 py-2 mb-4"
  }, [_vm._v("Listado de cuentas relacionadas")]), _c('v-spacer')], 1), _c('v-card-text', [(_vm.isLoadingGetAccounts) ? _c('span', [_vm._v("cargando...")]) : _vm._e(), (_vm.selected && !_vm.isLoadingGetAccounts) ? _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('usuario-seleccionar', {
    ref: "lista_usuarios_manager",
    attrs: {
      "perfiles": [_vm.selected.perfil],
      "multiple": "multiple",
      "username": _vm.usuariosRelacionados,
      "no-solo": false
    },
    on: {
      "user-selected": _vm.obtenerUsuarioSeleccionado
    }
  })], 1) : _vm._e()]), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "ligth"
    },
    on: {
      "click": function($event) {
        return _vm.closeModalIsAccountsList()
      }
    }
  }, [_c('small', [_vm._v("Cancelar")])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.isLoadingActivating,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarCuentas()
      }
    }
  }, [_c('small', [_vm._v("Guardar cambios")])])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalIsActiveAccount()
      }
    },
    model: {
      value: (_vm.isActiveAccount),
      callback: function($$v) {
        _vm.isActiveAccount = $$v
      },
      expression: "isActiveAccount"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-25 py-2"
  }, [_vm._v("Activar cuenta")]), _c('v-card-text', [_c('span', [_vm._v("Verifica los datos y presiona confirmar si deseas activar la siguiente cuenta de Help Desk.")]), _c('strong', {
    staticClass: "ml-3 primary--text"
  }, [_vm._v(_vm._s(_vm.selected ? _vm.selected.razonSocial : null))])]), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "ligth",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeModalIsActiveAccount()
      }
    }
  }, [_c('small', [_vm._v("Cancelar")])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.isLoadingActivating,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchActivateAccount()
      }
    }
  }, [_c('small', [_vm._v("Confirmar")])])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalIsActiveManagerAccount()
      }
    },
    model: {
      value: (_vm.isActiveManagerAccount),
      callback: function($$v) {
        _vm.isActiveManagerAccount = $$v
      },
      expression: "isActiveManagerAccount"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-25 py-2"
  }, [_vm._v(_vm._s(_vm.isManagerAccount ? 'Activar permisos de administrador' : 'Desactivar permisos de administrador'))]), _c('v-card-text', [_c('span', [_vm._v("Al activar esta opcion la cuenta podra tener visibilidad de los usuarios que tengan relacion con")]), _c('strong', {
    staticClass: "ml-3 primary--text"
  }, [_vm._v(_vm._s(_vm.selected ? _vm.selected.razonSocial : null))])]), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "ligth",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeModalIsActiveManagerAccount()
      }
    }
  }, [_c('small', [_vm._v("Cancelar")])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.isLoadingActivating,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchActivateManagerAccount()
      }
    }
  }, [_c('small', [_vm._v("Confirmar")])])], 1)], 1)], 1), (!_vm.selected) ? _c('v-card', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 elevation-0",
    attrs: {
      "height": "calc(100vh - 68px)"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("person_search")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No se selecciono un usuario")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Seleccione un usuario en el panel isquierdo")])], 1) : _vm._e(), (_vm.selected) ? _c('div', {
    staticClass: "d-flex fd-column",
    class: {
      'border-radius-none': _vm.isMovil
    },
    attrs: {
      "color": "white"
    }
  }, [(_vm.perfilUsuario !== 'sistemas') ? _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('div', {
    staticClass: "position-relative"
  }, [_c('v-avatar', {
    staticClass: "elevation-1",
    attrs: {
      "size": 50
    }
  }, [_c('avatar-perfil', {
    attrs: {
      "path": _vm.selected.foto,
      "gradient": "gradient"
    }
  })], 1)], 1), _c('v-list-item-content', {
    staticClass: "ml-3"
  }, [_c('v-list-item-title', [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "font-weight-700 mr-2 font-size-17"
  }, [_vm._v(_vm._s(_vm.selected.nombre))]), ((_vm.selected.fechaCuentaActivada && _vm.selected.perfil === 'usuario-contrato') || (_vm.selected.emailConfirmado && _vm.selected.perfil === 'usuario')) ? _c('v-chip', {
    staticClass: "font-weight-700 elevation-1",
    attrs: {
      "color": "success"
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "15"
    }
  }, [_vm._v("check")]), _c('span', [_vm._v("Activo")])], 1) : _c('v-chip', {
    staticClass: "font-weight-700 elevation-1",
    attrs: {
      "color": "warning"
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "15"
    }
  }, [_vm._v("timer")]), _c('span', [_vm._v("Pendiente")])], 1)], 1)]), _c('v-list-item-subtitle', {
    class: _vm.isMovil ? 'font-size-12' : 'font-size-12'
  }, [_c('span', [_vm._v(_vm._s(_vm.selected.cargo))]), (_vm.perfilUsuario !== 'usuario-contrato') ? _c('span', [_vm._v("  (" + _vm._s(_vm.selected.tipoArea) + "/" + _vm._s(_vm.selected.zonaGarantia) + ")")]) : _vm._e()])], 1), _c('v-list-item-action', [_c('v-menu', {
    attrs: {
      "transition": "slide-x-transition",
      "bottom": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "animated fadeInUp faster",
          attrs: {
            "icon": "icon",
            "disabled": _vm.perfilUsuario === 'supervisor'
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" more_vert")])], 1)]
      }
    }], null, false, 4094011321)
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.enviarDatosDelUsuario()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Enviar datos del usuario al SIV")])], 1)], 1)], 1)], 1)], 1), ((_vm.perfilUsuario === 'dispatcher' || _vm.perfilUsuario === 'supervisor' || _vm.perfilUsuario === 'sistemas') && _vm.selected && _vm.selected.perfil === 'usuario-contrato' && _vm.selected.emailConfirmado && !_vm.selected.fechaCuentaActivada) ? _c('v-alert', {
    staticClass: "elevation-2 py-3 ma-1 animated fadeInRight faster",
    attrs: {
      "dense": "dense",
      "border": "left",
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('small', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v("Esta cuenta esta pendiente de activación.")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "white warning--text"
    },
    on: {
      "click": function($event) {
        return _vm.openModalIsActiveAccount()
      }
    }
  }, [_c('v-icon', [_vm._v("check")]), _c('small', {
    staticClass: "is-bold"
  }, [_vm._v("Activar")])], 1)], 1)]) : _vm._e()], 1) : _vm._e(), (_vm.selected && _vm.selected.fechaCuentaActivada) ? _c('v-list', {
    staticClass: "px-4 py-0"
  }, [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("person")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('span', {
    staticClass: "font-size-13 font-weight-700"
  }, [_vm._v("Otorgar permisos para manejar otras cuentas")])]), _c('v-list-item-subtitle', [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Visibilidad de todas las acciones de cuentas relacionados.")])])], 1), _c('v-list-item-action', [_c('div', {
    staticClass: "d-flex ai-center jc-center"
  }, [(_vm.selected.esCuentaAdministrador) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "info",
      "loading": _vm.isLoadingActivating,
      "small": "small",
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.openModalIsAccountsList()
      }
    }
  }, [_c('small', [_vm._v("Administrar cuentas")])]) : _vm._e(), _c('v-switch', {
    attrs: {
      "dense": "dense"
    },
    on: {
      "change": function($event) {
        return _vm.openModalIsActiveManagerAccount()
      }
    },
    model: {
      value: (_vm.isManagerAccount),
      callback: function($$v) {
        _vm.isManagerAccount = $$v
      },
      expression: "isManagerAccount"
    }
  })], 1)])], 1)], 1) : _vm._e(), (_vm.isRenderComponent && _vm.selected.usuario && _vm.perfilUsuario !== 'sistemas') ? _c('item-usuario', {
    attrs: {
      "datos": _vm.selected,
      "show-details": "show-details"
    }
  }) : (_vm.isRenderComponent && _vm.selected.usuario && _vm.perfilUsuario === 'sistemas') ? _c('form-editar-usuario', {
    attrs: {
      "username": _vm.selected.usuario,
      "validar": _vm.perfilUsuario !== 'sistemas'
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": _vm.isMovil ? '100%' : '50%',
      "transition": "dialog-bottom-transition",
      "fullscreen": _vm.isMovil
    },
    model: {
      value: (_vm.isUploadAvatar),
      callback: function($$v) {
        _vm.isUploadAvatar = $$v
      },
      expression: "isUploadAvatar"
    }
  }, [_c('v-card', [(_vm.isUploadAvatar) ? _c('adjuntar-archivos', {
    ref: "archivos",
    attrs: {
      "multiple": false,
      "extensions": ['png', 'jpg', 'jpeg'],
      "accept": ['image/*'],
      "label": "Elegir como perfil",
      "is-set-profile": true
    },
    on: {
      "close": _vm.closeModalAdjuntar,
      "save": _vm.getImagenToProfile
    }
  }) : _vm._e()], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalIsActiveAccount()
      }
    },
    model: {
      value: (_vm.isActiveAccount),
      callback: function($$v) {
        _vm.isActiveAccount = $$v
      },
      expression: "isActiveAccount"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-25 py-2"
  }, [_vm._v("Activar cuenta")]), _c('v-card-text', [_c('span', [_vm._v("Verifica los datos y dale confirmar si realmente deseas aprobar la siguiente cuenta de Help Desk.")]), _c('strong', {
    staticClass: "ml-3 primary--text"
  }, [_vm._v(_vm._s(_vm.usuario.razonSocial))])]), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "ligth",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeModalIsActiveAccount()
      }
    }
  }, [_c('small', [_vm._v("Cancelar")])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.isLoadingActivating,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchActivateAccount()
      }
    }
  }, [_c('small', [_vm._v("Confirmar")])])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalSetPassword()
      }
    },
    model: {
      value: (_vm.isSetPassword),
      callback: function($$v) {
        _vm.isSetPassword = $$v
      },
      expression: "isSetPassword"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-20 py-2"
  }, [_vm._v(_vm._s(!_vm.validar ? 'Ingresa la contraseña actual del usuario, para guardar los cambios realizados.' : 'Ingresa tu contraseña actual, para guardar los cambios realizados.'))]), _c('v-card-text', [_c('v-text-field', {
    ref: "currentPassword",
    staticClass: "pt-6",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "append-icon": !_vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password',
      "label": "Contraseña actual"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    model: {
      value: (_vm.currentPassword),
      callback: function($$v) {
        _vm.currentPassword = $$v
      },
      expression: "currentPassword"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "ligth",
      "text": "",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.closeModalSetPassword()
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarCambios(true)
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)], 1), _c('v-card', {
    staticClass: "elevation-1 pa-3"
  }, [(!Object.keys(_vm.usuario).length) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line",
      "height": "100px"
    }
  }) : _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('div', {
    staticClass: "position-relative"
  }, [_c('v-avatar', {
    staticClass: "elevation-1",
    attrs: {
      "size": _vm.isMovil ? 50 : 70
    }
  }, [_c('avatar-perfil', {
    attrs: {
      "path": _vm.usuario.foto,
      "gradient": "gradient"
    }
  })], 1), (_vm.perfil === 'sistemas' || _vm.usuarioLogged === _vm.usuario.usuario) ? _c('v-btn', {
    staticClass: "position-absolute floatt",
    attrs: {
      "fab": "fab",
      "color": "primary white--text"
    },
    on: {
      "click": function($event) {
        return _vm.openModalAdjuntar()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1), _c('v-list-item-content', {
    staticClass: "ml-3"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: _vm.isMovil ? 'font-size-17' : 'font-size-17',
    domProps: {
      "textContent": _vm._s(_vm.usuario.nombre)
    }
  }), _c('v-list-item-subtitle', {
    class: _vm.isMovil ? 'font-size-12' : 'font-size-12'
  }, [_c('span', [_vm._v(_vm._s(_vm.usuario.cargo))]), (_vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario-contrato') ? _c('span', [_vm._v("  (" + _vm._s(_vm.usuario.tipoArea) + "/" + _vm._s(_vm.usuario.zonaGarantia) + ")")]) : _vm._e()])], 1)], 1)], 1), _c('div', {
    staticClass: "mt-4"
  }, [(_vm.perfil === 'sistemas' || _vm.usuarioLogged === _vm.usuario.usuario) ? _c('v-tabs', {
    attrs: {
      "color": "primary"
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    key: "tab-datos"
  }, [_vm._v("Datos")]), _c('v-tab', {
    key: "tab-reset-password"
  }, [_vm._v("cambiar contraseña")])], 1) : _vm._e(), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: "tab-datos"
  }, [_c('v-form', {
    staticClass: "pa-2",
    class: _vm.validar ? 'box-data-desktop-validar' : 'box-data-desktop'
  }, [(!_vm.isUsuarioEmpresa) ? _c('v-slide-group', {
    staticClass: "my-2",
    attrs: {
      "mandatory": "mandatory",
      "show-arrows": ""
    },
    model: {
      value: (_vm.usuario.entidad),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "entidad", $$v)
      },
      expression: "usuario.entidad"
    }
  }, _vm._l((_vm.tiposUsuario), function(n, index) {
    return _c('v-slide-item', {
      key: index,
      staticClass: "animated fadeInLeft faster",
      attrs: {
        "value": n.value
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "elevation-1 ma-1 d-flex ai-center jc-center text-center fd-column",
            attrs: {
              "color": active ? 'primary' : 'secondary primary--text',
              "height": "85",
              "dark": active,
              "disabled": _vm.isUsuarioEmpresa,
              "width": _vm.isMovil ? '100%' : '150px'
            },
            on: {
              "click": toggle
            }
          }, [_c('v-icon', {
            attrs: {
              "size": "30",
              "color": active ? 'white' : 'primary'
            }
          }, [_vm._v(_vm._s(n.icon))]), _c('span', {
            staticClass: "font-size-13 font-weight-700"
          }, [_vm._v(_vm._s(n.name))])], 1)]
        }
      }], null, true)
    })
  }), 1) : _vm._e(), _c('v-row', {
    staticClass: "pt-4 mt-8"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex relative w-full"
  }, [_c('v-text-field', {
    ref: "email",
    attrs: {
      "disabled": _vm.validar,
      "dense": "dense",
      "type": "email",
      "label": "Usuario (email)"
    },
    on: {
      "keyup": _vm.lowercase
    },
    model: {
      value: (_vm.usuario.usuario),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "usuario", $$v)
      },
      expression: "usuario.usuario"
    }
  }), _c('v-fade-transition', [_vm._v("(leave-absolute='')"), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-icon', _vm._g(_vm._b({
          attrs: {
            "center": "",
            "size": "20",
            "color": _vm.usuario.emailConfirmado ? 'success' : 'warning'
          }
        }, 'v-icon', attrs, false), on), [_vm._v(_vm._s(_vm.usuario.emailConfirmado ? 'check_circle' : 'do_not_disturb_on'))])]
      }
    }])
  }, [_c('small', [_vm._v(_vm._s(_vm.usuario.emailConfirmado ? 'Email verificado' : 'No verificado'))])])], 1)], 1)]), (_vm.usuario.entidad === 'persona natural') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    ref: "documento",
    attrs: {
      "dense": "dense",
      "type": "number",
      "label": "Nro. Documento (DNI) *"
    },
    model: {
      value: (_vm.usuario.documento),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "documento", $$v)
      },
      expression: "usuario.documento"
    }
  })], 1) : _vm._e(), (_vm.usuario.entidad === 'empresa') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    ref: "ruc",
    attrs: {
      "dense": "dense",
      "label": "Nro. RUC",
      "counter": "counter",
      "maxlength": "11",
      "type": "number"
    },
    model: {
      value: (_vm.usuario.ruc),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ruc", $$v)
      },
      expression: "usuario.ruc"
    }
  }), (_vm.perfil === 'sistemas') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fetchGetDatosSunat()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('img', {
          attrs: {
            "src": __webpack_require__(214),
            "width": "25",
            "height": "25"
          }
        })])]
      }
    }], null, false, 3793452433)
  }, [_c('small', [_vm._v("Obtener datos de SUNAT")])]) : _vm._e()], 1)]) : _vm._e(), (_vm.usuario.entidad === 'persona natural') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    ref: "nombreCompleto",
    attrs: {
      "dense": "dense",
      "label": "Nombre completo *"
    },
    on: {
      "keyup": function (e) {
        _vm.usuario.nombre = e.target.value.toUpperCase()
      }
    },
    model: {
      value: (_vm.usuario.nombre),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "nombre", $$v)
      },
      expression: "usuario.nombre"
    }
  })], 1) : _vm._e(), (_vm.usuario.entidad === 'empresa') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    ref: "razonsocial",
    attrs: {
      "dense": "dense",
      "label": "'Razon Social *"
    },
    on: {
      "keyup": function (e) {
        _vm.usuario.razonSocial = e.target.value.toUpperCase()
      }
    },
    model: {
      value: (_vm.usuario.razonSocial),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "razonSocial", $$v)
      },
      expression: "usuario.razonSocial"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    ref: "telefono",
    attrs: {
      "type": "number",
      "counter": "counter",
      "maxlength": "10",
      "dense": "dense",
      "label": "Telefono / Celular *"
    },
    model: {
      value: (_vm.usuario.telefono),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "telefono", $$v)
      },
      expression: "usuario.telefono"
    }
  })], 1)], 1), (_vm.usuario.entidad === 'empresa') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "label": "Nombre contacto *"
    },
    model: {
      value: (_vm.usuario.nombre),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "nombre", $$v)
      },
      expression: "usuario.nombre"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "documento",
      "label": "Nro. Documento del contacto *"
    },
    model: {
      value: (_vm.usuario.documento),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "documento", $$v)
      },
      expression: "usuario.documento"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "label": "Cargo del contacto"
    },
    model: {
      value: (_vm.usuario.cargo),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "cargo", $$v)
      },
      expression: "usuario.cargo"
    }
  })], 1)], 1) : _vm._e(), _c('v-row', [(_vm.usuario.entidad !== 'empresa') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "label": "Cargo"
    },
    model: {
      value: (_vm.usuario.cargo),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "cargo", $$v)
      },
      expression: "usuario.cargo"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": _vm.usuario.entidad === 'empresa' ? 12 : 9
    }
  }, [_c('v-text-field', {
    ref: "direccion",
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Dirección fiscal *"
    },
    model: {
      value: (_vm.usuario.direccion),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "direccion", $$v)
      },
      expression: "usuario.direccion"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": "Ubigeo",
      "type": "number",
      "loading": _vm.isLoadingUbigeos
    },
    model: {
      value: (_vm.usuario.ubigeo),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ubigeo", $$v)
      },
      expression: "usuario.ubigeo"
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "color": "primary",
            "small": "small",
            "disabled": _vm.isLoadingUbigeos
          },
          on: {
            "click": function($event) {
              return _vm.fetchUbigeos(true)
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("sync")])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Obtener ubigeo")])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.departamentos,
      "dense": "",
      "label": "Departamento"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('departamento')
      }
    },
    model: {
      value: (_vm.usuario.departamento),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "departamento", $$v)
      },
      expression: "usuario.departamento"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.provincias,
      "dense": "",
      "label": "Provincia"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('provincia')
      }
    },
    model: {
      value: (_vm.usuario.provincia),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "provincia", $$v)
      },
      expression: "usuario.provincia"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.distritos,
      "dense": "",
      "label": "Distrito"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('distrito')
      }
    },
    model: {
      value: (_vm.usuario.distrito),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "distrito", $$v)
      },
      expression: "usuario.distrito"
    }
  })], 1)], 1), (_vm.perfil === 'sistemas') ? _c('div', {
    staticClass: "d-flex mt-6"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.perfiles,
      "disabled": _vm.validar,
      "hide-details": "hide-details",
      "label": "Perfil para el aplicativo",
      "dense": "",
      "item-value": "nombre",
      "item-text": "nombre"
    },
    model: {
      value: (_vm.usuario.perfil),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "perfil", $$v)
      },
      expression: "usuario.perfil"
    }
  }), _c('v-select', {
    staticClass: "mx-4",
    attrs: {
      "items": _vm.zonasGarantia,
      "disabled": _vm.validar,
      "hide-details": "hide-details",
      "label": "Zona de garantia",
      "dense": ""
    },
    model: {
      value: (_vm.usuario.zonaGarantia),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "zonaGarantia", $$v)
      },
      expression: "usuario.zonaGarantia"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.tipoAreas,
      "disabled": _vm.validar,
      "hide-details": "hide-details",
      "label": "Tipo de area",
      "dense": ""
    },
    model: {
      value: (_vm.usuario.tipoArea),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "tipoArea", $$v)
      },
      expression: "usuario.tipoArea"
    }
  })], 1) : _vm._e(), (_vm.perfil === 'sistemas') ? _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Puede cambiar ruc del cliente"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("Puede cambiar ruc del cliente")])]
      },
      proxy: true
    }], null, false, 2522306904),
    model: {
      value: (_vm.usuario.puedeCambiarRucDeCliente),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "puedeCambiarRucDeCliente", $$v)
      },
      expression: "usuario.puedeCambiarRucDeCliente"
    }
  }) : _vm._e()], 1)], 1), _c('v-tab-item', {
    key: "tab-reset-password"
  }, [_c('v-form', {
    staticClass: "pa-2",
    class: {
      'box-data-movil': _vm.isMovil, 'box-data-desktop': !_vm.validar, 'box-data-desktop-validar': _vm.validar
    }
  }, [_c('v-alert', {
    staticClass: "my-2",
    attrs: {
      "icon": "info",
      "outlined": "outlined",
      "text": "",
      "type": "info"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-14"
  }, [_vm._v("Nota")]), _c('span', {
    staticClass: "font-size-11"
  }, [_vm._v(" Al realizar el cambio de tu contraeña, tendras que volver a iniciar sesión")])])]), _c('v-text-field', {
    ref: "password",
    staticClass: "pt-4",
    attrs: {
      "prepend-icon": "lock",
      "append-icon": !_vm.showPassword1 ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword1 ? 'text' : 'password',
      "label": "Ingrese una contraseña",
      "loading": "loading",
      "hint": "La contraseña que ingreses sera encriptada para mayor privacidad y seguridad",
      "persistent-hint": "persistent-hint"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword1 = !_vm.showPassword1
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGuardarCambios()
      }
    },
    scopedSlots: _vm._u([{
      key: "progress",
      fn: function() {
        return [_c('v-progress-linear', {
          attrs: {
            "value": _vm.progress,
            "color": _vm.color,
            "absolute": "",
            "height": "2"
          }
        })]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _c('v-text-field', {
    staticClass: "pt-4",
    attrs: {
      "dense": "dense",
      "prepend-icon": "lock",
      "type": _vm.showPassword2 ? 'text' : 'password',
      "append-icon": !_vm.showPassword2 ? 'visibility' : 'visibility_off',
      "label": "Repita la contraseña nueva"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword2 = !_vm.showPassword2
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGuardarCambios()
      }
    },
    model: {
      value: (_vm.newPasswordRepeat),
      callback: function($$v) {
        _vm.newPasswordRepeat = $$v
      },
      expression: "newPasswordRepeat"
    }
  })], 1)], 1)], 1), ((_vm.perfil === 'dispatcher' || _vm.perfil === 'supervisor' || _vm.perfil === 'sistemas') && _vm.usuario.perfil === 'usuario-contrato') ? _c('v-card', {
    staticClass: "mx-auto position-absolute position-active",
    attrs: {
      "elevation": "2",
      "absolute": "absolute",
      "min-height": "210px",
      "max-height": "300px",
      "min-width": "300px",
      "max-width": "300px"
    }
  }, [_c('v-card-item', [_c('v-card-title', {
    staticClass: "py-2"
  }, [_c('strong', {
    staticClass: "font-size-17"
  }, [_vm._v("Historial de inicio")])])], 1), _c('v-divider'), _c('v-card-text', [_c('div', {
    staticClass: "d-flex fd-column mb-2"
  }, [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Estado de email")]), (_vm.usuario.emailConfirmado) ? _c('strong', {
    staticClass: "success--text"
  }, [_vm._v("Verificado")]) : _c('strong', {
    staticClass: "warning--text"
  }, [_vm._v("No verificado")])]), _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Activación de cuenta")]), (_vm.usuario.emailConfirmado && _vm.usuario.fechaCuentaActivada) ? _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('strong', {
    staticClass: "success--text mb-1"
  }, [_vm._v("Activado")]), _c('div', {
    staticClass: "d-flex font-size-12 gray--text"
  }, [_c('span', [_vm._v("El")]), _c('strong', {
    staticClass: "mx-1"
  }, [_vm._v(_vm._s(_vm._f("fecha")(_vm.usuario.fechaCuentaActivada)))]), _c('span', {
    staticClass: "mr-1"
  }, [_vm._v("por")]), _c('strong', [_vm._v(" " + _vm._s(_vm.usuario.nombreUsuarioCuentaActivada))])])]) : _c('strong', {
    staticClass: "warning--text"
  }, [_vm._v("No activado")]), ((_vm.perfil === 'dispatcher' || _vm.perfil === 'supervisor' || _vm.perfil === 'sistemas') && _vm.usuario.emailConfirmado && !_vm.usuario.fechaCuentaActivada) ? _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "color": "info",
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.openModalIsActiveAccount()
      }
    }
  }, [_c('small', [_vm._v("Activar cuenta")])]) : _vm._e()], 1)])], 1) : _vm._e(), (_vm.perfil === 'sistemas' || _vm.usuarioLogged === _vm.usuario.usuario) ? _c('div', {
    staticClass: "d-flex align-end -end jc-end"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "success",
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarCambios()
      }
    }
  }, [_c('small', [_vm._v("Guardar cambios")])])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('client-list', {
    staticClass: "box",
    on: {
      "selected": _vm.selected,
      "deselected": _vm.deselected
    }
  }), (_vm.seleccionado) ? _c('client-contact-list', {
    staticClass: "box",
    attrs: {
      "cliente": _vm.clienteSeleccionado
    }
  }) : _vm._e(), (_vm.seleccionado) ? _c('client-equipo-list', {
    staticClass: "box",
    attrs: {
      "cliente": _vm.clienteSeleccionado
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-dialog', {
    attrs: {
      "width": "450",
      "min-height": "500"
    },
    on: {
      "click:outside": _vm.limpiarValoresConfirmacion
    },
    model: {
      value: (_vm.isModalConfirmacion),
      callback: function($$v) {
        _vm.isModalConfirmacion = $$v
      },
      expression: "isModalConfirmacion"
    }
  }, [_c('v-card', {
    staticClass: "pa-5"
  }, [_c('h2', {
    staticClass: "text-center font-weight-700 my-2"
  }, [_vm._v("¿Deseas continuar con la generación de  tickets?")]), _c('div', {
    staticClass: "my-2 ma-4"
  }, [_c('div', {
    staticClass: "d-flex ai-center jc-center py-2"
  }, [_c('v-icon', {
    attrs: {
      "size": "150",
      "color": "background"
    }
  }, [_vm._v(" control_point_duplicate")])], 1), (_vm.isUploadModal) ? _c('div', {
    staticClass: "d-flex my-4"
  }, [_c('v-file-input', {
    attrs: {
      "color": "primary",
      "label": "Adjuntar sustento para las series (boleta/factura)",
      "solo": "solo",
      "multiple": false,
      "dense": "dense",
      "placeholder": "Selecciona un archivo",
      "persistent-hint": "persistent-hint",
      "hint": "Es importante adjuntar el sustento por que hay series que se encuentran en garantia."
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var index = ref.index;
        var text = ref.text;

        return [(index < 2) ? _c('v-chip', {
          attrs: {
            "color": "primary",
            "dark": "",
            "label": "",
            "small": ""
          }
        }, [_vm._v(_vm._s(text))]) : (index === 2) ? _c('span', {
          staticClass: "text-overline grey--text text--darken-3 mx-2"
        }, [_vm._v("+" + _vm._s(_vm.files.length - 2) + " File(s)")]) : _vm._e()]
      }
    }], null, false, 2529350151),
    model: {
      value: (_vm.filesTickets),
      callback: function($$v) {
        _vm.filesTickets = $$v
      },
      expression: "filesTickets"
    }
  })], 1) : _vm._e(), _c('span', {
    staticClass: "text-muted font-size-11"
  }, [_vm._v("Este proceso generará " + _vm._s(_vm.equiposLista.length) + " tickets configurados previamente, Verificar.")])]), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "success",
      "block": "block",
      "small": !_vm.isMovil
    },
    on: {
      "click": _vm.fetchProcesoGenerarTickets
    }
  }, [_vm._v("Generar tickets")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "600",
      "min-height": "500"
    },
    on: {
      "click:outside": function($event) {
        return _vm.clsoeErroresEncontrados()
      }
    },
    model: {
      value: (_vm.isModalErroresEncontrados),
      callback: function($$v) {
        _vm.isModalErroresEncontrados = $$v
      },
      expression: "isModalErroresEncontrados"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "px-4 py-3"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700"
  }, [_vm._v("Validaciones")])]), _c('v-card', {
    staticClass: "overflow-y-auto elevation-0",
    attrs: {
      "max-height": "calc(100vh - 380px)"
    }
  }, _vm._l((_vm.erroresValidacion), function(e, index) {
    return _c('div', {
      key: index,
      staticClass: "pa-1 font-size-12 font-weight-700"
    }, [_vm._v("• " + _vm._s(e))])
  }), 0), _c('v-card-actions', {
    staticClass: "mt-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "block",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.clsoeErroresEncontrados()
      }
    }
  }, [_vm._v("Cerrar")])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-auto elevation-1"
  }, [_c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Generar tickets por plantilla")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Sube tu plantilla y edita los valores antes de generar")])], 1), (_vm.isMovil) ? _c('v-divider') : _vm._e(), (_vm.equiposLista.length) ? _c('v-card', {
    staticClass: "d-flex elevation-0 ai-center",
    class: {
      'ma-2': !_vm.isMovil
    }
  }) : _vm._e()], 1), _c('v-divider'), (_vm.equiposLista.length) ? _c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 192px)' : 'calc(100vh - 144px)'
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 295px)' : 'calc(100vh - 194px)',
      "fixed-header": "fixed-header",
      "headers": _vm.headers,
      "items": _vm.equiposLista,
      "dense": "dense",
      "hide-default-footer": "hide-default-footer",
      "disable-pagination": "disable-pagination"
    },
    scopedSlots: _vm._u([{
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [(item.status) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("check_circle")]) : _c('v-icon', {
          attrs: {
            "color": "warning"
          }
        }, [_vm._v("pending_actions")])]
      }
    }, {
      key: "item.usuario",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700",
          class: {
            'error--text': !item.usuario
          }
        }, [_vm._v(_vm._s(item.usuario || 'Es requerido'))])]
      }
    }, {
      key: "item.serie",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700",
          class: {
            'error--text': !item.serie
          }
        }, [_vm._v(_vm._s(item.serie || 'Es requerido'))])]
      }
    }, {
      key: "item.tipo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700",
          class: {
            'error--text': !item.tipo
          }
        }, [_vm._v(_vm._s(item.tipo || 'Es requerido'))])]
      }
    }, {
      key: "item.numeroFactura",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(item.numeroFactura))])]
      }
    }, {
      key: "item.sigueEnGarantia",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-checkbox', {
          staticClass: "ma-0",
          attrs: {
            "hide-details": "hide-details",
            "color": "primary",
            "disabled": "disabled"
          },
          model: {
            value: (item.sigueEnGarantia),
            callback: function($$v) {
              _vm.$set(item, "sigueEnGarantia", $$v)
            },
            expression: "item.sigueEnGarantia"
          }
        })]
      }
    }, {
      key: "item.comproAqui",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-checkbox', {
          staticClass: "ma-0",
          attrs: {
            "hide-details": "hide-details",
            "color": "primary",
            "disabled": "disabled"
          },
          model: {
            value: (item.comproAqui),
            callback: function($$v) {
              _vm.$set(item, "comproAqui", $$v)
            },
            expression: "item.comproAqui"
          }
        })]
      }
    }], null, false, 295122118)
  }), _c('v-divider'), _c('div', {
    staticClass: "pa-3 d-flex ai-center flex-wrap"
  }, [(!_vm.isMovil) ? _c('small', {
    staticClass: "text-muted font-size-11"
  }, [_vm._v("Mostrando " + _vm._s(_vm.equiposLista.length) + " registros")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    class: {
      'mx-2': !_vm.isMovil
    },
    attrs: {
      "color": "error",
      "small": !_vm.isMovil,
      "block": _vm.isMovil,
      "disabled": _vm.isLoadingProceso
    },
    on: {
      "click": function($event) {
        return _vm.volverASeleccionar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _c('span', [_vm._v("Volver adjuntar")])], 1), _c('v-btn', {
    class: {
      'mt-2': _vm.isMovil
    },
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil,
      "disabled": !_vm.equiposLista.length || _vm.isLoadingProceso
    },
    on: {
      "click": function($event) {
        return _vm.openModalValidarDatos()
      }
    }
  }, [_vm._v("Iniciar proceso")])], 1)], 1) : _c('v-card', {
    staticClass: "d-flex jc-center ai-center elevation-0 flex-wrap",
    attrs: {
      "height": "calc(100vh - 144px)",
      "id": "fileSelect"
    }
  }, [(_vm.renderInputFile) ? _c('input', {
    staticClass: "display-none",
    attrs: {
      "id": "fileElement",
      "type": "file",
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    on: {
      "change": _vm.decodedExcel
    }
  }) : _vm._e(), _c('v-card', {
    staticClass: "ma-4 d-flex ai-center jc-center fd-column pa-8",
    attrs: {
      "width": _vm.isMovil ? '100%' : 300,
      "height": _vm.isMovil ? 220 : 300,
      "color": "primary white--text",
      "hover": "hover"
    },
    on: {
      "click": _vm.adjuntarFileExcel
    }
  }, [_c('v-icon', {
    staticClass: "animated fadeInUp",
    attrs: {
      "size": "60"
    }
  }, [_vm._v("cloud_upload")]), _c('h1', {
    staticClass: "font-weight-700 animated fadeInLeft"
  }, [_vm._v("Adjuntar")])], 1), _c('v-card', {
    staticClass: "ma-4 d-flex ai-center jc-center fd-column pa-8",
    attrs: {
      "width": _vm.isMovil ? '100%' : 300,
      "height": _vm.isMovil ? 220 : 300,
      "color": "secondary primary--text",
      "hover": "hover"
    },
    on: {
      "click": _vm.fetchDescargarPlantilla
    }
  }, [_c('v-icon', {
    staticClass: "animated fadeInDown",
    attrs: {
      "size": "60",
      "color": "primary"
    }
  }, [_vm._v("cloud_download")]), _c('h1', {
    staticClass: "font-weight-700 animated fadeInLeft"
  }, [_vm._v("Plantilla")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('editar-datos-usuario', {
    attrs: {
      "username": _vm.usuario,
      "validar": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": _vm.isMovil ? '100%' : '450',
      "fullscreen": _vm.isMovil,
      "hide-overlay": _vm.isMovil
    },
    model: {
      value: (_vm.showModalFormEvent),
      callback: function($$v) {
        _vm.showModalFormEvent = $$v
      },
      expression: "showModalFormEvent"
    }
  }, [(_vm.showModalFormEvent) ? _c('form-cita', {
    attrs: {
      "id": _vm.idCita
    },
    on: {
      "close": function($event) {
        return _vm.closeModalEventSelected()
      },
      "update": _vm.getEvents
    }
  }) : _vm._e()], 1), _c('v-card', {
    staticClass: "mx-auto elevation-1"
  }, [_c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Programación de citas")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Crea, edita y elimina algunas citas")])], 1), (_vm.isMovil) ? _c('v-divider') : _vm._e(), _c('v-card', {
    staticClass: "d-flex elevation-0 ai-center",
    class: {
      'ma-2': !_vm.isMovil
    }
  }, [_c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "fab": "fab",
      "small": "small",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.calendar.prev()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _c('v-select', {
    staticClass: "ma-1",
    attrs: {
      "items": _vm.types,
      "item-text": "label",
      "item-value": "value",
      "dense": "",
      "solo": "solo",
      "hide-details": "",
      "label": "Visualizar por"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "fab": "fab",
      "small": "small",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.calendar.next()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "success",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.showEvent()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "info",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.getEvents()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1)], 1)], 1), _c('v-sheet', {
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 183px)' : 'calc(100vh - 133px)'
    }
  }, [_c('v-calendar', {
    ref: "calendar",
    attrs: {
      "event-ripple": false,
      "first-time": _vm.horaInicioDeIntervalo,
      "interval-count": _vm.countIntervals,
      "color": "primary",
      "type": _vm.type,
      "interval-minutes": _vm.intervaloProgramacionCitas,
      "events": _vm.events,
      "short-weekdays": _vm.isMovil,
      "weekdays": _vm.weekday,
      "interval-format": _vm.intervalFormatter,
      "interval-height": _vm.isMovil ? 40 : 27,
      "event-color": _vm.checkBGColorEvent,
      "event-text-color": _vm.checkColorEvent
    },
    on: {
      "change": _vm.getEvents,
      "click:event": _vm.showEvent,
      "click:date": _vm.showDay
    },
    scopedSlots: _vm._u([{
      key: "event",
      fn: function(ref) {
        var event = ref.event;
        var timed = ref.timed;
        var eventSummary = ref.eventSummary;

        return [_c('div', {
          staticClass: "v-event-draggable animated fadeInUp faster my-event",
          attrs: {
            "dark": "dark",
            "width": "100%"
          }
        }, [_c('v-chip', {
          staticClass: "px-2 mx-1",
          attrs: {
            "color": event.ingresadoAtaller ? 'success white--text' : 'orange white--text',
            "dark": event.ingresadoAtaller ? true : false,
            "x-small": "x-small",
            "to": !_vm.isMovil ? ("/ticket/" + (event.numeroTicket)) : ''
          }
        }, [_c('v-icon', {
          attrs: {
            "size": _vm.isMovil ? 2 : 6,
            "color": event.ingresadoAtaller ? 'white' : ''
          }
        }, [_vm._v("circle")]), _c('span', {
          class: {
            'white--text': event.ingresadoAtaller, 'font-size-10': _vm.isMovil, 'font-weight-700': !_vm.isMovil
          }
        }, [_vm._v(" " + _vm._s(("" + (event.numeroTicket))))])], 1), _c('span', {
          class: _vm.isMovil ? 'font-size-10' : ' font-size-11 font-weight-700'
        }, [_vm._v(" " + _vm._s(event.name && event.name.split(' - ')[0]) + " ")]), (!_vm.isMovil) ? _c('v-spacer') : _vm._e()], 1)]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', [_c('v-col', {
    staticClass: "pb-0 pr-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.isModalCambiosEnTicket),
      callback: function($$v) {
        _vm.isModalCambiosEnTicket = $$v
      },
      expression: "isModalCambiosEnTicket"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Cambios en el ticket")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Todos los procesos se aplicaran al numero de ticket")]), _c('div', {
    staticClass: "d-flex pa-3 fd-column"
  }, [_c('v-card', {
    staticClass: "flex-1 mb-3 pa-4",
    attrs: {
      "color": "background"
    }
  }, [_c('p', {
    staticClass: "mb-2 font-weight-700 primary--text"
  }, [_vm._v("Cambiar a un estado en especifico")]), _c('v-select', {
    attrs: {
      "hide-details": "hide-details",
      "items": _vm.estadosTicket,
      "item-value": "codigo",
      "item-text": "descripcion",
      "loading": _vm.isLoadingEstadosACambiar,
      "label": "Seleccionar estado",
      "dense": "",
      "solo": ""
    },
    model: {
      value: (_vm.estadoTicket),
      callback: function($$v) {
        _vm.estadoTicket = $$v
      },
      expression: "estadoTicket"
    }
  }), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "success",
      "block": "block",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchCambiarEstadoTicket()
      }
    }
  }, [_c('span', [_vm._v("Guardar cambios")])])], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-8"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "color": "primary",
      "small": "small",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogCambiosTicket()
      }
    }
  }, [_vm._v("regresar")])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "rounded": "0"
    }
  }, [_c('v-card-text', {
    staticClass: "py-3"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    staticClass: "mr-4",
    attrs: {
      "label": "Numero",
      "dense": "dense",
      "hide-details": "hide-details",
      "solo": "solo"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.resetLogsData(), _vm.fetchTickets()
      }
    },
    model: {
      value: (_vm.numeroTicket),
      callback: function($$v) {
        _vm.numeroTicket = $$v
      },
      expression: "numeroTicket"
    }
  }), _c('v-select', {
    staticClass: "mr-4",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "items": ['todos', 'garantia', 'incidencia con equipo', 'solicitud de insumo'],
      "label": "Tipo",
      "solo": "solo"
    },
    on: {
      "change": function($event) {
        _vm.resetLogsData(), _vm.fetchTickets()
      }
    },
    model: {
      value: (_vm.tipo),
      callback: function($$v) {
        _vm.tipo = $$v
      },
      expression: "tipo"
    }
  })], 1)]), _c('v-divider', {
    staticClass: "pa-0 ma-0"
  })], 1), _c('v-card', {
    staticClass: "box-logs",
    attrs: {
      "rounded": "0"
    }
  }, [_c('v-list', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "py-0",
    attrs: {
      "dense": "dense",
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('ticket-summary-info', {
      key: index,
      staticClass: "animated fadeInUp faster",
      attrs: {
        "ticket": o,
        "handler": true
      },
      on: {
        "href": function($event) {
          return _vm.fetchLogs(o.numero, index)
        }
      }
    })
  }), 1)], 1)], 1), _c('v-col', {
    staticClass: "pb-0 pr-0 pl-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "rounded": "0"
    }
  }, [_c('v-card-text', {
    staticClass: "py-3"
  }, [_c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [(_vm.indexSeleccionado !== '') ? _c('span', {
    staticClass: "font-weight-700 font-size-21 primary--text"
  }, [_vm._v(" " + _vm._s(("#" + (_vm.lista[_vm.indexSeleccionado].numero))))]) : _vm._e(), _c('v-spacer'), _c('span', [_vm._v(" ")]), (_vm.indexSeleccionado !== '') ? _c('div', {
    staticClass: "d-flex"
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "small",
      "color": "success",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDialogCambiosTicket()
      }
    }
  }, [_vm._v("realizar cambios")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-select', {
    staticClass: "mr-4",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "items": _vm.accionesActividades,
      "label": "Buscar por accion",
      "solo": "solo"
    },
    on: {
      "change": _vm.filtrarPorAccion
    },
    model: {
      value: (_vm.accion),
      callback: function($$v) {
        _vm.accion = $$v
      },
      expression: "accion"
    }
  })], 1)], 1)]), _c('v-divider', {
    staticClass: "pa-0 ma-0"
  })], 1), _c('v-card', {
    staticClass: "box-logs elevation-1",
    class: {
      'jc-center ai-center d-flex': !_vm.logs.length
    },
    attrs: {
      "rounded": "0"
    }
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-text', [(_vm.logs.length) ? _c('div', [_c('div', {
    staticClass: "font-weight-bold ml-8 mb-2"
  }, [_vm._v("Hoy")]), _c('v-timeline', {
    attrs: {
      "align-top": "",
      "dense": ""
    }
  }, _vm._l((_vm.logs), function(a, index) {
    return _c('v-timeline-item', {
      key: index,
      staticClass: "pb-4",
      attrs: {
        "color": "primary",
        "small": ""
      }
    }, [_c('div', [_c('div', {
      staticClass: "font-weight-normal"
    }, [_c('span', {
      staticClass: "font-weight-700 font-size-12"
    }, [_vm._v(_vm._s(a.usuario) + "  ")]), _c('v-icon', {
      attrs: {
        "size": "13"
      }
    }, [_vm._v("access_time")]), _c('small', [_vm._v(" " + _vm._s(_vm._f("now")(a.fecha)) + " - " + _vm._s(_vm._f("formatDate")(a.fecha)))])], 1), (a.numeroActividad) ? _c('v-menu', {
      attrs: {
        "transition": "slide-y-transition",
        "bottom": "",
        "close-on-content-click": false
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "mr-3",
            attrs: {
              "x-small": "",
              "color": "info",
              "dark": ""
            },
            on: {
              "click": function($event) {
                return _vm.fetchActividad(a.numeroActividad)
              }
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', {
            staticClass: "mr-1",
            attrs: {
              "size": "14"
            }
          }, [_vm._v("visibility")]), _vm._v("activ. (" + _vm._s(a.numeroActividad) + ")")], 1)]
        }
      }], null, true)
    }, [_c('span', [(_vm.isLoadingActividad) ? _c('v-progress-linear', {
      attrs: {
        "indeterminate": "indeterminate",
        "color": "primary"
      }
    }) : _c('item-actividad', {
      attrs: {
        "actividad": _vm.actividad,
        "is-log": "is-log"
      }
    })], 1)]) : _vm._e(), _c('span', {
      staticClass: "font-weight-700 info--text font-size-11"
    }, [_vm._v(_vm._s(a.accion))])], 1)])
  }), 1)], 1) : _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No existen logs para mostrar")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Seleccione un ticket para obtener el listado de logs")])], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": "dense",
      "nav": "nav"
    }
  }, [(_vm.procesos && !_vm.procesos.length) ? _c('div', {
    staticClass: "d-flex fd-column flex-1"
  }, _vm._l((3), function(a) {
    return _c('div', [_c('v-skeleton-loader', {
      attrs: {
        "type": "list-item-avatar-two-line"
      }
    }), _c('v-skeleton-loader', {
      attrs: {
        "type": "divider"
      }
    })], 1)
  }), 0) : _vm._l((_vm.procesos), function(o, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          o.done && _vm.downloadFile(o)
        }
      }
    }, [_c('v-list-item-avatar', [(!o.done && !o.error) ? _c('v-progress-circular', {
      attrs: {
        "indeterminate": "",
        "color": "primary",
        "width": 3
      }
    }) : _vm._e(), (o.done) ? _c('v-icon', {
      staticClass: "background success--text"
    }, [_vm._v("check_circle")]) : (o.error) ? _c('v-icon', {
      staticClass: "background error--text"
    }, [_vm._v("close")]) : _vm._e()], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "font-size-12"
    }, [_vm._v(_vm._s(o.name))]), (o.done) ? _c('v-list-item-subtitle', {
      staticClass: "text-muted font-size-11"
    }, [_vm._v("Terminó en  " + _vm._s(o.time))]) : (o.error) ? _c('v-list-item-subtitle', {
      staticClass: "font-size-11 error--text"
    }, [_vm._v("Error: " + _vm._s(o.message))]) : (!o.done && !o.error) ? _c('v-list-item-subtitle', {
      staticClass: "font-size-11 info--text"
    }, [_vm._v("Exportando...")]) : _vm._e()], 1), _c('v-list-item-action', [_c('div', {
      staticClass: "d-flex"
    }, [_c('v-btn', {
      attrs: {
        "disabled": !o.done,
        "fab": "fab",
        "color": "info white--text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.downloadFile(o)
        }
      }
    }, [_c('v-icon', [_vm._v(" arrow_downward")])], 1), _c('v-btn', {
      staticClass: "ml-3",
      attrs: {
        "disabled": !o.done,
        "fab": "fab",
        "color": "white error--text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.eliminar(o.id)
        }
      }
    }, [_c('v-icon', [_vm._v(" delete")])], 1)], 1)])], 1)
  }), _c('div', {
    staticClass: "d-flex ma-2 mt-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "error",
      "block": "block",
      "small": !_vm.isMovil,
      "loading": !_vm.procesos.length,
      "disabled": !_vm.procesos.length
    },
    on: {
      "click": function($event) {
        return _vm.eliminarTodasLasDescargas()
      }
    }
  }, [_vm._v("Eliminar  descargas")])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.tickets,
      "label": "Listado de tickets disponibles",
      "placeholder": "Realiza la busqueda por la desripción",
      "dense": "dense",
      "item-value": "numero",
      "item-text": "numero",
      "return-object": "return-object",
      "solo": "solo",
      "hide-details": "hide-details"
    },
    on: {
      "change": _vm.seleccionarTicket
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('div', _vm._b({
          staticClass: "d-flex"
        }, 'div', data.attrs, false), [_c('span', {
          staticClass: "font-weight-700 success--text"
        }, [_vm._v(_vm._s(("#" + (data.item.numero))) + ",")]), _c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v("  " + _vm._s(data.item.razonSocial) + "  ")]), (data.item.serie) ? _c('span', {
          staticClass: "grey--text font-size-11"
        }, [_vm._v("-   " + _vm._s(data.item.serie) + "  ")]) : _vm._e()])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-card', {
          staticClass: "elevation-0",
          attrs: {
            "width": "520"
          }
        }, [_c('ticket-summary-info', {
          key: data.item.numero,
          staticClass: "animated fadeInUp faster",
          attrs: {
            "ticket": data.item,
            "handler": true
          },
          on: {
            "href": function () {}
          }
        })], 1)]
      }
    }]),
    model: {
      value: (_vm.numeroTicket),
      callback: function($$v) {
        _vm.numeroTicket = $$v
      },
      expression: "numeroTicket"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex jc-center ai-center fd-column pa-4"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 45,
      "width": 4,
      "color": "primary",
      "indeterminate": ""
    }
  }), _c('span', {
    staticClass: "mt-4 font-weight-700"
  }, [_vm._v("Estamos activando tu cuenta")])], 1)
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-sheet', {
    staticClass: "pa-4",
    class: _vm.showDetails ? 'secondary' : 'primary'
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.isMovil || !_vm.isMovil && _vm.showDetails) ? _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "fab": "fab",
      "icon": "icon",
      "small": "small"
    },
    on: {
      "click": function($event) {
        _vm.showDetails ? _vm.closeOpciones() : _vm.close()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.showDetails ? 'primary' : 'white',
      "size": "25"
    }
  }, [_vm._v("arrow_back")])], 1) : _vm._e(), (!_vm.showDetails) ? _c('v-text-field', {
    attrs: {
      "dense": "dense",
      "label": "Buscar en configuraciones",
      "dark": "",
      "flat": "",
      "solo-inverted": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    on: {
      "input": _vm.buscarValor
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _c('div', {
    staticClass: "d-flex flex-1 ai-center"
  }, [_c('span', {
    staticClass: "primary--text font-weight-700 font-size-20"
  }, [_vm._v(_vm._s(_vm.showOptions.titulo))]), _c('v-spacer')], 1)], 1)]), (_vm.showAlertReload) ? _c('v-alert', {
    attrs: {
      "prominent": "",
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('small', [_vm._v("Al realizar cualquier cambio en las configuraciones de la aplicacion es recomendable presionar F5 o darle click en el siguiente boton")]), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "white warning--text",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.reloadPage()
      }
    }
  }, [_vm._v("Actualizar pagina")])], 1), _c('v-btn', {
    attrs: {
      "small": "small",
      "icon": "icon"
    },
    on: {
      "click": function($event) {
        return _vm.closeAlertReload()
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1)]) : _vm._e(), _c('div', {
    staticClass: "box-settings",
    class: _vm.showAlertReload ? 'reload' : ''
  }, [(_vm.configuraciones.length && !_vm.showDetails) ? _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense",
      "flat": "flat",
      "two-line": ""
    }
  }, [_vm._l((_vm.configuraciones), function(c, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.openOpciones(c)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', {
      staticClass: "background"
    }, [_vm._v(_vm._s(c.icon))])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(c.titulo))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(c.subtitulo))])], 1), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v(" chevron_right")])], 1)], 1)], 1)
  }), _c('v-list-item', [_c('v-list-item-content', [_c('theme-provider')], 1)], 1)], 2) : _vm._e(), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense",
      "flat": "",
      "two-line": ""
    }
  }, [(_vm.showDetails && _vm.showOptions.key === 'general') ? _c('v-list-item', [_c('v-list-item-content', {
    staticClass: "py-6"
  }, [_c('v-list-item-title', [_vm._v("Habilitar Modo Oscuro")]), _c('v-list-item-subtitle', {
    staticClass: "font-size-12"
  }, [_vm._v("Alarga la duración de la batería, Reduce la fatiga visual, Ayuda a la lectura etc.")])], 1), _c('v-list-item-action', [_c('v-switch', {
    attrs: {
      "dense": "dense"
    },
    model: {
      value: (_vm.isDark),
      callback: function($$v) {
        _vm.isDark = $$v
      },
      expression: "isDark"
    }
  })], 1)], 1) : _vm._e()], 1), (_vm.search && !_vm.configuraciones.length) ? _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-alert', {
    attrs: {
      "text": "",
      "dense": "dense",
      "type": "error",
      "icon": "settings"
    }
  }, [_c('small', [_vm._v("Ninguna coincidencia para esta busqueda")])])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex mx-4 my-2"
  }, [_c('v-btn', {
    attrs: {
      "color": "success",
      "dark": "dark",
      "block": "block",
      "small": !_vm.isMovil
    },
    on: {
      "click": _vm.fetchGuardarConfiguraciones
    }
  }, [_vm._v("Guardar configuraciones")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Tickets")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  cerrados ")]), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v(" " + _vm._s(_vm.tipo && _vm.tipo.toLowerCase()) + " (Duración en dias y horas)")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Listado general de tickets cerrados ordenados por duracion")])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.lineChart.fetchTicketsCerrados()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v("Actualizar")], 1)], 1), _c('v-divider'), (_vm.count) ? _c('div', {
    staticClass: "d-flex mx-1"
  }, [_c('div', {
    staticClass: "flex-1 ma-2"
  }, [_c('v-card', {
    staticClass: "pa-2 text-xs-center elevation-1",
    attrs: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center jc-center fd-column"
  }, [_c('div', {
    staticClass: "display-1 font-weight-700"
  }, [_vm._v(_vm._s(_vm.cantidadTicketsCerrados))]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Total de tickets")])])])], 1)]) : _vm._e(), (_vm.renderChart) ? _c('line-chart', {
    ref: "lineChart",
    attrs: {
      "tipo": _vm.tipo,
      "desde": _vm.desde,
      "hasta": _vm.hasta
    },
    on: {
      "count": _vm.obtenerCantidad
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "d-flex fd-column flex-1"
  }, [(_vm.modoLista) ? _c('div', _vm._l((5), function(a) {
    return _c('div', [_c('v-skeleton-loader', {
      attrs: {
        "type": "list-item-avatar-two-line"
      }
    }), _c('v-skeleton-loader', {
      attrs: {
        "type": "divider"
      }
    })], 1)
  }), 0) : _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  })], 1)]) : _c('div', [(_vm.modoLista) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "dense",
      "nav": "nav"
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "active-class": "primary--text",
      "mandatory": "mandatory"
    },
    on: {
      "change": _vm.seleccionarUsuario
    },
    model: {
      value: (_vm.seleccionado),
      callback: function($$v) {
        _vm.seleccionado = $$v
      },
      expression: "seleccionado"
    }
  }, [_vm._l((_vm.lista), function(e, index) {
    return [_c('v-list-item', {
      key: index,
      attrs: {
        "value": e
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;

          return [_c('v-list-item-avatar', [_c('img', {
            attrs: {
              "src": e.foto ? e.foto : '/static/nobody.jpg'
            }
          })]), _c('v-list-item-content', [_c('v-list-item-title', [_c('span', {
            staticClass: "font-weight-700"
          }, [_vm._v(_vm._s(e.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
            staticClass: "font-size-11"
          }, [_vm._v(_vm._s(e.cargo))])])], 1)]
        }
      }], null, true)
    })]
  })], 2)], 1) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.lista,
      "loading": _vm.isLoading,
      "disabled": _vm.isLoading,
      "item-text": "usuario",
      "label": _vm.multiple ? 'Selecciona varias opciones' : 'Selecciona una opcion',
      "placeholder": "Ingrese un nombre para buscar",
      "return-object": "",
      "dense": "dense",
      "chips": "chips",
      "solo": _vm.noSolo,
      "hide-details": "hide-details",
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.seleccionarUsuario
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', _vm._b({
          staticClass: "pa-4 ma-1",
          attrs: {
            "color": "background",
            "close": "close",
            "input-value": data.selected
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              data.select, _vm.showModal(data.item)
            },
            "click:close": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, 'v-chip', data.attrs, false), [_c('v-avatar', {
          attrs: {
            "left": ""
          }
        }, [_c('v-img', {
          attrs: {
            "src": data.item.foto ? data.item.foto : '/static/nobody.jpg'
          }
        })], 1), _c('div', {
          staticClass: "d-flex fd-column line-height-title"
        }, [_c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(data.item.nombre))]), _c('small', {
          staticClass: "blue--text font-size-11"
        }, [_vm._v(_vm._s(data.item.perfil))])])], 1)]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": data.item.foto ? data.item.foto : '/static/nobody.jpg'
          }
        })]), _c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-size-12 font-weight-700",
          domProps: {
            "innerHTML": _vm._s(data.item.nombre)
          }
        }), _c('v-list-item-subtitle', [_c('div', {
          staticClass: "d-flex"
        }, [_c('span', {
          staticClass: "font-size-12"
        }, [_vm._v(_vm._s(data.item.usuario))]), _c('span', {
          staticClass: "font-size-11 ml-3 primary--text"
        }, [_vm._v("(" + _vm._s(data.item.perfil) + ")")])])])], 1), (data.item.rutaSctr) ? _c('v-list-item-action', [_c('v-btn', {
          attrs: {
            "fab": "fab",
            "color": "white primary--text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.verPdfSctr(data.item.rutaSctr)
            }
          }
        }, [_c('v-icon', [_vm._v("picture_as_pdf")])], 1)], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.seleccionado),
      callback: function($$v) {
        _vm.seleccionado = $$v
      },
      expression: "seleccionado"
    }
  }), _c('v-dialog', {
    attrs: {
      "bottom": "",
      "width": "400",
      "right": "",
      "transition": "scale-transition",
      "origin": "top left"
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-card', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.usuarioDetalles.foto ? _vm.usuarioDetalles.foto : '/static/nobody.jpg',
      "contain": "contain",
      "max-height": "400"
    }
  }), _c('v-list', {
    attrs: {
      "color": "primary",
      "dark": "dark",
      "dense": "dense"
    }
  }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.usuarioDetalles.nombre))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.usuarioDetalles.usuario) + " - " + _vm._s(_vm.usuarioDetalles.cargo))])], 1), (_vm.usuarioDetalles.rutaSctr) ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "color": "white primary--text"
    },
    on: {
      "click": function($event) {
        return _vm.verPdfSctr()
      }
    }
  }, [_c('v-icon', [_vm._v("picture_as_pdf")])], 1)], 1) : _vm._e()], 1), (_vm.showChangeFoto) ? _c('v-list-item', [_c('v-list-item-content', [_c('v-btn', {
    attrs: {
      "small": !_vm.isMovil,
      "block": "block",
      "color": "white primary--text"
    },
    on: {
      "click": function($event) {
        return _vm.seleccionarFotoPerfil()
      }
    }
  }, [_vm._v("Cambiar foto de perfil")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "450",
      "max-height": "calc(100vh - 150px)",
      "origin": "top right",
      "offset-y": "offset-y",
      "transition": "slide-y-transition"
    },
    model: {
      value: (_vm.showNewTicketDispatcher),
      callback: function($$v) {
        _vm.showNewTicketDispatcher = $$v
      },
      expression: "showNewTicketDispatcher"
    }
  }, [_c('card-generate-ticket', {
    on: {
      "close": _vm.closeGenerarNuevoTicket
    }
  })], 1), _c('v-navigation-drawer', {
    attrs: {
      "width": _vm.isMovil ? '100%' : '380',
      "app": "app",
      "temporary": "temporary",
      "dense": "dense",
      "right": "right"
    },
    on: {
      "input": function($event) {
        !_vm.drawer_settings && _vm.$refs.configuraciones.close()
      }
    },
    model: {
      value: (_vm.drawer_settings),
      callback: function($$v) {
        _vm.drawer_settings = $$v
      },
      expression: "drawer_settings"
    }
  }, [_c('configuraciones-app', {
    ref: "configuraciones",
    on: {
      "close": function($event) {
        _vm.drawer_settings = false
      }
    }
  })], 1), _c('v-navigation-drawer', {
    attrs: {
      "dense": "dense",
      "app": "app"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('div', {
          staticClass: "pa-2"
        }, [_c('v-btn', {
          attrs: {
            "block": "",
            "small": !_vm.isMovil,
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.logout()
            }
          }
        }, [_vm._v("Cerrar sesión")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.mini),
      callback: function($$v) {
        _vm.mini = $$v
      },
      expression: "mini"
    }
  }, [_c('v-list', {
    staticClass: "py-1",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    attrs: {
      "to": "/",
      "color": !_vm.$vuetify.theme.dark ? 'white' : ''
    }
  }, [_c('v-list-item-title', [_c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/logo.png",
      "width": "55%"
    }
  }), _c('v-spacer'), _c('v-chip', {
    attrs: {
      "color": "primary"
    }
  }, [_c('small', {
    staticClass: "font-size-12"
  }, [_vm._v("Help Desk")])])], 1)])], 1)], 1), _c('v-divider'), _c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_vm._l((_vm.menu), function(m, index) {
    return [(m.children && m.children.length) ? _c('v-list-group', {
      attrs: {
        "value": false,
        "prepend-icon": m.icon,
        "no-action": "no-action"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function() {
          return [_c('v-list-item-title', [_vm._v(_vm._s(m.name))])]
        },
        proxy: true
      }], null, true)
    }, _vm._l((m.children), function(child, index2) {
      return _c('v-list-item', {
        key: index2,
        attrs: {
          "to": child.path,
          "link": "link"
        }
      }, [_c('v-list-item-icon', [_c('v-icon', {
        domProps: {
          "textContent": _vm._s(child.icon)
        }
      })], 1), _c('v-list-item-title', {
        domProps: {
          "textContent": _vm._s(child.name)
        }
      }), (_vm.abiertos[child.key]) ? _c('v-chip', {
        attrs: {
          "color": "primary",
          "x-small": "x-small",
          "label": "label"
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.abiertos[child.key]))])]) : _vm._e()], 1)
    }), 1) : _c('v-list-item', {
      attrs: {
        "active-class": "secondary primary--text",
        "to": m.path,
        "link": "link"
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(m.icon))])], 1), _c('v-list-item-title', [_vm._v(_vm._s(m.name))]), (_vm.abiertos[m.key]) ? _c('v-chip', {
      attrs: {
        "color": "primary",
        "x-small": "x-small",
        "label": "label"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.abiertos[m.key]))])]) : _vm._e()], 1)]
  })], 2)], 1), _c('v-app-bar', {
    staticClass: "elevation-1",
    attrs: {
      "app": "app",
      "dense": "dense",
      "color": !_vm.$vuetify.theme.dark ? 'white' : ''
    }
  }, [_c('v-app-bar-nav-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }), _c('v-spacer'), (_vm.perfil === 'dispatcher') ? _c('v-btn', {
    staticClass: "ma-5",
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.goToGenerarTicket()
      }
    }
  }, [_vm._v("Nuevo ticket")]) : _vm._e(), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-chip', _vm._g(_vm._b({
          staticClass: "pa-4",
          attrs: {
            "label": "label",
            "to": "/profile",
            "color": "background"
          }
        }, 'v-chip', attrs, false), on), [_c('v-avatar', {
          attrs: {
            "left": "left"
          }
        }, [_c('avatar-perfil', {
          attrs: {
            "usuario": _vm.username,
            "is-fetch": true
          }
        })], 1), _c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(_vm.nombre))])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Perfil de tu cuenta")])]), _c('notificaciones-app'), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "icon"
          },
          on: {
            "click": function($event) {
              _vm.drawer_settings = !_vm.drawer_settings
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("tune")])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Configuraciones de la aplicacion")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-clientes"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Equipos del cliente " + _vm._s(_vm.cliente.nombre))])]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_vm._v(_vm._s(o.serie))]), _c('td', [_vm._v(_vm._s(o.modelo))]), _c('td', [_vm._v(_vm._s(o.descripcion))]), _c('td', [_vm._v(_vm._s(o.numeroContrato))]), _c('td', [_vm._v(_vm._s(o.descripcionTipoContrato))]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.remover(o)
        }
      }
    }, [_vm._v("Eliminar")])])])])
  }), 0)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Serie")]), _c('th', [_vm._v("Modelo")]), _c('th', [_vm._v("Descripcion")]), _c('th', [_vm._v("Contrato")]), _c('th', [_vm._v("Tipo de contrato")]), _c('th')])
}]}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mx-auto elevation-0"
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-700 font-size-16"
  }, [_vm._v(_vm._s(_vm.datos.nombreArticulo))]), _c('v-list-item-subtitle', {
    staticClass: "font-size-12"
  }, [_vm._v(_vm._s(_vm.datos.codigoArticulo) + " - " + _vm._s(_vm.datos.modelo) + " - " + _vm._s(_vm.datos.linea))])], 1)], 1)], 1), _c('v-divider', {
    staticClass: "mx-4"
  }), _c('v-card-text', [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [(_vm.showImageMarca) ? _c('v-list-item', {
    staticClass: "py-1"
  }, [_c('v-list-item-content', [_c('v-img', {
    attrs: {
      "src": (_vm.apiUpload + "/upload/octopus/marcas/" + (_vm.datos.marca) + ".jpg"),
      "width": "90",
      "height": "90",
      "contain": "contain"
    }
  })], 1)], 1) : _vm._e(), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("circle")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v("Codigo nuevo articulo")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.datos.codigoArticuloNuevo
    }
  }, [_vm._v(_vm._s(_vm.datos.codigoArticuloNuevo ? _vm.datos.codigoArticuloNuevo : 'No se cuenta con codigo nuevo'))])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v("Cliente")]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.datos.nombreCliente) + " - " + _vm._s(_vm.datos.codigoClienteSap))])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("place")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v("Direccion")]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.datos.direccion) + " -  " + _vm._s(_vm.datos.codigoPostal))])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("description")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(" Fatura electronica")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.datos.factura
    }
  }, [_vm._v(_vm._s(_vm.datos.factura ? _vm.datos.factura : 'No se encontró ninguna factura o boleta'))])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("event_available")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(" Fecha de venta")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.datos.fechaVenta
    }
  }, [_vm._v(_vm._s(_vm.datos.fechaVenta ? _vm.datos.fechaVenta : 'No se especifico'))])], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "small",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cerrar ventana")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-clientes"
  }, [(_vm.seleccionado) ? _c('div', [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Cliente " + _vm._s(_vm.clienteSeleccionado.codigo) + " " + _vm._s(_vm.clienteSeleccionado.nombre) + " seleccionado")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.deseleccionar
    }
  }, [_vm._v("Deseleccionar")])]) : _c('div', [_vm._m(0), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "button is-small",
    class: {
      'is-loading': _vm.isUpdating
    },
    on: {
      "click": _vm.actualizarTodos
    }
  }, [_vm._v("Actualizar todos")])]), _c('div', {
    staticClass: "agregar"
  }, [_c('span', [_vm._v("Ingresa el codigo del cliente para agregregarlo")]), _c('div', {
    staticClass: "field d-flex ai-center jc-center"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('v-text-field', {
    staticClass: "is-empresa",
    attrs: {
      "type": "number",
      "label": "Codigo de cliente",
      "solo": "solo",
      "dense": "dense"
    },
    model: {
      value: (_vm.codigoClienteAgregar),
      callback: function($$v) {
        _vm.codigoClienteAgregar = $$v
      },
      expression: "codigoClienteAgregar"
    }
  })], 1)]), _c('button', {
    staticClass: "button is-small",
    class: {
      'is-loading': _vm.isAdding
    },
    on: {
      "click": _vm.agregar
    }
  }, [_vm._v("Agregar")])]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(1), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_vm._v(_vm._s(o.codigo))]), _c('td', [_vm._v(_vm._s(o.nombre))]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.ver(o)
        }
      }
    }, [_vm._v("Ver")]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.remove(o)
        }
      }
    }, [_vm._v("Eliminar")])])])])
  }), 0)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Clientes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Codigo")]), _c('th', [_vm._v("Nombre")]), _c('th')])
}]}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-clientes"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Usuarios del cliente " + _vm._s(_vm.cliente.nombre))])]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, [_vm._l((_vm.lista), function(o) {
    return _c('tr', {
      key: "o",
      staticClass: "row-table"
    }, [(!o.isEditing) ? [_c('td', [_vm._v(_vm._s(o.usuario))]), _c('td', [_vm._v(_vm._s(o.nombre))]), _c('td', [_vm._v(_vm._s(o.cargo))]), _c('td', [_vm._v(_vm._s(o.telefono))]), _c('td', [_vm._v(_vm._s(o.password))]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          o.isEditing = true
        }
      }
    }, [_vm._v("Editar")]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.remover(o)
        }
      }
    }, [_vm._v("Eliminar")])])])] : [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.usuario),
        expression: "o.usuario"
      }],
      domProps: {
        "value": (o.usuario)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "usuario", $event.target.value)
        }
      }
    })]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.nombre),
        expression: "o.nombre"
      }],
      domProps: {
        "value": (o.nombre)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "nombre", $event.target.value)
        }
      }
    })]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.cargo),
        expression: "o.cargo"
      }],
      domProps: {
        "value": (o.cargo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "cargo", $event.target.value)
        }
      }
    })]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.telefono),
        expression: "o.telefono"
      }],
      domProps: {
        "value": (o.telefono)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "telefono", $event.target.value)
        }
      }
    })]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.password),
        expression: "o.password"
      }],
      domProps: {
        "value": (o.password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "password", $event.target.value)
        }
      }
    })]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": function($event) {
          return _vm.guardar(o)
        }
      }
    }, [_vm._v("Guardar")]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          o.isEditing = false
        }
      }
    }, [_vm._v("Cancelar")])])])]], 2)
  }), (_vm.isAdding) ? [_c('tr', {
    key: "nuevo",
    staticClass: "row-table"
  }, [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevo.usuario),
      expression: "nuevo.usuario"
    }],
    domProps: {
      "value": (_vm.nuevo.usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevo, "usuario", $event.target.value)
      }
    }
  })]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevo.nombre),
      expression: "nuevo.nombre"
    }],
    domProps: {
      "value": (_vm.nuevo.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevo, "nombre", $event.target.value)
      }
    }
  })]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevo.cargo),
      expression: "nuevo.cargo"
    }],
    domProps: {
      "value": (_vm.nuevo.cargo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevo, "cargo", $event.target.value)
      }
    }
  })]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevo.telefono),
      expression: "nuevo.telefono"
    }],
    domProps: {
      "value": (_vm.nuevo.telefono)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevo, "telefono", $event.target.value)
      }
    }
  })]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevo.password),
      expression: "nuevo.password"
    }],
    domProps: {
      "value": (_vm.nuevo.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevo, "password", $event.target.value)
      }
    }
  })]), _c('td', [_c('div', {
    staticClass: "contenedor-acciones"
  }, [_c('button', {
    staticClass: "button is-small is-primary",
    on: {
      "click": function($event) {
        return _vm.insertar()
      }
    }
  }, [_vm._v("Guardar")]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        _vm.isAdding = false
      }
    }
  }, [_vm._v("Cancelar")])])])])] : _vm._e()], 2)], 1), _c('div', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.isAdding = true
      }
    }
  }, [_vm._v("Nuevo")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Email")]), _c('th', [_vm._v("Nombre")]), _c('th', [_vm._v("Cargo")]), _c('th', [_vm._v("Telefono")]), _c('th', [_vm._v("Password")]), _c('th')])
}]}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Tickets abiertos de")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  " + _vm._s(_vm.tipo.toLowerCase()) + " ")]), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v(" por estado")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Listado general de tickets")])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.reRenderChart()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v("Actualizar")], 1)], 1), _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('div', {
    staticClass: "d-flex mb-4 ml-4"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-select', {
    attrs: {
      "solo": "solo",
      "items": _vm.tiempos,
      "item-text": "name",
      "item-value": "id",
      "disabled": _vm.isLoading,
      "label": "Tiempo",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.getDatesForChart()
      }
    },
    model: {
      value: (_vm.tiempo),
      callback: function($$v) {
        _vm.tiempo = $$v
      },
      expression: "tiempo"
    }
  }), _c('div', {
    staticClass: "flex-1 d-flex"
  }, [_c('div', {
    staticClass: "ml-4"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Desde",
      "solo": "solo",
      "dense": "dense",
      "type": "date",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  })], 1), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Hasta",
      "solo": "solo",
      "dense": "dense",
      "type": "date",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  })], 1)])], 1)]), (_vm.renderChart) ? _c('LineChart', {
    ref: "lineChart",
    attrs: {
      "tipo": _vm.tipo,
      "desde": _vm.desde,
      "hasta": _vm.hasta
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "align-center": "align-center",
      "justify-center": "justify-center"
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-form', {
    attrs: {
      "disabled": _vm.isLoading
    }
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("¿Cuenta con un contrato vigente?")]), _c('v-slide-group', {
    attrs: {
      "mandatory": "mandatory",
      "show-arrows": ""
    },
    model: {
      value: (_vm.tipoUsuario),
      callback: function($$v) {
        _vm.tipoUsuario = $$v
      },
      expression: "tipoUsuario"
    }
  }, _vm._l((_vm.tiposUsuario), function(n, index) {
    return _c('v-slide-item', {
      key: index,
      staticClass: "animated fadeInLeft faster",
      attrs: {
        "value": n.value
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "elevation-1 ma-1 d-flex ai-center jc-center text-center flex-1",
            attrs: {
              "color": active ? 'primary' : 'secondary primary--text',
              "height": "60",
              "dark": active,
              "width": "140"
            },
            on: {
              "click": toggle
            }
          }, [_c('span', {
            staticClass: "font-size-13 font-weight-700"
          }, [_vm._v(_vm._s(n.name))])])]
        }
      }], null, true)
    })
  }), 1), (_vm.tipoUsuario === 'usuario-contrato') ? _c('div', {
    staticClass: "d-flex items-end jc-end"
  }, [_c('v-text-field', {
    ref: "ruc",
    attrs: {
      "light": "light",
      "prepend-icon": "circle",
      "label": "RUC (Requerido)",
      "type": "number",
      "hide-details": "hide-details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGetDatosSunat()
      }
    },
    model: {
      value: (_vm.ruc),
      callback: function($$v) {
        _vm.ruc = $$v
      },
      expression: "ruc"
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "disabled": _vm.isLoading,
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fetchGetDatosSunat()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('img', {
          attrs: {
            "src": __webpack_require__(214),
            "width": "25",
            "height": "25"
          }
        })])]
      }
    }], null, false, 3936401355)
  }, [_c('small', [_vm._v("Obtener datos de SUNAT")])])], 1) : _vm._e(), _c('v-text-field', {
    ref: "nombre",
    attrs: {
      "light": "light",
      "prepend-icon": "person",
      "label": "Nombre personal o Razón social",
      "type": "text",
      "hint": _vm.direccion,
      "persistent-hint": _vm.direccion !== '',
      "hide-details": !_vm.direccion
    },
    on: {
      "keyup": [_vm.uppercase, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrarme()
      }]
    },
    model: {
      value: (_vm.nombre),
      callback: function($$v) {
        _vm.nombre = $$v
      },
      expression: "nombre"
    }
  }), _c('v-text-field', {
    ref: "username",
    attrs: {
      "light": "light",
      "prepend-icon": "email",
      "label": "Email (Requerido)",
      "type": "email",
      "hide-details": "hide-details"
    },
    on: {
      "keyup": [_vm.lowercase, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrarme()
      }]
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _c('v-text-field', {
    ref: "password",
    attrs: {
      "prepend-icon": "lock",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password',
      "label": "Ingrese una contraseña",
      "hint": "La contraseña ingresada será encriptada para mayor seguridad",
      "persistent-hint": "persistent-hint"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrarme()
      }
    },
    scopedSlots: _vm._u([{
      key: "progress",
      fn: function() {
        return [_c('v-progress-linear', {
          attrs: {
            "value": _vm.progress,
            "color": _vm.color,
            "absolute": "",
            "height": "2"
          }
        })]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _c('v-checkbox', {
    staticClass: "mt-0 pt-2",
    attrs: {
      "color": "info"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("Acepto compartir datos -  "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.redirectProteccion()
            }
          }
        }, [_vm._v("LEY Nº 29733")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.aceptaPoliticasDePrivacidad),
      callback: function($$v) {
        _vm.aceptaPoliticasDePrivacidad = $$v
      },
      expression: "aceptaPoliticasDePrivacidad"
    }
  }), _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetchRegistrarme()
      }
    }
  }, [_c('small', [_vm._v(" Registrarme")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "app"
    }
  }, [_c('theme-provider'), _c('section', {
    staticClass: "flex w-full h-screen opacity-80 relative items-center justify-center",
    style: (("background-color: #303639; background-image: url(" + ('../static/hero-wallpaper.jpg') + "); background-repeat: no-repat; background-size: cover; background-blend-mode: multiply;  "))
  }, [(!_vm.isMovil) ? _c('div', {
    staticClass: "footer-copy"
  }, [_c('small', [_vm._v(" © Copyright " + _vm._s(new Date().getFullYear()) + " - Todos los derechos reservados " + _vm._s(_vm.empresaFull))])]) : _vm._e(), (!_vm.isMovil) ? _c('div', {
    staticClass: "d-flex ai-center jc-center header-logo"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/logo.png",
      "max-width": "150",
      "contain": "contain"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center h-full w-full"
  }, [_c('div', {
    staticClass: "d-flex flex-col ai-center mb-2"
  }, [_c('h1', {
    staticClass: "font-black white--text",
    class: _vm.isMovil ? 'font-size-45' : 'font-size-40'
  }, [_vm._v("Help Desk")])]), _c('v-card', {
    staticClass: "elevation-8 pa-3 card-principal",
    attrs: {
      "width": _vm.isMovil ? '100%' : 400
    }
  }, [(!_vm.hideTabs) ? _c('v-tabs', {
    attrs: {
      "color": "primary",
      "dense": "dense",
      "centered": "centered"
    }
  }, [_c('v-tab', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Iniciar Sesión")]), _c('v-tab', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Registrarse")])], 1) : _vm._e(), _c('v-tabs-items', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('router-view')], 1)], 1)], 1), _c('notifications', {
    class: _vm.isMovil ? 'width-full' : '',
    attrs: {
      "position": "top right"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('v-alert', {
          staticClass: "elevation-2 py-3 ma-1 animated fadeInRight faster",
          attrs: {
            "dense": "dense",
            "border": "left",
            "type": props.item.type
          }
        }, [_c('small', {
          staticClass: "font-size-12"
        }, [_vm._v(_vm._s(props.item.text))])])]
      }
    }])
  })], 1), (_vm.transaction.isProceso) ? _c('loading-transaction', {
    attrs: {
      "label": _vm.transaction.message
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": _vm.isMovil ? '100%' : '60%',
      "transition": "dialog-bottom-transition",
      "fullscreen": _vm.isMovil
    },
    model: {
      value: (_vm.isUploadFiles),
      callback: function($$v) {
        _vm.isUploadFiles = $$v
      },
      expression: "isUploadFiles"
    }
  }, [_c('v-card', [(_vm.isUploadFiles) ? _c('adjuntar-archivos', {
    ref: "archivos",
    on: {
      "close": _vm.closeModalAdjuntar,
      "save": _vm.setFilesToSave
    }
  }) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "d-flex jc-center ai-center pa-3"
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(_vm.numeroTelefonoCliente > 0 && _vm.perfil !== 'usuario-contrato') ? _c('v-btn', _vm._g(_vm._b({
          staticClass: "mr-3 my-1",
          attrs: {
            "fab": "",
            "disabled": _vm.disabled,
            "href": ("https://wa.me/" + _vm.numeroTelefonoCliente),
            "target": "_blanck",
            "small": "",
            "color": "success"
          }
        }, 'v-btn', attrs, false), on), [_c('svg', {
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "x": "0px",
            "y": "0px",
            "width": "45",
            "height": "70",
            "viewBox": "0 0 50 50"
          }
        }, [_c('path', {
          attrs: {
            "fill": "#fff",
            "d": "M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
          }
        }), _c('path', {
          attrs: {
            "fill": "#fff",
            "d": "M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
          }
        }), _c('path', {
          attrs: {
            "fill": "#cfd8dc",
            "d": "M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
          }
        }), _c('path', {
          attrs: {
            "fill": "#40c351",
            "d": "M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
          }
        }), _c('path', {
          attrs: {
            "fill": "#fff",
            "fill-rule": "evenodd",
            "d": "M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z",
            "clip-rule": "evenodd"
          }
        })])]) : _vm._e()]
      }
    }])
  }, [_c('small', [_vm._v("Enviar mensaje al whatsapp - " + _vm._s(_vm.numeroTelefonoCliente))])]), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mr-3",
          attrs: {
            "fab": "",
            "disabled": _vm.disabled,
            "small": "",
            "color": "primary"
          },
          on: {
            "click": function($event) {
              _vm.isUploadFiles = true
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("attach_file")])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Enviar archivo")])])], 1), _c('v-textarea', {
    ref: "mensaje",
    attrs: {
      "hide-details": "hide-details",
      "disabled": _vm.disabled,
      "placeholder": ("Escribe un mensaje para el " + (_vm.perfil !== 'usuario-contrato' &&  _vm.perfil !== 'usuario-contrato' ? 'cliente' :  'agente')),
      "solo": "solo",
      "height": "80",
      "no-resize": "no-resize"
    },
    model: {
      value: (_vm.comentario),
      callback: function($$v) {
        _vm.comentario = $$v
      },
      expression: "comentario"
    }
  }), _c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "fab": "",
      "disabled": _vm.disabled,
      "small": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.enviarComentario()
      }
    }
  }, [_c('v-icon', [_vm._v("send")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "align-center": "align-center",
      "justify-center": "justify-center"
    }
  }, [_c('v-flex', {
    staticClass: "flex-col text-xs-center"
  }, [_c('v-form', {
    attrs: {
      "disabled": _vm.isLoading
    }
  }, [_c('v-text-field', {
    ref: "username",
    attrs: {
      "light": "light",
      "prepend-icon": "email",
      "label": "Ingresa tu usuario (email)",
      "type": "email"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchLogin()
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _c('v-text-field', {
    ref: "password",
    attrs: {
      "hide-details": "hide-details",
      "prepend-icon": "lock",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password',
      "label": "Ingresa tu contraseña"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchLogin()
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _c('v-checkbox', {
    attrs: {
      "light": "light",
      "label": "Permanecer conectado"
    },
    model: {
      value: (_vm.shouldStayLoggedIn),
      callback: function($$v) {
        _vm.shouldStayLoggedIn = $$v
      },
      expression: "shouldStayLoggedIn"
    }
  }), _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetchLogin()
      }
    }
  }, [_vm._v("Ingresar")])], 1), _c('div', {
    staticClass: "d-flex jc-center ai-center mt-4"
  }, [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("¿Olvidaste tu contraseña?")]), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "small": "small",
      "text": "text",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/forgot-password-request')
      }
    }
  }, [_vm._v("click aquí")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "fullscreen"
    },
    model: {
      value: (_vm.isModalExportar),
      callback: function($$v) {
        _vm.isModalExportar = $$v
      },
      expression: "isModalExportar"
    }
  }, [(_vm.isModalExportar) ? _c('parametros-exportacion', {
    attrs: {
      "id": _vm.idReporteExportar,
      "preview": "save"
    },
    on: {
      "close": _vm.closeDialogExportar
    }
  }) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "max-width": "350"
    },
    model: {
      value: (_vm.isModalEliminar),
      callback: function($$v) {
        _vm.isModalEliminar = $$v
      },
      expression: "isModalEliminar"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('strong', {
    staticClass: "font-size-17"
  }, [_vm._v("¿Realmente deseas eliminar el reporte"), _c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("  " + _vm._s(_vm.reporteAEliminar.titulo) + "?")])]), _c('v-card-text', {
    staticClass: "mt-4 px-0"
  }, [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Si continuas con este proceso el reporte se eliminará permanentemente y no se podra recuperar")])]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "color": "ligth",
      "small": "small"
    },
    on: {
      "click": _vm.closeDialogEliminar
    }
  }, [_vm._v("cancelar")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchEliminarReporte()
      }
    }
  }, [_vm._v("Eliminar")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "400"
    },
    model: {
      value: (_vm.isModalGuardarReporte),
      callback: function($$v) {
        _vm.isModalGuardarReporte = $$v
      },
      expression: "isModalGuardarReporte"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Nuevo reporte")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Los filtros asignados a este nuevo reporte serán los parametros de tipo"), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("  " + _vm._s(_vm.tiposReporte[_vm.indexReporte].name))])])], 1), _c('v-text-field', {
    ref: "tituloModal",
    staticClass: "pa-4 pb-0",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Titulo  "
    },
    model: {
      value: (_vm.query.titulo),
      callback: function($$v) {
        _vm.$set(_vm.query, "titulo", $$v)
      },
      expression: "query.titulo"
    }
  }), _c('v-text-field', {
    staticClass: "pa-4 pb-0",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Descripcion del resultado "
    },
    model: {
      value: (_vm.query.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.query, "descripcion", $$v)
      },
      expression: "query.descripcion"
    }
  }), _c('v-card-actions', {
    staticClass: "mt-8"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "color": "ligth",
      "small": "small"
    },
    on: {
      "click": _vm.closeModalGuardarReporte
    }
  }, [_vm._v("  cancelar")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarReporte()
      }
    }
  }, [_vm._v("  Generar reporte")])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-auto elevation-1"
  }, [_c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("  Generador de reportes")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("  Crea, guarda y exporta tus reportes")])], 1)]), _c('v-divider'), (_vm.isMovil) ? _c('v-tabs', {
    staticClass: "elevation-1 position-sticky",
    attrs: {
      "fixed-tabs": ""
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabActive = 1
      }
    }
  }, [_c('small', [_vm._v("Listado Reportes")])]), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabActive = 2
      }
    }
  }, [_c('small', [_vm._v("Parametros")])])], 1) : _vm._e(), _c('v-sheet', {
    staticClass: "pa-3"
  }, [_c('v-row', [(!_vm.isMovil || _vm.isMovil && _vm.tabActive === 1) ? _c('v-col', {
    staticClass: "b-right",
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.tiposListados,
      "hide-details": "hide-details",
      "label": "Tipo Listado",
      "dense": "",
      "solo": "",
      "item-value": "id",
      "item-text": "name"
    },
    on: {
      "change": function($event) {
        _vm.definirNuevoReporte(), _vm.fetchObtenerListadoReportes(null)
      }
    },
    model: {
      value: (_vm.indexTipoListadoReportes),
      callback: function($$v) {
        _vm.indexTipoListadoReportes = $$v
      },
      expression: "indexTipoListadoReportes"
    }
  }), _c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "block": "block",
      "color": "success",
      "disabled": _vm.indexTipoListadoReportes === 1
    },
    on: {
      "click": function($event) {
        return _vm.definirNuevoReporte()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("add_circle")]), _vm._v(" reporte en blanco")], 1), _c('v-card', {
    staticClass: "overflow-y-auto elevation-0 px-1",
    attrs: {
      "max-height": "calc(100vh - 251px)"
    }
  }, _vm._l((_vm.listado), function(item, i) {
    return _c('v-card', {
      key: i,
      staticClass: "pa-0 my-2 elevation-1",
      attrs: {
        "nav": "",
        "dark": _vm.idReporteSeleccionado === item.id,
        "dense": "",
        "color": _vm.idReporteSeleccionado === item.id ? 'primary' : ''
      },
      on: {
        "dblclick": function($event) {
          return _vm.goToPrevisualizarReporte(item.id, item.esReporteDefinido)
        }
      }
    }, [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editarReporte(item, item.id)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "font-size-13"
    }, [_c('span', {
      staticClass: "font-weight-700"
    }, [_vm._v(_vm._s(item.titulo))])]), _c('v-list-item-subtitle', {
      staticClass: "font-size-11"
    }, [_vm._v(_vm._s(item.descripcion ? item.descripcion : 'No cuenta con subtitulo'))]), _c('div', {
      staticClass: "d-flex ai-center mt-1"
    }, [_c('v-chip', {
      staticClass: "mr-1",
      attrs: {
        "x-small": "x-small",
        "color": _vm.idReporteSeleccionado === item.id ? 'white primary--text' : 'primary'
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "8"
      }
    }, [_vm._v("circle")]), _c('span', {
      staticClass: "font-weight-700 font-size-11"
    }, [_vm._v(_vm._s(item.tipo))])], 1), _c('v-spacer'), _c('small', {
      staticClass: "font-size-10 text-muted"
    }, [_vm._v("fue creado  " + _vm._s(_vm._f("now")(item.fechaRegistro)))])], 1)], 1), _c('v-list-item-action', {
      staticClass: "ma-0"
    }, [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "icon": "icon"
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
        }
      }], null, true)
    }, [_c('v-list', {
      attrs: {
        "dense": "dense"
      }
    }, [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.goToPrevisualizarReporte(item.id, item.esReporteDefinido)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Visualizar resultados")])], 1), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.openDialogExportar(item.id)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Exportar resultados")])], 1), (!item.esReporteDefinido) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.openDialogEliminar(item)
        }
      }
    }, [_c('v-list-item-title', {
      staticClass: "primary--text"
    }, [_vm._v("Eliminar permanentemente")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
  }), 1)], 1) : _vm._e(), (!_vm.isMovil || _vm.isMovil && _vm.tabActive === 2) ? _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12",
      "sm": "9"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center flex-1 pa-4"
  }, _vm._l((_vm.tiposReporte), function(r, index) {
    return _c('v-card', {
      key: index,
      staticClass: "pa-2",
      class: {
        'mr-4': index < _vm.tiposReporte.length - 1
      },
      attrs: {
        "name": index,
        "id": _vm.tiposReporte.length - 1,
        "color": r.id === _vm.indexReporte ? 'primary white--text' : '',
        "width": _vm.isMovil ? '' : 200,
        "height": "70",
        "hover": "hover",
        "disabled": _vm.indexTipoListadoReportes === 1
      },
      on: {
        "click": function($event) {
          return _vm.seleccionarTipoReporte(r.id)
        }
      }
    }, [_c('div', {
      staticClass: "d-flex ai-center"
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "40",
        "color": r.id === _vm.indexReporte ? 'white' : 'background'
      }
    }, [_vm._v(_vm._s(r.icon))]), _c('div', {
      staticClass: "flex-1 d-flex fd-column"
    }, [_c('span', {
      staticClass: "font-weight-700 font-size-20",
      class: {
        'font-size-17': _vm.isMovil
      }
    }, [_vm._v(_vm._s(r.name))]), _c('small', {
      staticClass: "font-size-11",
      class: {
        'white--text': r.id === _vm.indexReporte
      }
    }, [_vm._v(_vm._s(r.description))])])], 1)])
  }), 1), (_vm.idReporteSeleccionado !== '') ? _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('v-text-field', {
    ref: "tituloCreado",
    staticClass: "pa-4 pb-0",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Titulo  ",
      "disabled": _vm.indexTipoListadoReportes === 1
    },
    model: {
      value: (_vm.query.titulo),
      callback: function($$v) {
        _vm.$set(_vm.query, "titulo", $$v)
      },
      expression: "query.titulo"
    }
  }), _c('v-text-field', {
    staticClass: "pa-4 pb-0",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Descripcion del resultado",
      "disabled": _vm.indexTipoListadoReportes === 1
    },
    model: {
      value: (_vm.query.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.query, "descripcion", $$v)
      },
      expression: "query.descripcion"
    }
  })], 1) : _vm._e(), _c('v-card-title', [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Asignación de parametros")])]), _c('v-card', {
    staticClass: "elevation-0 pa-3 overflow-y-auto pt-0",
    attrs: {
      "height": _vm.idReporteSeleccionado !== '' ? 'calc(100vh - 455px)' : 'calc(100vh - 364px)'
    }
  }, [(_vm.indexReporte === 0) ? [_c('v-text-field', {
    staticClass: "pb-3",
    attrs: {
      "label": "Numero de ticket",
      "persistent-hint": "persistent-hint",
      "hint": "Si usas este filtro, los demas parametros no se tomarán en cuenta",
      "type": "number"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.numero),
      callback: function($$v) {
        _vm.$set(_vm.query, "numero", $$v)
      },
      expression: "query.numero"
    }
  }), _c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Tipo")]), _c('v-radio-group', {
    staticClass: "pt-1 mt-1",
    attrs: {
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.reRenderEstados()
      }
    },
    model: {
      value: (_vm.query.tipo),
      callback: function($$v) {
        _vm.$set(_vm.query, "tipo", $$v)
      },
      expression: "query.tipo"
    }
  }, [_c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "incidencia con equipo"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.tipo === 'incidencia con equipo'
          }
        }, [_vm._v(" Incidencia con equipo - contrato")])]
      },
      proxy: true
    }], null, false, 3384785156)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "solicitud de insumo"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.tipo === 'solicitud de insumo'
          }
        }, [_vm._v(" Solicitud de insumo - contrato")])]
      },
      proxy: true
    }], null, false, 2466712196)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "garantia"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.tipo === 'garantia'
          }
        }, [_vm._v(" Garantia")])]
      },
      proxy: true
    }], null, false, 4089655639)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "-1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.tipo === '-1'
          }
        }, [_vm._v(" Todos")])]
      },
      proxy: true
    }], null, false, 1418143112)
  })], 1)], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Mostrar")]), _c('v-radio-group', {
    staticClass: "pt-1 mt-1",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.query.abierto),
      callback: function($$v) {
        _vm.$set(_vm.query, "abierto", $$v)
      },
      expression: "query.abierto"
    }
  }, [_c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.abierto === '1'
          }
        }, [_vm._v(" Abiertos")])]
      },
      proxy: true
    }], null, false, 2416177943)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "0"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.abierto === '0'
          }
        }, [_vm._v(" Cerrados")])]
      },
      proxy: true
    }], null, false, 403681116)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "-1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.abierto === '-1'
          }
        }, [_vm._v(" Todos")])]
      },
      proxy: true
    }], null, false, 2199221100)
  })], 1)], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Area")]), _c('v-radio-group', {
    staticClass: "pt-1 mt-1",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.query.area),
      callback: function($$v) {
        _vm.$set(_vm.query, "area", $$v)
      },
      expression: "query.area"
    }
  }, [_c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "campo"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.area === 'campo'
          }
        }, [_vm._v(" Campo")])]
      },
      proxy: true
    }], null, false, 808990114)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "taller"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.area === 'taller'
          }
        }, [_vm._v(" Taller")])]
      },
      proxy: true
    }], null, false, 2827400834)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.area === 'sin asignacion'
          }
        }, [_vm._v("Sin asignacion")])]
      },
      proxy: true
    }], null, false, 3402295298)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "-1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.area === '-1'
          }
        }, [_vm._v("Todos")])]
      },
      proxy: true
    }], null, false, 3560182205)
  })], 1)], 1)])]), (_vm.showFiltroEstados && _vm.query.tipo !== '-1') ? _c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Estados")]), _c('estados-ticket', {
    staticClass: "pt-1",
    attrs: {
      "tipo": _vm.query.tipo,
      "show-clear": "show-clear",
      "codigo": _vm.query.estado
    },
    on: {
      "selected": _vm.obtenerEstado
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Rango de fechas")]), _c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1 mr-2"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Desde ",
      "type": "date"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.desde),
      callback: function($$v) {
        _vm.$set(_vm.query, "desde", $$v)
      },
      expression: "query.desde"
    }
  })], 1), _c('div', {
    staticClass: "flex-1",
    class: {
      'ml-2': !_vm.isMovil
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Hasta ",
      "type": "date"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.hasta),
      callback: function($$v) {
        _vm.$set(_vm.query, "hasta", $$v)
      },
      expression: "query.hasta"
    }
  })], 1)])]), _c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Especifico")]), _c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1 mr-2"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Codigo de cliente - interno/sap",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.codigoCliente),
      callback: function($$v) {
        _vm.$set(_vm.query, "codigoCliente", $$v)
      },
      expression: "query.codigoCliente"
    }
  })], 1), _c('div', {
    staticClass: "flex-1",
    class: {
      'ml-2': !_vm.isMovil
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Serie",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.serie),
      callback: function($$v) {
        _vm.$set(_vm.query, "serie", $$v)
      },
      expression: "query.serie"
    }
  })], 1), _c('div', {
    staticClass: "flex-1",
    class: {
      'ml-2': !_vm.isMovil
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Modelo",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.modelo),
      callback: function($$v) {
        _vm.$set(_vm.query, "modelo", $$v)
      },
      expression: "query.modelo"
    }
  })], 1)])]), (_vm.query.tipo === 'garantia') ? _c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Zona de asignacion")]), _c('v-radio-group', {
    staticClass: "pt-1 mt-1",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.query.zona),
      callback: function($$v) {
        _vm.$set(_vm.query, "zona", $$v)
      },
      expression: "query.zona"
    }
  }, [_c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "lima"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.zona === 'lima'
          }
        }, [_vm._v(" Lima")])]
      },
      proxy: true
    }], null, false, 3720450511)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "arequipa"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.zona === 'arequipa'
          }
        }, [_vm._v(" Arequipa")])]
      },
      proxy: true
    }], null, false, 2978491343)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.zona === 'sin asignacion'
          }
        }, [_vm._v(" Sin asignacion")])]
      },
      proxy: true
    }], null, false, 2245825615)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "-1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.zona === '-1'
          }
        }, [_vm._v(" Todos")])]
      },
      proxy: true
    }], null, false, 4093891856)
  })], 1)], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v(" ¿Ingresaron a taller?")]), _c('v-radio-group', {
    staticClass: "pt-1 mt-1",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.query.ingresoATaller),
      callback: function($$v) {
        _vm.$set(_vm.query, "ingresoATaller", $$v)
      },
      expression: "query.ingresoATaller"
    }
  }, [_c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.ingresoATaller === '1'
          }
        }, [_vm._v(" Si")])]
      },
      proxy: true
    }], null, false, 4020795862)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "0"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.ingresoATaller === '0'
          }
        }, [_vm._v(" No")])]
      },
      proxy: true
    }], null, false, 1875698668)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "-1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.ingresoATaller === '-1'
          }
        }, [_vm._v(" Todos")])]
      },
      proxy: true
    }], null, false, 120740770)
  })], 1)], 1)])]) : _vm._e()] : _vm._e(), (_vm.indexReporte === 1) ? [(_vm.indexTipoListadoReportes === 0) ? _c('v-row', {
    staticClass: "pt-1",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "hide-details",
      "items": _vm.columnasTicket,
      "return-object": "return-object",
      "item-value": "valor",
      "item-text": "nombre",
      "loading": _vm.isLoadingColumsTickets,
      "label": "Seleccionar campo",
      "dense": "",
      "solo": ""
    },
    on: {
      "change": _vm.validarDataType
    },
    model: {
      value: (_vm.reporteAvanzado.campo),
      callback: function($$v) {
        _vm.$set(_vm.reporteAvanzado, "campo", $$v)
      },
      expression: "reporteAvanzado.campo"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "hide-details",
      "items": _vm.itemsCondiciones,
      "return-object": "return-object",
      "item-value": "valor",
      "item-text": "name",
      "label": "Criterios",
      "dense": "",
      "solo": ""
    },
    model: {
      value: (_vm.reporteAvanzado.criterio),
      callback: function($$v) {
        _vm.$set(_vm.reporteAvanzado, "criterio", $$v)
      },
      expression: "reporteAvanzado.criterio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Valor",
      "dense": "dense",
      "type": _vm.valorType,
      "solo": "solo"
    },
    model: {
      value: (_vm.reporteAvanzado.valor),
      callback: function($$v) {
        _vm.$set(_vm.reporteAvanzado, "valor", $$v)
      },
      expression: "reporteAvanzado.valor"
    }
  }), (Object.keys(_vm.reporteAvanzado.campo).length) ? _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Valor aceptado:  "), _c('strong', [_vm._v(_vm._s(_vm.reporteAvanzado.campo.descripcionType))])]) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "block",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.agregarQueryAvanzado()
      }
    }
  }, [_vm._v("Agregar")])], 1)], 1) : _vm._e(), _c('v-data-table', {
    staticClass: "elevation-0 mt-8",
    attrs: {
      "headers": _vm.headersFiltrosAvanzados,
      "items": _vm.queryAvanzados,
      "dense": "dense",
      "disable-pagination": true,
      "hide-default-footer": "hide-default-footer"
    },
    scopedSlots: _vm._u([{
      key: "item.columna",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', [_vm._v(_vm._s(item.columna.nombre))])]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('div', {
          staticClass: "d-flex ai-center",
          class: {
            'ma-1': !_vm.isMovil
          }
        }, [_c('v-btn', {
          staticClass: "mr-2",
          attrs: {
            "fab": "fab",
            "x-small": "x-small",
            "disabled": _vm.indexTipoListadoReportes === 1
          },
          on: {
            "click": function($event) {
              return _vm.editarRowFiltrosAvanzados(index)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1), _c('v-btn', {
          attrs: {
            "fab": "fab",
            "x-small": "x-small",
            "color": "primary",
            "disabled": _vm.indexTipoListadoReportes === 1
          },
          on: {
            "click": function($event) {
              return _vm.eliminarRowFiltrosAvanzados(index)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)]
      }
    }, {
      key: "item.condicion",
      fn: function(ref) {
        var item = ref.item;

        return [_c('strong', [_vm._v(_vm._s(item.condicion.name))])]
      }
    }], null, false, 496348782)
  })] : _vm._e()], 2), _c('div', {
    staticClass: "d-flex pa-4 border-top"
  }, [_c('div', {
    staticClass: "flex-1"
  }), _c('div', {
    staticClass: "flex-1 jc-end d-flex"
  }, [_c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goToPrevisualizarReporte()
      }
    }
  }, [(_vm.idReporteSeleccionado !== '') ? _c('span', [_vm._v("Previsualizar")]) : _c('span', [_vm._v("Ver datos borrador")])]), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "success",
      "disabled": _vm.indexTipoListadoReportes === 1
    },
    on: {
      "click": function($event) {
        return _vm.verificarSiEsReporteNuevo()
      }
    }
  }, [(_vm.idReporteSeleccionado !== '') ? _c('span', [_vm._v("Guardar cambios")]) : _c('span', [_vm._v("Guardar datos")])])], 1)])], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('div', {
    staticClass: "d-flex pt-2 px-4 jc-center ai-center"
  }, [_c('div', {
    staticClass: "flex-1 d-flex fd-column"
  }, [_c('span', {
    staticClass: "pa-0 font-size-20 font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Configuración de exportación")]), _c('span', {
    staticClass: "font-size-12 text-muted pl-0"
  }, [_vm._v("Selecciona el formato y las columnas a exportar")])]), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.descripcionPredefinido) ? _c('div', {
    staticClass: "mx-1 flex-1"
  }, [(_vm.descripcionPredefinido) ? _c('v-select', {
    attrs: {
      "hide-details": "hide-details",
      "items": _vm.reportesPredefinidos,
      "label": "Seleccionar tipo de listado",
      "dense": "",
      "solo": "",
      "item-text": "titulo",
      "item-value": "descripcion"
    },
    model: {
      value: (_vm.descripcionPredefinido),
      callback: function($$v) {
        _vm.descripcionPredefinido = $$v
      },
      expression: "descripcionPredefinido"
    }
  }) : _vm._e()], 1) : _vm._e()])]), _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('v-tabs', {
    staticClass: "d-flex mt-1",
    attrs: {
      "dense": "dense",
      "color": "primary",
      "grow": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    key: "lista"
  }, [(_vm.countLengthColumns('ticket')) ? _c('v-badge', {
    attrs: {
      "color": "primary",
      "dot": "dot"
    }
  }, [_c('span', [_vm._v("Ticket")])]) : _c('span', [_c('span', [_vm._v("Ticket")])])], 1), _c('v-tab', {
    key: "estados"
  }, [(_vm.countLengthColumns('estado')) ? _c('v-badge', {
    attrs: {
      "color": "primary",
      "dot": "dot"
    }
  }, [_c('span', [_vm._v("Estados")])]) : _c('span', [_vm._v("Estados")])], 1), _c('v-tab', {
    key: "etapas"
  }, [(_vm.countLengthColumns('etapa')) ? _c('v-badge', {
    attrs: {
      "color": "primary",
      "dot": "dot"
    }
  }, [_c('span', [_vm._v("Etapas")])]) : _c('span', [_vm._v("Etapas")])], 1), _c('v-tab', {
    key: "tiempos"
  }, [(_vm.countLengthColumns('tiempo')) ? _c('v-badge', {
    attrs: {
      "color": "primary",
      "dot": "dot"
    }
  }, [_c('span', [_vm._v("Tiempos")])]) : _c('span', [_vm._v("Tiempos")])], 1), _c('v-tab', {
    key: "orden"
  }, [(_vm.columnasAExportar.length) ? _c('v-badge', {
    attrs: {
      "color": "primary",
      "content": _vm.columnasAExportar.length
    }
  }, [_c('span', [_vm._v("Listo para exportar")])]) : _c('span', [_vm._v("Listo para exportar")])], 1)], 1), _c('v-card', {
    staticClass: "overflow-y-auto elevation-0",
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 228px)' : 'calc(100vh - 180px)'
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: "lista"
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [(!_vm.columnasTicket.length) ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 mt-12"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No habilitaste ninguna opcion")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Para visualizar columnas habilita alguna opcion en la parte superior")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.columnasTicket.length) ? _c('v-switch', {
    staticClass: "mx-4 my-2",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "color": "primary",
      "label": _vm.isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas del ticket'
    },
    on: {
      "change": _vm.seleccionarTodasLasColumnasTicket
    },
    model: {
      value: (_vm.isColumnasAllSeleccionadasTicket),
      callback: function($$v) {
        _vm.isColumnasAllSeleccionadasTicket = $$v
      },
      expression: "isColumnasAllSeleccionadasTicket"
    }
  }) : _vm._e()], 1), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.columnasAExportar),
      callback: function($$v) {
        _vm.columnasAExportar = $$v
      },
      expression: "columnasAExportar"
    }
  }, [_vm._l((_vm.columnasTicket), function(item, i) {
    return [_c('v-list-item', {
      key: ("item-" + i),
      attrs: {
        "value": item,
        "active-class": "secondary primary--text"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;

          return [_c('v-list-item-action', [_c('v-checkbox', {
            attrs: {
              "input-value": active,
              "dense": "dense",
              "color": "primary",
              "hide-details": "hide-details"
            }
          })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('strong', {
            staticClass: "font-size-12"
          }, [_vm._v(_vm._s(item.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
            staticClass: "font-size-11 text-muted"
          }, [_vm._v("columna de " + _vm._s(item.table))])])], 1), _c('v-list-item-action', [_c('v-icon', {
            attrs: {
              "color": item.color,
              "size": "12"
            }
          }, [_vm._v("circle")])], 1)]
        }
      }], null, true)
    }), _c('v-divider')]
  })], 2)], 1)], 1)], 1), _c('v-tab-item', {
    key: "estados"
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [(!_vm.columnasEstados.length) ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 mt-12"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No habilitaste ninguna opcion")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Para visualizar columnas habilita alguna opcion en la parte superior")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.columnasEstados.length) ? _c('v-switch', {
    staticClass: "mx-4 my-2",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "color": "primary",
      "label": _vm.isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas de los estados'
    },
    on: {
      "change": _vm.seleccionarTodasLasColumnasEstados
    },
    model: {
      value: (_vm.isColumnasAllSeleccionadasEstados),
      callback: function($$v) {
        _vm.isColumnasAllSeleccionadasEstados = $$v
      },
      expression: "isColumnasAllSeleccionadasEstados"
    }
  }) : _vm._e()], 1), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.columnasAExportar),
      callback: function($$v) {
        _vm.columnasAExportar = $$v
      },
      expression: "columnasAExportar"
    }
  }, [_vm._l((_vm.columnasEstados), function(item, i) {
    return [_c('v-list-item', {
      key: ("item-" + i),
      attrs: {
        "value": item,
        "active-class": "secondary primary--text"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;

          return [_c('v-list-item-action', [_c('v-checkbox', {
            attrs: {
              "input-value": active,
              "dense": "dense",
              "color": "primary",
              "hide-details": "hide-details"
            }
          })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('strong', {
            staticClass: "font-size-12"
          }, [_vm._v(_vm._s(item.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
            staticClass: "font-size-11 text-muted"
          }, [_vm._v("columna de " + _vm._s(item.table))])])], 1), _c('v-list-item-action', [_c('v-icon', {
            attrs: {
              "color": item.color,
              "size": "12"
            }
          }, [_vm._v("circle")])], 1)]
        }
      }], null, true)
    }), _c('v-divider')]
  })], 2)], 1)], 1)], 1), _c('v-tab-item', {
    key: "etapas"
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [(!_vm.columnasEtapas.length) ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 mt-12"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No habilitaste ninguna opcion")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Para visualizar columnas habilita alguna opcion en la parte superior")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.columnasEtapas.length) ? _c('v-switch', {
    staticClass: "mx-4 my-2",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "color": "primary",
      "label": _vm.isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas de las etapas'
    },
    on: {
      "change": _vm.seleccionarTodasLasColumnasEtapas
    },
    model: {
      value: (_vm.isColumnasAllSeleccionadasEtapas),
      callback: function($$v) {
        _vm.isColumnasAllSeleccionadasEtapas = $$v
      },
      expression: "isColumnasAllSeleccionadasEtapas"
    }
  }) : _vm._e()], 1), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.columnasAExportar),
      callback: function($$v) {
        _vm.columnasAExportar = $$v
      },
      expression: "columnasAExportar"
    }
  }, [_vm._l((_vm.columnasEtapas), function(item, i) {
    return [_c('v-list-item', {
      key: ("item-" + i),
      attrs: {
        "value": item,
        "active-class": "secondary primary--text"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;

          return [_c('v-list-item-action', [_c('v-checkbox', {
            attrs: {
              "input-value": active,
              "dense": "dense",
              "color": "primary",
              "hide-details": "hide-details"
            }
          })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('strong', {
            staticClass: "font-size-12"
          }, [_vm._v(_vm._s(item.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
            staticClass: "font-size-11 text-muted"
          }, [_vm._v("columna de " + _vm._s(item.table))])])], 1), _c('v-list-item-action', [_c('v-icon', {
            attrs: {
              "color": item.color,
              "size": "12"
            }
          }, [_vm._v("circle")])], 1)]
        }
      }], null, true)
    }), _c('v-divider')]
  })], 2)], 1)], 1)], 1), _c('v-tab-item', {
    key: "tiempos"
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [(!_vm.columnasTiempos.length) ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 mt-12"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No habilitaste ninguna opcion")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Para visualizar columnas habilita alguna opcion en la parte superior")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.columnasTiempos.length) ? _c('v-switch', {
    staticClass: "mx-4 my-2",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "color": "primary",
      "label": _vm.isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas de los tiempos'
    },
    on: {
      "change": _vm.seleccionarTodasLasColumnasTiempos
    },
    model: {
      value: (_vm.isColumnasAllSeleccionadasTiempos),
      callback: function($$v) {
        _vm.isColumnasAllSeleccionadasTiempos = $$v
      },
      expression: "isColumnasAllSeleccionadasTiempos"
    }
  }) : _vm._e()], 1), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.columnasAExportar),
      callback: function($$v) {
        _vm.columnasAExportar = $$v
      },
      expression: "columnasAExportar"
    }
  }, [_vm._l((_vm.columnasTiempos), function(item, i) {
    return [_c('v-list-item', {
      key: ("item-" + i),
      attrs: {
        "value": item,
        "active-class": "secondary primary--text"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;

          return [_c('v-list-item-action', [_c('v-checkbox', {
            attrs: {
              "input-value": active,
              "dense": "dense",
              "color": "primary",
              "hide-details": "hide-details"
            }
          })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('strong', {
            staticClass: "font-size-12"
          }, [_vm._v(_vm._s(item.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
            staticClass: "font-size-11 text-muted"
          }, [_vm._v("columna de " + _vm._s(item.table))])])], 1), _c('v-list-item-action', [_c('v-icon', {
            attrs: {
              "color": item.color,
              "size": "12"
            }
          }, [_vm._v("circle")])], 1)]
        }
      }], null, true)
    }), _c('v-divider')]
  })], 2)], 1)], 1)], 1), _c('v-tab-item', {
    key: "orden"
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [(!_vm.columnasAExportar.length) ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 mt-12"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No seleccionaste ninguna columna")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Regresa a la primera pestaña para seleccionar algunos")])], 1) : _c('div', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('lista-draggable', {
    attrs: {
      "options": _vm.optionDragable,
      "ghost-class": "ghost",
      "chosen-class": "chosen",
      "drag-class": "drag"
    },
    model: {
      value: (_vm.columnasAExportar),
      callback: function($$v) {
        _vm.columnasAExportar = $$v
      },
      expression: "columnasAExportar"
    }
  }, _vm._l((_vm.columnasAExportar), function(item, i) {
    return _c('v-list', {
      key: ("item-" + i),
      staticClass: "py-0"
    }, [_c('v-list-item', {
      attrs: {
        "value": item,
        "active-class": "secondary primary--text"
      },
      on: {
        "click": function () {}
      }
    }, [_c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": item.color,
        "size": "12"
      }
    }, [_vm._v("circle")])], 1), _c('v-list-item-content', {
      staticClass: "py-0"
    }, [_c('v-list-item-title', [_c('strong', {
      staticClass: "font-size-12"
    }, [_vm._v(_vm._s(item.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
      staticClass: "font-size-11 grey--text"
    }, [_vm._v(_vm._s(item.descripcionType) + " / " + _vm._s(item.table))])])], 1), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "fab": "fab",
        "color": "error",
        "x-small": "x-small"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return (function () {
            _vm.columnasAExportar.splice(i, 1)
          })($event)
        }
      }
    }, [_c('v-icon', [_vm._v("remove")])], 1)], 1), _c('v-list-item-action', {
      staticClass: "handle"
    }, [_c('v-btn', {
      attrs: {
        "icon": "icon",
        "small": "small"
      }
    }, [_c('v-icon', [_vm._v("drag_indicator")])], 1)], 1)], 1), _c('v-divider')], 1)
  }), 1)], 1)])], 1)], 1)], 1), _c('div', {
    staticClass: "mt-1 d-flex mx-4"
  }, [_c('span'), _c('v-spacer'), _c('small', {
    staticClass: "font-size-11 font-weight-700"
  }, [_vm._v(_vm._s(_vm.columnasTicket.length + _vm.columnasEstados.length + _vm.columnasEtapas.length + _vm.columnasTiempos.length) + " columnas disp., " + _vm._s(_vm.columnasAExportar.length) + "  para descargar")])], 1), _c('div', {
    staticClass: "d-flex mt-1 mb-4 mx-4",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('v-btn', {
    class: {
      'mx-2': !_vm.isMovil
    },
    attrs: {
      "color": "error",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogExportar()
      }
    }
  }, [_vm._v("Cancelar exportacion")]), _c('v-spacer'), _c('v-btn', {
    class: {
      'mt-2': _vm.isMovil
    },
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchExportarReporte()
      }
    }
  }, [_vm._v("Exportar informacion")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.isTransaction),
      callback: function($$v) {
        _vm.isTransaction = $$v
      },
      expression: "isTransaction"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-4"
  }, [_c('small', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v(_vm._s(_vm.label))]), _c('v-progress-linear', {
    staticClass: "ma-1",
    attrs: {
      "value": _vm.value,
      "color": "white"
    }
  }), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("se cancelará automaticamente en " + _vm._s(_vm.timer) + " seg.")])], 1), (Math.sign(_vm.timer) === -1) ? _c('div', {
    staticClass: "d-flex mt-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "white primary--text",
      "small": !_vm.isMovil,
      "block": "block"
    },
    on: {
      "click": _vm.reloadPage
    }
  }, [_vm._v("Recargar pagina")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-img', {
    staticClass: "rounded-circle",
    attrs: {
      "src": _vm.urlImage,
      "gradient": _vm.gradient ? 'to bottom, rgba(0,0,0,.1),#161f2b85' : '',
      "loading": _vm.isLoading
    },
    on: {
      "error": function($event) {
        _vm.urlImage = '/static/nobody.jpg'
      }
    }
  }, [(_vm.isLoading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "indeterminate",
      "color": "primary",
      "size": "30"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Total de tickets")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  " + _vm._s(_vm.tipo) + " ")]), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v(" pendientes por asesor")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Listado general de todos los tickets pendientes atencion")])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchTicketsPorAnio()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v("Actualizar")], 1)], 1), _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('div', {
    staticClass: "d-flex ml-3 mb-2"
  }, [_c('div', {
    staticClass: "d-flex mx-2"
  }, [_c('v-select', {
    attrs: {
      "solo": "solo",
      "items": _vm.years,
      "disabled": _vm.isLoading,
      "label": "Periodo",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.fetchTicketsPorAnio()
      }
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1), (_vm.tipoArea) ? _c('div', {
    staticClass: "d-flex mx-2"
  }, [_c('v-select', {
    attrs: {
      "solo": "solo",
      "items": ['taller', 'campo', 'sin asignacion'],
      "disabled": _vm.isLoading,
      "label": "Area",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.fetchTicketsPorAnio()
      }
    },
    model: {
      value: (_vm.tipoArea),
      callback: function($$v) {
        _vm.tipoArea = $$v
      },
      expression: "tipoArea"
    }
  })], 1) : _vm._e()]), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "dense": "dense",
      "item-key": "codigo",
      "items": _vm.lista,
      "hide-default-footer": "hide-default-footer",
      "loading": _vm.isLoading,
      "disable-pagination": "disable-pagination"
    }
  }), (_vm.renderChart) ? _c('Pie-Chart', {
    ref: "lineChart",
    attrs: {
      "pendientes": _vm.valuesPendientes,
      "resueltos": _vm.valuesResueltos
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ })
],[262]);


// WEBPACK FOOTER //
// static/js/app.a08dce0e13ffcc82da12.js